/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/**
 * @license
 * lodash 3.10.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash modern -o ./lodash.js`
 */
;(function(){function n(n,t){if(n!==t){var r=null===n,e=n===w,u=n===n,o=null===t,i=t===w,f=t===t;if(n>t&&!o||!u||r&&!i&&f||e&&f)return 1;if(n<t&&!r||!f||o&&!e&&u||i&&u)return-1}return 0}function t(n,t,r){for(var e=n.length,u=r?e:-1;r?u--:++u<e;)if(t(n[u],u,n))return u;return-1}function r(n,t,r){if(t!==t)return p(n,r);r-=1;for(var e=n.length;++r<e;)if(n[r]===t)return r;return-1}function e(n){return typeof n=="function"||false}function u(n){return null==n?"":n+""}function o(n,t){for(var r=-1,e=n.length;++r<e&&-1<t.indexOf(n.charAt(r)););
return r}function i(n,t){for(var r=n.length;r--&&-1<t.indexOf(n.charAt(r)););return r}function f(t,r){return n(t.a,r.a)||t.b-r.b}function a(n){return Nn[n]}function c(n){return Tn[n]}function l(n,t,r){return t?n=Bn[n]:r&&(n=Dn[n]),"\\"+n}function s(n){return"\\"+Dn[n]}function p(n,t,r){var e=n.length;for(t+=r?0:-1;r?t--:++t<e;){var u=n[t];if(u!==u)return t}return-1}function h(n){return!!n&&typeof n=="object"}function _(n){return 160>=n&&9<=n&&13>=n||32==n||160==n||5760==n||6158==n||8192<=n&&(8202>=n||8232==n||8233==n||8239==n||8287==n||12288==n||65279==n);
}function v(n,t){for(var r=-1,e=n.length,u=-1,o=[];++r<e;)n[r]===t&&(n[r]=z,o[++u]=r);return o}function g(n){for(var t=-1,r=n.length;++t<r&&_(n.charCodeAt(t)););return t}function y(n){for(var t=n.length;t--&&_(n.charCodeAt(t)););return t}function d(n){return Ln[n]}function m(_){function Nn(n){if(h(n)&&!(Oo(n)||n instanceof zn)){if(n instanceof Ln)return n;if(nu.call(n,"__chain__")&&nu.call(n,"__wrapped__"))return Mr(n)}return new Ln(n)}function Tn(){}function Ln(n,t,r){this.__wrapped__=n,this.__actions__=r||[],
this.__chain__=!!t}function zn(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=Ru,this.__views__=[]}function Bn(){this.__data__={}}function Dn(n){var t=n?n.length:0;for(this.data={hash:gu(null),set:new lu};t--;)this.push(n[t])}function Mn(n,t){var r=n.data;return(typeof t=="string"||ge(t)?r.set.has(t):r.hash[t])?0:-1}function qn(n,t){var r=-1,e=n.length;for(t||(t=Be(e));++r<e;)t[r]=n[r];return t}function Pn(n,t){for(var r=-1,e=n.length;++r<e&&false!==t(n[r],r,n););
return n}function Kn(n,t){for(var r=-1,e=n.length;++r<e;)if(!t(n[r],r,n))return false;return true}function Vn(n,t){for(var r=-1,e=n.length,u=-1,o=[];++r<e;){var i=n[r];t(i,r,n)&&(o[++u]=i)}return o}function Gn(n,t){for(var r=-1,e=n.length,u=Be(e);++r<e;)u[r]=t(n[r],r,n);return u}function Jn(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function Xn(n,t,r,e){var u=-1,o=n.length;for(e&&o&&(r=n[++u]);++u<o;)r=t(r,n[u],u,n);return r}function Hn(n,t){for(var r=-1,e=n.length;++r<e;)if(t(n[r],r,n))return true;
return false}function Qn(n,t,r,e){return n!==w&&nu.call(e,r)?n:t}function nt(n,t,r){for(var e=-1,u=zo(t),o=u.length;++e<o;){var i=u[e],f=n[i],a=r(f,t[i],i,n,t);(a===a?a===f:f!==f)&&(f!==w||i in n)||(n[i]=a)}return n}function tt(n,t){return null==t?n:et(t,zo(t),n)}function rt(n,t){for(var r=-1,e=null==n,u=!e&&Er(n),o=u?n.length:0,i=t.length,f=Be(i);++r<i;){var a=t[r];f[r]=u?Cr(a,o)?n[a]:w:e?w:n[a]}return f}function et(n,t,r){r||(r={});for(var e=-1,u=t.length;++e<u;){var o=t[e];r[o]=n[o]}return r}function ut(n,t,r){
var e=typeof n;return"function"==e?t===w?n:Bt(n,t,r):null==n?Fe:"object"==e?bt(n):t===w?ze(n):xt(n,t)}function ot(n,t,r,e,u,o,i){var f;if(r&&(f=u?r(n,e,u):r(n)),f!==w)return f;if(!ge(n))return n;if(e=Oo(n)){if(f=kr(n),!t)return qn(n,f)}else{var a=ru.call(n),c=a==K;if(a!=Z&&a!=B&&(!c||u))return Fn[a]?Rr(n,a,t):u?n:{};if(f=Ir(c?{}:n),!t)return tt(f,n)}for(o||(o=[]),i||(i=[]),u=o.length;u--;)if(o[u]==n)return i[u];return o.push(n),i.push(f),(e?Pn:_t)(n,function(e,u){f[u]=ot(e,t,r,u,n,o,i)}),f}function it(n,t,r){
if(typeof n!="function")throw new Ge(L);return su(function(){n.apply(w,r)},t)}function ft(n,t){var e=n?n.length:0,u=[];if(!e)return u;var o=-1,i=xr(),f=i===r,a=f&&t.length>=F&&gu&&lu?new Dn(t):null,c=t.length;a&&(i=Mn,f=false,t=a);n:for(;++o<e;)if(a=n[o],f&&a===a){for(var l=c;l--;)if(t[l]===a)continue n;u.push(a)}else 0>i(t,a,0)&&u.push(a);return u}function at(n,t){var r=true;return Su(n,function(n,e,u){return r=!!t(n,e,u)}),r}function ct(n,t,r,e){var u=e,o=u;return Su(n,function(n,i,f){i=+t(n,i,f),(r(i,u)||i===e&&i===o)&&(u=i,
o=n)}),o}function lt(n,t){var r=[];return Su(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function st(n,t,r,e){var u;return r(n,function(n,r,o){return t(n,r,o)?(u=e?r:n,false):void 0}),u}function pt(n,t,r,e){e||(e=[]);for(var u=-1,o=n.length;++u<o;){var i=n[u];h(i)&&Er(i)&&(r||Oo(i)||pe(i))?t?pt(i,t,r,e):Jn(e,i):r||(e[e.length]=i)}return e}function ht(n,t){Nu(n,t,Re)}function _t(n,t){return Nu(n,t,zo)}function vt(n,t){return Tu(n,t,zo)}function gt(n,t){for(var r=-1,e=t.length,u=-1,o=[];++r<e;){var i=t[r];
ve(n[i])&&(o[++u]=i)}return o}function yt(n,t,r){if(null!=n){r!==w&&r in Br(n)&&(t=[r]),r=0;for(var e=t.length;null!=n&&r<e;)n=n[t[r++]];return r&&r==e?n:w}}function dt(n,t,r,e,u,o){if(n===t)n=true;else if(null==n||null==t||!ge(n)&&!h(t))n=n!==n&&t!==t;else n:{var i=dt,f=Oo(n),a=Oo(t),c=D,l=D;f||(c=ru.call(n),c==B?c=Z:c!=Z&&(f=xe(n))),a||(l=ru.call(t),l==B?l=Z:l!=Z&&xe(t));var s=c==Z,a=l==Z,l=c==l;if(!l||f||s){if(!e&&(c=s&&nu.call(n,"__wrapped__"),a=a&&nu.call(t,"__wrapped__"),c||a)){n=i(c?n.value():n,a?t.value():t,r,e,u,o);
break n}if(l){for(u||(u=[]),o||(o=[]),c=u.length;c--;)if(u[c]==n){n=o[c]==t;break n}u.push(n),o.push(t),n=(f?yr:mr)(n,t,i,r,e,u,o),u.pop(),o.pop()}else n=false}else n=dr(n,t,c)}return n}function mt(n,t,r){var e=t.length,u=e,o=!r;if(null==n)return!u;for(n=Br(n);e--;){var i=t[e];if(o&&i[2]?i[1]!==n[i[0]]:!(i[0]in n))return false}for(;++e<u;){var i=t[e],f=i[0],a=n[f],c=i[1];if(o&&i[2]){if(a===w&&!(f in n))return false}else if(i=r?r(a,c,f):w,i===w?!dt(c,a,r,true):!i)return false}return true}function wt(n,t){var r=-1,e=Er(n)?Be(n.length):[];
return Su(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function bt(n){var t=Ar(n);if(1==t.length&&t[0][2]){var r=t[0][0],e=t[0][1];return function(n){return null==n?false:n[r]===e&&(e!==w||r in Br(n))}}return function(n){return mt(n,t)}}function xt(n,t){var r=Oo(n),e=Wr(n)&&t===t&&!ge(t),u=n+"";return n=Dr(n),function(o){if(null==o)return false;var i=u;if(o=Br(o),!(!r&&e||i in o)){if(o=1==n.length?o:yt(o,Et(n,0,-1)),null==o)return false;i=Zr(n),o=Br(o)}return o[i]===t?t!==w||i in o:dt(t,o[i],w,true)}}function At(n,t,r,e,u){
if(!ge(n))return n;var o=Er(t)&&(Oo(t)||xe(t)),i=o?w:zo(t);return Pn(i||t,function(f,a){if(i&&(a=f,f=t[a]),h(f)){e||(e=[]),u||(u=[]);n:{for(var c=a,l=e,s=u,p=l.length,_=t[c];p--;)if(l[p]==_){n[c]=s[p];break n}var p=n[c],v=r?r(p,_,c,n,t):w,g=v===w;g&&(v=_,Er(_)&&(Oo(_)||xe(_))?v=Oo(p)?p:Er(p)?qn(p):[]:me(_)||pe(_)?v=pe(p)?ke(p):me(p)?p:{}:g=false),l.push(_),s.push(v),g?n[c]=At(v,_,r,l,s):(v===v?v!==p:p===p)&&(n[c]=v)}}else c=n[a],l=r?r(c,f,a,n,t):w,(s=l===w)&&(l=f),l===w&&(!o||a in n)||!s&&(l===l?l===c:c!==c)||(n[a]=l);
}),n}function jt(n){return function(t){return null==t?w:t[n]}}function kt(n){var t=n+"";return n=Dr(n),function(r){return yt(r,n,t)}}function It(n,t){for(var r=n?t.length:0;r--;){var e=t[r];if(e!=u&&Cr(e)){var u=e;pu.call(n,e,1)}}}function Rt(n,t){return n+yu(ku()*(t-n+1))}function Ot(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function Et(n,t,r){var e=-1,u=n.length;for(t=null==t?0:+t||0,0>t&&(t=-t>u?0:u+t),r=r===w||r>u?u:+r||0,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Be(u);++e<u;)r[e]=n[e+t];
return r}function Ct(n,t){var r;return Su(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function Ut(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function Wt(t,r,e){var u=wr(),o=-1;return r=Gn(r,function(n){return u(n)}),t=wt(t,function(n){return{a:Gn(r,function(t){return t(n)}),b:++o,c:n}}),Ut(t,function(t,r){var u;n:{for(var o=-1,i=t.a,f=r.a,a=i.length,c=e.length;++o<a;)if(u=n(i[o],f[o])){if(o>=c)break n;o=e[o],u*="asc"===o||true===o?1:-1;break n}u=t.b-r.b}return u})}function $t(n,t){
var r=0;return Su(n,function(n,e,u){r+=+t(n,e,u)||0}),r}function St(n,t){var e=-1,u=xr(),o=n.length,i=u===r,f=i&&o>=F,a=f&&gu&&lu?new Dn(void 0):null,c=[];a?(u=Mn,i=false):(f=false,a=t?[]:c);n:for(;++e<o;){var l=n[e],s=t?t(l,e,n):l;if(i&&l===l){for(var p=a.length;p--;)if(a[p]===s)continue n;t&&a.push(s),c.push(l)}else 0>u(a,s,0)&&((t||f)&&a.push(s),c.push(l))}return c}function Ft(n,t){for(var r=-1,e=t.length,u=Be(e);++r<e;)u[r]=n[t[r]];return u}function Nt(n,t,r,e){for(var u=n.length,o=e?u:-1;(e?o--:++o<u)&&t(n[o],o,n););
return r?Et(n,e?0:o,e?o+1:u):Et(n,e?o+1:0,e?u:o)}function Tt(n,t){var r=n;r instanceof zn&&(r=r.value());for(var e=-1,u=t.length;++e<u;)var o=t[e],r=o.func.apply(o.thisArg,Jn([r],o.args));return r}function Lt(n,t,r){var e=0,u=n?n.length:e;if(typeof t=="number"&&t===t&&u<=Eu){for(;e<u;){var o=e+u>>>1,i=n[o];(r?i<=t:i<t)&&null!==i?e=o+1:u=o}return u}return zt(n,t,Fe,r)}function zt(n,t,r,e){t=r(t);for(var u=0,o=n?n.length:0,i=t!==t,f=null===t,a=t===w;u<o;){var c=yu((u+o)/2),l=r(n[c]),s=l!==w,p=l===l;
(i?p||e:f?p&&s&&(e||null!=l):a?p&&(e||s):null==l?0:e?l<=t:l<t)?u=c+1:o=c}return xu(o,Ou)}function Bt(n,t,r){if(typeof n!="function")return Fe;if(t===w)return n;switch(r){case 1:return function(r){return n.call(t,r)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,o){return n.call(t,r,e,u,o)};case 5:return function(r,e,u,o,i){return n.call(t,r,e,u,o,i)}}return function(){return n.apply(t,arguments)}}function Dt(n){var t=new ou(n.byteLength);return new hu(t).set(new hu(n)),
t}function Mt(n,t,r){for(var e=r.length,u=-1,o=bu(n.length-e,0),i=-1,f=t.length,a=Be(f+o);++i<f;)a[i]=t[i];for(;++u<e;)a[r[u]]=n[u];for(;o--;)a[i++]=n[u++];return a}function qt(n,t,r){for(var e=-1,u=r.length,o=-1,i=bu(n.length-u,0),f=-1,a=t.length,c=Be(i+a);++o<i;)c[o]=n[o];for(i=o;++f<a;)c[i+f]=t[f];for(;++e<u;)c[i+r[e]]=n[o++];return c}function Pt(n,t){return function(r,e,u){var o=t?t():{};if(e=wr(e,u,3),Oo(r)){u=-1;for(var i=r.length;++u<i;){var f=r[u];n(o,f,e(f,u,r),r)}}else Su(r,function(t,r,u){
n(o,t,e(t,r,u),u)});return o}}function Kt(n){return le(function(t,r){var e=-1,u=null==t?0:r.length,o=2<u?r[u-2]:w,i=2<u?r[2]:w,f=1<u?r[u-1]:w;for(typeof o=="function"?(o=Bt(o,f,5),u-=2):(o=typeof f=="function"?f:w,u-=o?1:0),i&&Ur(r[0],r[1],i)&&(o=3>u?w:o,u=1);++e<u;)(i=r[e])&&n(t,i,o);return t})}function Vt(n,t){return function(r,e){var u=r?Bu(r):0;if(!Sr(u))return n(r,e);for(var o=t?u:-1,i=Br(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}function Zt(n){return function(t,r,e){var u=Br(t);e=e(t);for(var o=e.length,i=n?o:-1;n?i--:++i<o;){
var f=e[i];if(false===r(u[f],f,u))break}return t}}function Yt(n,t){function r(){return(this&&this!==Zn&&this instanceof r?e:n).apply(t,arguments)}var e=Jt(n);return r}function Gt(n){return function(t){var r=-1;t=$e(Ce(t));for(var e=t.length,u="";++r<e;)u=n(u,t[r],r);return u}}function Jt(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:
return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=$u(n.prototype),t=n.apply(r,t);return ge(t)?t:r}}function Xt(n){function t(r,e,u){return u&&Ur(r,e,u)&&(e=w),r=gr(r,n,w,w,w,w,w,e),r.placeholder=t.placeholder,r}return t}function Ht(n,t){return le(function(r){var e=r[0];return null==e?e:(r.push(t),n.apply(w,r))})}function Qt(n,t){return function(r,e,u){if(u&&Ur(r,e,u)&&(e=w),e=wr(e,u,3),1==e.length){
u=r=Oo(r)?r:zr(r);for(var o=e,i=-1,f=u.length,a=t,c=a;++i<f;){var l=u[i],s=+o(l);n(s,a)&&(a=s,c=l)}if(u=c,!r.length||u!==t)return u}return ct(r,e,n,t)}}function nr(n,r){return function(e,u,o){return u=wr(u,o,3),Oo(e)?(u=t(e,u,r),-1<u?e[u]:w):st(e,u,n)}}function tr(n){return function(r,e,u){return r&&r.length?(e=wr(e,u,3),t(r,e,n)):-1}}function rr(n){return function(t,r,e){return r=wr(r,e,3),st(t,r,n,true)}}function er(n){return function(){for(var t,r=arguments.length,e=n?r:-1,u=0,o=Be(r);n?e--:++e<r;){
var i=o[u++]=arguments[e];if(typeof i!="function")throw new Ge(L);!t&&Ln.prototype.thru&&"wrapper"==br(i)&&(t=new Ln([],true))}for(e=t?-1:r;++e<r;){var i=o[e],u=br(i),f="wrapper"==u?zu(i):w;t=f&&$r(f[0])&&f[1]==(E|k|R|C)&&!f[4].length&&1==f[9]?t[br(f[0])].apply(t,f[3]):1==i.length&&$r(i)?t[u]():t.thru(i)}return function(){var n=arguments,e=n[0];if(t&&1==n.length&&Oo(e)&&e.length>=F)return t.plant(e).value();for(var u=0,n=r?o[u].apply(this,n):e;++u<r;)n=o[u].call(this,n);return n}}}function ur(n,t){
return function(r,e,u){return typeof e=="function"&&u===w&&Oo(r)?n(r,e):t(r,Bt(e,u,3))}}function or(n){return function(t,r,e){return(typeof r!="function"||e!==w)&&(r=Bt(r,e,3)),n(t,r,Re)}}function ir(n){return function(t,r,e){return(typeof r!="function"||e!==w)&&(r=Bt(r,e,3)),n(t,r)}}function fr(n){return function(t,r,e){var u={};return r=wr(r,e,3),_t(t,function(t,e,o){o=r(t,e,o),e=n?o:e,t=n?t:o,u[e]=t}),u}}function ar(n){return function(t,r,e){return t=u(t),(n?t:"")+pr(t,r,e)+(n?"":t)}}function cr(n){
var t=le(function(r,e){var u=v(e,t.placeholder);return gr(r,n,w,e,u)});return t}function lr(n,t){return function(r,e,u,o){var i=3>arguments.length;return typeof e=="function"&&o===w&&Oo(r)?n(r,e,u,i):Ot(r,wr(e,o,4),u,i,t)}}function sr(n,t,r,e,u,o,i,f,a,c){function l(){for(var m=arguments.length,b=m,j=Be(m);b--;)j[b]=arguments[b];if(e&&(j=Mt(j,e,u)),o&&(j=qt(j,o,i)),_||y){var b=l.placeholder,k=v(j,b),m=m-k.length;if(m<c){var I=f?qn(f):w,m=bu(c-m,0),E=_?k:w,k=_?w:k,C=_?j:w,j=_?w:j;return t|=_?R:O,t&=~(_?O:R),
g||(t&=~(x|A)),j=[n,t,r,C,E,j,k,I,a,m],I=sr.apply(w,j),$r(n)&&Du(I,j),I.placeholder=b,I}}if(b=p?r:this,I=h?b[n]:n,f)for(m=j.length,E=xu(f.length,m),k=qn(j);E--;)C=f[E],j[E]=Cr(C,m)?k[C]:w;return s&&a<j.length&&(j.length=a),this&&this!==Zn&&this instanceof l&&(I=d||Jt(n)),I.apply(b,j)}var s=t&E,p=t&x,h=t&A,_=t&k,g=t&j,y=t&I,d=h?w:Jt(n);return l}function pr(n,t,r){return n=n.length,t=+t,n<t&&mu(t)?(t-=n,r=null==r?" ":r+"",Ue(r,vu(t/r.length)).slice(0,t)):""}function hr(n,t,r,e){function u(){for(var t=-1,f=arguments.length,a=-1,c=e.length,l=Be(c+f);++a<c;)l[a]=e[a];
for(;f--;)l[a++]=arguments[++t];return(this&&this!==Zn&&this instanceof u?i:n).apply(o?r:this,l)}var o=t&x,i=Jt(n);return u}function _r(n){var t=Pe[n];return function(n,r){return(r=r===w?0:+r||0)?(r=au(10,r),t(n*r)/r):t(n)}}function vr(n){return function(t,r,e,u){var o=wr(e);return null==e&&o===ut?Lt(t,r,n):zt(t,r,o(e,u,1),n)}}function gr(n,t,r,e,u,o,i,f){var a=t&A;if(!a&&typeof n!="function")throw new Ge(L);var c=e?e.length:0;if(c||(t&=~(R|O),e=u=w),c-=u?u.length:0,t&O){var l=e,s=u;e=u=w}var p=a?w:zu(n);
return r=[n,t,r,e,u,l,s,o,i,f],p&&(e=r[1],t=p[1],f=e|t,u=t==E&&e==k||t==E&&e==C&&r[7].length<=p[8]||t==(E|C)&&e==k,(f<E||u)&&(t&x&&(r[2]=p[2],f|=e&x?0:j),(e=p[3])&&(u=r[3],r[3]=u?Mt(u,e,p[4]):qn(e),r[4]=u?v(r[3],z):qn(p[4])),(e=p[5])&&(u=r[5],r[5]=u?qt(u,e,p[6]):qn(e),r[6]=u?v(r[5],z):qn(p[6])),(e=p[7])&&(r[7]=qn(e)),t&E&&(r[8]=null==r[8]?p[8]:xu(r[8],p[8])),null==r[9]&&(r[9]=p[9]),r[0]=p[0],r[1]=f),t=r[1],f=r[9]),r[9]=null==f?a?0:n.length:bu(f-c,0)||0,(p?Lu:Du)(t==x?Yt(r[0],r[2]):t!=R&&t!=(x|R)||r[4].length?sr.apply(w,r):hr.apply(w,r),r);
}function yr(n,t,r,e,u,o,i){var f=-1,a=n.length,c=t.length;if(a!=c&&(!u||c<=a))return false;for(;++f<a;){var l=n[f],c=t[f],s=e?e(u?c:l,u?l:c,f):w;if(s!==w){if(s)continue;return false}if(u){if(!Hn(t,function(n){return l===n||r(l,n,e,u,o,i)}))return false}else if(l!==c&&!r(l,c,e,u,o,i))return false}return true}function dr(n,t,r){switch(r){case M:case q:return+n==+t;case P:return n.name==t.name&&n.message==t.message;case V:return n!=+n?t!=+t:n==+t;case Y:case G:return n==t+""}return false}function mr(n,t,r,e,u,o,i){var f=zo(n),a=f.length,c=zo(t).length;
if(a!=c&&!u)return false;for(c=a;c--;){var l=f[c];if(!(u?l in t:nu.call(t,l)))return false}for(var s=u;++c<a;){var l=f[c],p=n[l],h=t[l],_=e?e(u?h:p,u?p:h,l):w;if(_===w?!r(p,h,e,u,o,i):!_)return false;s||(s="constructor"==l)}return s||(r=n.constructor,e=t.constructor,!(r!=e&&"constructor"in n&&"constructor"in t)||typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)?true:false}function wr(n,t,r){var e=Nn.callback||Se,e=e===Se?ut:e;return r?e(n,t,r):e}function br(n){for(var t=n.name+"",r=Wu[t],e=r?r.length:0;e--;){
var u=r[e],o=u.func;if(null==o||o==n)return u.name}return t}function xr(n,t,e){var u=Nn.indexOf||Vr,u=u===Vr?r:u;return n?u(n,t,e):u}function Ar(n){n=Oe(n);for(var t=n.length;t--;){var r=n[t][1];n[t][2]=r===r&&!ge(r)}return n}function jr(n,t){var r=null==n?w:n[t];return ye(r)?r:w}function kr(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&nu.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ir(n){return n=n.constructor,typeof n=="function"&&n instanceof n||(n=Ve),
new n}function Rr(n,t,r){var e=n.constructor;switch(t){case J:return Dt(n);case M:case q:return new e(+n);case X:case H:case Q:case nn:case tn:case rn:case en:case un:case on:return t=n.buffer,new e(r?Dt(t):t,n.byteOffset,n.length);case V:case G:return new e(n);case Y:var u=new e(n.source,kn.exec(n));u.lastIndex=n.lastIndex}return u}function Or(n,t,r){return null==n||Wr(t,n)||(t=Dr(t),n=1==t.length?n:yt(n,Et(t,0,-1)),t=Zr(t)),t=null==n?n:n[t],null==t?w:t.apply(n,r)}function Er(n){return null!=n&&Sr(Bu(n));
}function Cr(n,t){return n=typeof n=="number"||On.test(n)?+n:-1,t=null==t?Cu:t,-1<n&&0==n%1&&n<t}function Ur(n,t,r){if(!ge(r))return false;var e=typeof t;return("number"==e?Er(r)&&Cr(t,r.length):"string"==e&&t in r)?(t=r[t],n===n?n===t:t!==t):false}function Wr(n,t){var r=typeof n;return"string"==r&&dn.test(n)||"number"==r?true:Oo(n)?false:!yn.test(n)||null!=t&&n in Br(t)}function $r(n){var t=br(n),r=Nn[t];return typeof r=="function"&&t in zn.prototype?n===r?true:(t=zu(r),!!t&&n===t[0]):false}function Sr(n){return typeof n=="number"&&-1<n&&0==n%1&&n<=Cu;
}function Fr(n,t){return n===w?t:Eo(n,t,Fr)}function Nr(n,t){n=Br(n);for(var r=-1,e=t.length,u={};++r<e;){var o=t[r];o in n&&(u[o]=n[o])}return u}function Tr(n,t){var r={};return ht(n,function(n,e,u){t(n,e,u)&&(r[e]=n)}),r}function Lr(n){for(var t=Re(n),r=t.length,e=r&&n.length,u=!!e&&Sr(e)&&(Oo(n)||pe(n)),o=-1,i=[];++o<r;){var f=t[o];(u&&Cr(f,e)||nu.call(n,f))&&i.push(f)}return i}function zr(n){return null==n?[]:Er(n)?ge(n)?n:Ve(n):Ee(n)}function Br(n){return ge(n)?n:Ve(n)}function Dr(n){if(Oo(n))return n;
var t=[];return u(n).replace(mn,function(n,r,e,u){t.push(e?u.replace(An,"$1"):r||n)}),t}function Mr(n){return n instanceof zn?n.clone():new Ln(n.__wrapped__,n.__chain__,qn(n.__actions__))}function qr(n,t,r){return n&&n.length?((r?Ur(n,t,r):null==t)&&(t=1),Et(n,0>t?0:t)):[]}function Pr(n,t,r){var e=n?n.length:0;return e?((r?Ur(n,t,r):null==t)&&(t=1),t=e-(+t||0),Et(n,0,0>t?0:t)):[]}function Kr(n){return n?n[0]:w}function Vr(n,t,e){var u=n?n.length:0;if(!u)return-1;if(typeof e=="number")e=0>e?bu(u+e,0):e;else if(e)return e=Lt(n,t),
e<u&&(t===t?t===n[e]:n[e]!==n[e])?e:-1;return r(n,t,e||0)}function Zr(n){var t=n?n.length:0;return t?n[t-1]:w}function Yr(n){return qr(n,1)}function Gr(n,t,e,u){if(!n||!n.length)return[];null!=t&&typeof t!="boolean"&&(u=e,e=Ur(n,t,u)?w:t,t=false);var o=wr();if((null!=e||o!==ut)&&(e=o(e,u,3)),t&&xr()===r){t=e;var i;e=-1,u=n.length;for(var o=-1,f=[];++e<u;){var a=n[e],c=t?t(a,e,n):a;e&&i===c||(i=c,f[++o]=a)}n=f}else n=St(n,e);return n}function Jr(n){if(!n||!n.length)return[];var t=-1,r=0;n=Vn(n,function(n){
return Er(n)?(r=bu(n.length,r),true):void 0});for(var e=Be(r);++t<r;)e[t]=Gn(n,jt(t));return e}function Xr(n,t,r){return n&&n.length?(n=Jr(n),null==t?n:(t=Bt(t,r,4),Gn(n,function(n){return Xn(n,t,w,true)}))):[]}function Hr(n,t){var r=-1,e=n?n.length:0,u={};for(!e||t||Oo(n[0])||(t=[]);++r<e;){var o=n[r];t?u[o]=t[r]:o&&(u[o[0]]=o[1])}return u}function Qr(n){return n=Nn(n),n.__chain__=true,n}function ne(n,t,r){return t.call(r,n)}function te(n,t,r){var e=Oo(n)?Kn:at;return r&&Ur(n,t,r)&&(t=w),(typeof t!="function"||r!==w)&&(t=wr(t,r,3)),
e(n,t)}function re(n,t,r){var e=Oo(n)?Vn:lt;return t=wr(t,r,3),e(n,t)}function ee(n,t,r,e){var u=n?Bu(n):0;return Sr(u)||(n=Ee(n),u=n.length),r=typeof r!="number"||e&&Ur(t,r,e)?0:0>r?bu(u+r,0):r||0,typeof n=="string"||!Oo(n)&&be(n)?r<=u&&-1<n.indexOf(t,r):!!u&&-1<xr(n,t,r)}function ue(n,t,r){var e=Oo(n)?Gn:wt;return t=wr(t,r,3),e(n,t)}function oe(n,t,r){if(r?Ur(n,t,r):null==t){n=zr(n);var e=n.length;return 0<e?n[Rt(0,e-1)]:w}r=-1,n=je(n);var e=n.length,u=e-1;for(t=xu(0>t?0:+t||0,e);++r<t;){var e=Rt(r,u),o=n[e];
n[e]=n[r],n[r]=o}return n.length=t,n}function ie(n,t,r){var e=Oo(n)?Hn:Ct;return r&&Ur(n,t,r)&&(t=w),(typeof t!="function"||r!==w)&&(t=wr(t,r,3)),e(n,t)}function fe(n,t){var r;if(typeof t!="function"){if(typeof n!="function")throw new Ge(L);var e=n;n=t,t=e}return function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=w),r}}function ae(n,t,r){function e(t,r){r&&iu(r),a=p=h=w,t&&(_=ho(),c=n.apply(s,f),p||a||(f=s=w))}function u(){var n=t-(ho()-l);0>=n||n>t?e(h,a):p=su(u,n)}function o(){e(g,p);
}function i(){if(f=arguments,l=ho(),s=this,h=g&&(p||!y),false===v)var r=y&&!p;else{a||y||(_=l);var e=v-(l-_),i=0>=e||e>v;i?(a&&(a=iu(a)),_=l,c=n.apply(s,f)):a||(a=su(o,e))}return i&&p?p=iu(p):p||t===v||(p=su(u,t)),r&&(i=true,c=n.apply(s,f)),!i||p||a||(f=s=w),c}var f,a,c,l,s,p,h,_=0,v=false,g=true;if(typeof n!="function")throw new Ge(L);if(t=0>t?0:+t||0,true===r)var y=true,g=false;else ge(r)&&(y=!!r.leading,v="maxWait"in r&&bu(+r.maxWait||0,t),g="trailing"in r?!!r.trailing:g);return i.cancel=function(){p&&iu(p),a&&iu(a),
_=0,a=p=h=w},i}function ce(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],o=r.cache;return o.has(u)?o.get(u):(e=n.apply(this,e),r.cache=o.set(u,e),e)}if(typeof n!="function"||t&&typeof t!="function")throw new Ge(L);return r.cache=new ce.Cache,r}function le(n,t){if(typeof n!="function")throw new Ge(L);return t=bu(t===w?n.length-1:+t||0,0),function(){for(var r=arguments,e=-1,u=bu(r.length-t,0),o=Be(u);++e<u;)o[e]=r[t+e];switch(t){case 0:return n.call(this,o);case 1:return n.call(this,r[0],o);
case 2:return n.call(this,r[0],r[1],o)}for(u=Be(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function se(n,t){return n>t}function pe(n){return h(n)&&Er(n)&&nu.call(n,"callee")&&!cu.call(n,"callee")}function he(n,t,r,e){return e=(r=typeof r=="function"?Bt(r,e,3):w)?r(n,t):w,e===w?dt(n,t,r):!!e}function _e(n){return h(n)&&typeof n.message=="string"&&ru.call(n)==P}function ve(n){return ge(n)&&ru.call(n)==K}function ge(n){var t=typeof n;return!!n&&("object"==t||"function"==t)}function ye(n){
return null==n?false:ve(n)?uu.test(Qe.call(n)):h(n)&&Rn.test(n)}function de(n){return typeof n=="number"||h(n)&&ru.call(n)==V}function me(n){var t;if(!h(n)||ru.call(n)!=Z||pe(n)||!(nu.call(n,"constructor")||(t=n.constructor,typeof t!="function"||t instanceof t)))return false;var r;return ht(n,function(n,t){r=t}),r===w||nu.call(n,r)}function we(n){return ge(n)&&ru.call(n)==Y}function be(n){return typeof n=="string"||h(n)&&ru.call(n)==G}function xe(n){return h(n)&&Sr(n.length)&&!!Sn[ru.call(n)]}function Ae(n,t){
return n<t}function je(n){var t=n?Bu(n):0;return Sr(t)?t?qn(n):[]:Ee(n)}function ke(n){return et(n,Re(n))}function Ie(n){return gt(n,Re(n))}function Re(n){if(null==n)return[];ge(n)||(n=Ve(n));for(var t=n.length,t=t&&Sr(t)&&(Oo(n)||pe(n))&&t||0,r=n.constructor,e=-1,r=typeof r=="function"&&r.prototype===n,u=Be(t),o=0<t;++e<t;)u[e]=e+"";for(var i in n)o&&Cr(i,t)||"constructor"==i&&(r||!nu.call(n,i))||u.push(i);return u}function Oe(n){n=Br(n);for(var t=-1,r=zo(n),e=r.length,u=Be(e);++t<e;){var o=r[t];
u[t]=[o,n[o]]}return u}function Ee(n){return Ft(n,zo(n))}function Ce(n){return(n=u(n))&&n.replace(En,a).replace(xn,"")}function Ue(n,t){var r="";if(n=u(n),t=+t,1>t||!n||!mu(t))return r;do t%2&&(r+=n),t=yu(t/2),n+=n;while(t);return r}function We(n,t,r){var e=n;return(n=u(n))?(r?Ur(e,t,r):null==t)?n.slice(g(n),y(n)+1):(t+="",n.slice(o(n,t),i(n,t)+1)):n}function $e(n,t,r){return r&&Ur(n,t,r)&&(t=w),n=u(n),n.match(t||Wn)||[]}function Se(n,t,r){return r&&Ur(n,t,r)&&(t=w),h(n)?Ne(n):ut(n,t)}function Fe(n){
return n}function Ne(n){return bt(ot(n,true))}function Te(n,t,r){if(null==r){var e=ge(t),u=e?zo(t):w;((u=u&&u.length?gt(t,u):w)?u.length:e)||(u=false,r=t,t=n,n=this)}u||(u=gt(t,zo(t)));var o=true,e=-1,i=ve(n),f=u.length;false===r?o=false:ge(r)&&"chain"in r&&(o=r.chain);for(;++e<f;){r=u[e];var a=t[r];n[r]=a,i&&(n.prototype[r]=function(t){return function(){var r=this.__chain__;if(o||r){var e=n(this.__wrapped__);return(e.__actions__=qn(this.__actions__)).push({func:t,args:arguments,thisArg:n}),e.__chain__=r,e}return t.apply(n,Jn([this.value()],arguments));
}}(a))}return n}function Le(){}function ze(n){return Wr(n)?jt(n):kt(n)}_=_?Yn.defaults(Zn.Object(),_,Yn.pick(Zn,$n)):Zn;var Be=_.Array,De=_.Date,Me=_.Error,qe=_.Function,Pe=_.Math,Ke=_.Number,Ve=_.Object,Ze=_.RegExp,Ye=_.String,Ge=_.TypeError,Je=Be.prototype,Xe=Ve.prototype,He=Ye.prototype,Qe=qe.prototype.toString,nu=Xe.hasOwnProperty,tu=0,ru=Xe.toString,eu=Zn._,uu=Ze("^"+Qe.call(nu).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),ou=_.ArrayBuffer,iu=_.clearTimeout,fu=_.parseFloat,au=Pe.pow,cu=Xe.propertyIsEnumerable,lu=jr(_,"Set"),su=_.setTimeout,pu=Je.splice,hu=_.Uint8Array,_u=jr(_,"WeakMap"),vu=Pe.ceil,gu=jr(Ve,"create"),yu=Pe.floor,du=jr(Be,"isArray"),mu=_.isFinite,wu=jr(Ve,"keys"),bu=Pe.max,xu=Pe.min,Au=jr(De,"now"),ju=_.parseInt,ku=Pe.random,Iu=Ke.NEGATIVE_INFINITY,Ru=Ke.POSITIVE_INFINITY,Ou=4294967294,Eu=2147483647,Cu=9007199254740991,Uu=_u&&new _u,Wu={};
Nn.support={},Nn.templateSettings={escape:_n,evaluate:vn,interpolate:gn,variable:"",imports:{_:Nn}};var $u=function(){function n(){}return function(t){if(ge(t)){n.prototype=t;var r=new n;n.prototype=w}return r||{}}}(),Su=Vt(_t),Fu=Vt(vt,true),Nu=Zt(),Tu=Zt(true),Lu=Uu?function(n,t){return Uu.set(n,t),n}:Fe,zu=Uu?function(n){return Uu.get(n)}:Le,Bu=jt("length"),Du=function(){var n=0,t=0;return function(r,e){var u=ho(),o=S-(u-t);if(t=u,0<o){if(++n>=$)return r}else n=0;return Lu(r,e)}}(),Mu=le(function(n,t){
return h(n)&&Er(n)?ft(n,pt(t,false,true)):[]}),qu=tr(),Pu=tr(true),Ku=le(function(n){for(var t=n.length,e=t,u=Be(l),o=xr(),i=o===r,f=[];e--;){var a=n[e]=Er(a=n[e])?a:[];u[e]=i&&120<=a.length&&gu&&lu?new Dn(e&&a):null}var i=n[0],c=-1,l=i?i.length:0,s=u[0];n:for(;++c<l;)if(a=i[c],0>(s?Mn(s,a):o(f,a,0))){for(e=t;--e;){var p=u[e];if(0>(p?Mn(p,a):o(n[e],a,0)))continue n}s&&s.push(a),f.push(a)}return f}),Vu=le(function(t,r){r=pt(r);var e=rt(t,r);return It(t,r.sort(n)),e}),Zu=vr(),Yu=vr(true),Gu=le(function(n){return St(pt(n,false,true));
}),Ju=le(function(n,t){return Er(n)?ft(n,t):[]}),Xu=le(Jr),Hu=le(function(n){var t=n.length,r=2<t?n[t-2]:w,e=1<t?n[t-1]:w;return 2<t&&typeof r=="function"?t-=2:(r=1<t&&typeof e=="function"?(--t,e):w,e=w),n.length=t,Xr(n,r,e)}),Qu=le(function(n){return n=pt(n),this.thru(function(t){t=Oo(t)?t:[Br(t)];for(var r=n,e=-1,u=t.length,o=-1,i=r.length,f=Be(u+i);++e<u;)f[e]=t[e];for(;++o<i;)f[e++]=r[o];return f})}),no=le(function(n,t){return rt(n,pt(t))}),to=Pt(function(n,t,r){nu.call(n,r)?++n[r]:n[r]=1}),ro=nr(Su),eo=nr(Fu,true),uo=ur(Pn,Su),oo=ur(function(n,t){
for(var r=n.length;r--&&false!==t(n[r],r,n););return n},Fu),io=Pt(function(n,t,r){nu.call(n,r)?n[r].push(t):n[r]=[t]}),fo=Pt(function(n,t,r){n[r]=t}),ao=le(function(n,t,r){var e=-1,u=typeof t=="function",o=Wr(t),i=Er(n)?Be(n.length):[];return Su(n,function(n){var f=u?t:o&&null!=n?n[t]:w;i[++e]=f?f.apply(n,r):Or(n,t,r)}),i}),co=Pt(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),lo=lr(Xn,Su),so=lr(function(n,t,r,e){var u=n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r},Fu),po=le(function(n,t){
if(null==n)return[];var r=t[2];return r&&Ur(t[0],t[1],r)&&(t.length=1),Wt(n,pt(t),[])}),ho=Au||function(){return(new De).getTime()},_o=le(function(n,t,r){var e=x;if(r.length)var u=v(r,_o.placeholder),e=e|R;return gr(n,e,t,r,u)}),vo=le(function(n,t){t=t.length?pt(t):Ie(n);for(var r=-1,e=t.length;++r<e;){var u=t[r];n[u]=gr(n[u],x,n)}return n}),go=le(function(n,t,r){var e=x|A;if(r.length)var u=v(r,go.placeholder),e=e|R;return gr(t,e,n,r,u)}),yo=Xt(k),mo=Xt(I),wo=le(function(n,t){return it(n,1,t)}),bo=le(function(n,t,r){
return it(n,t,r)}),xo=er(),Ao=er(true),jo=le(function(n,t){if(t=pt(t),typeof n!="function"||!Kn(t,e))throw new Ge(L);var r=t.length;return le(function(e){for(var u=xu(e.length,r);u--;)e[u]=t[u](e[u]);return n.apply(this,e)})}),ko=cr(R),Io=cr(O),Ro=le(function(n,t){return gr(n,C,w,w,w,pt(t))}),Oo=du||function(n){return h(n)&&Sr(n.length)&&ru.call(n)==D},Eo=Kt(At),Co=Kt(function(n,t,r){return r?nt(n,t,r):tt(n,t)}),Uo=Ht(Co,function(n,t){return n===w?t:n}),Wo=Ht(Eo,Fr),$o=rr(_t),So=rr(vt),Fo=or(Nu),No=or(Tu),To=ir(_t),Lo=ir(vt),zo=wu?function(n){
var t=null==n?w:n.constructor;return typeof t=="function"&&t.prototype===n||typeof n!="function"&&Er(n)?Lr(n):ge(n)?wu(n):[]}:Lr,Bo=fr(true),Do=fr(),Mo=le(function(n,t){if(null==n)return{};if("function"!=typeof t[0])return t=Gn(pt(t),Ye),Nr(n,ft(Re(n),t));var r=Bt(t[0],t[1],3);return Tr(n,function(n,t,e){return!r(n,t,e)})}),qo=le(function(n,t){return null==n?{}:"function"==typeof t[0]?Tr(n,Bt(t[0],t[1],3)):Nr(n,pt(t))}),Po=Gt(function(n,t,r){return t=t.toLowerCase(),n+(r?t.charAt(0).toUpperCase()+t.slice(1):t);
}),Ko=Gt(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Vo=ar(),Zo=ar(true),Yo=Gt(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Go=Gt(function(n,t,r){return n+(r?" ":"")+(t.charAt(0).toUpperCase()+t.slice(1))}),Jo=le(function(n,t){try{return n.apply(w,t)}catch(r){return _e(r)?r:new Me(r)}}),Xo=le(function(n,t){return function(r){return Or(r,n,t)}}),Ho=le(function(n,t){return function(r){return Or(n,r,t)}}),Qo=_r("ceil"),ni=_r("floor"),ti=Qt(se,Iu),ri=Qt(Ae,Ru),ei=_r("round");return Nn.prototype=Tn.prototype,
Ln.prototype=$u(Tn.prototype),Ln.prototype.constructor=Ln,zn.prototype=$u(Tn.prototype),zn.prototype.constructor=zn,Bn.prototype["delete"]=function(n){return this.has(n)&&delete this.__data__[n]},Bn.prototype.get=function(n){return"__proto__"==n?w:this.__data__[n]},Bn.prototype.has=function(n){return"__proto__"!=n&&nu.call(this.__data__,n)},Bn.prototype.set=function(n,t){return"__proto__"!=n&&(this.__data__[n]=t),this},Dn.prototype.push=function(n){var t=this.data;typeof n=="string"||ge(n)?t.set.add(n):t.hash[n]=true;
},ce.Cache=Bn,Nn.after=function(n,t){if(typeof t!="function"){if(typeof n!="function")throw new Ge(L);var r=n;n=t,t=r}return n=mu(n=+n)?n:0,function(){return 1>--n?t.apply(this,arguments):void 0}},Nn.ary=function(n,t,r){return r&&Ur(n,t,r)&&(t=w),t=n&&null==t?n.length:bu(+t||0,0),gr(n,E,w,w,w,w,t)},Nn.assign=Co,Nn.at=no,Nn.before=fe,Nn.bind=_o,Nn.bindAll=vo,Nn.bindKey=go,Nn.callback=Se,Nn.chain=Qr,Nn.chunk=function(n,t,r){t=(r?Ur(n,t,r):null==t)?1:bu(yu(t)||1,1),r=0;for(var e=n?n.length:0,u=-1,o=Be(vu(e/t));r<e;)o[++u]=Et(n,r,r+=t);
return o},Nn.compact=function(n){for(var t=-1,r=n?n.length:0,e=-1,u=[];++t<r;){var o=n[t];o&&(u[++e]=o)}return u},Nn.constant=function(n){return function(){return n}},Nn.countBy=to,Nn.create=function(n,t,r){var e=$u(n);return r&&Ur(n,t,r)&&(t=w),t?tt(e,t):e},Nn.curry=yo,Nn.curryRight=mo,Nn.debounce=ae,Nn.defaults=Uo,Nn.defaultsDeep=Wo,Nn.defer=wo,Nn.delay=bo,Nn.difference=Mu,Nn.drop=qr,Nn.dropRight=Pr,Nn.dropRightWhile=function(n,t,r){return n&&n.length?Nt(n,wr(t,r,3),true,true):[]},Nn.dropWhile=function(n,t,r){
return n&&n.length?Nt(n,wr(t,r,3),true):[]},Nn.fill=function(n,t,r,e){var u=n?n.length:0;if(!u)return[];for(r&&typeof r!="number"&&Ur(n,t,r)&&(r=0,e=u),u=n.length,r=null==r?0:+r||0,0>r&&(r=-r>u?0:u+r),e=e===w||e>u?u:+e||0,0>e&&(e+=u),u=r>e?0:e>>>0,r>>>=0;r<u;)n[r++]=t;return n},Nn.filter=re,Nn.flatten=function(n,t,r){var e=n?n.length:0;return r&&Ur(n,t,r)&&(t=false),e?pt(n,t):[]},Nn.flattenDeep=function(n){return n&&n.length?pt(n,true):[]},Nn.flow=xo,Nn.flowRight=Ao,Nn.forEach=uo,Nn.forEachRight=oo,Nn.forIn=Fo,
Nn.forInRight=No,Nn.forOwn=To,Nn.forOwnRight=Lo,Nn.functions=Ie,Nn.groupBy=io,Nn.indexBy=fo,Nn.initial=function(n){return Pr(n,1)},Nn.intersection=Ku,Nn.invert=function(n,t,r){r&&Ur(n,t,r)&&(t=w),r=-1;for(var e=zo(n),u=e.length,o={};++r<u;){var i=e[r],f=n[i];t?nu.call(o,f)?o[f].push(i):o[f]=[i]:o[f]=i}return o},Nn.invoke=ao,Nn.keys=zo,Nn.keysIn=Re,Nn.map=ue,Nn.mapKeys=Bo,Nn.mapValues=Do,Nn.matches=Ne,Nn.matchesProperty=function(n,t){return xt(n,ot(t,true))},Nn.memoize=ce,Nn.merge=Eo,Nn.method=Xo,Nn.methodOf=Ho,
Nn.mixin=Te,Nn.modArgs=jo,Nn.negate=function(n){if(typeof n!="function")throw new Ge(L);return function(){return!n.apply(this,arguments)}},Nn.omit=Mo,Nn.once=function(n){return fe(2,n)},Nn.pairs=Oe,Nn.partial=ko,Nn.partialRight=Io,Nn.partition=co,Nn.pick=qo,Nn.pluck=function(n,t){return ue(n,ze(t))},Nn.property=ze,Nn.propertyOf=function(n){return function(t){return yt(n,Dr(t),t+"")}},Nn.pull=function(){var n=arguments,t=n[0];if(!t||!t.length)return t;for(var r=0,e=xr(),u=n.length;++r<u;)for(var o=0,i=n[r];-1<(o=e(t,i,o));)pu.call(t,o,1);
return t},Nn.pullAt=Vu,Nn.range=function(n,t,r){r&&Ur(n,t,r)&&(t=r=w),n=+n||0,r=null==r?1:+r||0,null==t?(t=n,n=0):t=+t||0;var e=-1;t=bu(vu((t-n)/(r||1)),0);for(var u=Be(t);++e<t;)u[e]=n,n+=r;return u},Nn.rearg=Ro,Nn.reject=function(n,t,r){var e=Oo(n)?Vn:lt;return t=wr(t,r,3),e(n,function(n,r,e){return!t(n,r,e)})},Nn.remove=function(n,t,r){var e=[];if(!n||!n.length)return e;var u=-1,o=[],i=n.length;for(t=wr(t,r,3);++u<i;)r=n[u],t(r,u,n)&&(e.push(r),o.push(u));return It(n,o),e},Nn.rest=Yr,Nn.restParam=le,
Nn.set=function(n,t,r){if(null==n)return n;var e=t+"";t=null!=n[e]||Wr(t,n)?[e]:Dr(t);for(var e=-1,u=t.length,o=u-1,i=n;null!=i&&++e<u;){var f=t[e];ge(i)&&(e==o?i[f]=r:null==i[f]&&(i[f]=Cr(t[e+1])?[]:{})),i=i[f]}return n},Nn.shuffle=function(n){return oe(n,Ru)},Nn.slice=function(n,t,r){var e=n?n.length:0;return e?(r&&typeof r!="number"&&Ur(n,t,r)&&(t=0,r=e),Et(n,t,r)):[]},Nn.sortBy=function(n,t,r){if(null==n)return[];r&&Ur(n,t,r)&&(t=w);var e=-1;return t=wr(t,r,3),n=wt(n,function(n,r,u){return{a:t(n,r,u),
b:++e,c:n}}),Ut(n,f)},Nn.sortByAll=po,Nn.sortByOrder=function(n,t,r,e){return null==n?[]:(e&&Ur(t,r,e)&&(r=w),Oo(t)||(t=null==t?[]:[t]),Oo(r)||(r=null==r?[]:[r]),Wt(n,t,r))},Nn.spread=function(n){if(typeof n!="function")throw new Ge(L);return function(t){return n.apply(this,t)}},Nn.take=function(n,t,r){return n&&n.length?((r?Ur(n,t,r):null==t)&&(t=1),Et(n,0,0>t?0:t)):[]},Nn.takeRight=function(n,t,r){var e=n?n.length:0;return e?((r?Ur(n,t,r):null==t)&&(t=1),t=e-(+t||0),Et(n,0>t?0:t)):[]},Nn.takeRightWhile=function(n,t,r){
return n&&n.length?Nt(n,wr(t,r,3),false,true):[]},Nn.takeWhile=function(n,t,r){return n&&n.length?Nt(n,wr(t,r,3)):[]},Nn.tap=function(n,t,r){return t.call(r,n),n},Nn.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new Ge(L);return false===r?e=false:ge(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),ae(n,t,{leading:e,maxWait:+t,trailing:u})},Nn.thru=ne,Nn.times=function(n,t,r){if(n=yu(n),1>n||!mu(n))return[];var e=-1,u=Be(xu(n,4294967295));for(t=Bt(t,r,1);++e<n;)4294967295>e?u[e]=t(e):t(e);
return u},Nn.toArray=je,Nn.toPlainObject=ke,Nn.transform=function(n,t,r,e){var u=Oo(n)||xe(n);return t=wr(t,e,4),null==r&&(u||ge(n)?(e=n.constructor,r=u?Oo(n)?new e:[]:$u(ve(e)?e.prototype:w)):r={}),(u?Pn:_t)(n,function(n,e,u){return t(r,n,e,u)}),r},Nn.union=Gu,Nn.uniq=Gr,Nn.unzip=Jr,Nn.unzipWith=Xr,Nn.values=Ee,Nn.valuesIn=function(n){return Ft(n,Re(n))},Nn.where=function(n,t){return re(n,bt(t))},Nn.without=Ju,Nn.wrap=function(n,t){return t=null==t?Fe:t,gr(t,R,w,[n],[])},Nn.xor=function(){for(var n=-1,t=arguments.length;++n<t;){
var r=arguments[n];if(Er(r))var e=e?Jn(ft(e,r),ft(r,e)):r}return e?St(e):[]},Nn.zip=Xu,Nn.zipObject=Hr,Nn.zipWith=Hu,Nn.backflow=Ao,Nn.collect=ue,Nn.compose=Ao,Nn.each=uo,Nn.eachRight=oo,Nn.extend=Co,Nn.iteratee=Se,Nn.methods=Ie,Nn.object=Hr,Nn.select=re,Nn.tail=Yr,Nn.unique=Gr,Te(Nn,Nn),Nn.add=function(n,t){return(+n||0)+(+t||0)},Nn.attempt=Jo,Nn.camelCase=Po,Nn.capitalize=function(n){return(n=u(n))&&n.charAt(0).toUpperCase()+n.slice(1)},Nn.ceil=Qo,Nn.clone=function(n,t,r,e){return t&&typeof t!="boolean"&&Ur(n,t,r)?t=false:typeof t=="function"&&(e=r,
r=t,t=false),typeof r=="function"?ot(n,t,Bt(r,e,3)):ot(n,t)},Nn.cloneDeep=function(n,t,r){return typeof t=="function"?ot(n,true,Bt(t,r,3)):ot(n,true)},Nn.deburr=Ce,Nn.endsWith=function(n,t,r){n=u(n),t+="";var e=n.length;return r=r===w?e:xu(0>r?0:+r||0,e),r-=t.length,0<=r&&n.indexOf(t,r)==r},Nn.escape=function(n){return(n=u(n))&&hn.test(n)?n.replace(sn,c):n},Nn.escapeRegExp=function(n){return(n=u(n))&&bn.test(n)?n.replace(wn,l):n||"(?:)"},Nn.every=te,Nn.find=ro,Nn.findIndex=qu,Nn.findKey=$o,Nn.findLast=eo,
Nn.findLastIndex=Pu,Nn.findLastKey=So,Nn.findWhere=function(n,t){return ro(n,bt(t))},Nn.first=Kr,Nn.floor=ni,Nn.get=function(n,t,r){return n=null==n?w:yt(n,Dr(t),t+""),n===w?r:n},Nn.gt=se,Nn.gte=function(n,t){return n>=t},Nn.has=function(n,t){if(null==n)return false;var r=nu.call(n,t);if(!r&&!Wr(t)){if(t=Dr(t),n=1==t.length?n:yt(n,Et(t,0,-1)),null==n)return false;t=Zr(t),r=nu.call(n,t)}return r||Sr(n.length)&&Cr(t,n.length)&&(Oo(n)||pe(n))},Nn.identity=Fe,Nn.includes=ee,Nn.indexOf=Vr,Nn.inRange=function(n,t,r){
return t=+t||0,r===w?(r=t,t=0):r=+r||0,n>=xu(t,r)&&n<bu(t,r)},Nn.isArguments=pe,Nn.isArray=Oo,Nn.isBoolean=function(n){return true===n||false===n||h(n)&&ru.call(n)==M},Nn.isDate=function(n){return h(n)&&ru.call(n)==q},Nn.isElement=function(n){return!!n&&1===n.nodeType&&h(n)&&!me(n)},Nn.isEmpty=function(n){return null==n?true:Er(n)&&(Oo(n)||be(n)||pe(n)||h(n)&&ve(n.splice))?!n.length:!zo(n).length},Nn.isEqual=he,Nn.isError=_e,Nn.isFinite=function(n){return typeof n=="number"&&mu(n)},Nn.isFunction=ve,Nn.isMatch=function(n,t,r,e){
return r=typeof r=="function"?Bt(r,e,3):w,mt(n,Ar(t),r)},Nn.isNaN=function(n){return de(n)&&n!=+n},Nn.isNative=ye,Nn.isNull=function(n){return null===n},Nn.isNumber=de,Nn.isObject=ge,Nn.isPlainObject=me,Nn.isRegExp=we,Nn.isString=be,Nn.isTypedArray=xe,Nn.isUndefined=function(n){return n===w},Nn.kebabCase=Ko,Nn.last=Zr,Nn.lastIndexOf=function(n,t,r){var e=n?n.length:0;if(!e)return-1;var u=e;if(typeof r=="number")u=(0>r?bu(e+r,0):xu(r||0,e-1))+1;else if(r)return u=Lt(n,t,true)-1,n=n[u],(t===t?t===n:n!==n)?u:-1;
if(t!==t)return p(n,u,true);for(;u--;)if(n[u]===t)return u;return-1},Nn.lt=Ae,Nn.lte=function(n,t){return n<=t},Nn.max=ti,Nn.min=ri,Nn.noConflict=function(){return Zn._=eu,this},Nn.noop=Le,Nn.now=ho,Nn.pad=function(n,t,r){n=u(n),t=+t;var e=n.length;return e<t&&mu(t)?(e=(t-e)/2,t=yu(e),e=vu(e),r=pr("",e,r),r.slice(0,t)+n+r):n},Nn.padLeft=Vo,Nn.padRight=Zo,Nn.parseInt=function(n,t,r){return(r?Ur(n,t,r):null==t)?t=0:t&&(t=+t),n=We(n),ju(n,t||(In.test(n)?16:10))},Nn.random=function(n,t,r){r&&Ur(n,t,r)&&(t=r=w);
var e=null==n,u=null==t;return null==r&&(u&&typeof n=="boolean"?(r=n,n=1):typeof t=="boolean"&&(r=t,u=true)),e&&u&&(t=1,u=false),n=+n||0,u?(t=n,n=0):t=+t||0,r||n%1||t%1?(r=ku(),xu(n+r*(t-n+fu("1e-"+((r+"").length-1))),t)):Rt(n,t)},Nn.reduce=lo,Nn.reduceRight=so,Nn.repeat=Ue,Nn.result=function(n,t,r){var e=null==n?w:n[t];return e===w&&(null==n||Wr(t,n)||(t=Dr(t),n=1==t.length?n:yt(n,Et(t,0,-1)),e=null==n?w:n[Zr(t)]),e=e===w?r:e),ve(e)?e.call(n):e},Nn.round=ei,Nn.runInContext=m,Nn.size=function(n){var t=n?Bu(n):0;
return Sr(t)?t:zo(n).length},Nn.snakeCase=Yo,Nn.some=ie,Nn.sortedIndex=Zu,Nn.sortedLastIndex=Yu,Nn.startCase=Go,Nn.startsWith=function(n,t,r){return n=u(n),r=null==r?0:xu(0>r?0:+r||0,n.length),n.lastIndexOf(t,r)==r},Nn.sum=function(n,t,r){if(r&&Ur(n,t,r)&&(t=w),t=wr(t,r,3),1==t.length){n=Oo(n)?n:zr(n),r=n.length;for(var e=0;r--;)e+=+t(n[r])||0;n=e}else n=$t(n,t);return n},Nn.template=function(n,t,r){var e=Nn.templateSettings;r&&Ur(n,t,r)&&(t=r=w),n=u(n),t=nt(tt({},r||t),e,Qn),r=nt(tt({},t.imports),e.imports,Qn);
var o,i,f=zo(r),a=Ft(r,f),c=0;r=t.interpolate||Cn;var l="__p+='";r=Ze((t.escape||Cn).source+"|"+r.source+"|"+(r===gn?jn:Cn).source+"|"+(t.evaluate||Cn).source+"|$","g");var p="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,u,f,a){return e||(e=u),l+=n.slice(c,a).replace(Un,s),r&&(o=true,l+="'+__e("+r+")+'"),f&&(i=true,l+="';"+f+";\n__p+='"),e&&(l+="'+((__t=("+e+"))==null?'':__t)+'"),c=a+t.length,t}),l+="';",(t=t.variable)||(l="with(obj){"+l+"}"),l=(i?l.replace(fn,""):l).replace(an,"$1").replace(cn,"$1;"),
l="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(o?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+l+"return __p}",t=Jo(function(){return qe(f,p+"return "+l).apply(w,a)}),t.source=l,_e(t))throw t;return t},Nn.trim=We,Nn.trimLeft=function(n,t,r){var e=n;return(n=u(n))?n.slice((r?Ur(e,t,r):null==t)?g(n):o(n,t+"")):n},Nn.trimRight=function(n,t,r){var e=n;return(n=u(n))?(r?Ur(e,t,r):null==t)?n.slice(0,y(n)+1):n.slice(0,i(n,t+"")+1):n;
},Nn.trunc=function(n,t,r){r&&Ur(n,t,r)&&(t=w);var e=U;if(r=W,null!=t)if(ge(t)){var o="separator"in t?t.separator:o,e="length"in t?+t.length||0:e;r="omission"in t?u(t.omission):r}else e=+t||0;if(n=u(n),e>=n.length)return n;if(e-=r.length,1>e)return r;if(t=n.slice(0,e),null==o)return t+r;if(we(o)){if(n.slice(e).search(o)){var i,f=n.slice(0,e);for(o.global||(o=Ze(o.source,(kn.exec(o)||"")+"g")),o.lastIndex=0;n=o.exec(f);)i=n.index;t=t.slice(0,null==i?e:i)}}else n.indexOf(o,e)!=e&&(o=t.lastIndexOf(o),
-1<o&&(t=t.slice(0,o)));return t+r},Nn.unescape=function(n){return(n=u(n))&&pn.test(n)?n.replace(ln,d):n},Nn.uniqueId=function(n){var t=++tu;return u(n)+t},Nn.words=$e,Nn.all=te,Nn.any=ie,Nn.contains=ee,Nn.eq=he,Nn.detect=ro,Nn.foldl=lo,Nn.foldr=so,Nn.head=Kr,Nn.include=ee,Nn.inject=lo,Te(Nn,function(){var n={};return _t(Nn,function(t,r){Nn.prototype[r]||(n[r]=t)}),n}(),false),Nn.sample=oe,Nn.prototype.sample=function(n){return this.__chain__||null!=n?this.thru(function(t){return oe(t,n)}):oe(this.value());
},Nn.VERSION=b,Pn("bind bindKey curry curryRight partial partialRight".split(" "),function(n){Nn[n].placeholder=Nn}),Pn(["drop","take"],function(n,t){zn.prototype[n]=function(r){var e=this.__filtered__;if(e&&!t)return new zn(this);r=null==r?1:bu(yu(r)||0,0);var u=this.clone();return e?u.__takeCount__=xu(u.__takeCount__,r):u.__views__.push({size:r,type:n+(0>u.__dir__?"Right":"")}),u},zn.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),Pn(["filter","map","takeWhile"],function(n,t){
var r=t+1,e=r!=T;zn.prototype[n]=function(n,t){var u=this.clone();return u.__iteratees__.push({iteratee:wr(n,t,1),type:r}),u.__filtered__=u.__filtered__||e,u}}),Pn(["first","last"],function(n,t){var r="take"+(t?"Right":"");zn.prototype[n]=function(){return this[r](1).value()[0]}}),Pn(["initial","rest"],function(n,t){var r="drop"+(t?"":"Right");zn.prototype[n]=function(){return this.__filtered__?new zn(this):this[r](1)}}),Pn(["pluck","where"],function(n,t){var r=t?"filter":"map",e=t?bt:ze;zn.prototype[n]=function(n){
return this[r](e(n))}}),zn.prototype.compact=function(){return this.filter(Fe)},zn.prototype.reject=function(n,t){return n=wr(n,t,1),this.filter(function(t){return!n(t)})},zn.prototype.slice=function(n,t){n=null==n?0:+n||0;var r=this;return r.__filtered__&&(0<n||0>t)?new zn(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==w&&(t=+t||0,r=0>t?r.dropRight(-t):r.take(t-n)),r)},zn.prototype.takeRightWhile=function(n,t){return this.reverse().takeWhile(n,t).reverse()},zn.prototype.toArray=function(){return this.take(Ru);
},_t(zn.prototype,function(n,t){var r=/^(?:filter|map|reject)|While$/.test(t),e=/^(?:first|last)$/.test(t),u=Nn[e?"take"+("last"==t?"Right":""):t];u&&(Nn.prototype[t]=function(){function t(n){return e&&i?u(n,1)[0]:u.apply(w,Jn([n],o))}var o=e?[1]:arguments,i=this.__chain__,f=this.__wrapped__,a=!!this.__actions__.length,c=f instanceof zn,l=o[0],s=c||Oo(f);return s&&r&&typeof l=="function"&&1!=l.length&&(c=s=false),l={func:ne,args:[t],thisArg:w},a=c&&!a,e&&!i?a?(f=f.clone(),f.__actions__.push(l),n.call(f)):u.call(w,this.value())[0]:!e&&s?(f=a?f:new zn(this),
f=n.apply(f,o),f.__actions__.push(l),new Ln(f,i)):this.thru(t)})}),Pn("join pop push replace shift sort splice split unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?He:Je)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:join|pop|replace|shift)$/.test(n);Nn.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),_t(zn.prototype,function(n,t){var r=Nn[t];if(r){var e=r.name+"";(Wu[e]||(Wu[e]=[])).push({
name:t,func:r})}}),Wu[sr(w,A).name]=[{name:"wrapper",func:w}],zn.prototype.clone=function(){var n=new zn(this.__wrapped__);return n.__actions__=qn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=qn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=qn(this.__views__),n},zn.prototype.reverse=function(){if(this.__filtered__){var n=new zn(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},zn.prototype.value=function(){
var n,t=this.__wrapped__.value(),r=this.__dir__,e=Oo(t),u=0>r,o=e?t.length:0;n=o;for(var i=this.__views__,f=0,a=-1,c=i.length;++a<c;){var l=i[a],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=xu(n,f+s);break;case"takeRight":f=bu(f,n-s)}}if(n={start:f,end:n},i=n.start,f=n.end,n=f-i,u=u?f:i-1,i=this.__iteratees__,f=i.length,a=0,c=xu(n,this.__takeCount__),!e||o<F||o==n&&c==n)return Tt(t,this.__actions__);e=[];n:for(;n--&&a<c;){for(u+=r,o=-1,l=t[u];++o<f;){var p=i[o],s=p.type,p=p.iteratee(l);
if(s==T)l=p;else if(!p){if(s==N)continue n;break n}}e[a++]=l}return e},Nn.prototype.chain=function(){return Qr(this)},Nn.prototype.commit=function(){return new Ln(this.value(),this.__chain__)},Nn.prototype.concat=Qu,Nn.prototype.plant=function(n){for(var t,r=this;r instanceof Tn;){var e=Mr(r);t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},Nn.prototype.reverse=function(){function n(n){return n.reverse()}var t=this.__wrapped__;return t instanceof zn?(this.__actions__.length&&(t=new zn(this)),
t=t.reverse(),t.__actions__.push({func:ne,args:[n],thisArg:w}),new Ln(t,this.__chain__)):this.thru(n)},Nn.prototype.toString=function(){return this.value()+""},Nn.prototype.run=Nn.prototype.toJSON=Nn.prototype.valueOf=Nn.prototype.value=function(){return Tt(this.__wrapped__,this.__actions__)},Nn.prototype.collect=Nn.prototype.map,Nn.prototype.head=Nn.prototype.first,Nn.prototype.select=Nn.prototype.filter,Nn.prototype.tail=Nn.prototype.rest,Nn}var w,b="3.10.1",x=1,A=2,j=4,k=8,I=16,R=32,O=64,E=128,C=256,U=30,W="...",$=150,S=16,F=200,N=1,T=2,L="Expected a function",z="__lodash_placeholder__",B="[object Arguments]",D="[object Array]",M="[object Boolean]",q="[object Date]",P="[object Error]",K="[object Function]",V="[object Number]",Z="[object Object]",Y="[object RegExp]",G="[object String]",J="[object ArrayBuffer]",X="[object Float32Array]",H="[object Float64Array]",Q="[object Int8Array]",nn="[object Int16Array]",tn="[object Int32Array]",rn="[object Uint8Array]",en="[object Uint8ClampedArray]",un="[object Uint16Array]",on="[object Uint32Array]",fn=/\b__p\+='';/g,an=/\b(__p\+=)''\+/g,cn=/(__e\(.*?\)|\b__t\))\+'';/g,ln=/&(?:amp|lt|gt|quot|#39|#96);/g,sn=/[&<>"'`]/g,pn=RegExp(ln.source),hn=RegExp(sn.source),_n=/<%-([\s\S]+?)%>/g,vn=/<%([\s\S]+?)%>/g,gn=/<%=([\s\S]+?)%>/g,yn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,dn=/^\w*$/,mn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,wn=/^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,bn=RegExp(wn.source),xn=/[\u0300-\u036f\ufe20-\ufe23]/g,An=/\\(\\)?/g,jn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,kn=/\w*$/,In=/^0[xX]/,Rn=/^\[object .+?Constructor\]$/,On=/^\d+$/,En=/[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g,Cn=/($^)/,Un=/['\n\r\u2028\u2029\\]/g,Wn=RegExp("[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?=[A-Z\\xc0-\\xd6\\xd8-\\xde][a-z\\xdf-\\xf6\\xf8-\\xff]+)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+|[A-Z\\xc0-\\xd6\\xd8-\\xde]+|[0-9]+","g"),$n="Array ArrayBuffer Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Math Number Object RegExp Set String _ clearTimeout isFinite parseFloat parseInt setTimeout TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap".split(" "),Sn={};
Sn[X]=Sn[H]=Sn[Q]=Sn[nn]=Sn[tn]=Sn[rn]=Sn[en]=Sn[un]=Sn[on]=true,Sn[B]=Sn[D]=Sn[J]=Sn[M]=Sn[q]=Sn[P]=Sn[K]=Sn["[object Map]"]=Sn[V]=Sn[Z]=Sn[Y]=Sn["[object Set]"]=Sn[G]=Sn["[object WeakMap]"]=false;var Fn={};Fn[B]=Fn[D]=Fn[J]=Fn[M]=Fn[q]=Fn[X]=Fn[H]=Fn[Q]=Fn[nn]=Fn[tn]=Fn[V]=Fn[Z]=Fn[Y]=Fn[G]=Fn[rn]=Fn[en]=Fn[un]=Fn[on]=true,Fn[P]=Fn[K]=Fn["[object Map]"]=Fn["[object Set]"]=Fn["[object WeakMap]"]=false;var Nn={"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a",
"\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y",
"\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss"},Tn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},Ln={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'","&#96;":"`"},zn={"function":true,object:true},Bn={0:"x30",1:"x31",2:"x32",3:"x33",4:"x34",5:"x35",6:"x36",7:"x37",8:"x38",9:"x39",A:"x41",B:"x42",C:"x43",D:"x44",E:"x45",F:"x46",a:"x61",b:"x62",c:"x63",d:"x64",e:"x65",f:"x66",n:"x6e",r:"x72",t:"x74",u:"x75",v:"x76",x:"x78"},Dn={"\\":"\\",
"'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Mn=zn[typeof exports]&&exports&&!exports.nodeType&&exports,qn=zn[typeof module]&&module&&!module.nodeType&&module,Pn=zn[typeof self]&&self&&self.Object&&self,Kn=zn[typeof window]&&window&&window.Object&&window,Vn=qn&&qn.exports===Mn&&Mn,Zn=Mn&&qn&&typeof global=="object"&&global&&global.Object&&global||Kn!==(this&&this.window)&&Kn||Pn||this,Yn=m();typeof define=="function"&&typeof define.amd=="object"&&define.amd?(Zn._=Yn, define(function(){
return Yn})):Mn&&qn?Vn?(qn.exports=Yn)._=Yn:Mn._=Yn:Zn._=Yn}).call(this);
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.deepmerge = factory());
}(this, function () { 'use strict';

    var isMergeableObject = function isMergeableObject(value) {
        return isNonNullObject(value)
            && !isSpecial(value)
    };

    function isNonNullObject(value) {
        return !!value && typeof value === 'object'
    }

    function isSpecial(value) {
        var stringValue = Object.prototype.toString.call(value);

        return stringValue === '[object RegExp]'
            || stringValue === '[object Date]'
            || isReactElement(value)
    }

    // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
    var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

    function isReactElement(value) {
        return value.$$typeof === REACT_ELEMENT_TYPE
    }

    function emptyTarget(val) {
        return Array.isArray(val) ? [] : {}
    }

    function cloneUnlessOtherwiseSpecified(value, options) {
        return (options.clone !== false && options.isMergeableObject(value))
            ? deepmerge(emptyTarget(value), value, options)
            : value
    }

    function defaultArrayMerge(target, source, options) {
        return target.concat(source).map(function(element) {
            return cloneUnlessOtherwiseSpecified(element, options)
        })
    }

    function getMergeFunction(key, options) {
        if (!options.customMerge) {
            return deepmerge
        }
        var customMerge = options.customMerge(key);
        return typeof customMerge === 'function' ? customMerge : deepmerge
    }

    function getEnumerableOwnPropertySymbols(target) {
        return Object.getOwnPropertySymbols
            ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                return Object.propertyIsEnumerable.call(target, symbol)
            })
            : []
    }

    function getKeys(target) {
        return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
    }

    function propertyIsOnObject(object, property) {
        try {
            return property in object
        } catch(_) {
            return false
        }
    }

    // Protects from prototype poisoning and unexpected merging up the prototype chain.
    function propertyIsUnsafe(target, key) {
        return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
            && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                && Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
    }

    function mergeObject(target, source, options) {
        var destination = {};
        if (options.isMergeableObject(target)) {
            getKeys(target).forEach(function(key) {
                destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
            });
        }
        getKeys(source).forEach(function(key) {
            if (propertyIsUnsafe(target, key)) {
                return
            }

            if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
                destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
            } else {
                destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
            }
        });
        return destination
    }

    function deepmerge(target, source, options) {
        options = options || {};
        options.arrayMerge = options.arrayMerge || defaultArrayMerge;
        options.isMergeableObject = options.isMergeableObject || isMergeableObject;
        // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
        // implementations can use it. The caller may not replace it.
        options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

        var sourceIsArray = Array.isArray(source);
        var targetIsArray = Array.isArray(target);
        var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

        if (!sourceAndTargetTypesMatch) {
            return cloneUnlessOtherwiseSpecified(source, options)
        } else if (sourceIsArray) {
            return options.arrayMerge(target, source, options)
        } else {
            return mergeObject(target, source, options)
        }
    }

    deepmerge.all = function deepmergeAll(array, options) {
        if (!Array.isArray(array)) {
            throw new Error('first argument should be an array')
        }

        return array.reduce(function(prev, next) {
            return deepmerge(prev, next, options)
        }, {})
    };

    var deepmerge_1 = deepmerge;

    return deepmerge_1;

}));
/*! lazysizes - v5.3.1 */

!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).ImageKit=t()}(this,(function(){"use strict";function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(t)}function t(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function r(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function n(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function o(e){for(var t=1;t<arguments.length;t++){var o=null!=arguments[t]?arguments[t]:{};t%2?n(Object(o),!0).forEach((function(t){r(e,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(o)):n(Object(o)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(o,t))}))}return e}var a={message:"Missing urlEndpoint during SDK initialization",help:""},i={message:"Invalid transformationPosition parameter",help:""},s={message:"Missing file parameter for upload",help:""},u={message:"Missing fileName parameter for upload",help:""},p={message:"Missing public key for upload",help:""},l={message:"Request to ImageKit upload endpoint failed due to network error",help:""},f={message:"Invalid uploadOptions parameter",help:""},c={message:"Missing signature for upload. The SDK expects token, sginature and expire for authentication.",help:""},y={message:"Missing token for upload. The SDK expects token, sginature and expire for authentication.",help:""},d={message:"Missing expire for upload. The SDK expects token, sginature and expire for authentication.",help:""};function g(e,t,r){"function"==typeof r&&(e?r(t,null):r(null,t))}function h(e){var t={},r=e.getAllResponseHeaders();return Object.keys(r).length&&r.trim().split(/[\r\n]+/).map((function(e){return e.split(/: /)})).forEach((function(e){t[e[0].trim()]=e[1].trim()})),t}var m=function(e,t){var r=o({},e),n={statusCode:t.status,headers:h(t)};return Object.defineProperty(r,"$ResponseMetadata",{value:n,enumerable:!1,writable:!1}),r},v=function(e,t){return new Promise((function(r,n){e.open("POST","https://upload.imagekit.io/api/v1/files/upload"),e.onerror=function(e){return n(l)},e.onload=function(){if(200===e.status)try{var t=JSON.parse(e.responseText),o=m(t,e);return r(o)}catch(e){return n(e)}else try{t=JSON.parse(e.responseText);var a=m(t,e);return n(a)}catch(e){return n(e)}},e.send(t)}))},b=function(t,r,n,o){if(r.file)if(r.fileName)if(n.publicKey)if(r.token)if(r.signature)if(r.expire){var a,i=new FormData;for(a in r)a&&("file"===a&&"string"!=typeof r.file?i.append("file",r.file,String(r.fileName)):"tags"===a&&Array.isArray(r.tags)?i.append("tags",r.tags.join(",")):"signature"===a?i.append("signature",r.signature):"expire"===a?i.append("expire",String(r.expire)):"token"===a?i.append("token",r.token):"responseFields"===a&&Array.isArray(r.responseFields)?i.append("responseFields",r.responseFields.join(",")):"extensions"===a&&Array.isArray(r.extensions)?i.append("extensions",JSON.stringify(r.extensions)):"customMetadata"!==a||"object"!==e(r.customMetadata)||Array.isArray(r.customMetadata)||null===r.customMetadata?void 0!==r[a]&&i.append(a,String(r[a])):i.append("customMetadata",JSON.stringify(r.customMetadata)));i.append("publicKey",n.publicKey),function(e,t,r){v(e,t).then((function(e){return g(!1,e,r)}),(function(e){return g(!0,e,r)}))}(t,i,o)}else g(!0,d,o);else g(!0,c,o);else g(!0,y,o);else g(!0,p,o);else g(!0,u,o);else g(!0,s,o)},x={width:"w",height:"h",aspectRatio:"ar",quality:"q",crop:"c",cropMode:"cm",focus:"fo",x:"x",y:"y",format:"f",radius:"r",background:"bg",border:"b",rotation:"rt",rotate:"rt",blur:"bl",named:"n",overlayImage:"oi",overlayImageAspectRatio:"oiar",overlayImageBackground:"oibg",overlayImageBorder:"oib",overlayImageDPR:"oidpr",overlayImageQuality:"oiq",overlayImageCropping:"oic",overlayImageTrim:"oit",overlayX:"ox",overlayY:"oy",overlayFocus:"ofo",overlayHeight:"oh",overlayWidth:"ow",overlayText:"ot",overlayTextFontSize:"ots",overlayTextFontFamily:"otf",overlayTextColor:"otc",overlayTextTransparency:"oa",overlayAlpha:"oa",overlayTextTypography:"ott",overlayBackground:"obg",overlayTextEncoded:"ote",overlayTextWidth:"otw",overlayTextBackground:"otbg",overlayTextPadding:"otp",overlayTextInnerAlignment:"otia",overlayRadius:"or",progressive:"pr",lossless:"lo",trim:"t",metadata:"md",colorProfile:"cp",defaultImage:"di",dpr:"dpr",effectSharpen:"e-sharpen",effectUSM:"e-usm",effectContrast:"e-contrast",effectGray:"e-grayscale",original:"orig",raw:"raw"},w=["path","query"],O=function(){return"path"},P=function(e){return"query"===e.transformationPosition},j=function(e){return void 0!==e.transformationPosition&&-1!=w.indexOf(e.transformationPosition)},S=function(e){return e&&(x[e]||x[e.toLowerCase()])||""},T=function(){return":"},k=function(){return","},M=function(){return"-"};function A(e){return"string"==typeof e&&"/"==e[e.length-1]&&(e=e.substring(0,e.length-1)),e}function I(e,t){var r=t||"/",n=new RegExp(r+"{1,}","g");return e.join(r).replace(n,r)}var E=function(e){if(!e.path&&!e.src)return"";var t,r,n;try{e.path?(n=new URL(e.urlEndpoint).pathname,t=new URL(I([e.urlEndpoint.replace(n,""),e.path]))):(t=new URL(e.src),r=!0)}catch(e){return console.error(e),""}for(var o in e.queryParameters)t.searchParams.append(o,String(e.queryParameters[o]));var a=function(e){if(!Array.isArray(e))return"";for(var t=[],r=0,n=e.length;r<n;r++){var o=[];for(var a in e[r]){var i=S(a);if(i||(i=a),"-"===e[r][a])o.push(i);else if("raw"===a)o.push(e[r][a]);else{var s=e[r][a];"oi"!==i&&"di"!==i||(s=(s=A(("string"==typeof(u=s||"")&&"/"==u[0]&&(u=u.slice(1)),u))).replace(/\//g,"@@")),o.push([i,s].join(M()))}}t.push(o.join(k()))}var u;return t.join(T())}(e.transformation);return a&&a.length&&(P(e)||r?t.searchParams.append("tr",a):t.pathname=I(["tr"+T()+a,t.pathname])),t.pathname=I(n?[n,t.pathname]:[t.pathname]),t.href};return function(){function n(e){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),r(this,"options",{sdkVersion:"javascript-".concat("2.0.0"),publicKey:"",urlEndpoint:"",transformationPosition:O()}),this.options=o(o({},this.options),e||{}),!this.options.urlEndpoint)throw a;if(!j(this.options))throw i}var s,u,p;return s=n,(u=[{key:"url",value:function(e){return t=e,r=this.options,E(o(o({},r),t));var t,r}},{key:"upload",value:function(t,r,n){var a;if("function"==typeof r?a=r:n=r||{},!t||"object"!==e(t))return g(!0,f,a);var i=o(o({},this.options),n),s=(t||{}).xhr;delete t.xhr;var u,p,l=s||new XMLHttpRequest;return(u=this,p=b,function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];if(t.length!==p.length||void 0===t[t.length-1])return new Promise((function(e,r){t.pop(),t.push((function(t){if(t)return r(t);for(var n=arguments.length,o=new Array(n>1?n-1:0),a=1;a<n;a++)o[a-1]=arguments[a];e(o.length>1?o:o[0])})),p.call.apply(p,[u].concat(t))}));if("function"!=typeof t[t.length-1])throw new Error("Callback must be a function.");p.call.apply(p,[u].concat(t))})(l,t,i,a)}}])&&t(s.prototype,u),p&&t(s,p),n}()}));
/*
 AngularJS v1.4.9
 (c) 2010-2015 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(S,W,w){'use strict';function M(a){return function(){var b=arguments[0],d;d="["+(a?a+":":"")+b+"] http://errors.angularjs.org/1.4.9/"+(a?a+"/":"")+b;for(b=1;b<arguments.length;b++){d=d+(1==b?"?":"&")+"p"+(b-1)+"=";var c=encodeURIComponent,e;e=arguments[b];e="function"==typeof e?e.toString().replace(/ \{[\s\S]*$/,""):"undefined"==typeof e?"undefined":"string"!=typeof e?JSON.stringify(e):e;d+=c(e)}return Error(d)}}function Aa(a){if(null==a||Xa(a))return!1;if(E(a)||F(a)||A&&a instanceof A)return!0;
var b="length"in Object(a)&&a.length;return Q(b)&&(0<=b&&(b-1 in a||a instanceof Array)||"function"==typeof a.item)}function n(a,b,d){var c,e;if(a)if(B(a))for(c in a)"prototype"==c||"length"==c||"name"==c||a.hasOwnProperty&&!a.hasOwnProperty(c)||b.call(d,a[c],c,a);else if(E(a)||Aa(a)){var f="object"!==typeof a;c=0;for(e=a.length;c<e;c++)(f||c in a)&&b.call(d,a[c],c,a)}else if(a.forEach&&a.forEach!==n)a.forEach(b,d,a);else if(oc(a))for(c in a)b.call(d,a[c],c,a);else if("function"===typeof a.hasOwnProperty)for(c in a)a.hasOwnProperty(c)&&
b.call(d,a[c],c,a);else for(c in a)ra.call(a,c)&&b.call(d,a[c],c,a);return a}function pc(a,b,d){for(var c=Object.keys(a).sort(),e=0;e<c.length;e++)b.call(d,a[c[e]],c[e]);return c}function qc(a){return function(b,d){a(d,b)}}function Xd(){return++ob}function Ob(a,b,d){for(var c=a.$$hashKey,e=0,f=b.length;e<f;++e){var g=b[e];if(G(g)||B(g))for(var h=Object.keys(g),k=0,l=h.length;k<l;k++){var m=h[k],r=g[m];d&&G(r)?da(r)?a[m]=new Date(r.valueOf()):La(r)?a[m]=new RegExp(r):r.nodeName?a[m]=r.cloneNode(!0):
Pb(r)?a[m]=r.clone():(G(a[m])||(a[m]=E(r)?[]:{}),Ob(a[m],[r],!0)):a[m]=r}}c?a.$$hashKey=c:delete a.$$hashKey;return a}function N(a){return Ob(a,sa.call(arguments,1),!1)}function Yd(a){return Ob(a,sa.call(arguments,1),!0)}function Z(a){return parseInt(a,10)}function Qb(a,b){return N(Object.create(a),b)}function z(){}function Ya(a){return a}function na(a){return function(){return a}}function rc(a){return B(a.toString)&&a.toString!==ta}function q(a){return"undefined"===typeof a}function u(a){return"undefined"!==
typeof a}function G(a){return null!==a&&"object"===typeof a}function oc(a){return null!==a&&"object"===typeof a&&!sc(a)}function F(a){return"string"===typeof a}function Q(a){return"number"===typeof a}function da(a){return"[object Date]"===ta.call(a)}function B(a){return"function"===typeof a}function La(a){return"[object RegExp]"===ta.call(a)}function Xa(a){return a&&a.window===a}function Za(a){return a&&a.$evalAsync&&a.$watch}function $a(a){return"boolean"===typeof a}function tc(a){return a&&Q(a.length)&&
Zd.test(ta.call(a))}function Pb(a){return!(!a||!(a.nodeName||a.prop&&a.attr&&a.find))}function $d(a){var b={};a=a.split(",");var d;for(d=0;d<a.length;d++)b[a[d]]=!0;return b}function oa(a){return K(a.nodeName||a[0]&&a[0].nodeName)}function ab(a,b){var d=a.indexOf(b);0<=d&&a.splice(d,1);return d}function Ma(a,b){function d(a,b){var d=b.$$hashKey,e;if(E(a)){e=0;for(var f=a.length;e<f;e++)b.push(c(a[e]))}else if(oc(a))for(e in a)b[e]=c(a[e]);else if(a&&"function"===typeof a.hasOwnProperty)for(e in a)a.hasOwnProperty(e)&&
(b[e]=c(a[e]));else for(e in a)ra.call(a,e)&&(b[e]=c(a[e]));d?b.$$hashKey=d:delete b.$$hashKey;return b}function c(a){if(!G(a))return a;var b=e.indexOf(a);if(-1!==b)return f[b];if(Xa(a)||Za(a))throw Ba("cpws");var b=!1,c;E(a)?(c=[],b=!0):tc(a)?c=new a.constructor(a):da(a)?c=new Date(a.getTime()):La(a)?(c=new RegExp(a.source,a.toString().match(/[^\/]*$/)[0]),c.lastIndex=a.lastIndex):B(a.cloneNode)?c=a.cloneNode(!0):(c=Object.create(sc(a)),b=!0);e.push(a);f.push(c);return b?d(a,c):c}var e=[],f=[];if(b){if(tc(b))throw Ba("cpta");
if(a===b)throw Ba("cpi");E(b)?b.length=0:n(b,function(a,c){"$$hashKey"!==c&&delete b[c]});e.push(a);f.push(b);return d(a,b)}return c(a)}function ha(a,b){if(E(a)){b=b||[];for(var d=0,c=a.length;d<c;d++)b[d]=a[d]}else if(G(a))for(d in b=b||{},a)if("$"!==d.charAt(0)||"$"!==d.charAt(1))b[d]=a[d];return b||a}function ka(a,b){if(a===b)return!0;if(null===a||null===b)return!1;if(a!==a&&b!==b)return!0;var d=typeof a,c;if(d==typeof b&&"object"==d)if(E(a)){if(!E(b))return!1;if((d=a.length)==b.length){for(c=
0;c<d;c++)if(!ka(a[c],b[c]))return!1;return!0}}else{if(da(a))return da(b)?ka(a.getTime(),b.getTime()):!1;if(La(a))return La(b)?a.toString()==b.toString():!1;if(Za(a)||Za(b)||Xa(a)||Xa(b)||E(b)||da(b)||La(b))return!1;d=ea();for(c in a)if("$"!==c.charAt(0)&&!B(a[c])){if(!ka(a[c],b[c]))return!1;d[c]=!0}for(c in b)if(!(c in d)&&"$"!==c.charAt(0)&&u(b[c])&&!B(b[c]))return!1;return!0}return!1}function bb(a,b,d){return a.concat(sa.call(b,d))}function uc(a,b){var d=2<arguments.length?sa.call(arguments,2):
[];return!B(b)||b instanceof RegExp?b:d.length?function(){return arguments.length?b.apply(a,bb(d,arguments,0)):b.apply(a,d)}:function(){return arguments.length?b.apply(a,arguments):b.call(a)}}function ae(a,b){var d=b;"string"===typeof a&&"$"===a.charAt(0)&&"$"===a.charAt(1)?d=w:Xa(b)?d="$WINDOW":b&&W===b?d="$DOCUMENT":Za(b)&&(d="$SCOPE");return d}function cb(a,b){if("undefined"===typeof a)return w;Q(b)||(b=b?2:null);return JSON.stringify(a,ae,b)}function vc(a){return F(a)?JSON.parse(a):a}function wc(a,
b){var d=Date.parse("Jan 01, 1970 00:00:00 "+a)/6E4;return isNaN(d)?b:d}function Rb(a,b,d){d=d?-1:1;var c=wc(b,a.getTimezoneOffset());b=a;a=d*(c-a.getTimezoneOffset());b=new Date(b.getTime());b.setMinutes(b.getMinutes()+a);return b}function ua(a){a=A(a).clone();try{a.empty()}catch(b){}var d=A("<div>").append(a).html();try{return a[0].nodeType===Na?K(d):d.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/,function(a,b){return"<"+K(b)})}catch(c){return K(d)}}function xc(a){try{return decodeURIComponent(a)}catch(b){}}
function yc(a){var b={};n((a||"").split("&"),function(a){var c,e,f;a&&(e=a=a.replace(/\+/g,"%20"),c=a.indexOf("="),-1!==c&&(e=a.substring(0,c),f=a.substring(c+1)),e=xc(e),u(e)&&(f=u(f)?xc(f):!0,ra.call(b,e)?E(b[e])?b[e].push(f):b[e]=[b[e],f]:b[e]=f))});return b}function Sb(a){var b=[];n(a,function(a,c){E(a)?n(a,function(a){b.push(ia(c,!0)+(!0===a?"":"="+ia(a,!0)))}):b.push(ia(c,!0)+(!0===a?"":"="+ia(a,!0)))});return b.length?b.join("&"):""}function pb(a){return ia(a,!0).replace(/%26/gi,"&").replace(/%3D/gi,
"=").replace(/%2B/gi,"+")}function ia(a,b){return encodeURIComponent(a).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%3B/gi,";").replace(/%20/g,b?"%20":"+")}function be(a,b){var d,c,e=Oa.length;for(c=0;c<e;++c)if(d=Oa[c]+b,F(d=a.getAttribute(d)))return d;return null}function ce(a,b){var d,c,e={};n(Oa,function(b){b+="app";!d&&a.hasAttribute&&a.hasAttribute(b)&&(d=a,c=a.getAttribute(b))});n(Oa,function(b){b+="app";var e;!d&&(e=a.querySelector("["+b.replace(":",
"\\:")+"]"))&&(d=e,c=e.getAttribute(b))});d&&(e.strictDi=null!==be(d,"strict-di"),b(d,c?[c]:[],e))}function zc(a,b,d){G(d)||(d={});d=N({strictDi:!1},d);var c=function(){a=A(a);if(a.injector()){var c=a[0]===W?"document":ua(a);throw Ba("btstrpd",c.replace(/</,"&lt;").replace(/>/,"&gt;"));}b=b||[];b.unshift(["$provide",function(b){b.value("$rootElement",a)}]);d.debugInfoEnabled&&b.push(["$compileProvider",function(a){a.debugInfoEnabled(!0)}]);b.unshift("ng");c=db(b,d.strictDi);c.invoke(["$rootScope",
"$rootElement","$compile","$injector",function(a,b,c,d){a.$apply(function(){b.data("$injector",d);c(b)(a)})}]);return c},e=/^NG_ENABLE_DEBUG_INFO!/,f=/^NG_DEFER_BOOTSTRAP!/;S&&e.test(S.name)&&(d.debugInfoEnabled=!0,S.name=S.name.replace(e,""));if(S&&!f.test(S.name))return c();S.name=S.name.replace(f,"");$.resumeBootstrap=function(a){n(a,function(a){b.push(a)});return c()};B($.resumeDeferredBootstrap)&&$.resumeDeferredBootstrap()}function de(){S.name="NG_ENABLE_DEBUG_INFO!"+S.name;S.location.reload()}
function ee(a){a=$.element(a).injector();if(!a)throw Ba("test");return a.get("$$testability")}function Ac(a,b){b=b||"_";return a.replace(fe,function(a,c){return(c?b:"")+a.toLowerCase()})}function ge(){var a;if(!Bc){var b=qb();(pa=q(b)?S.jQuery:b?S[b]:w)&&pa.fn.on?(A=pa,N(pa.fn,{scope:Pa.scope,isolateScope:Pa.isolateScope,controller:Pa.controller,injector:Pa.injector,inheritedData:Pa.inheritedData}),a=pa.cleanData,pa.cleanData=function(b){var c;if(Tb)Tb=!1;else for(var e=0,f;null!=(f=b[e]);e++)(c=
pa._data(f,"events"))&&c.$destroy&&pa(f).triggerHandler("$destroy");a(b)}):A=P;$.element=A;Bc=!0}}function rb(a,b,d){if(!a)throw Ba("areq",b||"?",d||"required");return a}function Qa(a,b,d){d&&E(a)&&(a=a[a.length-1]);rb(B(a),b,"not a function, got "+(a&&"object"===typeof a?a.constructor.name||"Object":typeof a));return a}function Ra(a,b){if("hasOwnProperty"===a)throw Ba("badname",b);}function Cc(a,b,d){if(!b)return a;b=b.split(".");for(var c,e=a,f=b.length,g=0;g<f;g++)c=b[g],a&&(a=(e=a)[c]);return!d&&
B(a)?uc(e,a):a}function sb(a){for(var b=a[0],d=a[a.length-1],c,e=1;b!==d&&(b=b.nextSibling);e++)if(c||a[e]!==b)c||(c=A(sa.call(a,0,e))),c.push(b);return c||a}function ea(){return Object.create(null)}function he(a){function b(a,b,c){return a[b]||(a[b]=c())}var d=M("$injector"),c=M("ng");a=b(a,"angular",Object);a.$$minErr=a.$$minErr||M;return b(a,"module",function(){var a={};return function(f,g,h){if("hasOwnProperty"===f)throw c("badname","module");g&&a.hasOwnProperty(f)&&(a[f]=null);return b(a,f,function(){function a(b,
d,e,f){f||(f=c);return function(){f[e||"push"]([b,d,arguments]);return y}}function b(a,d){return function(b,e){e&&B(e)&&(e.$$moduleName=f);c.push([a,d,arguments]);return y}}if(!g)throw d("nomod",f);var c=[],e=[],t=[],C=a("$injector","invoke","push",e),y={_invokeQueue:c,_configBlocks:e,_runBlocks:t,requires:g,name:f,provider:b("$provide","provider"),factory:b("$provide","factory"),service:b("$provide","service"),value:a("$provide","value"),constant:a("$provide","constant","unshift"),decorator:b("$provide",
"decorator"),animation:b("$animateProvider","register"),filter:b("$filterProvider","register"),controller:b("$controllerProvider","register"),directive:b("$compileProvider","directive"),config:C,run:function(a){t.push(a);return this}};h&&C(h);return y})}})}function ie(a){N(a,{bootstrap:zc,copy:Ma,extend:N,merge:Yd,equals:ka,element:A,forEach:n,injector:db,noop:z,bind:uc,toJson:cb,fromJson:vc,identity:Ya,isUndefined:q,isDefined:u,isString:F,isFunction:B,isObject:G,isNumber:Q,isElement:Pb,isArray:E,
version:je,isDate:da,lowercase:K,uppercase:tb,callbacks:{counter:0},getTestability:ee,$$minErr:M,$$csp:Ca,reloadWithDebugInfo:de});Ub=he(S);Ub("ng",["ngLocale"],["$provide",function(a){a.provider({$$sanitizeUri:ke});a.provider("$compile",Dc).directive({a:le,input:Ec,textarea:Ec,form:me,script:ne,select:oe,style:pe,option:qe,ngBind:re,ngBindHtml:se,ngBindTemplate:te,ngClass:ue,ngClassEven:ve,ngClassOdd:we,ngCloak:xe,ngController:ye,ngForm:ze,ngHide:Ae,ngIf:Be,ngInclude:Ce,ngInit:De,ngNonBindable:Ee,
ngPluralize:Fe,ngRepeat:Ge,ngShow:He,ngStyle:Ie,ngSwitch:Je,ngSwitchWhen:Ke,ngSwitchDefault:Le,ngOptions:Me,ngTransclude:Ne,ngModel:Oe,ngList:Pe,ngChange:Qe,pattern:Fc,ngPattern:Fc,required:Gc,ngRequired:Gc,minlength:Hc,ngMinlength:Hc,maxlength:Ic,ngMaxlength:Ic,ngValue:Re,ngModelOptions:Se}).directive({ngInclude:Te}).directive(ub).directive(Jc);a.provider({$anchorScroll:Ue,$animate:Ve,$animateCss:We,$$animateJs:Xe,$$animateQueue:Ye,$$AnimateRunner:Ze,$$animateAsyncRun:$e,$browser:af,$cacheFactory:bf,
$controller:cf,$document:df,$exceptionHandler:ef,$filter:Kc,$$forceReflow:ff,$interpolate:gf,$interval:hf,$http:jf,$httpParamSerializer:kf,$httpParamSerializerJQLike:lf,$httpBackend:mf,$xhrFactory:nf,$location:of,$log:pf,$parse:qf,$rootScope:rf,$q:sf,$$q:tf,$sce:uf,$sceDelegate:vf,$sniffer:wf,$templateCache:xf,$templateRequest:yf,$$testability:zf,$timeout:Af,$window:Bf,$$rAF:Cf,$$jqLite:Df,$$HashMap:Ef,$$cookieReader:Ff})}])}function eb(a){return a.replace(Gf,function(a,d,c,e){return e?c.toUpperCase():
c}).replace(Hf,"Moz$1")}function Lc(a){a=a.nodeType;return 1===a||!a||9===a}function Mc(a,b){var d,c,e=b.createDocumentFragment(),f=[];if(Vb.test(a)){d=d||e.appendChild(b.createElement("div"));c=(If.exec(a)||["",""])[1].toLowerCase();c=ja[c]||ja._default;d.innerHTML=c[1]+a.replace(Jf,"<$1></$2>")+c[2];for(c=c[0];c--;)d=d.lastChild;f=bb(f,d.childNodes);d=e.firstChild;d.textContent=""}else f.push(b.createTextNode(a));e.textContent="";e.innerHTML="";n(f,function(a){e.appendChild(a)});return e}function P(a){if(a instanceof
P)return a;var b;F(a)&&(a=T(a),b=!0);if(!(this instanceof P)){if(b&&"<"!=a.charAt(0))throw Wb("nosel");return new P(a)}if(b){b=W;var d;a=(d=Kf.exec(a))?[b.createElement(d[1])]:(d=Mc(a,b))?d.childNodes:[]}Nc(this,a)}function Xb(a){return a.cloneNode(!0)}function vb(a,b){b||wb(a);if(a.querySelectorAll)for(var d=a.querySelectorAll("*"),c=0,e=d.length;c<e;c++)wb(d[c])}function Oc(a,b,d,c){if(u(c))throw Wb("offargs");var e=(c=xb(a))&&c.events,f=c&&c.handle;if(f)if(b){var g=function(b){var c=e[b];u(d)&&
ab(c||[],d);u(d)&&c&&0<c.length||(a.removeEventListener(b,f,!1),delete e[b])};n(b.split(" "),function(a){g(a);yb[a]&&g(yb[a])})}else for(b in e)"$destroy"!==b&&a.removeEventListener(b,f,!1),delete e[b]}function wb(a,b){var d=a.ng339,c=d&&fb[d];c&&(b?delete c.data[b]:(c.handle&&(c.events.$destroy&&c.handle({},"$destroy"),Oc(a)),delete fb[d],a.ng339=w))}function xb(a,b){var d=a.ng339,d=d&&fb[d];b&&!d&&(a.ng339=d=++Lf,d=fb[d]={events:{},data:{},handle:w});return d}function Yb(a,b,d){if(Lc(a)){var c=
u(d),e=!c&&b&&!G(b),f=!b;a=(a=xb(a,!e))&&a.data;if(c)a[b]=d;else{if(f)return a;if(e)return a&&a[b];N(a,b)}}}function zb(a,b){return a.getAttribute?-1<(" "+(a.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").indexOf(" "+b+" "):!1}function Ab(a,b){b&&a.setAttribute&&n(b.split(" "),function(b){a.setAttribute("class",T((" "+(a.getAttribute("class")||"")+" ").replace(/[\n\t]/g," ").replace(" "+T(b)+" "," ")))})}function Bb(a,b){if(b&&a.setAttribute){var d=(" "+(a.getAttribute("class")||"")+" ").replace(/[\n\t]/g,
" ");n(b.split(" "),function(a){a=T(a);-1===d.indexOf(" "+a+" ")&&(d+=a+" ")});a.setAttribute("class",T(d))}}function Nc(a,b){if(b)if(b.nodeType)a[a.length++]=b;else{var d=b.length;if("number"===typeof d&&b.window!==b){if(d)for(var c=0;c<d;c++)a[a.length++]=b[c]}else a[a.length++]=b}}function Pc(a,b){return Cb(a,"$"+(b||"ngController")+"Controller")}function Cb(a,b,d){9==a.nodeType&&(a=a.documentElement);for(b=E(b)?b:[b];a;){for(var c=0,e=b.length;c<e;c++)if(u(d=A.data(a,b[c])))return d;a=a.parentNode||
11===a.nodeType&&a.host}}function Qc(a){for(vb(a,!0);a.firstChild;)a.removeChild(a.firstChild)}function Zb(a,b){b||vb(a);var d=a.parentNode;d&&d.removeChild(a)}function Mf(a,b){b=b||S;if("complete"===b.document.readyState)b.setTimeout(a);else A(b).on("load",a)}function Rc(a,b){var d=Db[b.toLowerCase()];return d&&Sc[oa(a)]&&d}function Nf(a,b){var d=function(c,d){c.isDefaultPrevented=function(){return c.defaultPrevented};var f=b[d||c.type],g=f?f.length:0;if(g){if(q(c.immediatePropagationStopped)){var h=
c.stopImmediatePropagation;c.stopImmediatePropagation=function(){c.immediatePropagationStopped=!0;c.stopPropagation&&c.stopPropagation();h&&h.call(c)}}c.isImmediatePropagationStopped=function(){return!0===c.immediatePropagationStopped};var k=f.specialHandlerWrapper||Of;1<g&&(f=ha(f));for(var l=0;l<g;l++)c.isImmediatePropagationStopped()||k(a,c,f[l])}};d.elem=a;return d}function Of(a,b,d){d.call(a,b)}function Pf(a,b,d){var c=b.relatedTarget;c&&(c===a||Qf.call(a,c))||d.call(a,b)}function Df(){this.$get=
function(){return N(P,{hasClass:function(a,b){a.attr&&(a=a[0]);return zb(a,b)},addClass:function(a,b){a.attr&&(a=a[0]);return Bb(a,b)},removeClass:function(a,b){a.attr&&(a=a[0]);return Ab(a,b)}})}}function Da(a,b){var d=a&&a.$$hashKey;if(d)return"function"===typeof d&&(d=a.$$hashKey()),d;d=typeof a;return d="function"==d||"object"==d&&null!==a?a.$$hashKey=d+":"+(b||Xd)():d+":"+a}function Sa(a,b){if(b){var d=0;this.nextUid=function(){return++d}}n(a,this.put,this)}function Rf(a){return(a=a.toString().replace(Tc,
"").match(Uc))?"function("+(a[1]||"").replace(/[\s\r\n]+/," ")+")":"fn"}function db(a,b){function d(a){return function(b,c){if(G(b))n(b,qc(a));else return a(b,c)}}function c(a,b){Ra(a,"service");if(B(b)||E(b))b=t.instantiate(b);if(!b.$get)throw Ea("pget",a);return r[a+"Provider"]=b}function e(a,b){return function(){var c=y.invoke(b,this);if(q(c))throw Ea("undef",a);return c}}function f(a,b,d){return c(a,{$get:!1!==d?e(a,b):b})}function g(a){rb(q(a)||E(a),"modulesToLoad","not an array");var b=[],c;
n(a,function(a){function d(a){var b,c;b=0;for(c=a.length;b<c;b++){var e=a[b],f=t.get(e[0]);f[e[1]].apply(f,e[2])}}if(!m.get(a)){m.put(a,!0);try{F(a)?(c=Ub(a),b=b.concat(g(c.requires)).concat(c._runBlocks),d(c._invokeQueue),d(c._configBlocks)):B(a)?b.push(t.invoke(a)):E(a)?b.push(t.invoke(a)):Qa(a,"module")}catch(e){throw E(a)&&(a=a[a.length-1]),e.message&&e.stack&&-1==e.stack.indexOf(e.message)&&(e=e.message+"\n"+e.stack),Ea("modulerr",a,e.stack||e.message||e);}}});return b}function h(a,c){function d(b,
e){if(a.hasOwnProperty(b)){if(a[b]===k)throw Ea("cdep",b+" <- "+l.join(" <- "));return a[b]}try{return l.unshift(b),a[b]=k,a[b]=c(b,e)}catch(f){throw a[b]===k&&delete a[b],f;}finally{l.shift()}}function e(a,c,f,g){"string"===typeof f&&(g=f,f=null);var k=[],h=db.$$annotate(a,b,g),l,m,t;m=0;for(l=h.length;m<l;m++){t=h[m];if("string"!==typeof t)throw Ea("itkn",t);k.push(f&&f.hasOwnProperty(t)?f[t]:d(t,g))}E(a)&&(a=a[l]);return a.apply(c,k)}return{invoke:e,instantiate:function(a,b,c){var d=Object.create((E(a)?
a[a.length-1]:a).prototype||null);a=e(a,d,b,c);return G(a)||B(a)?a:d},get:d,annotate:db.$$annotate,has:function(b){return r.hasOwnProperty(b+"Provider")||a.hasOwnProperty(b)}}}b=!0===b;var k={},l=[],m=new Sa([],!0),r={$provide:{provider:d(c),factory:d(f),service:d(function(a,b){return f(a,["$injector",function(a){return a.instantiate(b)}])}),value:d(function(a,b){return f(a,na(b),!1)}),constant:d(function(a,b){Ra(a,"constant");r[a]=b;C[a]=b}),decorator:function(a,b){var c=t.get(a+"Provider"),d=c.$get;
c.$get=function(){var a=y.invoke(d,c);return y.invoke(b,null,{$delegate:a})}}}},t=r.$injector=h(r,function(a,b){$.isString(b)&&l.push(b);throw Ea("unpr",l.join(" <- "));}),C={},y=C.$injector=h(C,function(a,b){var c=t.get(a+"Provider",b);return y.invoke(c.$get,c,w,a)});n(g(a),function(a){a&&y.invoke(a)});return y}function Ue(){var a=!0;this.disableAutoScrolling=function(){a=!1};this.$get=["$window","$location","$rootScope",function(b,d,c){function e(a){var b=null;Array.prototype.some.call(a,function(a){if("a"===
oa(a))return b=a,!0});return b}function f(a){if(a){a.scrollIntoView();var c;c=g.yOffset;B(c)?c=c():Pb(c)?(c=c[0],c="fixed"!==b.getComputedStyle(c).position?0:c.getBoundingClientRect().bottom):Q(c)||(c=0);c&&(a=a.getBoundingClientRect().top,b.scrollBy(0,a-c))}else b.scrollTo(0,0)}function g(a){a=F(a)?a:d.hash();var b;a?(b=h.getElementById(a))?f(b):(b=e(h.getElementsByName(a)))?f(b):"top"===a&&f(null):f(null)}var h=b.document;a&&c.$watch(function(){return d.hash()},function(a,b){a===b&&""===a||Mf(function(){c.$evalAsync(g)})});
return g}]}function gb(a,b){if(!a&&!b)return"";if(!a)return b;if(!b)return a;E(a)&&(a=a.join(" "));E(b)&&(b=b.join(" "));return a+" "+b}function Sf(a){F(a)&&(a=a.split(" "));var b=ea();n(a,function(a){a.length&&(b[a]=!0)});return b}function Fa(a){return G(a)?a:{}}function Tf(a,b,d,c){function e(a){try{a.apply(null,sa.call(arguments,1))}finally{if(y--,0===y)for(;R.length;)try{R.pop()()}catch(b){d.error(b)}}}function f(){H=null;g();h()}function g(){a:{try{p=m.state;break a}catch(a){}p=void 0}p=q(p)?
null:p;ka(p,D)&&(p=D);D=p}function h(){if(v!==k.url()||x!==p)v=k.url(),x=p,n(la,function(a){a(k.url(),p)})}var k=this,l=a.location,m=a.history,r=a.setTimeout,t=a.clearTimeout,C={};k.isMock=!1;var y=0,R=[];k.$$completeOutstandingRequest=e;k.$$incOutstandingRequestCount=function(){y++};k.notifyWhenNoOutstandingRequests=function(a){0===y?a():R.push(a)};var p,x,v=l.href,Y=b.find("base"),H=null;g();x=p;k.url=function(b,d,e){q(e)&&(e=null);l!==a.location&&(l=a.location);m!==a.history&&(m=a.history);if(b){var f=
x===e;if(v===b&&(!c.history||f))return k;var h=v&&Ga(v)===Ga(b);v=b;x=e;if(!c.history||h&&f){if(!h||H)H=b;d?l.replace(b):h?(d=l,e=b.indexOf("#"),e=-1===e?"":b.substr(e),d.hash=e):l.href=b;l.href!==b&&(H=b)}else m[d?"replaceState":"pushState"](e,"",b),g(),x=p;return k}return H||l.href.replace(/%27/g,"'")};k.state=function(){return p};var la=[],I=!1,D=null;k.onUrlChange=function(b){if(!I){if(c.history)A(a).on("popstate",f);A(a).on("hashchange",f);I=!0}la.push(b);return b};k.$$applicationDestroyed=function(){A(a).off("hashchange popstate",
f)};k.$$checkUrlChange=h;k.baseHref=function(){var a=Y.attr("href");return a?a.replace(/^(https?\:)?\/\/[^\/]*/,""):""};k.defer=function(a,b){var c;y++;c=r(function(){delete C[c];e(a)},b||0);C[c]=!0;return c};k.defer.cancel=function(a){return C[a]?(delete C[a],t(a),e(z),!0):!1}}function af(){this.$get=["$window","$log","$sniffer","$document",function(a,b,d,c){return new Tf(a,c,b,d)}]}function bf(){this.$get=function(){function a(a,c){function e(a){a!=r&&(t?t==a&&(t=a.n):t=a,f(a.n,a.p),f(a,r),r=a,
r.n=null)}function f(a,b){a!=b&&(a&&(a.p=b),b&&(b.n=a))}if(a in b)throw M("$cacheFactory")("iid",a);var g=0,h=N({},c,{id:a}),k=ea(),l=c&&c.capacity||Number.MAX_VALUE,m=ea(),r=null,t=null;return b[a]={put:function(a,b){if(!q(b)){if(l<Number.MAX_VALUE){var c=m[a]||(m[a]={key:a});e(c)}a in k||g++;k[a]=b;g>l&&this.remove(t.key);return b}},get:function(a){if(l<Number.MAX_VALUE){var b=m[a];if(!b)return;e(b)}return k[a]},remove:function(a){if(l<Number.MAX_VALUE){var b=m[a];if(!b)return;b==r&&(r=b.p);b==
t&&(t=b.n);f(b.n,b.p);delete m[a]}a in k&&(delete k[a],g--)},removeAll:function(){k=ea();g=0;m=ea();r=t=null},destroy:function(){m=h=k=null;delete b[a]},info:function(){return N({},h,{size:g})}}}var b={};a.info=function(){var a={};n(b,function(b,e){a[e]=b.info()});return a};a.get=function(a){return b[a]};return a}}function xf(){this.$get=["$cacheFactory",function(a){return a("templates")}]}function Dc(a,b){function d(a,b,c){var d=/^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/,e={};n(a,function(a,f){var g=a.match(d);
if(!g)throw ga("iscp",b,f,a,c?"controller bindings definition":"isolate scope definition");e[f]={mode:g[1][0],collection:"*"===g[2],optional:"?"===g[3],attrName:g[4]||f}});return e}function c(a){var b=a.charAt(0);if(!b||b!==K(b))throw ga("baddir",a);if(a!==a.trim())throw ga("baddir",a);}var e={},f=/^\s*directive\:\s*([\w\-]+)\s+(.*)$/,g=/(([\w\-]+)(?:\:([^;]+))?;?)/,h=$d("ngSrc,ngSrcset,src,srcset"),k=/^(?:(\^\^?)?(\?)?(\^\^?)?)?/,l=/^(on[a-z]+|formaction)$/;this.directive=function t(b,f){Ra(b,"directive");
F(b)?(c(b),rb(f,"directiveFactory"),e.hasOwnProperty(b)||(e[b]=[],a.factory(b+"Directive",["$injector","$exceptionHandler",function(a,c){var f=[];n(e[b],function(e,g){try{var h=a.invoke(e);B(h)?h={compile:na(h)}:!h.compile&&h.link&&(h.compile=na(h.link));h.priority=h.priority||0;h.index=g;h.name=h.name||b;h.require=h.require||h.controller&&h.name;h.restrict=h.restrict||"EA";var k=h,l=h,m=h.name,t={isolateScope:null,bindToController:null};G(l.scope)&&(!0===l.bindToController?(t.bindToController=d(l.scope,
m,!0),t.isolateScope={}):t.isolateScope=d(l.scope,m,!1));G(l.bindToController)&&(t.bindToController=d(l.bindToController,m,!0));if(G(t.bindToController)){var y=l.controller,X=l.controllerAs;if(!y)throw ga("noctrl",m);var U;a:if(X&&F(X))U=X;else{if(F(y)){var n=Vc.exec(y);if(n){U=n[3];break a}}U=void 0}if(!U)throw ga("noident",m);}var s=k.$$bindings=t;G(s.isolateScope)&&(h.$$isolateBindings=s.isolateScope);h.$$moduleName=e.$$moduleName;f.push(h)}catch(w){c(w)}});return f}])),e[b].push(f)):n(b,qc(t));
return this};this.aHrefSanitizationWhitelist=function(a){return u(a)?(b.aHrefSanitizationWhitelist(a),this):b.aHrefSanitizationWhitelist()};this.imgSrcSanitizationWhitelist=function(a){return u(a)?(b.imgSrcSanitizationWhitelist(a),this):b.imgSrcSanitizationWhitelist()};var m=!0;this.debugInfoEnabled=function(a){return u(a)?(m=a,this):m};this.$get=["$injector","$interpolate","$exceptionHandler","$templateRequest","$parse","$controller","$rootScope","$sce","$animate","$$sanitizeUri",function(a,b,c,
d,p,x,v,Y,H,la){function I(a,b){try{a.addClass(b)}catch(c){}}function D(a,b,c,d,e){a instanceof A||(a=A(a));n(a,function(b,c){b.nodeType==Na&&b.nodeValue.match(/\S+/)&&(a[c]=A(b).wrap("<span></span>").parent()[0])});var f=L(a,b,a,c,d,e);D.$$addScopeClass(a);var g=null;return function(b,c,d){rb(b,"scope");e&&e.needsNewScope&&(b=b.$parent.$new());d=d||{};var h=d.parentBoundTranscludeFn,k=d.transcludeControllers;d=d.futureParentElement;h&&h.$$boundTransclude&&(h=h.$$boundTransclude);g||(g=(d=d&&d[0])?
"foreignobject"!==oa(d)&&d.toString().match(/SVG/)?"svg":"html":"html");d="html"!==g?A(Q(g,A("<div>").append(a).html())):c?Pa.clone.call(a):a;if(k)for(var l in k)d.data("$"+l+"Controller",k[l].instance);D.$$addScopeInfo(d,b);c&&c(d,b);f&&f(b,d,d,h);return d}}function L(a,b,c,d,e,f){function g(a,c,d,e){var f,k,l,m,t,v,I;if(p)for(I=Array(c.length),m=0;m<h.length;m+=3)f=h[m],I[f]=c[f];else I=c;m=0;for(t=h.length;m<t;)k=I[h[m++]],c=h[m++],f=h[m++],c?(c.scope?(l=a.$new(),D.$$addScopeInfo(A(k),l)):l=a,
v=c.transcludeOnThisElement?O(a,c.transclude,e):!c.templateOnThisElement&&e?e:!e&&b?O(a,b):null,c(f,l,k,d,v)):f&&f(a,k.childNodes,w,e)}for(var h=[],k,l,m,t,p,v=0;v<a.length;v++){k=new aa;l=X(a[v],[],k,0===v?d:w,e);(f=l.length?s(l,a[v],k,b,c,null,[],[],f):null)&&f.scope&&D.$$addScopeClass(k.$$element);k=f&&f.terminal||!(m=a[v].childNodes)||!m.length?null:L(m,f?(f.transcludeOnThisElement||!f.templateOnThisElement)&&f.transclude:b);if(f||k)h.push(v,f,k),t=!0,p=p||f;f=null}return t?g:null}function O(a,
b,c){return function(d,e,f,g,h){d||(d=a.$new(!1,h),d.$$transcluded=!0);return b(d,e,{parentBoundTranscludeFn:c,transcludeControllers:f,futureParentElement:g})}}function X(a,b,c,d,e){var h=c.$attr,k;switch(a.nodeType){case 1:u(b,va(oa(a)),"E",d,e);for(var l,m,t,p=a.attributes,v=0,I=p&&p.length;v<I;v++){var L=!1,C=!1;l=p[v];k=l.name;m=T(l.value);l=va(k);if(t=ia.test(l))k=k.replace(Yc,"").substr(8).replace(/_(.)/g,function(a,b){return b.toUpperCase()});(l=l.match(ja))&&fa(l[1])&&(L=k,C=k.substr(0,k.length-
5)+"end",k=k.substr(0,k.length-6));l=va(k.toLowerCase());h[l]=k;if(t||!c.hasOwnProperty(l))c[l]=m,Rc(a,l)&&(c[l]=!0);P(a,b,m,l,t);u(b,l,"A",d,e,L,C)}a=a.className;G(a)&&(a=a.animVal);if(F(a)&&""!==a)for(;k=g.exec(a);)l=va(k[2]),u(b,l,"C",d,e)&&(c[l]=T(k[3])),a=a.substr(k.index+k[0].length);break;case Na:if(11===Ha)for(;a.parentNode&&a.nextSibling&&a.nextSibling.nodeType===Na;)a.nodeValue+=a.nextSibling.nodeValue,a.parentNode.removeChild(a.nextSibling);J(b,a.nodeValue);break;case 8:try{if(k=f.exec(a.nodeValue))l=
va(k[1]),u(b,l,"M",d,e)&&(c[l]=T(k[2]))}catch(X){}}b.sort(wa);return b}function U(a,b,c){var d=[],e=0;if(b&&a.hasAttribute&&a.hasAttribute(b)){do{if(!a)throw ga("uterdir",b,c);1==a.nodeType&&(a.hasAttribute(b)&&e++,a.hasAttribute(c)&&e--);d.push(a);a=a.nextSibling}while(0<e)}else d.push(a);return A(d)}function Ta(a,b,c){return function(d,e,f,g,h){e=U(e[0],b,c);return a(d,e,f,g,h)}}function s(a,b,d,e,f,g,h,l,m){function t(a,b,c,d){if(a){c&&(a=Ta(a,c,d));a.require=q.require;a.directiveName=z;if(O===
q||q.$$isolateScope)a=ba(a,{isolateScope:!0});h.push(a)}if(b){c&&(b=Ta(b,c,d));b.require=q.require;b.directiveName=z;if(O===q||q.$$isolateScope)b=ba(b,{isolateScope:!0});l.push(b)}}function p(a,b,c,d){var e;if(F(b)){var f=b.match(k);b=b.substring(f[0].length);var g=f[1]||f[3],f="?"===f[2];"^^"===g?c=c.parent():e=(e=d&&d[b])&&e.instance;e||(d="$"+b+"Controller",e=g?c.inheritedData(d):c.data(d));if(!e&&!f)throw ga("ctreq",b,a);}else if(E(b))for(e=[],g=0,f=b.length;g<f;g++)e[g]=p(a,b[g],c,d);return e||
null}function v(a,b,c,d,e,f){var g=ea(),h;for(h in d){var k=d[h],l={$scope:k===O||k.$$isolateScope?e:f,$element:a,$attrs:b,$transclude:c},m=k.controller;"@"==m&&(m=b[k.name]);l=x(m,l,!0,k.controllerAs);g[k.name]=l;hb||a.data("$"+k.name+"Controller",l.instance)}return g}function I(a,c,e,f,g){function k(a,b,c){var d;Za(a)||(c=b,b=a,a=w);hb&&(d=X);c||(c=hb?x.parent():x);return g(a,b,d,c,Ta)}var m,t,L,X,y,x,U;b===e?(f=d,x=d.$$element):(x=A(e),f=new aa(x,d));L=c;O?t=c.$new(!0):C&&(L=c.$parent);g&&(y=k,
y.$$boundTransclude=g);R&&(X=v(x,f,y,R,t,c));O&&(D.$$addScopeInfo(x,t,!0,!(n&&(n===O||n===O.$$originalDirective))),D.$$addScopeClass(x,!0),t.$$isolateBindings=O.$$isolateBindings,(U=Z(c,f,t,t.$$isolateBindings,O))&&t.$on("$destroy",U));for(var Xc in X){U=R[Xc];var Y=X[Xc],H=U.$$bindings.bindToController;Y.identifier&&H&&(m=Z(L,f,Y.instance,H,U));var q=Y();q!==Y.instance&&(Y.instance=q,x.data("$"+U.name+"Controller",q),m&&m(),m=Z(L,f,Y.instance,H,U))}fa=0;for(K=h.length;fa<K;fa++)m=h[fa],ca(m,m.isolateScope?
t:c,x,f,m.require&&p(m.directiveName,m.require,x,X),y);var Ta=c;O&&(O.template||null===O.templateUrl)&&(Ta=t);a&&a(Ta,e.childNodes,w,g);for(fa=l.length-1;0<=fa;fa--)m=l[fa],ca(m,m.isolateScope?t:c,x,f,m.require&&p(m.directiveName,m.require,x,X),y)}m=m||{};for(var L=-Number.MAX_VALUE,C=m.newScopeDirective,R=m.controllerDirectives,O=m.newIsolateScopeDirective,n=m.templateDirective,Y=m.nonTlbTranscludeDirective,H=!1,la=!1,hb=m.hasElementTranscludeDirective,u=d.$$element=A(b),q,z,J,ib=e,wa,fa=0,K=a.length;fa<
K;fa++){q=a[fa];var N=q.$$start,P=q.$$end;N&&(u=U(b,N,P));J=w;if(L>q.priority)break;if(J=q.scope)q.templateUrl||(G(J)?(Ua("new/isolated scope",O||C,q,u),O=q):Ua("new/isolated scope",O,q,u)),C=C||q;z=q.name;!q.templateUrl&&q.controller&&(J=q.controller,R=R||ea(),Ua("'"+z+"' controller",R[z],q,u),R[z]=q);if(J=q.transclude)H=!0,q.$$tlb||(Ua("transclusion",Y,q,u),Y=q),"element"==J?(hb=!0,L=q.priority,J=u,u=d.$$element=A(W.createComment(" "+z+": "+d[z]+" ")),b=u[0],V(f,sa.call(J,0),b),ib=D(J,e,L,g&&g.name,
{nonTlbTranscludeDirective:Y})):(J=A(Xb(b)).contents(),u.empty(),ib=D(J,e,w,w,{needsNewScope:q.$$isolateScope||q.$$newScope}));if(q.template)if(la=!0,Ua("template",n,q,u),n=q,J=B(q.template)?q.template(u,d):q.template,J=ha(J),q.replace){g=q;J=Vb.test(J)?Zc(Q(q.templateNamespace,T(J))):[];b=J[0];if(1!=J.length||1!==b.nodeType)throw ga("tplrt",z,"");V(f,u,b);J={$attr:{}};var Eb=X(b,[],J),$=a.splice(fa+1,a.length-(fa+1));(O||C)&&Wc(Eb,O,C);a=a.concat(Eb).concat($);M(d,J);K=a.length}else u.html(J);if(q.templateUrl)la=
!0,Ua("template",n,q,u),n=q,q.replace&&(g=q),I=S(a.splice(fa,a.length-fa),u,d,f,H&&ib,h,l,{controllerDirectives:R,newScopeDirective:C!==q&&C,newIsolateScopeDirective:O,templateDirective:n,nonTlbTranscludeDirective:Y}),K=a.length;else if(q.compile)try{wa=q.compile(u,d,ib),B(wa)?t(null,wa,N,P):wa&&t(wa.pre,wa.post,N,P)}catch(da){c(da,ua(u))}q.terminal&&(I.terminal=!0,L=Math.max(L,q.priority))}I.scope=C&&!0===C.scope;I.transcludeOnThisElement=H;I.templateOnThisElement=la;I.transclude=ib;m.hasElementTranscludeDirective=
hb;return I}function Wc(a,b,c){for(var d=0,e=a.length;d<e;d++)a[d]=Qb(a[d],{$$isolateScope:b,$$newScope:c})}function u(b,d,f,g,h,k,l){if(d===h)return null;h=null;if(e.hasOwnProperty(d)){var m;d=a.get(d+"Directive");for(var p=0,v=d.length;p<v;p++)try{m=d[p],(q(g)||g>m.priority)&&-1!=m.restrict.indexOf(f)&&(k&&(m=Qb(m,{$$start:k,$$end:l})),b.push(m),h=m)}catch(I){c(I)}}return h}function fa(b){if(e.hasOwnProperty(b))for(var c=a.get(b+"Directive"),d=0,f=c.length;d<f;d++)if(b=c[d],b.multiElement)return!0;
return!1}function M(a,b){var c=b.$attr,d=a.$attr,e=a.$$element;n(a,function(d,e){"$"!=e.charAt(0)&&(b[e]&&b[e]!==d&&(d+=("style"===e?";":" ")+b[e]),a.$set(e,d,!0,c[e]))});n(b,function(b,f){"class"==f?(I(e,b),a["class"]=(a["class"]?a["class"]+" ":"")+b):"style"==f?(e.attr("style",e.attr("style")+";"+b),a.style=(a.style?a.style+";":"")+b):"$"==f.charAt(0)||a.hasOwnProperty(f)||(a[f]=b,d[f]=c[f])})}function S(a,b,c,e,f,g,h,k){var l=[],m,t,p=b[0],v=a.shift(),C=Qb(v,{templateUrl:null,transclude:null,replace:null,
$$originalDirective:v}),x=B(v.templateUrl)?v.templateUrl(b,c):v.templateUrl,y=v.templateNamespace;b.empty();d(x).then(function(d){var R,D;d=ha(d);if(v.replace){d=Vb.test(d)?Zc(Q(y,T(d))):[];R=d[0];if(1!=d.length||1!==R.nodeType)throw ga("tplrt",v.name,x);d={$attr:{}};V(e,b,R);var U=X(R,[],d);G(v.scope)&&Wc(U,!0);a=U.concat(a);M(c,d)}else R=p,b.html(d);a.unshift(C);m=s(a,R,c,f,b,v,g,h,k);n(e,function(a,c){a==R&&(e[c]=b[0])});for(t=L(b[0].childNodes,f);l.length;){d=l.shift();D=l.shift();var Y=l.shift(),
H=l.shift(),U=b[0];if(!d.$$destroyed){if(D!==p){var q=D.className;k.hasElementTranscludeDirective&&v.replace||(U=Xb(R));V(Y,A(D),U);I(A(U),q)}D=m.transcludeOnThisElement?O(d,m.transclude,H):H;m(t,d,U,e,D)}}l=null});return function(a,b,c,d,e){a=e;b.$$destroyed||(l?l.push(b,c,d,a):(m.transcludeOnThisElement&&(a=O(b,m.transclude,e)),m(t,b,c,d,a)))}}function wa(a,b){var c=b.priority-a.priority;return 0!==c?c:a.name!==b.name?a.name<b.name?-1:1:a.index-b.index}function Ua(a,b,c,d){function e(a){return a?
" (module: "+a+")":""}if(b)throw ga("multidir",b.name,e(b.$$moduleName),c.name,e(c.$$moduleName),a,ua(d));}function J(a,c){var d=b(c,!0);d&&a.push({priority:0,compile:function(a){a=a.parent();var b=!!a.length;b&&D.$$addBindingClass(a);return function(a,c){var e=c.parent();b||D.$$addBindingClass(e);D.$$addBindingInfo(e,d.expressions);a.$watch(d,function(a){c[0].nodeValue=a})}}})}function Q(a,b){a=K(a||"html");switch(a){case "svg":case "math":var c=W.createElement("div");c.innerHTML="<"+a+">"+b+"</"+
a+">";return c.childNodes[0].childNodes;default:return b}}function Eb(a,b){if("srcdoc"==b)return Y.HTML;var c=oa(a);if("xlinkHref"==b||"form"==c&&"action"==b||"img"!=c&&("src"==b||"ngSrc"==b))return Y.RESOURCE_URL}function P(a,c,d,e,f){var g=Eb(a,e);f=h[e]||f;var k=b(d,!0,g,f);if(k){if("multiple"===e&&"select"===oa(a))throw ga("selmulti",ua(a));c.push({priority:100,compile:function(){return{pre:function(a,c,h){c=h.$$observers||(h.$$observers=ea());if(l.test(e))throw ga("nodomevents");var m=h[e];m!==
d&&(k=m&&b(m,!0,g,f),d=m);k&&(h[e]=k(a),(c[e]||(c[e]=[])).$$inter=!0,(h.$$observers&&h.$$observers[e].$$scope||a).$watch(k,function(a,b){"class"===e&&a!=b?h.$updateClass(a,b):h.$set(e,a)}))}}}})}}function V(a,b,c){var d=b[0],e=b.length,f=d.parentNode,g,h;if(a)for(g=0,h=a.length;g<h;g++)if(a[g]==d){a[g++]=c;h=g+e-1;for(var k=a.length;g<k;g++,h++)h<k?a[g]=a[h]:delete a[g];a.length-=e-1;a.context===d&&(a.context=c);break}f&&f.replaceChild(c,d);a=W.createDocumentFragment();a.appendChild(d);A.hasData(d)&&
(A.data(c,A.data(d)),pa?(Tb=!0,pa.cleanData([d])):delete A.cache[d[A.expando]]);d=1;for(e=b.length;d<e;d++)f=b[d],A(f).remove(),a.appendChild(f),delete b[d];b[0]=c;b.length=1}function ba(a,b){return N(function(){return a.apply(null,arguments)},a,b)}function ca(a,b,d,e,f,g){try{a(b,d,e,f,g)}catch(h){c(h,ua(d))}}function Z(a,c,d,e,f){var g=[];n(e,function(e,h){var k=e.attrName,l=e.optional,m,t,v,I;switch(e.mode){case "@":l||ra.call(c,k)||(d[h]=c[k]=void 0);c.$observe(k,function(a){F(a)&&(d[h]=a)});
c.$$observers[k].$$scope=a;F(c[k])&&(d[h]=b(c[k])(a));break;case "=":if(!ra.call(c,k)){if(l)break;c[k]=void 0}if(l&&!c[k])break;t=p(c[k]);I=t.literal?ka:function(a,b){return a===b||a!==a&&b!==b};v=t.assign||function(){m=d[h]=t(a);throw ga("nonassign",c[k],f.name);};m=d[h]=t(a);l=function(b){I(b,d[h])||(I(b,m)?v(a,b=d[h]):d[h]=b);return m=b};l.$stateful=!0;l=e.collection?a.$watchCollection(c[k],l):a.$watch(p(c[k],l),null,t.literal);g.push(l);break;case "&":t=c.hasOwnProperty(k)?p(c[k]):z;if(t===z&&
l)break;d[h]=function(b){return t(a,b)}}});return g.length&&function(){for(var a=0,b=g.length;a<b;++a)g[a]()}}var aa=function(a,b){if(b){var c=Object.keys(b),d,e,f;d=0;for(e=c.length;d<e;d++)f=c[d],this[f]=b[f]}else this.$attr={};this.$$element=a};aa.prototype={$normalize:va,$addClass:function(a){a&&0<a.length&&H.addClass(this.$$element,a)},$removeClass:function(a){a&&0<a.length&&H.removeClass(this.$$element,a)},$updateClass:function(a,b){var c=$c(a,b);c&&c.length&&H.addClass(this.$$element,c);(c=
$c(b,a))&&c.length&&H.removeClass(this.$$element,c)},$set:function(a,b,d,e){var f=Rc(this.$$element[0],a),g=ad[a],h=a;f?(this.$$element.prop(a,b),e=f):g&&(this[g]=b,h=g);this[a]=b;e?this.$attr[a]=e:(e=this.$attr[a])||(this.$attr[a]=e=Ac(a,"-"));f=oa(this.$$element);if("a"===f&&"href"===a||"img"===f&&"src"===a)this[a]=b=la(b,"src"===a);else if("img"===f&&"srcset"===a){for(var f="",g=T(b),k=/(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/,k=/\s/.test(g)?k:/(,)/,g=g.split(k),k=Math.floor(g.length/2),l=0;l<k;l++)var m=
2*l,f=f+la(T(g[m]),!0),f=f+(" "+T(g[m+1]));g=T(g[2*l]).split(/\s/);f+=la(T(g[0]),!0);2===g.length&&(f+=" "+T(g[1]));this[a]=b=f}!1!==d&&(null===b||q(b)?this.$$element.removeAttr(e):this.$$element.attr(e,b));(a=this.$$observers)&&n(a[h],function(a){try{a(b)}catch(d){c(d)}})},$observe:function(a,b){var c=this,d=c.$$observers||(c.$$observers=ea()),e=d[a]||(d[a]=[]);e.push(b);v.$evalAsync(function(){e.$$inter||!c.hasOwnProperty(a)||q(c[a])||b(c[a])});return function(){ab(e,b)}}};var $=b.startSymbol(),
da=b.endSymbol(),ha="{{"==$||"}}"==da?Ya:function(a){return a.replace(/\{\{/g,$).replace(/}}/g,da)},ia=/^ngAttr[A-Z]/,ja=/^(.+)Start$/;D.$$addBindingInfo=m?function(a,b){var c=a.data("$binding")||[];E(b)?c=c.concat(b):c.push(b);a.data("$binding",c)}:z;D.$$addBindingClass=m?function(a){I(a,"ng-binding")}:z;D.$$addScopeInfo=m?function(a,b,c,d){a.data(c?d?"$isolateScopeNoTemplate":"$isolateScope":"$scope",b)}:z;D.$$addScopeClass=m?function(a,b){I(a,b?"ng-isolate-scope":"ng-scope")}:z;return D}]}function va(a){return eb(a.replace(Yc,
""))}function $c(a,b){var d="",c=a.split(/\s+/),e=b.split(/\s+/),f=0;a:for(;f<c.length;f++){for(var g=c[f],h=0;h<e.length;h++)if(g==e[h])continue a;d+=(0<d.length?" ":"")+g}return d}function Zc(a){a=A(a);var b=a.length;if(1>=b)return a;for(;b--;)8===a[b].nodeType&&Uf.call(a,b,1);return a}function cf(){var a={},b=!1;this.register=function(b,c){Ra(b,"controller");G(b)?N(a,b):a[b]=c};this.allowGlobals=function(){b=!0};this.$get=["$injector","$window",function(d,c){function e(a,b,c,d){if(!a||!G(a.$scope))throw M("$controller")("noscp",
d,b);a.$scope[b]=c}return function(f,g,h,k){var l,m,r;h=!0===h;k&&F(k)&&(r=k);if(F(f)){k=f.match(Vc);if(!k)throw Vf("ctrlfmt",f);m=k[1];r=r||k[3];f=a.hasOwnProperty(m)?a[m]:Cc(g.$scope,m,!0)||(b?Cc(c,m,!0):w);Qa(f,m,!0)}if(h)return h=(E(f)?f[f.length-1]:f).prototype,l=Object.create(h||null),r&&e(g,r,l,m||f.name),N(function(){var a=d.invoke(f,l,g,m);a!==l&&(G(a)||B(a))&&(l=a,r&&e(g,r,l,m||f.name));return l},{instance:l,identifier:r});l=d.instantiate(f,g,m);r&&e(g,r,l,m||f.name);return l}}]}function df(){this.$get=
["$window",function(a){return A(a.document)}]}function ef(){this.$get=["$log",function(a){return function(b,d){a.error.apply(a,arguments)}}]}function $b(a){return G(a)?da(a)?a.toISOString():cb(a):a}function kf(){this.$get=function(){return function(a){if(!a)return"";var b=[];pc(a,function(a,c){null===a||q(a)||(E(a)?n(a,function(a,d){b.push(ia(c)+"="+ia($b(a)))}):b.push(ia(c)+"="+ia($b(a))))});return b.join("&")}}}function lf(){this.$get=function(){return function(a){function b(a,e,f){null===a||q(a)||
(E(a)?n(a,function(a,c){b(a,e+"["+(G(a)?c:"")+"]")}):G(a)&&!da(a)?pc(a,function(a,c){b(a,e+(f?"":"[")+c+(f?"":"]"))}):d.push(ia(e)+"="+ia($b(a))))}if(!a)return"";var d=[];b(a,"",!0);return d.join("&")}}}function ac(a,b){if(F(a)){var d=a.replace(Wf,"").trim();if(d){var c=b("Content-Type");(c=c&&0===c.indexOf(bd))||(c=(c=d.match(Xf))&&Yf[c[0]].test(d));c&&(a=vc(d))}}return a}function cd(a){var b=ea(),d;F(a)?n(a.split("\n"),function(a){d=a.indexOf(":");var e=K(T(a.substr(0,d)));a=T(a.substr(d+1));e&&
(b[e]=b[e]?b[e]+", "+a:a)}):G(a)&&n(a,function(a,d){var f=K(d),g=T(a);f&&(b[f]=b[f]?b[f]+", "+g:g)});return b}function dd(a){var b;return function(d){b||(b=cd(a));return d?(d=b[K(d)],void 0===d&&(d=null),d):b}}function ed(a,b,d,c){if(B(c))return c(a,b,d);n(c,function(c){a=c(a,b,d)});return a}function jf(){var a=this.defaults={transformResponse:[ac],transformRequest:[function(a){return G(a)&&"[object File]"!==ta.call(a)&&"[object Blob]"!==ta.call(a)&&"[object FormData]"!==ta.call(a)?cb(a):a}],headers:{common:{Accept:"application/json, text/plain, */*"},
post:ha(bc),put:ha(bc),patch:ha(bc)},xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",paramSerializer:"$httpParamSerializer"},b=!1;this.useApplyAsync=function(a){return u(a)?(b=!!a,this):b};var d=!0;this.useLegacyPromiseExtensions=function(a){return u(a)?(d=!!a,this):d};var c=this.interceptors=[];this.$get=["$httpBackend","$$cookieReader","$cacheFactory","$rootScope","$q","$injector",function(e,f,g,h,k,l){function m(b){function c(a){var b=N({},a);b.data=ed(a.data,a.headers,a.status,f.transformResponse);
a=a.status;return 200<=a&&300>a?b:k.reject(b)}function e(a,b){var c,d={};n(a,function(a,e){B(a)?(c=a(b),null!=c&&(d[e]=c)):d[e]=a});return d}if(!$.isObject(b))throw M("$http")("badreq",b);if(!F(b.url))throw M("$http")("badreq",b.url);var f=N({method:"get",transformRequest:a.transformRequest,transformResponse:a.transformResponse,paramSerializer:a.paramSerializer},b);f.headers=function(b){var c=a.headers,d=N({},b.headers),f,g,h,c=N({},c.common,c[K(b.method)]);a:for(f in c){g=K(f);for(h in d)if(K(h)===
g)continue a;d[f]=c[f]}return e(d,ha(b))}(b);f.method=tb(f.method);f.paramSerializer=F(f.paramSerializer)?l.get(f.paramSerializer):f.paramSerializer;var g=[function(b){var d=b.headers,e=ed(b.data,dd(d),w,b.transformRequest);q(e)&&n(d,function(a,b){"content-type"===K(b)&&delete d[b]});q(b.withCredentials)&&!q(a.withCredentials)&&(b.withCredentials=a.withCredentials);return r(b,e).then(c,c)},w],h=k.when(f);for(n(y,function(a){(a.request||a.requestError)&&g.unshift(a.request,a.requestError);(a.response||
a.responseError)&&g.push(a.response,a.responseError)});g.length;){b=g.shift();var m=g.shift(),h=h.then(b,m)}d?(h.success=function(a){Qa(a,"fn");h.then(function(b){a(b.data,b.status,b.headers,f)});return h},h.error=function(a){Qa(a,"fn");h.then(null,function(b){a(b.data,b.status,b.headers,f)});return h}):(h.success=fd("success"),h.error=fd("error"));return h}function r(c,d){function g(a,c,d,e){function f(){l(c,a,d,e)}D&&(200<=a&&300>a?D.put(X,[a,c,cd(d),e]):D.remove(X));b?h.$applyAsync(f):(f(),h.$$phase||
h.$apply())}function l(a,b,d,e){b=-1<=b?b:0;(200<=b&&300>b?n.resolve:n.reject)({data:a,status:b,headers:dd(d),config:c,statusText:e})}function r(a){l(a.data,a.status,ha(a.headers()),a.statusText)}function y(){var a=m.pendingRequests.indexOf(c);-1!==a&&m.pendingRequests.splice(a,1)}var n=k.defer(),I=n.promise,D,L,O=c.headers,X=t(c.url,c.paramSerializer(c.params));m.pendingRequests.push(c);I.then(y,y);!c.cache&&!a.cache||!1===c.cache||"GET"!==c.method&&"JSONP"!==c.method||(D=G(c.cache)?c.cache:G(a.cache)?
a.cache:C);D&&(L=D.get(X),u(L)?L&&B(L.then)?L.then(r,r):E(L)?l(L[1],L[0],ha(L[2]),L[3]):l(L,200,{},"OK"):D.put(X,I));q(L)&&((L=gd(c.url)?f()[c.xsrfCookieName||a.xsrfCookieName]:w)&&(O[c.xsrfHeaderName||a.xsrfHeaderName]=L),e(c.method,X,d,g,O,c.timeout,c.withCredentials,c.responseType));return I}function t(a,b){0<b.length&&(a+=(-1==a.indexOf("?")?"?":"&")+b);return a}var C=g("$http");a.paramSerializer=F(a.paramSerializer)?l.get(a.paramSerializer):a.paramSerializer;var y=[];n(c,function(a){y.unshift(F(a)?
l.get(a):l.invoke(a))});m.pendingRequests=[];(function(a){n(arguments,function(a){m[a]=function(b,c){return m(N({},c||{},{method:a,url:b}))}})})("get","delete","head","jsonp");(function(a){n(arguments,function(a){m[a]=function(b,c,d){return m(N({},d||{},{method:a,url:b,data:c}))}})})("post","put","patch");m.defaults=a;return m}]}function nf(){this.$get=function(){return function(){return new S.XMLHttpRequest}}}function mf(){this.$get=["$browser","$window","$document","$xhrFactory",function(a,b,d,
c){return Zf(a,c,a.defer,b.angular.callbacks,d[0])}]}function Zf(a,b,d,c,e){function f(a,b,d){var f=e.createElement("script"),m=null;f.type="text/javascript";f.src=a;f.async=!0;m=function(a){f.removeEventListener("load",m,!1);f.removeEventListener("error",m,!1);e.body.removeChild(f);f=null;var g=-1,C="unknown";a&&("load"!==a.type||c[b].called||(a={type:"error"}),C=a.type,g="error"===a.type?404:200);d&&d(g,C)};f.addEventListener("load",m,!1);f.addEventListener("error",m,!1);e.body.appendChild(f);return m}
return function(e,h,k,l,m,r,t,C){function y(){x&&x();v&&v.abort()}function R(b,c,e,f,g){u(H)&&d.cancel(H);x=v=null;b(c,e,f,g);a.$$completeOutstandingRequest(z)}a.$$incOutstandingRequestCount();h=h||a.url();if("jsonp"==K(e)){var p="_"+(c.counter++).toString(36);c[p]=function(a){c[p].data=a;c[p].called=!0};var x=f(h.replace("JSON_CALLBACK","angular.callbacks."+p),p,function(a,b){R(l,a,c[p].data,"",b);c[p]=z})}else{var v=b(e,h);v.open(e,h,!0);n(m,function(a,b){u(a)&&v.setRequestHeader(b,a)});v.onload=
function(){var a=v.statusText||"",b="response"in v?v.response:v.responseText,c=1223===v.status?204:v.status;0===c&&(c=b?200:"file"==xa(h).protocol?404:0);R(l,c,b,v.getAllResponseHeaders(),a)};e=function(){R(l,-1,null,null,"")};v.onerror=e;v.onabort=e;t&&(v.withCredentials=!0);if(C)try{v.responseType=C}catch(Y){if("json"!==C)throw Y;}v.send(q(k)?null:k)}if(0<r)var H=d(y,r);else r&&B(r.then)&&r.then(y)}}function gf(){var a="{{",b="}}";this.startSymbol=function(b){return b?(a=b,this):a};this.endSymbol=
function(a){return a?(b=a,this):b};this.$get=["$parse","$exceptionHandler","$sce",function(d,c,e){function f(a){return"\\\\\\"+a}function g(c){return c.replace(m,a).replace(r,b)}function h(f,h,m,r){function p(a){try{var b=a;a=m?e.getTrusted(m,b):e.valueOf(b);var d;if(r&&!u(a))d=a;else if(null==a)d="";else{switch(typeof a){case "string":break;case "number":a=""+a;break;default:a=cb(a)}d=a}return d}catch(g){c(Ia.interr(f,g))}}r=!!r;for(var x,v,n=0,H=[],s=[],I=f.length,D=[],L=[];n<I;)if(-1!=(x=f.indexOf(a,
n))&&-1!=(v=f.indexOf(b,x+k)))n!==x&&D.push(g(f.substring(n,x))),n=f.substring(x+k,v),H.push(n),s.push(d(n,p)),n=v+l,L.push(D.length),D.push("");else{n!==I&&D.push(g(f.substring(n)));break}m&&1<D.length&&Ia.throwNoconcat(f);if(!h||H.length){var O=function(a){for(var b=0,c=H.length;b<c;b++){if(r&&q(a[b]))return;D[L[b]]=a[b]}return D.join("")};return N(function(a){var b=0,d=H.length,e=Array(d);try{for(;b<d;b++)e[b]=s[b](a);return O(e)}catch(g){c(Ia.interr(f,g))}},{exp:f,expressions:H,$$watchDelegate:function(a,
b){var c;return a.$watchGroup(s,function(d,e){var f=O(d);B(b)&&b.call(this,f,d!==e?c:f,a);c=f})}})}}var k=a.length,l=b.length,m=new RegExp(a.replace(/./g,f),"g"),r=new RegExp(b.replace(/./g,f),"g");h.startSymbol=function(){return a};h.endSymbol=function(){return b};return h}]}function hf(){this.$get=["$rootScope","$window","$q","$$q",function(a,b,d,c){function e(e,h,k,l){var m=4<arguments.length,r=m?sa.call(arguments,4):[],t=b.setInterval,C=b.clearInterval,y=0,n=u(l)&&!l,p=(n?c:d).defer(),x=p.promise;
k=u(k)?k:0;x.then(null,null,m?function(){e.apply(null,r)}:e);x.$$intervalId=t(function(){p.notify(y++);0<k&&y>=k&&(p.resolve(y),C(x.$$intervalId),delete f[x.$$intervalId]);n||a.$apply()},h);f[x.$$intervalId]=p;return x}var f={};e.cancel=function(a){return a&&a.$$intervalId in f?(f[a.$$intervalId].reject("canceled"),b.clearInterval(a.$$intervalId),delete f[a.$$intervalId],!0):!1};return e}]}function cc(a){a=a.split("/");for(var b=a.length;b--;)a[b]=pb(a[b]);return a.join("/")}function hd(a,b){var d=
xa(a);b.$$protocol=d.protocol;b.$$host=d.hostname;b.$$port=Z(d.port)||$f[d.protocol]||null}function id(a,b){var d="/"!==a.charAt(0);d&&(a="/"+a);var c=xa(a);b.$$path=decodeURIComponent(d&&"/"===c.pathname.charAt(0)?c.pathname.substring(1):c.pathname);b.$$search=yc(c.search);b.$$hash=decodeURIComponent(c.hash);b.$$path&&"/"!=b.$$path.charAt(0)&&(b.$$path="/"+b.$$path)}function qa(a,b){if(0===b.indexOf(a))return b.substr(a.length)}function Ga(a){var b=a.indexOf("#");return-1==b?a:a.substr(0,b)}function jb(a){return a.replace(/(#.+)|#$/,
"$1")}function dc(a,b,d){this.$$html5=!0;d=d||"";hd(a,this);this.$$parse=function(a){var d=qa(b,a);if(!F(d))throw Fb("ipthprfx",a,b);id(d,this);this.$$path||(this.$$path="/");this.$$compose()};this.$$compose=function(){var a=Sb(this.$$search),d=this.$$hash?"#"+pb(this.$$hash):"";this.$$url=cc(this.$$path)+(a?"?"+a:"")+d;this.$$absUrl=b+this.$$url.substr(1)};this.$$parseLinkUrl=function(c,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,g;u(f=qa(a,c))?(g=f,g=u(f=qa(d,f))?b+(qa("/",f)||f):
a+g):u(f=qa(b,c))?g=b+f:b==c+"/"&&(g=b);g&&this.$$parse(g);return!!g}}function ec(a,b,d){hd(a,this);this.$$parse=function(c){var e=qa(a,c)||qa(b,c),f;q(e)||"#"!==e.charAt(0)?this.$$html5?f=e:(f="",q(e)&&(a=c,this.replace())):(f=qa(d,e),q(f)&&(f=e));id(f,this);c=this.$$path;var e=a,g=/^\/[A-Z]:(\/.*)/;0===f.indexOf(e)&&(f=f.replace(e,""));g.exec(f)||(c=(f=g.exec(c))?f[1]:c);this.$$path=c;this.$$compose()};this.$$compose=function(){var b=Sb(this.$$search),e=this.$$hash?"#"+pb(this.$$hash):"";this.$$url=
cc(this.$$path)+(b?"?"+b:"")+e;this.$$absUrl=a+(this.$$url?d+this.$$url:"")};this.$$parseLinkUrl=function(b,d){return Ga(a)==Ga(b)?(this.$$parse(b),!0):!1}}function jd(a,b,d){this.$$html5=!0;ec.apply(this,arguments);this.$$parseLinkUrl=function(c,e){if(e&&"#"===e[0])return this.hash(e.slice(1)),!0;var f,g;a==Ga(c)?f=c:(g=qa(b,c))?f=a+d+g:b===c+"/"&&(f=b);f&&this.$$parse(f);return!!f};this.$$compose=function(){var b=Sb(this.$$search),e=this.$$hash?"#"+pb(this.$$hash):"";this.$$url=cc(this.$$path)+
(b?"?"+b:"")+e;this.$$absUrl=a+d+this.$$url}}function Gb(a){return function(){return this[a]}}function kd(a,b){return function(d){if(q(d))return this[a];this[a]=b(d);this.$$compose();return this}}function of(){var a="",b={enabled:!1,requireBase:!0,rewriteLinks:!0};this.hashPrefix=function(b){return u(b)?(a=b,this):a};this.html5Mode=function(a){return $a(a)?(b.enabled=a,this):G(a)?($a(a.enabled)&&(b.enabled=a.enabled),$a(a.requireBase)&&(b.requireBase=a.requireBase),$a(a.rewriteLinks)&&(b.rewriteLinks=
a.rewriteLinks),this):b};this.$get=["$rootScope","$browser","$sniffer","$rootElement","$window",function(d,c,e,f,g){function h(a,b,d){var e=l.url(),f=l.$$state;try{c.url(a,b,d),l.$$state=c.state()}catch(g){throw l.url(e),l.$$state=f,g;}}function k(a,b){d.$broadcast("$locationChangeSuccess",l.absUrl(),a,l.$$state,b)}var l,m;m=c.baseHref();var r=c.url(),t;if(b.enabled){if(!m&&b.requireBase)throw Fb("nobase");t=r.substring(0,r.indexOf("/",r.indexOf("//")+2))+(m||"/");m=e.history?dc:jd}else t=Ga(r),m=
ec;var C=t.substr(0,Ga(t).lastIndexOf("/")+1);l=new m(t,C,"#"+a);l.$$parseLinkUrl(r,r);l.$$state=c.state();var y=/^\s*(javascript|mailto):/i;f.on("click",function(a){if(b.rewriteLinks&&!a.ctrlKey&&!a.metaKey&&!a.shiftKey&&2!=a.which&&2!=a.button){for(var e=A(a.target);"a"!==oa(e[0]);)if(e[0]===f[0]||!(e=e.parent())[0])return;var h=e.prop("href"),k=e.attr("href")||e.attr("xlink:href");G(h)&&"[object SVGAnimatedString]"===h.toString()&&(h=xa(h.animVal).href);y.test(h)||!h||e.attr("target")||a.isDefaultPrevented()||
!l.$$parseLinkUrl(h,k)||(a.preventDefault(),l.absUrl()!=c.url()&&(d.$apply(),g.angular["ff-684208-preventDefault"]=!0))}});jb(l.absUrl())!=jb(r)&&c.url(l.absUrl(),!0);var n=!0;c.onUrlChange(function(a,b){q(qa(C,a))?g.location.href=a:(d.$evalAsync(function(){var c=l.absUrl(),e=l.$$state,f;a=jb(a);l.$$parse(a);l.$$state=b;f=d.$broadcast("$locationChangeStart",a,c,b,e).defaultPrevented;l.absUrl()===a&&(f?(l.$$parse(c),l.$$state=e,h(c,!1,e)):(n=!1,k(c,e)))}),d.$$phase||d.$digest())});d.$watch(function(){var a=
jb(c.url()),b=jb(l.absUrl()),f=c.state(),g=l.$$replace,m=a!==b||l.$$html5&&e.history&&f!==l.$$state;if(n||m)n=!1,d.$evalAsync(function(){var b=l.absUrl(),c=d.$broadcast("$locationChangeStart",b,a,l.$$state,f).defaultPrevented;l.absUrl()===b&&(c?(l.$$parse(a),l.$$state=f):(m&&h(b,g,f===l.$$state?null:l.$$state),k(a,f)))});l.$$replace=!1});return l}]}function pf(){var a=!0,b=this;this.debugEnabled=function(b){return u(b)?(a=b,this):a};this.$get=["$window",function(d){function c(a){a instanceof Error&&
(a.stack?a=a.message&&-1===a.stack.indexOf(a.message)?"Error: "+a.message+"\n"+a.stack:a.stack:a.sourceURL&&(a=a.message+"\n"+a.sourceURL+":"+a.line));return a}function e(a){var b=d.console||{},e=b[a]||b.log||z;a=!1;try{a=!!e.apply}catch(k){}return a?function(){var a=[];n(arguments,function(b){a.push(c(b))});return e.apply(b,a)}:function(a,b){e(a,null==b?"":b)}}return{log:e("log"),info:e("info"),warn:e("warn"),error:e("error"),debug:function(){var c=e("debug");return function(){a&&c.apply(b,arguments)}}()}}]}
function Va(a,b){if("__defineGetter__"===a||"__defineSetter__"===a||"__lookupGetter__"===a||"__lookupSetter__"===a||"__proto__"===a)throw aa("isecfld",b);return a}function ld(a,b){a+="";if(!F(a))throw aa("iseccst",b);return a}function ya(a,b){if(a){if(a.constructor===a)throw aa("isecfn",b);if(a.window===a)throw aa("isecwindow",b);if(a.children&&(a.nodeName||a.prop&&a.attr&&a.find))throw aa("isecdom",b);if(a===Object)throw aa("isecobj",b);}return a}function md(a,b){if(a){if(a.constructor===a)throw aa("isecfn",
b);if(a===ag||a===bg||a===cg)throw aa("isecff",b);}}function nd(a,b){if(a&&(a===(0).constructor||a===(!1).constructor||a==="".constructor||a==={}.constructor||a===[].constructor||a===Function.constructor))throw aa("isecaf",b);}function dg(a,b){return"undefined"!==typeof a?a:b}function od(a,b){return"undefined"===typeof a?b:"undefined"===typeof b?a:a+b}function V(a,b){var d,c;switch(a.type){case s.Program:d=!0;n(a.body,function(a){V(a.expression,b);d=d&&a.expression.constant});a.constant=d;break;case s.Literal:a.constant=
!0;a.toWatch=[];break;case s.UnaryExpression:V(a.argument,b);a.constant=a.argument.constant;a.toWatch=a.argument.toWatch;break;case s.BinaryExpression:V(a.left,b);V(a.right,b);a.constant=a.left.constant&&a.right.constant;a.toWatch=a.left.toWatch.concat(a.right.toWatch);break;case s.LogicalExpression:V(a.left,b);V(a.right,b);a.constant=a.left.constant&&a.right.constant;a.toWatch=a.constant?[]:[a];break;case s.ConditionalExpression:V(a.test,b);V(a.alternate,b);V(a.consequent,b);a.constant=a.test.constant&&
a.alternate.constant&&a.consequent.constant;a.toWatch=a.constant?[]:[a];break;case s.Identifier:a.constant=!1;a.toWatch=[a];break;case s.MemberExpression:V(a.object,b);a.computed&&V(a.property,b);a.constant=a.object.constant&&(!a.computed||a.property.constant);a.toWatch=[a];break;case s.CallExpression:d=a.filter?!b(a.callee.name).$stateful:!1;c=[];n(a.arguments,function(a){V(a,b);d=d&&a.constant;a.constant||c.push.apply(c,a.toWatch)});a.constant=d;a.toWatch=a.filter&&!b(a.callee.name).$stateful?c:
[a];break;case s.AssignmentExpression:V(a.left,b);V(a.right,b);a.constant=a.left.constant&&a.right.constant;a.toWatch=[a];break;case s.ArrayExpression:d=!0;c=[];n(a.elements,function(a){V(a,b);d=d&&a.constant;a.constant||c.push.apply(c,a.toWatch)});a.constant=d;a.toWatch=c;break;case s.ObjectExpression:d=!0;c=[];n(a.properties,function(a){V(a.value,b);d=d&&a.value.constant;a.value.constant||c.push.apply(c,a.value.toWatch)});a.constant=d;a.toWatch=c;break;case s.ThisExpression:a.constant=!1,a.toWatch=
[]}}function pd(a){if(1==a.length){a=a[0].expression;var b=a.toWatch;return 1!==b.length?b:b[0]!==a?b:w}}function qd(a){return a.type===s.Identifier||a.type===s.MemberExpression}function rd(a){if(1===a.body.length&&qd(a.body[0].expression))return{type:s.AssignmentExpression,left:a.body[0].expression,right:{type:s.NGValueParameter},operator:"="}}function sd(a){return 0===a.body.length||1===a.body.length&&(a.body[0].expression.type===s.Literal||a.body[0].expression.type===s.ArrayExpression||a.body[0].expression.type===
s.ObjectExpression)}function td(a,b){this.astBuilder=a;this.$filter=b}function ud(a,b){this.astBuilder=a;this.$filter=b}function Hb(a){return"constructor"==a}function fc(a){return B(a.valueOf)?a.valueOf():eg.call(a)}function qf(){var a=ea(),b=ea();this.$get=["$filter",function(d){function c(a,b){return null==a||null==b?a===b:"object"===typeof a&&(a=fc(a),"object"===typeof a)?!1:a===b||a!==a&&b!==b}function e(a,b,d,e,f){var g=e.inputs,h;if(1===g.length){var k=c,g=g[0];return a.$watch(function(a){var b=
g(a);c(b,k)||(h=e(a,w,w,[b]),k=b&&fc(b));return h},b,d,f)}for(var l=[],m=[],r=0,n=g.length;r<n;r++)l[r]=c,m[r]=null;return a.$watch(function(a){for(var b=!1,d=0,f=g.length;d<f;d++){var k=g[d](a);if(b||(b=!c(k,l[d])))m[d]=k,l[d]=k&&fc(k)}b&&(h=e(a,w,w,m));return h},b,d,f)}function f(a,b,c,d){var e,f;return e=a.$watch(function(a){return d(a)},function(a,c,d){f=a;B(b)&&b.apply(this,arguments);u(a)&&d.$$postDigest(function(){u(f)&&e()})},c)}function g(a,b,c,d){function e(a){var b=!0;n(a,function(a){u(a)||
(b=!1)});return b}var f,g;return f=a.$watch(function(a){return d(a)},function(a,c,d){g=a;B(b)&&b.call(this,a,c,d);e(a)&&d.$$postDigest(function(){e(g)&&f()})},c)}function h(a,b,c,d){var e;return e=a.$watch(function(a){return d(a)},function(a,c,d){B(b)&&b.apply(this,arguments);e()},c)}function k(a,b){if(!b)return a;var c=a.$$watchDelegate,d=!1,c=c!==g&&c!==f?function(c,e,f,g){f=d&&g?g[0]:a(c,e,f,g);return b(f,c,e)}:function(c,d,e,f){e=a(c,d,e,f);c=b(e,c,d);return u(e)?c:e};a.$$watchDelegate&&a.$$watchDelegate!==
e?c.$$watchDelegate=a.$$watchDelegate:b.$stateful||(c.$$watchDelegate=e,d=!a.inputs,c.inputs=a.inputs?a.inputs:[a]);return c}var l=Ca().noUnsafeEval,m={csp:l,expensiveChecks:!1},r={csp:l,expensiveChecks:!0};return function(c,l,y){var n,p,x;switch(typeof c){case "string":x=c=c.trim();var v=y?b:a;n=v[x];n||(":"===c.charAt(0)&&":"===c.charAt(1)&&(p=!0,c=c.substring(2)),y=y?r:m,n=new gc(y),n=(new hc(n,d,y)).parse(c),n.constant?n.$$watchDelegate=h:p?n.$$watchDelegate=n.literal?g:f:n.inputs&&(n.$$watchDelegate=
e),v[x]=n);return k(n,l);case "function":return k(c,l);default:return k(z,l)}}}]}function sf(){this.$get=["$rootScope","$exceptionHandler",function(a,b){return vd(function(b){a.$evalAsync(b)},b)}]}function tf(){this.$get=["$browser","$exceptionHandler",function(a,b){return vd(function(b){a.defer(b)},b)}]}function vd(a,b){function d(a,b,c){function d(b){return function(c){e||(e=!0,b.call(a,c))}}var e=!1;return[d(b),d(c)]}function c(){this.$$state={status:0}}function e(a,b){return function(c){b.call(a,
c)}}function f(c){!c.processScheduled&&c.pending&&(c.processScheduled=!0,a(function(){var a,d,e;e=c.pending;c.processScheduled=!1;c.pending=w;for(var f=0,g=e.length;f<g;++f){d=e[f][0];a=e[f][c.status];try{B(a)?d.resolve(a(c.value)):1===c.status?d.resolve(c.value):d.reject(c.value)}catch(h){d.reject(h),b(h)}}}))}function g(){this.promise=new c;this.resolve=e(this,this.resolve);this.reject=e(this,this.reject);this.notify=e(this,this.notify)}var h=M("$q",TypeError);N(c.prototype,{then:function(a,b,c){if(q(a)&&
q(b)&&q(c))return this;var d=new g;this.$$state.pending=this.$$state.pending||[];this.$$state.pending.push([d,a,b,c]);0<this.$$state.status&&f(this.$$state);return d.promise},"catch":function(a){return this.then(null,a)},"finally":function(a,b){return this.then(function(b){return l(b,!0,a)},function(b){return l(b,!1,a)},b)}});N(g.prototype,{resolve:function(a){this.promise.$$state.status||(a===this.promise?this.$$reject(h("qcycle",a)):this.$$resolve(a))},$$resolve:function(a){var c,e;e=d(this,this.$$resolve,
this.$$reject);try{if(G(a)||B(a))c=a&&a.then;B(c)?(this.promise.$$state.status=-1,c.call(a,e[0],e[1],this.notify)):(this.promise.$$state.value=a,this.promise.$$state.status=1,f(this.promise.$$state))}catch(g){e[1](g),b(g)}},reject:function(a){this.promise.$$state.status||this.$$reject(a)},$$reject:function(a){this.promise.$$state.value=a;this.promise.$$state.status=2;f(this.promise.$$state)},notify:function(c){var d=this.promise.$$state.pending;0>=this.promise.$$state.status&&d&&d.length&&a(function(){for(var a,
e,f=0,g=d.length;f<g;f++){e=d[f][0];a=d[f][3];try{e.notify(B(a)?a(c):c)}catch(h){b(h)}}})}});var k=function(a,b){var c=new g;b?c.resolve(a):c.reject(a);return c.promise},l=function(a,b,c){var d=null;try{B(c)&&(d=c())}catch(e){return k(e,!1)}return d&&B(d.then)?d.then(function(){return k(a,b)},function(a){return k(a,!1)}):k(a,b)},m=function(a,b,c,d){var e=new g;e.resolve(a);return e.promise.then(b,c,d)},r=function C(a){if(!B(a))throw h("norslvr",a);if(!(this instanceof C))return new C(a);var b=new g;
a(function(a){b.resolve(a)},function(a){b.reject(a)});return b.promise};r.defer=function(){return new g};r.reject=function(a){var b=new g;b.reject(a);return b.promise};r.when=m;r.resolve=m;r.all=function(a){var b=new g,c=0,d=E(a)?[]:{};n(a,function(a,e){c++;m(a).then(function(a){d.hasOwnProperty(e)||(d[e]=a,--c||b.resolve(d))},function(a){d.hasOwnProperty(e)||b.reject(a)})});0===c&&b.resolve(d);return b.promise};return r}function Cf(){this.$get=["$window","$timeout",function(a,b){var d=a.requestAnimationFrame||
a.webkitRequestAnimationFrame,c=a.cancelAnimationFrame||a.webkitCancelAnimationFrame||a.webkitCancelRequestAnimationFrame,e=!!d,f=e?function(a){var b=d(a);return function(){c(b)}}:function(a){var c=b(a,16.66,!1);return function(){b.cancel(c)}};f.supported=e;return f}]}function rf(){function a(a){function b(){this.$$watchers=this.$$nextSibling=this.$$childHead=this.$$childTail=null;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$id=++ob;this.$$ChildScope=null}b.prototype=a;
return b}var b=10,d=M("$rootScope"),c=null,e=null;this.digestTtl=function(a){arguments.length&&(b=a);return b};this.$get=["$injector","$exceptionHandler","$parse","$browser",function(f,g,h,k){function l(a){a.currentScope.$$destroyed=!0}function m(a){9===Ha&&(a.$$childHead&&m(a.$$childHead),a.$$nextSibling&&m(a.$$nextSibling));a.$parent=a.$$nextSibling=a.$$prevSibling=a.$$childHead=a.$$childTail=a.$root=a.$$watchers=null}function r(){this.$id=++ob;this.$$phase=this.$parent=this.$$watchers=this.$$nextSibling=
this.$$prevSibling=this.$$childHead=this.$$childTail=null;this.$root=this;this.$$destroyed=!1;this.$$listeners={};this.$$listenerCount={};this.$$watchersCount=0;this.$$isolateBindings=null}function t(a){if(v.$$phase)throw d("inprog",v.$$phase);v.$$phase=a}function C(a,b){do a.$$watchersCount+=b;while(a=a.$parent)}function y(a,b,c){do a.$$listenerCount[c]-=b,0===a.$$listenerCount[c]&&delete a.$$listenerCount[c];while(a=a.$parent)}function s(){}function p(){for(;w.length;)try{w.shift()()}catch(a){g(a)}e=
null}function x(){null===e&&(e=k.defer(function(){v.$apply(p)}))}r.prototype={constructor:r,$new:function(b,c){var d;c=c||this;b?(d=new r,d.$root=this.$root):(this.$$ChildScope||(this.$$ChildScope=a(this)),d=new this.$$ChildScope);d.$parent=c;d.$$prevSibling=c.$$childTail;c.$$childHead?(c.$$childTail.$$nextSibling=d,c.$$childTail=d):c.$$childHead=c.$$childTail=d;(b||c!=this)&&d.$on("$destroy",l);return d},$watch:function(a,b,d,e){var f=h(a);if(f.$$watchDelegate)return f.$$watchDelegate(this,b,d,f,
a);var g=this,k=g.$$watchers,l={fn:b,last:s,get:f,exp:e||a,eq:!!d};c=null;B(b)||(l.fn=z);k||(k=g.$$watchers=[]);k.unshift(l);C(this,1);return function(){0<=ab(k,l)&&C(g,-1);c=null}},$watchGroup:function(a,b){function c(){h=!1;k?(k=!1,b(e,e,g)):b(e,d,g)}var d=Array(a.length),e=Array(a.length),f=[],g=this,h=!1,k=!0;if(!a.length){var l=!0;g.$evalAsync(function(){l&&b(e,e,g)});return function(){l=!1}}if(1===a.length)return this.$watch(a[0],function(a,c,f){e[0]=a;d[0]=c;b(e,a===c?e:d,f)});n(a,function(a,
b){var k=g.$watch(a,function(a,f){e[b]=a;d[b]=f;h||(h=!0,g.$evalAsync(c))});f.push(k)});return function(){for(;f.length;)f.shift()()}},$watchCollection:function(a,b){function c(a){e=a;var b,d,g,h;if(!q(e)){if(G(e))if(Aa(e))for(f!==r&&(f=r,p=f.length=0,l++),a=e.length,p!==a&&(l++,f.length=p=a),b=0;b<a;b++)h=f[b],g=e[b],d=h!==h&&g!==g,d||h===g||(l++,f[b]=g);else{f!==t&&(f=t={},p=0,l++);a=0;for(b in e)ra.call(e,b)&&(a++,g=e[b],h=f[b],b in f?(d=h!==h&&g!==g,d||h===g||(l++,f[b]=g)):(p++,f[b]=g,l++));if(p>
a)for(b in l++,f)ra.call(e,b)||(p--,delete f[b])}else f!==e&&(f=e,l++);return l}}c.$stateful=!0;var d=this,e,f,g,k=1<b.length,l=0,m=h(a,c),r=[],t={},n=!0,p=0;return this.$watch(m,function(){n?(n=!1,b(e,e,d)):b(e,g,d);if(k)if(G(e))if(Aa(e)){g=Array(e.length);for(var a=0;a<e.length;a++)g[a]=e[a]}else for(a in g={},e)ra.call(e,a)&&(g[a]=e[a]);else g=e})},$digest:function(){var a,f,h,l,m,r,n=b,C,x=[],q,y;t("$digest");k.$$checkUrlChange();this===v&&null!==e&&(k.defer.cancel(e),p());c=null;do{r=!1;for(C=
this;u.length;){try{y=u.shift(),y.scope.$eval(y.expression,y.locals)}catch(w){g(w)}c=null}a:do{if(l=C.$$watchers)for(m=l.length;m--;)try{if(a=l[m])if((f=a.get(C))!==(h=a.last)&&!(a.eq?ka(f,h):"number"===typeof f&&"number"===typeof h&&isNaN(f)&&isNaN(h)))r=!0,c=a,a.last=a.eq?Ma(f,null):f,a.fn(f,h===s?f:h,C),5>n&&(q=4-n,x[q]||(x[q]=[]),x[q].push({msg:B(a.exp)?"fn: "+(a.exp.name||a.exp.toString()):a.exp,newVal:f,oldVal:h}));else if(a===c){r=!1;break a}}catch(la){g(la)}if(!(l=C.$$watchersCount&&C.$$childHead||
C!==this&&C.$$nextSibling))for(;C!==this&&!(l=C.$$nextSibling);)C=C.$parent}while(C=l);if((r||u.length)&&!n--)throw v.$$phase=null,d("infdig",b,x);}while(r||u.length);for(v.$$phase=null;H.length;)try{H.shift()()}catch(A){g(A)}},$destroy:function(){if(!this.$$destroyed){var a=this.$parent;this.$broadcast("$destroy");this.$$destroyed=!0;this===v&&k.$$applicationDestroyed();C(this,-this.$$watchersCount);for(var b in this.$$listenerCount)y(this,this.$$listenerCount[b],b);a&&a.$$childHead==this&&(a.$$childHead=
this.$$nextSibling);a&&a.$$childTail==this&&(a.$$childTail=this.$$prevSibling);this.$$prevSibling&&(this.$$prevSibling.$$nextSibling=this.$$nextSibling);this.$$nextSibling&&(this.$$nextSibling.$$prevSibling=this.$$prevSibling);this.$destroy=this.$digest=this.$apply=this.$evalAsync=this.$applyAsync=z;this.$on=this.$watch=this.$watchGroup=function(){return z};this.$$listeners={};this.$$nextSibling=null;m(this)}},$eval:function(a,b){return h(a)(this,b)},$evalAsync:function(a,b){v.$$phase||u.length||
k.defer(function(){u.length&&v.$digest()});u.push({scope:this,expression:a,locals:b})},$$postDigest:function(a){H.push(a)},$apply:function(a){try{t("$apply");try{return this.$eval(a)}finally{v.$$phase=null}}catch(b){g(b)}finally{try{v.$digest()}catch(c){throw g(c),c;}}},$applyAsync:function(a){function b(){c.$eval(a)}var c=this;a&&w.push(b);x()},$on:function(a,b){var c=this.$$listeners[a];c||(this.$$listeners[a]=c=[]);c.push(b);var d=this;do d.$$listenerCount[a]||(d.$$listenerCount[a]=0),d.$$listenerCount[a]++;
while(d=d.$parent);var e=this;return function(){var d=c.indexOf(b);-1!==d&&(c[d]=null,y(e,1,a))}},$emit:function(a,b){var c=[],d,e=this,f=!1,h={name:a,targetScope:e,stopPropagation:function(){f=!0},preventDefault:function(){h.defaultPrevented=!0},defaultPrevented:!1},k=bb([h],arguments,1),l,m;do{d=e.$$listeners[a]||c;h.currentScope=e;l=0;for(m=d.length;l<m;l++)if(d[l])try{d[l].apply(null,k)}catch(r){g(r)}else d.splice(l,1),l--,m--;if(f)return h.currentScope=null,h;e=e.$parent}while(e);h.currentScope=
null;return h},$broadcast:function(a,b){var c=this,d=this,e={name:a,targetScope:this,preventDefault:function(){e.defaultPrevented=!0},defaultPrevented:!1};if(!this.$$listenerCount[a])return e;for(var f=bb([e],arguments,1),h,k;c=d;){e.currentScope=c;d=c.$$listeners[a]||[];h=0;for(k=d.length;h<k;h++)if(d[h])try{d[h].apply(null,f)}catch(l){g(l)}else d.splice(h,1),h--,k--;if(!(d=c.$$listenerCount[a]&&c.$$childHead||c!==this&&c.$$nextSibling))for(;c!==this&&!(d=c.$$nextSibling);)c=c.$parent}e.currentScope=
null;return e}};var v=new r,u=v.$$asyncQueue=[],H=v.$$postDigestQueue=[],w=v.$$applyAsyncQueue=[];return v}]}function ke(){var a=/^\s*(https?|ftp|mailto|tel|file):/,b=/^\s*((https?|ftp|file|blob):|data:image\/)/;this.aHrefSanitizationWhitelist=function(b){return u(b)?(a=b,this):a};this.imgSrcSanitizationWhitelist=function(a){return u(a)?(b=a,this):b};this.$get=function(){return function(d,c){var e=c?b:a,f;f=xa(d).href;return""===f||f.match(e)?d:"unsafe:"+f}}}function fg(a){if("self"===a)return a;
if(F(a)){if(-1<a.indexOf("***"))throw za("iwcard",a);a=wd(a).replace("\\*\\*",".*").replace("\\*","[^:/.?&;]*");return new RegExp("^"+a+"$")}if(La(a))return new RegExp("^"+a.source+"$");throw za("imatcher");}function xd(a){var b=[];u(a)&&n(a,function(a){b.push(fg(a))});return b}function vf(){this.SCE_CONTEXTS=ma;var a=["self"],b=[];this.resourceUrlWhitelist=function(b){arguments.length&&(a=xd(b));return a};this.resourceUrlBlacklist=function(a){arguments.length&&(b=xd(a));return b};this.$get=["$injector",
function(d){function c(a,b){return"self"===a?gd(b):!!a.exec(b.href)}function e(a){var b=function(a){this.$$unwrapTrustedValue=function(){return a}};a&&(b.prototype=new a);b.prototype.valueOf=function(){return this.$$unwrapTrustedValue()};b.prototype.toString=function(){return this.$$unwrapTrustedValue().toString()};return b}var f=function(a){throw za("unsafe");};d.has("$sanitize")&&(f=d.get("$sanitize"));var g=e(),h={};h[ma.HTML]=e(g);h[ma.CSS]=e(g);h[ma.URL]=e(g);h[ma.JS]=e(g);h[ma.RESOURCE_URL]=
e(h[ma.URL]);return{trustAs:function(a,b){var c=h.hasOwnProperty(a)?h[a]:null;if(!c)throw za("icontext",a,b);if(null===b||q(b)||""===b)return b;if("string"!==typeof b)throw za("itype",a);return new c(b)},getTrusted:function(d,e){if(null===e||q(e)||""===e)return e;var g=h.hasOwnProperty(d)?h[d]:null;if(g&&e instanceof g)return e.$$unwrapTrustedValue();if(d===ma.RESOURCE_URL){var g=xa(e.toString()),r,t,n=!1;r=0;for(t=a.length;r<t;r++)if(c(a[r],g)){n=!0;break}if(n)for(r=0,t=b.length;r<t;r++)if(c(b[r],
g)){n=!1;break}if(n)return e;throw za("insecurl",e.toString());}if(d===ma.HTML)return f(e);throw za("unsafe");},valueOf:function(a){return a instanceof g?a.$$unwrapTrustedValue():a}}}]}function uf(){var a=!0;this.enabled=function(b){arguments.length&&(a=!!b);return a};this.$get=["$parse","$sceDelegate",function(b,d){if(a&&8>Ha)throw za("iequirks");var c=ha(ma);c.isEnabled=function(){return a};c.trustAs=d.trustAs;c.getTrusted=d.getTrusted;c.valueOf=d.valueOf;a||(c.trustAs=c.getTrusted=function(a,b){return b},
c.valueOf=Ya);c.parseAs=function(a,d){var e=b(d);return e.literal&&e.constant?e:b(d,function(b){return c.getTrusted(a,b)})};var e=c.parseAs,f=c.getTrusted,g=c.trustAs;n(ma,function(a,b){var d=K(b);c[eb("parse_as_"+d)]=function(b){return e(a,b)};c[eb("get_trusted_"+d)]=function(b){return f(a,b)};c[eb("trust_as_"+d)]=function(b){return g(a,b)}});return c}]}function wf(){this.$get=["$window","$document",function(a,b){var d={},c=Z((/android (\d+)/.exec(K((a.navigator||{}).userAgent))||[])[1]),e=/Boxee/i.test((a.navigator||
{}).userAgent),f=b[0]||{},g,h=/^(Moz|webkit|ms)(?=[A-Z])/,k=f.body&&f.body.style,l=!1,m=!1;if(k){for(var r in k)if(l=h.exec(r)){g=l[0];g=g.substr(0,1).toUpperCase()+g.substr(1);break}g||(g="WebkitOpacity"in k&&"webkit");l=!!("transition"in k||g+"Transition"in k);m=!!("animation"in k||g+"Animation"in k);!c||l&&m||(l=F(k.webkitTransition),m=F(k.webkitAnimation))}return{history:!(!a.history||!a.history.pushState||4>c||e),hasEvent:function(a){if("input"===a&&11>=Ha)return!1;if(q(d[a])){var b=f.createElement("div");
d[a]="on"+a in b}return d[a]},csp:Ca(),vendorPrefix:g,transitions:l,animations:m,android:c}}]}function yf(){this.$get=["$templateCache","$http","$q","$sce",function(a,b,d,c){function e(f,g){e.totalPendingRequests++;F(f)&&a.get(f)||(f=c.getTrustedResourceUrl(f));var h=b.defaults&&b.defaults.transformResponse;E(h)?h=h.filter(function(a){return a!==ac}):h===ac&&(h=null);return b.get(f,{cache:a,transformResponse:h})["finally"](function(){e.totalPendingRequests--}).then(function(b){a.put(f,b.data);return b.data},
function(a){if(!g)throw ga("tpload",f,a.status,a.statusText);return d.reject(a)})}e.totalPendingRequests=0;return e}]}function zf(){this.$get=["$rootScope","$browser","$location",function(a,b,d){return{findBindings:function(a,b,d){a=a.getElementsByClassName("ng-binding");var g=[];n(a,function(a){var c=$.element(a).data("$binding");c&&n(c,function(c){d?(new RegExp("(^|\\s)"+wd(b)+"(\\s|\\||$)")).test(c)&&g.push(a):-1!=c.indexOf(b)&&g.push(a)})});return g},findModels:function(a,b,d){for(var g=["ng-",
"data-ng-","ng\\:"],h=0;h<g.length;++h){var k=a.querySelectorAll("["+g[h]+"model"+(d?"=":"*=")+'"'+b+'"]');if(k.length)return k}},getLocation:function(){return d.url()},setLocation:function(b){b!==d.url()&&(d.url(b),a.$digest())},whenStable:function(a){b.notifyWhenNoOutstandingRequests(a)}}}]}function Af(){this.$get=["$rootScope","$browser","$q","$$q","$exceptionHandler",function(a,b,d,c,e){function f(f,k,l){B(f)||(l=k,k=f,f=z);var m=sa.call(arguments,3),r=u(l)&&!l,t=(r?c:d).defer(),n=t.promise,q;
q=b.defer(function(){try{t.resolve(f.apply(null,m))}catch(b){t.reject(b),e(b)}finally{delete g[n.$$timeoutId]}r||a.$apply()},k);n.$$timeoutId=q;g[q]=t;return n}var g={};f.cancel=function(a){return a&&a.$$timeoutId in g?(g[a.$$timeoutId].reject("canceled"),delete g[a.$$timeoutId],b.defer.cancel(a.$$timeoutId)):!1};return f}]}function xa(a){Ha&&(ba.setAttribute("href",a),a=ba.href);ba.setAttribute("href",a);return{href:ba.href,protocol:ba.protocol?ba.protocol.replace(/:$/,""):"",host:ba.host,search:ba.search?
ba.search.replace(/^\?/,""):"",hash:ba.hash?ba.hash.replace(/^#/,""):"",hostname:ba.hostname,port:ba.port,pathname:"/"===ba.pathname.charAt(0)?ba.pathname:"/"+ba.pathname}}function gd(a){a=F(a)?xa(a):a;return a.protocol===yd.protocol&&a.host===yd.host}function Bf(){this.$get=na(S)}function zd(a){function b(a){try{return decodeURIComponent(a)}catch(b){return a}}var d=a[0]||{},c={},e="";return function(){var a,g,h,k,l;a=d.cookie||"";if(a!==e)for(e=a,a=e.split("; "),c={},h=0;h<a.length;h++)g=a[h],k=
g.indexOf("="),0<k&&(l=b(g.substring(0,k)),q(c[l])&&(c[l]=b(g.substring(k+1))));return c}}function Ff(){this.$get=zd}function Kc(a){function b(d,c){if(G(d)){var e={};n(d,function(a,c){e[c]=b(c,a)});return e}return a.factory(d+"Filter",c)}this.register=b;this.$get=["$injector",function(a){return function(b){return a.get(b+"Filter")}}];b("currency",Ad);b("date",Bd);b("filter",gg);b("json",hg);b("limitTo",ig);b("lowercase",jg);b("number",Cd);b("orderBy",Dd);b("uppercase",kg)}function gg(){return function(a,
b,d){if(!Aa(a)){if(null==a)return a;throw M("filter")("notarray",a);}var c;switch(ic(b)){case "function":break;case "boolean":case "null":case "number":case "string":c=!0;case "object":b=lg(b,d,c);break;default:return a}return Array.prototype.filter.call(a,b)}}function lg(a,b,d){var c=G(a)&&"$"in a;!0===b?b=ka:B(b)||(b=function(a,b){if(q(a))return!1;if(null===a||null===b)return a===b;if(G(b)||G(a)&&!rc(a))return!1;a=K(""+a);b=K(""+b);return-1!==a.indexOf(b)});return function(e){return c&&!G(e)?Ja(e,
a.$,b,!1):Ja(e,a,b,d)}}function Ja(a,b,d,c,e){var f=ic(a),g=ic(b);if("string"===g&&"!"===b.charAt(0))return!Ja(a,b.substring(1),d,c);if(E(a))return a.some(function(a){return Ja(a,b,d,c)});switch(f){case "object":var h;if(c){for(h in a)if("$"!==h.charAt(0)&&Ja(a[h],b,d,!0))return!0;return e?!1:Ja(a,b,d,!1)}if("object"===g){for(h in b)if(e=b[h],!B(e)&&!q(e)&&(f="$"===h,!Ja(f?a:a[h],e,d,f,f)))return!1;return!0}return d(a,b);case "function":return!1;default:return d(a,b)}}function ic(a){return null===
a?"null":typeof a}function Ad(a){var b=a.NUMBER_FORMATS;return function(a,c,e){q(c)&&(c=b.CURRENCY_SYM);q(e)&&(e=b.PATTERNS[1].maxFrac);return null==a?a:Ed(a,b.PATTERNS[1],b.GROUP_SEP,b.DECIMAL_SEP,e).replace(/\u00A4/g,c)}}function Cd(a){var b=a.NUMBER_FORMATS;return function(a,c){return null==a?a:Ed(a,b.PATTERNS[0],b.GROUP_SEP,b.DECIMAL_SEP,c)}}function mg(a){var b=0,d,c,e,f,g;-1<(c=a.indexOf(Fd))&&(a=a.replace(Fd,""));0<(e=a.search(/e/i))?(0>c&&(c=e),c+=+a.slice(e+1),a=a.substring(0,e)):0>c&&(c=
a.length);for(e=0;a.charAt(e)==jc;e++);if(e==(g=a.length))d=[0],c=1;else{for(g--;a.charAt(g)==jc;)g--;c-=e;d=[];for(f=0;e<=g;e++,f++)d[f]=+a.charAt(e)}c>Gd&&(d=d.splice(0,Gd-1),b=c-1,c=1);return{d:d,e:b,i:c}}function ng(a,b,d,c){var e=a.d,f=e.length-a.i;b=q(b)?Math.min(Math.max(d,f),c):+b;d=b+a.i;c=e[d];if(0<d)e.splice(d);else{a.i=1;e.length=d=b+1;for(var g=0;g<d;g++)e[g]=0}for(5<=c&&e[d-1]++;f<b;f++)e.push(0);if(b=e.reduceRight(function(a,b,c,d){b+=a;d[c]=b%10;return Math.floor(b/10)},0))e.unshift(b),
a.i++}function Ed(a,b,d,c,e){if(!F(a)&&!Q(a)||isNaN(a))return"";var f=!isFinite(a),g=!1,h=Math.abs(a)+"",k="";if(f)k="\u221e";else{g=mg(h);ng(g,e,b.minFrac,b.maxFrac);k=g.d;h=g.i;e=g.e;f=[];for(g=k.reduce(function(a,b){return a&&!b},!0);0>h;)k.unshift(0),h++;0<h?f=k.splice(h):(f=k,k=[0]);h=[];for(k.length>b.lgSize&&h.unshift(k.splice(-b.lgSize).join(""));k.length>b.gSize;)h.unshift(k.splice(-b.gSize).join(""));k.length&&h.unshift(k.join(""));k=h.join(d);f.length&&(k+=c+f.join(""));e&&(k+="e+"+e)}return 0>
a&&!g?b.negPre+k+b.negSuf:b.posPre+k+b.posSuf}function Ib(a,b,d){var c="";0>a&&(c="-",a=-a);for(a=""+a;a.length<b;)a=jc+a;d&&(a=a.substr(a.length-b));return c+a}function ca(a,b,d,c){d=d||0;return function(e){e=e["get"+a]();if(0<d||e>-d)e+=d;0===e&&-12==d&&(e=12);return Ib(e,b,c)}}function Jb(a,b){return function(d,c){var e=d["get"+a](),f=tb(b?"SHORT"+a:a);return c[f][e]}}function Hd(a){var b=(new Date(a,0,1)).getDay();return new Date(a,0,(4>=b?5:12)-b)}function Id(a){return function(b){var d=Hd(b.getFullYear());
b=+new Date(b.getFullYear(),b.getMonth(),b.getDate()+(4-b.getDay()))-+d;b=1+Math.round(b/6048E5);return Ib(b,a)}}function kc(a,b){return 0>=a.getFullYear()?b.ERAS[0]:b.ERAS[1]}function Bd(a){function b(a){var b;if(b=a.match(d)){a=new Date(0);var f=0,g=0,h=b[8]?a.setUTCFullYear:a.setFullYear,k=b[8]?a.setUTCHours:a.setHours;b[9]&&(f=Z(b[9]+b[10]),g=Z(b[9]+b[11]));h.call(a,Z(b[1]),Z(b[2])-1,Z(b[3]));f=Z(b[4]||0)-f;g=Z(b[5]||0)-g;h=Z(b[6]||0);b=Math.round(1E3*parseFloat("0."+(b[7]||0)));k.call(a,f,g,
h,b)}return a}var d=/^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;return function(c,d,f){var g="",h=[],k,l;d=d||"mediumDate";d=a.DATETIME_FORMATS[d]||d;F(c)&&(c=og.test(c)?Z(c):b(c));Q(c)&&(c=new Date(c));if(!da(c)||!isFinite(c.getTime()))return c;for(;d;)(l=pg.exec(d))?(h=bb(h,l,1),d=h.pop()):(h.push(d),d=null);var m=c.getTimezoneOffset();f&&(m=wc(f,c.getTimezoneOffset()),c=Rb(c,f,!0));n(h,function(b){k=qg[b];g+=k?k(c,a.DATETIME_FORMATS,m):
b.replace(/(^'|'$)/g,"").replace(/''/g,"'")});return g}}function hg(){return function(a,b){q(b)&&(b=2);return cb(a,b)}}function ig(){return function(a,b,d){b=Infinity===Math.abs(Number(b))?Number(b):Z(b);if(isNaN(b))return a;Q(a)&&(a=a.toString());if(!E(a)&&!F(a))return a;d=!d||isNaN(d)?0:Z(d);d=0>d?Math.max(0,a.length+d):d;return 0<=b?a.slice(d,d+b):0===d?a.slice(b,a.length):a.slice(Math.max(0,d+b),d)}}function Dd(a){function b(b,d){d=d?-1:1;return b.map(function(b){var c=1,h=Ya;if(B(b))h=b;else if(F(b)){if("+"==
b.charAt(0)||"-"==b.charAt(0))c="-"==b.charAt(0)?-1:1,b=b.substring(1);if(""!==b&&(h=a(b),h.constant))var k=h(),h=function(a){return a[k]}}return{get:h,descending:c*d}})}function d(a){switch(typeof a){case "number":case "boolean":case "string":return!0;default:return!1}}return function(a,e,f){if(!Aa(a))return a;E(e)||(e=[e]);0===e.length&&(e=["+"]);var g=b(e,f);g.push({get:function(){return{}},descending:f?-1:1});a=Array.prototype.map.call(a,function(a,b){return{value:a,predicateValues:g.map(function(c){var e=
c.get(a);c=typeof e;if(null===e)c="string",e="null";else if("string"===c)e=e.toLowerCase();else if("object"===c)a:{if("function"===typeof e.valueOf&&(e=e.valueOf(),d(e)))break a;if(rc(e)&&(e=e.toString(),d(e)))break a;e=b}return{value:e,type:c}})}});a.sort(function(a,b){for(var c=0,d=0,e=g.length;d<e;++d){var c=a.predicateValues[d],f=b.predicateValues[d],n=0;c.type===f.type?c.value!==f.value&&(n=c.value<f.value?-1:1):n=c.type<f.type?-1:1;if(c=n*g[d].descending)break}return c});return a=a.map(function(a){return a.value})}}
function Ka(a){B(a)&&(a={link:a});a.restrict=a.restrict||"AC";return na(a)}function Jd(a,b,d,c,e){var f=this,g=[];f.$error={};f.$$success={};f.$pending=w;f.$name=e(b.name||b.ngForm||"")(d);f.$dirty=!1;f.$pristine=!0;f.$valid=!0;f.$invalid=!1;f.$submitted=!1;f.$$parentForm=Kb;f.$rollbackViewValue=function(){n(g,function(a){a.$rollbackViewValue()})};f.$commitViewValue=function(){n(g,function(a){a.$commitViewValue()})};f.$addControl=function(a){Ra(a.$name,"input");g.push(a);a.$name&&(f[a.$name]=a);a.$$parentForm=
f};f.$$renameControl=function(a,b){var c=a.$name;f[c]===a&&delete f[c];f[b]=a;a.$name=b};f.$removeControl=function(a){a.$name&&f[a.$name]===a&&delete f[a.$name];n(f.$pending,function(b,c){f.$setValidity(c,null,a)});n(f.$error,function(b,c){f.$setValidity(c,null,a)});n(f.$$success,function(b,c){f.$setValidity(c,null,a)});ab(g,a);a.$$parentForm=Kb};Kd({ctrl:this,$element:a,set:function(a,b,c){var d=a[b];d?-1===d.indexOf(c)&&d.push(c):a[b]=[c]},unset:function(a,b,c){var d=a[b];d&&(ab(d,c),0===d.length&&
delete a[b])},$animate:c});f.$setDirty=function(){c.removeClass(a,Wa);c.addClass(a,Lb);f.$dirty=!0;f.$pristine=!1;f.$$parentForm.$setDirty()};f.$setPristine=function(){c.setClass(a,Wa,Lb+" ng-submitted");f.$dirty=!1;f.$pristine=!0;f.$submitted=!1;n(g,function(a){a.$setPristine()})};f.$setUntouched=function(){n(g,function(a){a.$setUntouched()})};f.$setSubmitted=function(){c.addClass(a,"ng-submitted");f.$submitted=!0;f.$$parentForm.$setSubmitted()}}function lc(a){a.$formatters.push(function(b){return a.$isEmpty(b)?
b:b.toString()})}function kb(a,b,d,c,e,f){var g=K(b[0].type);if(!e.android){var h=!1;b.on("compositionstart",function(a){h=!0});b.on("compositionend",function(){h=!1;k()})}var k=function(a){l&&(f.defer.cancel(l),l=null);if(!h){var e=b.val();a=a&&a.type;"password"===g||d.ngTrim&&"false"===d.ngTrim||(e=T(e));(c.$viewValue!==e||""===e&&c.$$hasNativeValidators)&&c.$setViewValue(e,a)}};if(e.hasEvent("input"))b.on("input",k);else{var l,m=function(a,b,c){l||(l=f.defer(function(){l=null;b&&b.value===c||k(a)}))};
b.on("keydown",function(a){var b=a.keyCode;91===b||15<b&&19>b||37<=b&&40>=b||m(a,this,this.value)});if(e.hasEvent("paste"))b.on("paste cut",m)}b.on("change",k);c.$render=function(){var a=c.$isEmpty(c.$viewValue)?"":c.$viewValue;b.val()!==a&&b.val(a)}}function Mb(a,b){return function(d,c){var e,f;if(da(d))return d;if(F(d)){'"'==d.charAt(0)&&'"'==d.charAt(d.length-1)&&(d=d.substring(1,d.length-1));if(rg.test(d))return new Date(d);a.lastIndex=0;if(e=a.exec(d))return e.shift(),f=c?{yyyy:c.getFullYear(),
MM:c.getMonth()+1,dd:c.getDate(),HH:c.getHours(),mm:c.getMinutes(),ss:c.getSeconds(),sss:c.getMilliseconds()/1E3}:{yyyy:1970,MM:1,dd:1,HH:0,mm:0,ss:0,sss:0},n(e,function(a,c){c<b.length&&(f[b[c]]=+a)}),new Date(f.yyyy,f.MM-1,f.dd,f.HH,f.mm,f.ss||0,1E3*f.sss||0)}return NaN}}function lb(a,b,d,c){return function(e,f,g,h,k,l,m){function r(a){return a&&!(a.getTime&&a.getTime()!==a.getTime())}function n(a){return u(a)&&!da(a)?d(a)||w:a}Ld(e,f,g,h);kb(e,f,g,h,k,l);var C=h&&h.$options&&h.$options.timezone,
y;h.$$parserName=a;h.$parsers.push(function(a){return h.$isEmpty(a)?null:b.test(a)?(a=d(a,y),C&&(a=Rb(a,C)),a):w});h.$formatters.push(function(a){if(a&&!da(a))throw mb("datefmt",a);if(r(a))return(y=a)&&C&&(y=Rb(y,C,!0)),m("date")(a,c,C);y=null;return""});if(u(g.min)||g.ngMin){var s;h.$validators.min=function(a){return!r(a)||q(s)||d(a)>=s};g.$observe("min",function(a){s=n(a);h.$validate()})}if(u(g.max)||g.ngMax){var p;h.$validators.max=function(a){return!r(a)||q(p)||d(a)<=p};g.$observe("max",function(a){p=
n(a);h.$validate()})}}}function Ld(a,b,d,c){(c.$$hasNativeValidators=G(b[0].validity))&&c.$parsers.push(function(a){var c=b.prop("validity")||{};return c.badInput&&!c.typeMismatch?w:a})}function Md(a,b,d,c,e){if(u(c)){a=a(c);if(!a.constant)throw mb("constexpr",d,c);return a(b)}return e}function mc(a,b){a="ngClass"+a;return["$animate",function(d){function c(a,b){var c=[],d=0;a:for(;d<a.length;d++){for(var e=a[d],m=0;m<b.length;m++)if(e==b[m])continue a;c.push(e)}return c}function e(a){var b=[];return E(a)?
(n(a,function(a){b=b.concat(e(a))}),b):F(a)?a.split(" "):G(a)?(n(a,function(a,c){a&&(b=b.concat(c.split(" ")))}),b):a}return{restrict:"AC",link:function(f,g,h){function k(a,b){var c=g.data("$classCounts")||ea(),d=[];n(a,function(a){if(0<b||c[a])c[a]=(c[a]||0)+b,c[a]===+(0<b)&&d.push(a)});g.data("$classCounts",c);return d.join(" ")}function l(a){if(!0===b||f.$index%2===b){var l=e(a||[]);if(!m){var n=k(l,1);h.$addClass(n)}else if(!ka(a,m)){var q=e(m),n=c(l,q),l=c(q,l),n=k(n,1),l=k(l,-1);n&&n.length&&
d.addClass(g,n);l&&l.length&&d.removeClass(g,l)}}m=ha(a)}var m;f.$watch(h[a],l,!0);h.$observe("class",function(b){l(f.$eval(h[a]))});"ngClass"!==a&&f.$watch("$index",function(c,d){var g=c&1;if(g!==(d&1)){var l=e(f.$eval(h[a]));g===b?(g=k(l,1),h.$addClass(g)):(g=k(l,-1),h.$removeClass(g))}})}}}]}function Kd(a){function b(a,b){b&&!f[a]?(k.addClass(e,a),f[a]=!0):!b&&f[a]&&(k.removeClass(e,a),f[a]=!1)}function d(a,c){a=a?"-"+Ac(a,"-"):"";b(nb+a,!0===c);b(Nd+a,!1===c)}var c=a.ctrl,e=a.$element,f={},g=
a.set,h=a.unset,k=a.$animate;f[Nd]=!(f[nb]=e.hasClass(nb));c.$setValidity=function(a,e,f){q(e)?(c.$pending||(c.$pending={}),g(c.$pending,a,f)):(c.$pending&&h(c.$pending,a,f),Od(c.$pending)&&(c.$pending=w));$a(e)?e?(h(c.$error,a,f),g(c.$$success,a,f)):(g(c.$error,a,f),h(c.$$success,a,f)):(h(c.$error,a,f),h(c.$$success,a,f));c.$pending?(b(Pd,!0),c.$valid=c.$invalid=w,d("",null)):(b(Pd,!1),c.$valid=Od(c.$error),c.$invalid=!c.$valid,d("",c.$valid));e=c.$pending&&c.$pending[a]?w:c.$error[a]?!1:c.$$success[a]?
!0:null;d(a,e);c.$$parentForm.$setValidity(a,e,c)}}function Od(a){if(a)for(var b in a)if(a.hasOwnProperty(b))return!1;return!0}var sg=/^\/(.+)\/([a-z]*)$/,K=function(a){return F(a)?a.toLowerCase():a},ra=Object.prototype.hasOwnProperty,tb=function(a){return F(a)?a.toUpperCase():a},Ha,A,pa,sa=[].slice,Uf=[].splice,tg=[].push,ta=Object.prototype.toString,sc=Object.getPrototypeOf,Ba=M("ng"),$=S.angular||(S.angular={}),Ub,ob=0;Ha=W.documentMode;z.$inject=[];Ya.$inject=[];var E=Array.isArray,Zd=/^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/,
T=function(a){return F(a)?a.trim():a},wd=function(a){return a.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")},Ca=function(){if(!u(Ca.rules)){var a=W.querySelector("[ng-csp]")||W.querySelector("[data-ng-csp]");if(a){var b=a.getAttribute("ng-csp")||a.getAttribute("data-ng-csp");Ca.rules={noUnsafeEval:!b||-1!==b.indexOf("no-unsafe-eval"),noInlineStyle:!b||-1!==b.indexOf("no-inline-style")}}else{a=Ca;try{new Function(""),b=!1}catch(d){b=!0}a.rules={noUnsafeEval:b,noInlineStyle:!1}}}return Ca.rules},
qb=function(){if(u(qb.name_))return qb.name_;var a,b,d=Oa.length,c,e;for(b=0;b<d;++b)if(c=Oa[b],a=W.querySelector("["+c.replace(":","\\:")+"jq]")){e=a.getAttribute(c+"jq");break}return qb.name_=e},Oa=["ng-","data-ng-","ng:","x-ng-"],fe=/[A-Z]/g,Bc=!1,Tb,Na=3,je={full:"1.4.9",major:1,minor:4,dot:9,codeName:"implicit-superannuation"};P.expando="ng339";var fb=P.cache={},Lf=1;P._data=function(a){return this.cache[a[this.expando]]||{}};var Gf=/([\:\-\_]+(.))/g,Hf=/^moz([A-Z])/,yb={mouseleave:"mouseout",
mouseenter:"mouseover"},Wb=M("jqLite"),Kf=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,Vb=/<|&#?\w+;/,If=/<([\w:-]+)/,Jf=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,ja={option:[1,'<select multiple="multiple">',"</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ja.optgroup=ja.option;ja.tbody=ja.tfoot=ja.colgroup=ja.caption=ja.thead;
ja.th=ja.td;var Qf=Node.prototype.contains||function(a){return!!(this.compareDocumentPosition(a)&16)},Pa=P.prototype={ready:function(a){function b(){d||(d=!0,a())}var d=!1;"complete"===W.readyState?setTimeout(b):(this.on("DOMContentLoaded",b),P(S).on("load",b))},toString:function(){var a=[];n(this,function(b){a.push(""+b)});return"["+a.join(", ")+"]"},eq:function(a){return 0<=a?A(this[a]):A(this[this.length+a])},length:0,push:tg,sort:[].sort,splice:[].splice},Db={};n("multiple selected checked disabled readOnly required open".split(" "),
function(a){Db[K(a)]=a});var Sc={};n("input select option textarea button form details".split(" "),function(a){Sc[a]=!0});var ad={ngMinlength:"minlength",ngMaxlength:"maxlength",ngMin:"min",ngMax:"max",ngPattern:"pattern"};n({data:Yb,removeData:wb,hasData:function(a){for(var b in fb[a.ng339])return!0;return!1}},function(a,b){P[b]=a});n({data:Yb,inheritedData:Cb,scope:function(a){return A.data(a,"$scope")||Cb(a.parentNode||a,["$isolateScope","$scope"])},isolateScope:function(a){return A.data(a,"$isolateScope")||
A.data(a,"$isolateScopeNoTemplate")},controller:Pc,injector:function(a){return Cb(a,"$injector")},removeAttr:function(a,b){a.removeAttribute(b)},hasClass:zb,css:function(a,b,d){b=eb(b);if(u(d))a.style[b]=d;else return a.style[b]},attr:function(a,b,d){var c=a.nodeType;if(c!==Na&&2!==c&&8!==c)if(c=K(b),Db[c])if(u(d))d?(a[b]=!0,a.setAttribute(b,c)):(a[b]=!1,a.removeAttribute(c));else return a[b]||(a.attributes.getNamedItem(b)||z).specified?c:w;else if(u(d))a.setAttribute(b,d);else if(a.getAttribute)return a=
a.getAttribute(b,2),null===a?w:a},prop:function(a,b,d){if(u(d))a[b]=d;else return a[b]},text:function(){function a(a,d){if(q(d)){var c=a.nodeType;return 1===c||c===Na?a.textContent:""}a.textContent=d}a.$dv="";return a}(),val:function(a,b){if(q(b)){if(a.multiple&&"select"===oa(a)){var d=[];n(a.options,function(a){a.selected&&d.push(a.value||a.text)});return 0===d.length?null:d}return a.value}a.value=b},html:function(a,b){if(q(b))return a.innerHTML;vb(a,!0);a.innerHTML=b},empty:Qc},function(a,b){P.prototype[b]=
function(b,c){var e,f,g=this.length;if(a!==Qc&&q(2==a.length&&a!==zb&&a!==Pc?b:c)){if(G(b)){for(e=0;e<g;e++)if(a===Yb)a(this[e],b);else for(f in b)a(this[e],f,b[f]);return this}e=a.$dv;g=q(e)?Math.min(g,1):g;for(f=0;f<g;f++){var h=a(this[f],b,c);e=e?e+h:h}return e}for(e=0;e<g;e++)a(this[e],b,c);return this}});n({removeData:wb,on:function(a,b,d,c){if(u(c))throw Wb("onargs");if(Lc(a)){c=xb(a,!0);var e=c.events,f=c.handle;f||(f=c.handle=Nf(a,e));c=0<=b.indexOf(" ")?b.split(" "):[b];for(var g=c.length,
h=function(b,c,g){var h=e[b];h||(h=e[b]=[],h.specialHandlerWrapper=c,"$destroy"===b||g||a.addEventListener(b,f,!1));h.push(d)};g--;)b=c[g],yb[b]?(h(yb[b],Pf),h(b,w,!0)):h(b)}},off:Oc,one:function(a,b,d){a=A(a);a.on(b,function e(){a.off(b,d);a.off(b,e)});a.on(b,d)},replaceWith:function(a,b){var d,c=a.parentNode;vb(a);n(new P(b),function(b){d?c.insertBefore(b,d.nextSibling):c.replaceChild(b,a);d=b})},children:function(a){var b=[];n(a.childNodes,function(a){1===a.nodeType&&b.push(a)});return b},contents:function(a){return a.contentDocument||
a.childNodes||[]},append:function(a,b){var d=a.nodeType;if(1===d||11===d){b=new P(b);for(var d=0,c=b.length;d<c;d++)a.appendChild(b[d])}},prepend:function(a,b){if(1===a.nodeType){var d=a.firstChild;n(new P(b),function(b){a.insertBefore(b,d)})}},wrap:function(a,b){b=A(b).eq(0).clone()[0];var d=a.parentNode;d&&d.replaceChild(b,a);b.appendChild(a)},remove:Zb,detach:function(a){Zb(a,!0)},after:function(a,b){var d=a,c=a.parentNode;b=new P(b);for(var e=0,f=b.length;e<f;e++){var g=b[e];c.insertBefore(g,
d.nextSibling);d=g}},addClass:Bb,removeClass:Ab,toggleClass:function(a,b,d){b&&n(b.split(" "),function(b){var e=d;q(e)&&(e=!zb(a,b));(e?Bb:Ab)(a,b)})},parent:function(a){return(a=a.parentNode)&&11!==a.nodeType?a:null},next:function(a){return a.nextElementSibling},find:function(a,b){return a.getElementsByTagName?a.getElementsByTagName(b):[]},clone:Xb,triggerHandler:function(a,b,d){var c,e,f=b.type||b,g=xb(a);if(g=(g=g&&g.events)&&g[f])c={preventDefault:function(){this.defaultPrevented=!0},isDefaultPrevented:function(){return!0===
this.defaultPrevented},stopImmediatePropagation:function(){this.immediatePropagationStopped=!0},isImmediatePropagationStopped:function(){return!0===this.immediatePropagationStopped},stopPropagation:z,type:f,target:a},b.type&&(c=N(c,b)),b=ha(g),e=d?[c].concat(d):[c],n(b,function(b){c.isImmediatePropagationStopped()||b.apply(a,e)})}},function(a,b){P.prototype[b]=function(b,c,e){for(var f,g=0,h=this.length;g<h;g++)q(f)?(f=a(this[g],b,c,e),u(f)&&(f=A(f))):Nc(f,a(this[g],b,c,e));return u(f)?f:this};P.prototype.bind=
P.prototype.on;P.prototype.unbind=P.prototype.off});Sa.prototype={put:function(a,b){this[Da(a,this.nextUid)]=b},get:function(a){return this[Da(a,this.nextUid)]},remove:function(a){var b=this[a=Da(a,this.nextUid)];delete this[a];return b}};var Ef=[function(){this.$get=[function(){return Sa}]}],Uc=/^[^\(]*\(\s*([^\)]*)\)/m,ug=/,/,vg=/^\s*(_?)(\S+?)\1\s*$/,Tc=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg,Ea=M("$injector");db.$$annotate=function(a,b,d){var c;if("function"===typeof a){if(!(c=a.$inject)){c=[];if(a.length){if(b)throw F(d)&&
d||(d=a.name||Rf(a)),Ea("strictdi",d);b=a.toString().replace(Tc,"");b=b.match(Uc);n(b[1].split(ug),function(a){a.replace(vg,function(a,b,d){c.push(d)})})}a.$inject=c}}else E(a)?(b=a.length-1,Qa(a[b],"fn"),c=a.slice(0,b)):Qa(a,"fn",!0);return c};var Qd=M("$animate"),Xe=function(){this.$get=function(){}},Ye=function(){var a=new Sa,b=[];this.$get=["$$AnimateRunner","$rootScope",function(d,c){function e(a,b,c){var d=!1;b&&(b=F(b)?b.split(" "):E(b)?b:[],n(b,function(b){b&&(d=!0,a[b]=c)}));return d}function f(){n(b,
function(b){var c=a.get(b);if(c){var d=Sf(b.attr("class")),e="",f="";n(c,function(a,b){a!==!!d[b]&&(a?e+=(e.length?" ":"")+b:f+=(f.length?" ":"")+b)});n(b,function(a){e&&Bb(a,e);f&&Ab(a,f)});a.remove(b)}});b.length=0}return{enabled:z,on:z,off:z,pin:z,push:function(g,h,k,l){l&&l();k=k||{};k.from&&g.css(k.from);k.to&&g.css(k.to);if(k.addClass||k.removeClass)if(h=k.addClass,l=k.removeClass,k=a.get(g)||{},h=e(k,h,!0),l=e(k,l,!1),h||l)a.put(g,k),b.push(g),1===b.length&&c.$$postDigest(f);g=new d;g.complete();
return g}}}]},Ve=["$provide",function(a){var b=this;this.$$registeredAnimations=Object.create(null);this.register=function(d,c){if(d&&"."!==d.charAt(0))throw Qd("notcsel",d);var e=d+"-animation";b.$$registeredAnimations[d.substr(1)]=e;a.factory(e,c)};this.classNameFilter=function(a){if(1===arguments.length&&(this.$$classNameFilter=a instanceof RegExp?a:null)&&/(\s+|\/)ng-animate(\s+|\/)/.test(this.$$classNameFilter.toString()))throw Qd("nongcls","ng-animate");return this.$$classNameFilter};this.$get=
["$$animateQueue",function(a){function b(a,c,d){if(d){var h;a:{for(h=0;h<d.length;h++){var k=d[h];if(1===k.nodeType){h=k;break a}}h=void 0}!h||h.parentNode||h.previousElementSibling||(d=null)}d?d.after(a):c.prepend(a)}return{on:a.on,off:a.off,pin:a.pin,enabled:a.enabled,cancel:function(a){a.end&&a.end()},enter:function(e,f,g,h){f=f&&A(f);g=g&&A(g);f=f||g.parent();b(e,f,g);return a.push(e,"enter",Fa(h))},move:function(e,f,g,h){f=f&&A(f);g=g&&A(g);f=f||g.parent();b(e,f,g);return a.push(e,"move",Fa(h))},
leave:function(b,c){return a.push(b,"leave",Fa(c),function(){b.remove()})},addClass:function(b,c,g){g=Fa(g);g.addClass=gb(g.addclass,c);return a.push(b,"addClass",g)},removeClass:function(b,c,g){g=Fa(g);g.removeClass=gb(g.removeClass,c);return a.push(b,"removeClass",g)},setClass:function(b,c,g,h){h=Fa(h);h.addClass=gb(h.addClass,c);h.removeClass=gb(h.removeClass,g);return a.push(b,"setClass",h)},animate:function(b,c,g,h,k){k=Fa(k);k.from=k.from?N(k.from,c):c;k.to=k.to?N(k.to,g):g;k.tempClasses=gb(k.tempClasses,
h||"ng-inline-animate");return a.push(b,"animate",k)}}}]}],$e=function(){this.$get=["$$rAF",function(a){function b(b){d.push(b);1<d.length||a(function(){for(var a=0;a<d.length;a++)d[a]();d=[]})}var d=[];return function(){var a=!1;b(function(){a=!0});return function(d){a?d():b(d)}}}]},Ze=function(){this.$get=["$q","$sniffer","$$animateAsyncRun","$document","$timeout",function(a,b,d,c,e){function f(a){this.setHost(a);var b=d();this._doneCallbacks=[];this._tick=function(a){var d=c[0];d&&d.hidden?e(a,
0,!1):b(a)};this._state=0}f.chain=function(a,b){function c(){if(d===a.length)b(!0);else a[d](function(a){!1===a?b(!1):(d++,c())})}var d=0;c()};f.all=function(a,b){function c(f){e=e&&f;++d===a.length&&b(e)}var d=0,e=!0;n(a,function(a){a.done(c)})};f.prototype={setHost:function(a){this.host=a||{}},done:function(a){2===this._state?a():this._doneCallbacks.push(a)},progress:z,getPromise:function(){if(!this.promise){var b=this;this.promise=a(function(a,c){b.done(function(b){!1===b?c():a()})})}return this.promise},
then:function(a,b){return this.getPromise().then(a,b)},"catch":function(a){return this.getPromise()["catch"](a)},"finally":function(a){return this.getPromise()["finally"](a)},pause:function(){this.host.pause&&this.host.pause()},resume:function(){this.host.resume&&this.host.resume()},end:function(){this.host.end&&this.host.end();this._resolve(!0)},cancel:function(){this.host.cancel&&this.host.cancel();this._resolve(!1)},complete:function(a){var b=this;0===b._state&&(b._state=1,b._tick(function(){b._resolve(a)}))},
_resolve:function(a){2!==this._state&&(n(this._doneCallbacks,function(b){b(a)}),this._doneCallbacks.length=0,this._state=2)}};return f}]},We=function(){this.$get=["$$rAF","$q","$$AnimateRunner",function(a,b,d){return function(b,e){function f(){a(function(){g.addClass&&(b.addClass(g.addClass),g.addClass=null);g.removeClass&&(b.removeClass(g.removeClass),g.removeClass=null);g.to&&(b.css(g.to),g.to=null);h||k.complete();h=!0});return k}var g=e||{};g.$$prepared||(g=Ma(g));g.cleanupStyles&&(g.from=g.to=
null);g.from&&(b.css(g.from),g.from=null);var h,k=new d;return{start:f,end:f}}}]},ga=M("$compile");Dc.$inject=["$provide","$$sanitizeUriProvider"];var Yc=/^((?:x|data)[\:\-_])/i,Vf=M("$controller"),Vc=/^(\S+)(\s+as\s+([\w$]+))?$/,ff=function(){this.$get=["$document",function(a){return function(b){b?!b.nodeType&&b instanceof A&&(b=b[0]):b=a[0].body;return b.offsetWidth+1}}]},bd="application/json",bc={"Content-Type":bd+";charset=utf-8"},Xf=/^\[|^\{(?!\{)/,Yf={"[":/]$/,"{":/}$/},Wf=/^\)\]\}',?\n/,wg=
M("$http"),fd=function(a){return function(){throw wg("legacy",a);}},Ia=$.$interpolateMinErr=M("$interpolate");Ia.throwNoconcat=function(a){throw Ia("noconcat",a);};Ia.interr=function(a,b){return Ia("interr",a,b.toString())};var xg=/^([^\?#]*)(\?([^#]*))?(#(.*))?$/,$f={http:80,https:443,ftp:21},Fb=M("$location"),yg={$$html5:!1,$$replace:!1,absUrl:Gb("$$absUrl"),url:function(a){if(q(a))return this.$$url;var b=xg.exec(a);(b[1]||""===a)&&this.path(decodeURIComponent(b[1]));(b[2]||b[1]||""===a)&&this.search(b[3]||
"");this.hash(b[5]||"");return this},protocol:Gb("$$protocol"),host:Gb("$$host"),port:Gb("$$port"),path:kd("$$path",function(a){a=null!==a?a.toString():"";return"/"==a.charAt(0)?a:"/"+a}),search:function(a,b){switch(arguments.length){case 0:return this.$$search;case 1:if(F(a)||Q(a))a=a.toString(),this.$$search=yc(a);else if(G(a))a=Ma(a,{}),n(a,function(b,c){null==b&&delete a[c]}),this.$$search=a;else throw Fb("isrcharg");break;default:q(b)||null===b?delete this.$$search[a]:this.$$search[a]=b}this.$$compose();
return this},hash:kd("$$hash",function(a){return null!==a?a.toString():""}),replace:function(){this.$$replace=!0;return this}};n([jd,ec,dc],function(a){a.prototype=Object.create(yg);a.prototype.state=function(b){if(!arguments.length)return this.$$state;if(a!==dc||!this.$$html5)throw Fb("nostate");this.$$state=q(b)?null:b;return this}});var aa=M("$parse"),ag=Function.prototype.call,bg=Function.prototype.apply,cg=Function.prototype.bind,Nb=ea();n("+ - * / % === !== == != < > <= >= && || ! = |".split(" "),
function(a){Nb[a]=!0});var zg={n:"\n",f:"\f",r:"\r",t:"\t",v:"\v","'":"'",'"':'"'},gc=function(a){this.options=a};gc.prototype={constructor:gc,lex:function(a){this.text=a;this.index=0;for(this.tokens=[];this.index<this.text.length;)if(a=this.text.charAt(this.index),'"'===a||"'"===a)this.readString(a);else if(this.isNumber(a)||"."===a&&this.isNumber(this.peek()))this.readNumber();else if(this.isIdent(a))this.readIdent();else if(this.is(a,"(){}[].,;:?"))this.tokens.push({index:this.index,text:a}),this.index++;
else if(this.isWhitespace(a))this.index++;else{var b=a+this.peek(),d=b+this.peek(2),c=Nb[b],e=Nb[d];Nb[a]||c||e?(a=e?d:c?b:a,this.tokens.push({index:this.index,text:a,operator:!0}),this.index+=a.length):this.throwError("Unexpected next character ",this.index,this.index+1)}return this.tokens},is:function(a,b){return-1!==b.indexOf(a)},peek:function(a){a=a||1;return this.index+a<this.text.length?this.text.charAt(this.index+a):!1},isNumber:function(a){return"0"<=a&&"9">=a&&"string"===typeof a},isWhitespace:function(a){return" "===
a||"\r"===a||"\t"===a||"\n"===a||"\v"===a||"\u00a0"===a},isIdent:function(a){return"a"<=a&&"z">=a||"A"<=a&&"Z">=a||"_"===a||"$"===a},isExpOperator:function(a){return"-"===a||"+"===a||this.isNumber(a)},throwError:function(a,b,d){d=d||this.index;b=u(b)?"s "+b+"-"+this.index+" ["+this.text.substring(b,d)+"]":" "+d;throw aa("lexerr",a,b,this.text);},readNumber:function(){for(var a="",b=this.index;this.index<this.text.length;){var d=K(this.text.charAt(this.index));if("."==d||this.isNumber(d))a+=d;else{var c=
this.peek();if("e"==d&&this.isExpOperator(c))a+=d;else if(this.isExpOperator(d)&&c&&this.isNumber(c)&&"e"==a.charAt(a.length-1))a+=d;else if(!this.isExpOperator(d)||c&&this.isNumber(c)||"e"!=a.charAt(a.length-1))break;else this.throwError("Invalid exponent")}this.index++}this.tokens.push({index:b,text:a,constant:!0,value:Number(a)})},readIdent:function(){for(var a=this.index;this.index<this.text.length;){var b=this.text.charAt(this.index);if(!this.isIdent(b)&&!this.isNumber(b))break;this.index++}this.tokens.push({index:a,
text:this.text.slice(a,this.index),identifier:!0})},readString:function(a){var b=this.index;this.index++;for(var d="",c=a,e=!1;this.index<this.text.length;){var f=this.text.charAt(this.index),c=c+f;if(e)"u"===f?(e=this.text.substring(this.index+1,this.index+5),e.match(/[\da-f]{4}/i)||this.throwError("Invalid unicode escape [\\u"+e+"]"),this.index+=4,d+=String.fromCharCode(parseInt(e,16))):d+=zg[f]||f,e=!1;else if("\\"===f)e=!0;else{if(f===a){this.index++;this.tokens.push({index:b,text:c,constant:!0,
value:d});return}d+=f}this.index++}this.throwError("Unterminated quote",b)}};var s=function(a,b){this.lexer=a;this.options=b};s.Program="Program";s.ExpressionStatement="ExpressionStatement";s.AssignmentExpression="AssignmentExpression";s.ConditionalExpression="ConditionalExpression";s.LogicalExpression="LogicalExpression";s.BinaryExpression="BinaryExpression";s.UnaryExpression="UnaryExpression";s.CallExpression="CallExpression";s.MemberExpression="MemberExpression";s.Identifier="Identifier";s.Literal=
"Literal";s.ArrayExpression="ArrayExpression";s.Property="Property";s.ObjectExpression="ObjectExpression";s.ThisExpression="ThisExpression";s.NGValueParameter="NGValueParameter";s.prototype={ast:function(a){this.text=a;this.tokens=this.lexer.lex(a);a=this.program();0!==this.tokens.length&&this.throwError("is an unexpected token",this.tokens[0]);return a},program:function(){for(var a=[];;)if(0<this.tokens.length&&!this.peek("}",")",";","]")&&a.push(this.expressionStatement()),!this.expect(";"))return{type:s.Program,
body:a}},expressionStatement:function(){return{type:s.ExpressionStatement,expression:this.filterChain()}},filterChain:function(){for(var a=this.expression();this.expect("|");)a=this.filter(a);return a},expression:function(){return this.assignment()},assignment:function(){var a=this.ternary();this.expect("=")&&(a={type:s.AssignmentExpression,left:a,right:this.assignment(),operator:"="});return a},ternary:function(){var a=this.logicalOR(),b,d;return this.expect("?")&&(b=this.expression(),this.consume(":"))?
(d=this.expression(),{type:s.ConditionalExpression,test:a,alternate:b,consequent:d}):a},logicalOR:function(){for(var a=this.logicalAND();this.expect("||");)a={type:s.LogicalExpression,operator:"||",left:a,right:this.logicalAND()};return a},logicalAND:function(){for(var a=this.equality();this.expect("&&");)a={type:s.LogicalExpression,operator:"&&",left:a,right:this.equality()};return a},equality:function(){for(var a=this.relational(),b;b=this.expect("==","!=","===","!==");)a={type:s.BinaryExpression,
operator:b.text,left:a,right:this.relational()};return a},relational:function(){for(var a=this.additive(),b;b=this.expect("<",">","<=",">=");)a={type:s.BinaryExpression,operator:b.text,left:a,right:this.additive()};return a},additive:function(){for(var a=this.multiplicative(),b;b=this.expect("+","-");)a={type:s.BinaryExpression,operator:b.text,left:a,right:this.multiplicative()};return a},multiplicative:function(){for(var a=this.unary(),b;b=this.expect("*","/","%");)a={type:s.BinaryExpression,operator:b.text,
left:a,right:this.unary()};return a},unary:function(){var a;return(a=this.expect("+","-","!"))?{type:s.UnaryExpression,operator:a.text,prefix:!0,argument:this.unary()}:this.primary()},primary:function(){var a;this.expect("(")?(a=this.filterChain(),this.consume(")")):this.expect("[")?a=this.arrayDeclaration():this.expect("{")?a=this.object():this.constants.hasOwnProperty(this.peek().text)?a=Ma(this.constants[this.consume().text]):this.peek().identifier?a=this.identifier():this.peek().constant?a=this.constant():
this.throwError("not a primary expression",this.peek());for(var b;b=this.expect("(","[",".");)"("===b.text?(a={type:s.CallExpression,callee:a,arguments:this.parseArguments()},this.consume(")")):"["===b.text?(a={type:s.MemberExpression,object:a,property:this.expression(),computed:!0},this.consume("]")):"."===b.text?a={type:s.MemberExpression,object:a,property:this.identifier(),computed:!1}:this.throwError("IMPOSSIBLE");return a},filter:function(a){a=[a];for(var b={type:s.CallExpression,callee:this.identifier(),
arguments:a,filter:!0};this.expect(":");)a.push(this.expression());return b},parseArguments:function(){var a=[];if(")"!==this.peekToken().text){do a.push(this.expression());while(this.expect(","))}return a},identifier:function(){var a=this.consume();a.identifier||this.throwError("is not a valid identifier",a);return{type:s.Identifier,name:a.text}},constant:function(){return{type:s.Literal,value:this.consume().value}},arrayDeclaration:function(){var a=[];if("]"!==this.peekToken().text){do{if(this.peek("]"))break;
a.push(this.expression())}while(this.expect(","))}this.consume("]");return{type:s.ArrayExpression,elements:a}},object:function(){var a=[],b;if("}"!==this.peekToken().text){do{if(this.peek("}"))break;b={type:s.Property,kind:"init"};this.peek().constant?b.key=this.constant():this.peek().identifier?b.key=this.identifier():this.throwError("invalid key",this.peek());this.consume(":");b.value=this.expression();a.push(b)}while(this.expect(","))}this.consume("}");return{type:s.ObjectExpression,properties:a}},
throwError:function(a,b){throw aa("syntax",b.text,a,b.index+1,this.text,this.text.substring(b.index));},consume:function(a){if(0===this.tokens.length)throw aa("ueoe",this.text);var b=this.expect(a);b||this.throwError("is unexpected, expecting ["+a+"]",this.peek());return b},peekToken:function(){if(0===this.tokens.length)throw aa("ueoe",this.text);return this.tokens[0]},peek:function(a,b,d,c){return this.peekAhead(0,a,b,d,c)},peekAhead:function(a,b,d,c,e){if(this.tokens.length>a){a=this.tokens[a];
var f=a.text;if(f===b||f===d||f===c||f===e||!(b||d||c||e))return a}return!1},expect:function(a,b,d,c){return(a=this.peek(a,b,d,c))?(this.tokens.shift(),a):!1},constants:{"true":{type:s.Literal,value:!0},"false":{type:s.Literal,value:!1},"null":{type:s.Literal,value:null},undefined:{type:s.Literal,value:w},"this":{type:s.ThisExpression}}};td.prototype={compile:function(a,b){var d=this,c=this.astBuilder.ast(a);this.state={nextId:0,filters:{},expensiveChecks:b,fn:{vars:[],body:[],own:{}},assign:{vars:[],
body:[],own:{}},inputs:[]};V(c,d.$filter);var e="",f;this.stage="assign";if(f=rd(c))this.state.computing="assign",e=this.nextId(),this.recurse(f,e),this.return_(e),e="fn.assign="+this.generateFunction("assign","s,v,l");f=pd(c.body);d.stage="inputs";n(f,function(a,b){var c="fn"+b;d.state[c]={vars:[],body:[],own:{}};d.state.computing=c;var e=d.nextId();d.recurse(a,e);d.return_(e);d.state.inputs.push(c);a.watchId=b});this.state.computing="fn";this.stage="main";this.recurse(c);e='"'+this.USE+" "+this.STRICT+
'";\n'+this.filterPrefix()+"var fn="+this.generateFunction("fn","s,l,a,i")+e+this.watchFns()+"return fn;";e=(new Function("$filter","ensureSafeMemberName","ensureSafeObject","ensureSafeFunction","getStringValue","ensureSafeAssignContext","ifDefined","plus","text",e))(this.$filter,Va,ya,md,ld,nd,dg,od,a);this.state=this.stage=w;e.literal=sd(c);e.constant=c.constant;return e},USE:"use",STRICT:"strict",watchFns:function(){var a=[],b=this.state.inputs,d=this;n(b,function(b){a.push("var "+b+"="+d.generateFunction(b,
"s"))});b.length&&a.push("fn.inputs=["+b.join(",")+"];");return a.join("")},generateFunction:function(a,b){return"function("+b+"){"+this.varsPrefix(a)+this.body(a)+"};"},filterPrefix:function(){var a=[],b=this;n(this.state.filters,function(d,c){a.push(d+"=$filter("+b.escape(c)+")")});return a.length?"var "+a.join(",")+";":""},varsPrefix:function(a){return this.state[a].vars.length?"var "+this.state[a].vars.join(",")+";":""},body:function(a){return this.state[a].body.join("")},recurse:function(a,b,
d,c,e,f){var g,h,k=this,l,m;c=c||z;if(!f&&u(a.watchId))b=b||this.nextId(),this.if_("i",this.lazyAssign(b,this.computedMember("i",a.watchId)),this.lazyRecurse(a,b,d,c,e,!0));else switch(a.type){case s.Program:n(a.body,function(b,c){k.recurse(b.expression,w,w,function(a){h=a});c!==a.body.length-1?k.current().body.push(h,";"):k.return_(h)});break;case s.Literal:m=this.escape(a.value);this.assign(b,m);c(m);break;case s.UnaryExpression:this.recurse(a.argument,w,w,function(a){h=a});m=a.operator+"("+this.ifDefined(h,
0)+")";this.assign(b,m);c(m);break;case s.BinaryExpression:this.recurse(a.left,w,w,function(a){g=a});this.recurse(a.right,w,w,function(a){h=a});m="+"===a.operator?this.plus(g,h):"-"===a.operator?this.ifDefined(g,0)+a.operator+this.ifDefined(h,0):"("+g+")"+a.operator+"("+h+")";this.assign(b,m);c(m);break;case s.LogicalExpression:b=b||this.nextId();k.recurse(a.left,b);k.if_("&&"===a.operator?b:k.not(b),k.lazyRecurse(a.right,b));c(b);break;case s.ConditionalExpression:b=b||this.nextId();k.recurse(a.test,
b);k.if_(b,k.lazyRecurse(a.alternate,b),k.lazyRecurse(a.consequent,b));c(b);break;case s.Identifier:b=b||this.nextId();d&&(d.context="inputs"===k.stage?"s":this.assign(this.nextId(),this.getHasOwnProperty("l",a.name)+"?l:s"),d.computed=!1,d.name=a.name);Va(a.name);k.if_("inputs"===k.stage||k.not(k.getHasOwnProperty("l",a.name)),function(){k.if_("inputs"===k.stage||"s",function(){e&&1!==e&&k.if_(k.not(k.nonComputedMember("s",a.name)),k.lazyAssign(k.nonComputedMember("s",a.name),"{}"));k.assign(b,k.nonComputedMember("s",
a.name))})},b&&k.lazyAssign(b,k.nonComputedMember("l",a.name)));(k.state.expensiveChecks||Hb(a.name))&&k.addEnsureSafeObject(b);c(b);break;case s.MemberExpression:g=d&&(d.context=this.nextId())||this.nextId();b=b||this.nextId();k.recurse(a.object,g,w,function(){k.if_(k.notNull(g),function(){if(a.computed)h=k.nextId(),k.recurse(a.property,h),k.getStringValue(h),k.addEnsureSafeMemberName(h),e&&1!==e&&k.if_(k.not(k.computedMember(g,h)),k.lazyAssign(k.computedMember(g,h),"{}")),m=k.ensureSafeObject(k.computedMember(g,
h)),k.assign(b,m),d&&(d.computed=!0,d.name=h);else{Va(a.property.name);e&&1!==e&&k.if_(k.not(k.nonComputedMember(g,a.property.name)),k.lazyAssign(k.nonComputedMember(g,a.property.name),"{}"));m=k.nonComputedMember(g,a.property.name);if(k.state.expensiveChecks||Hb(a.property.name))m=k.ensureSafeObject(m);k.assign(b,m);d&&(d.computed=!1,d.name=a.property.name)}},function(){k.assign(b,"undefined")});c(b)},!!e);break;case s.CallExpression:b=b||this.nextId();a.filter?(h=k.filter(a.callee.name),l=[],n(a.arguments,
function(a){var b=k.nextId();k.recurse(a,b);l.push(b)}),m=h+"("+l.join(",")+")",k.assign(b,m),c(b)):(h=k.nextId(),g={},l=[],k.recurse(a.callee,h,g,function(){k.if_(k.notNull(h),function(){k.addEnsureSafeFunction(h);n(a.arguments,function(a){k.recurse(a,k.nextId(),w,function(a){l.push(k.ensureSafeObject(a))})});g.name?(k.state.expensiveChecks||k.addEnsureSafeObject(g.context),m=k.member(g.context,g.name,g.computed)+"("+l.join(",")+")"):m=h+"("+l.join(",")+")";m=k.ensureSafeObject(m);k.assign(b,m)},
function(){k.assign(b,"undefined")});c(b)}));break;case s.AssignmentExpression:h=this.nextId();g={};if(!qd(a.left))throw aa("lval");this.recurse(a.left,w,g,function(){k.if_(k.notNull(g.context),function(){k.recurse(a.right,h);k.addEnsureSafeObject(k.member(g.context,g.name,g.computed));k.addEnsureSafeAssignContext(g.context);m=k.member(g.context,g.name,g.computed)+a.operator+h;k.assign(b,m);c(b||m)})},1);break;case s.ArrayExpression:l=[];n(a.elements,function(a){k.recurse(a,k.nextId(),w,function(a){l.push(a)})});
m="["+l.join(",")+"]";this.assign(b,m);c(m);break;case s.ObjectExpression:l=[];n(a.properties,function(a){k.recurse(a.value,k.nextId(),w,function(b){l.push(k.escape(a.key.type===s.Identifier?a.key.name:""+a.key.value)+":"+b)})});m="{"+l.join(",")+"}";this.assign(b,m);c(m);break;case s.ThisExpression:this.assign(b,"s");c("s");break;case s.NGValueParameter:this.assign(b,"v"),c("v")}},getHasOwnProperty:function(a,b){var d=a+"."+b,c=this.current().own;c.hasOwnProperty(d)||(c[d]=this.nextId(!1,a+"&&("+
this.escape(b)+" in "+a+")"));return c[d]},assign:function(a,b){if(a)return this.current().body.push(a,"=",b,";"),a},filter:function(a){this.state.filters.hasOwnProperty(a)||(this.state.filters[a]=this.nextId(!0));return this.state.filters[a]},ifDefined:function(a,b){return"ifDefined("+a+","+this.escape(b)+")"},plus:function(a,b){return"plus("+a+","+b+")"},return_:function(a){this.current().body.push("return ",a,";")},if_:function(a,b,d){if(!0===a)b();else{var c=this.current().body;c.push("if(",a,
"){");b();c.push("}");d&&(c.push("else{"),d(),c.push("}"))}},not:function(a){return"!("+a+")"},notNull:function(a){return a+"!=null"},nonComputedMember:function(a,b){return a+"."+b},computedMember:function(a,b){return a+"["+b+"]"},member:function(a,b,d){return d?this.computedMember(a,b):this.nonComputedMember(a,b)},addEnsureSafeObject:function(a){this.current().body.push(this.ensureSafeObject(a),";")},addEnsureSafeMemberName:function(a){this.current().body.push(this.ensureSafeMemberName(a),";")},
addEnsureSafeFunction:function(a){this.current().body.push(this.ensureSafeFunction(a),";")},addEnsureSafeAssignContext:function(a){this.current().body.push(this.ensureSafeAssignContext(a),";")},ensureSafeObject:function(a){return"ensureSafeObject("+a+",text)"},ensureSafeMemberName:function(a){return"ensureSafeMemberName("+a+",text)"},ensureSafeFunction:function(a){return"ensureSafeFunction("+a+",text)"},getStringValue:function(a){this.assign(a,"getStringValue("+a+",text)")},ensureSafeAssignContext:function(a){return"ensureSafeAssignContext("+
a+",text)"},lazyRecurse:function(a,b,d,c,e,f){var g=this;return function(){g.recurse(a,b,d,c,e,f)}},lazyAssign:function(a,b){var d=this;return function(){d.assign(a,b)}},stringEscapeRegex:/[^ a-zA-Z0-9]/g,stringEscapeFn:function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)},escape:function(a){if(F(a))return"'"+a.replace(this.stringEscapeRegex,this.stringEscapeFn)+"'";if(Q(a))return a.toString();if(!0===a)return"true";if(!1===a)return"false";if(null===a)return"null";if("undefined"===
typeof a)return"undefined";throw aa("esc");},nextId:function(a,b){var d="v"+this.state.nextId++;a||this.current().vars.push(d+(b?"="+b:""));return d},current:function(){return this.state[this.state.computing]}};ud.prototype={compile:function(a,b){var d=this,c=this.astBuilder.ast(a);this.expression=a;this.expensiveChecks=b;V(c,d.$filter);var e,f;if(e=rd(c))f=this.recurse(e);e=pd(c.body);var g;e&&(g=[],n(e,function(a,b){var c=d.recurse(a);a.input=c;g.push(c);a.watchId=b}));var h=[];n(c.body,function(a){h.push(d.recurse(a.expression))});
e=0===c.body.length?function(){}:1===c.body.length?h[0]:function(a,b){var c;n(h,function(d){c=d(a,b)});return c};f&&(e.assign=function(a,b,c){return f(a,c,b)});g&&(e.inputs=g);e.literal=sd(c);e.constant=c.constant;return e},recurse:function(a,b,d){var c,e,f=this,g;if(a.input)return this.inputs(a.input,a.watchId);switch(a.type){case s.Literal:return this.value(a.value,b);case s.UnaryExpression:return e=this.recurse(a.argument),this["unary"+a.operator](e,b);case s.BinaryExpression:return c=this.recurse(a.left),
e=this.recurse(a.right),this["binary"+a.operator](c,e,b);case s.LogicalExpression:return c=this.recurse(a.left),e=this.recurse(a.right),this["binary"+a.operator](c,e,b);case s.ConditionalExpression:return this["ternary?:"](this.recurse(a.test),this.recurse(a.alternate),this.recurse(a.consequent),b);case s.Identifier:return Va(a.name,f.expression),f.identifier(a.name,f.expensiveChecks||Hb(a.name),b,d,f.expression);case s.MemberExpression:return c=this.recurse(a.object,!1,!!d),a.computed||(Va(a.property.name,
f.expression),e=a.property.name),a.computed&&(e=this.recurse(a.property)),a.computed?this.computedMember(c,e,b,d,f.expression):this.nonComputedMember(c,e,f.expensiveChecks,b,d,f.expression);case s.CallExpression:return g=[],n(a.arguments,function(a){g.push(f.recurse(a))}),a.filter&&(e=this.$filter(a.callee.name)),a.filter||(e=this.recurse(a.callee,!0)),a.filter?function(a,c,d,f){for(var r=[],n=0;n<g.length;++n)r.push(g[n](a,c,d,f));a=e.apply(w,r,f);return b?{context:w,name:w,value:a}:a}:function(a,
c,d,m){var n=e(a,c,d,m),t;if(null!=n.value){ya(n.context,f.expression);md(n.value,f.expression);t=[];for(var q=0;q<g.length;++q)t.push(ya(g[q](a,c,d,m),f.expression));t=ya(n.value.apply(n.context,t),f.expression)}return b?{value:t}:t};case s.AssignmentExpression:return c=this.recurse(a.left,!0,1),e=this.recurse(a.right),function(a,d,g,m){var n=c(a,d,g,m);a=e(a,d,g,m);ya(n.value,f.expression);nd(n.context);n.context[n.name]=a;return b?{value:a}:a};case s.ArrayExpression:return g=[],n(a.elements,function(a){g.push(f.recurse(a))}),
function(a,c,d,e){for(var f=[],n=0;n<g.length;++n)f.push(g[n](a,c,d,e));return b?{value:f}:f};case s.ObjectExpression:return g=[],n(a.properties,function(a){g.push({key:a.key.type===s.Identifier?a.key.name:""+a.key.value,value:f.recurse(a.value)})}),function(a,c,d,e){for(var f={},n=0;n<g.length;++n)f[g[n].key]=g[n].value(a,c,d,e);return b?{value:f}:f};case s.ThisExpression:return function(a){return b?{value:a}:a};case s.NGValueParameter:return function(a,c,d,e){return b?{value:d}:d}}},"unary+":function(a,
b){return function(d,c,e,f){d=a(d,c,e,f);d=u(d)?+d:0;return b?{value:d}:d}},"unary-":function(a,b){return function(d,c,e,f){d=a(d,c,e,f);d=u(d)?-d:0;return b?{value:d}:d}},"unary!":function(a,b){return function(d,c,e,f){d=!a(d,c,e,f);return b?{value:d}:d}},"binary+":function(a,b,d){return function(c,e,f,g){var h=a(c,e,f,g);c=b(c,e,f,g);h=od(h,c);return d?{value:h}:h}},"binary-":function(a,b,d){return function(c,e,f,g){var h=a(c,e,f,g);c=b(c,e,f,g);h=(u(h)?h:0)-(u(c)?c:0);return d?{value:h}:h}},"binary*":function(a,
b,d){return function(c,e,f,g){c=a(c,e,f,g)*b(c,e,f,g);return d?{value:c}:c}},"binary/":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)/b(c,e,f,g);return d?{value:c}:c}},"binary%":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)%b(c,e,f,g);return d?{value:c}:c}},"binary===":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)===b(c,e,f,g);return d?{value:c}:c}},"binary!==":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)!==b(c,e,f,g);return d?{value:c}:c}},"binary==":function(a,b,
d){return function(c,e,f,g){c=a(c,e,f,g)==b(c,e,f,g);return d?{value:c}:c}},"binary!=":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)!=b(c,e,f,g);return d?{value:c}:c}},"binary<":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)<b(c,e,f,g);return d?{value:c}:c}},"binary>":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)>b(c,e,f,g);return d?{value:c}:c}},"binary<=":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)<=b(c,e,f,g);return d?{value:c}:c}},"binary>=":function(a,b,d){return function(c,
e,f,g){c=a(c,e,f,g)>=b(c,e,f,g);return d?{value:c}:c}},"binary&&":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)&&b(c,e,f,g);return d?{value:c}:c}},"binary||":function(a,b,d){return function(c,e,f,g){c=a(c,e,f,g)||b(c,e,f,g);return d?{value:c}:c}},"ternary?:":function(a,b,d,c){return function(e,f,g,h){e=a(e,f,g,h)?b(e,f,g,h):d(e,f,g,h);return c?{value:e}:e}},value:function(a,b){return function(){return b?{context:w,name:w,value:a}:a}},identifier:function(a,b,d,c,e){return function(f,g,h,k){f=
g&&a in g?g:f;c&&1!==c&&f&&!f[a]&&(f[a]={});g=f?f[a]:w;b&&ya(g,e);return d?{context:f,name:a,value:g}:g}},computedMember:function(a,b,d,c,e){return function(f,g,h,k){var l=a(f,g,h,k),m,n;null!=l&&(m=b(f,g,h,k),m=ld(m),Va(m,e),c&&1!==c&&l&&!l[m]&&(l[m]={}),n=l[m],ya(n,e));return d?{context:l,name:m,value:n}:n}},nonComputedMember:function(a,b,d,c,e,f){return function(g,h,k,l){g=a(g,h,k,l);e&&1!==e&&g&&!g[b]&&(g[b]={});h=null!=g?g[b]:w;(d||Hb(b))&&ya(h,f);return c?{context:g,name:b,value:h}:h}},inputs:function(a,
b){return function(d,c,e,f){return f?f[b]:a(d,c,e)}}};var hc=function(a,b,d){this.lexer=a;this.$filter=b;this.options=d;this.ast=new s(this.lexer);this.astCompiler=d.csp?new ud(this.ast,b):new td(this.ast,b)};hc.prototype={constructor:hc,parse:function(a){return this.astCompiler.compile(a,this.options.expensiveChecks)}};var eg=Object.prototype.valueOf,za=M("$sce"),ma={HTML:"html",CSS:"css",URL:"url",RESOURCE_URL:"resourceUrl",JS:"js"},ga=M("$compile"),ba=W.createElement("a"),yd=xa(S.location.href);
zd.$inject=["$document"];Kc.$inject=["$provide"];var Gd=22,Fd=".",jc="0";Ad.$inject=["$locale"];Cd.$inject=["$locale"];var qg={yyyy:ca("FullYear",4),yy:ca("FullYear",2,0,!0),y:ca("FullYear",1),MMMM:Jb("Month"),MMM:Jb("Month",!0),MM:ca("Month",2,1),M:ca("Month",1,1),dd:ca("Date",2),d:ca("Date",1),HH:ca("Hours",2),H:ca("Hours",1),hh:ca("Hours",2,-12),h:ca("Hours",1,-12),mm:ca("Minutes",2),m:ca("Minutes",1),ss:ca("Seconds",2),s:ca("Seconds",1),sss:ca("Milliseconds",3),EEEE:Jb("Day"),EEE:Jb("Day",!0),
a:function(a,b){return 12>a.getHours()?b.AMPMS[0]:b.AMPMS[1]},Z:function(a,b,d){a=-1*d;return a=(0<=a?"+":"")+(Ib(Math[0<a?"floor":"ceil"](a/60),2)+Ib(Math.abs(a%60),2))},ww:Id(2),w:Id(1),G:kc,GG:kc,GGG:kc,GGGG:function(a,b){return 0>=a.getFullYear()?b.ERANAMES[0]:b.ERANAMES[1]}},pg=/((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,og=/^\-?\d+$/;Bd.$inject=["$locale"];var jg=na(K),kg=na(tb);Dd.$inject=["$parse"];var le=na({restrict:"E",compile:function(a,b){if(!b.href&&
!b.xlinkHref)return function(a,b){if("a"===b[0].nodeName.toLowerCase()){var e="[object SVGAnimatedString]"===ta.call(b.prop("href"))?"xlink:href":"href";b.on("click",function(a){b.attr(e)||a.preventDefault()})}}}}),ub={};n(Db,function(a,b){function d(a,d,e){a.$watch(e[c],function(a){e.$set(b,!!a)})}if("multiple"!=a){var c=va("ng-"+b),e=d;"checked"===a&&(e=function(a,b,e){e.ngModel!==e[c]&&d(a,b,e)});ub[c]=function(){return{restrict:"A",priority:100,link:e}}}});n(ad,function(a,b){ub[b]=function(){return{priority:100,
link:function(a,c,e){if("ngPattern"===b&&"/"==e.ngPattern.charAt(0)&&(c=e.ngPattern.match(sg))){e.$set("ngPattern",new RegExp(c[1],c[2]));return}a.$watch(e[b],function(a){e.$set(b,a)})}}}});n(["src","srcset","href"],function(a){var b=va("ng-"+a);ub[b]=function(){return{priority:99,link:function(d,c,e){var f=a,g=a;"href"===a&&"[object SVGAnimatedString]"===ta.call(c.prop("href"))&&(g="xlinkHref",e.$attr[g]="xlink:href",f=null);e.$observe(b,function(b){b?(e.$set(g,b),Ha&&f&&c.prop(f,e[g])):"href"===
a&&e.$set(g,null)})}}}});var Kb={$addControl:z,$$renameControl:function(a,b){a.$name=b},$removeControl:z,$setValidity:z,$setDirty:z,$setPristine:z,$setSubmitted:z};Jd.$inject=["$element","$attrs","$scope","$animate","$interpolate"];var Rd=function(a){return["$timeout","$parse",function(b,d){function c(a){return""===a?d('this[""]').assign:d(a).assign||z}return{name:"form",restrict:a?"EAC":"E",require:["form","^^?form"],controller:Jd,compile:function(d,f){d.addClass(Wa).addClass(nb);var g=f.name?"name":
a&&f.ngForm?"ngForm":!1;return{pre:function(a,d,e,f){var n=f[0];if(!("action"in e)){var t=function(b){a.$apply(function(){n.$commitViewValue();n.$setSubmitted()});b.preventDefault()};d[0].addEventListener("submit",t,!1);d.on("$destroy",function(){b(function(){d[0].removeEventListener("submit",t,!1)},0,!1)})}(f[1]||n.$$parentForm).$addControl(n);var q=g?c(n.$name):z;g&&(q(a,n),e.$observe(g,function(b){n.$name!==b&&(q(a,w),n.$$parentForm.$$renameControl(n,b),q=c(n.$name),q(a,n))}));d.on("$destroy",
function(){n.$$parentForm.$removeControl(n);q(a,w);N(n,Kb)})}}}}}]},me=Rd(),ze=Rd(!0),rg=/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/,Ag=/^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i,Bg=/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,Cg=/^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/,Sd=/^(\d{4})-(\d{2})-(\d{2})$/,Td=/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,
nc=/^(\d{4})-W(\d\d)$/,Ud=/^(\d{4})-(\d\d)$/,Vd=/^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/,Wd={text:function(a,b,d,c,e,f){kb(a,b,d,c,e,f);lc(c)},date:lb("date",Sd,Mb(Sd,["yyyy","MM","dd"]),"yyyy-MM-dd"),"datetime-local":lb("datetimelocal",Td,Mb(Td,"yyyy MM dd HH mm ss sss".split(" ")),"yyyy-MM-ddTHH:mm:ss.sss"),time:lb("time",Vd,Mb(Vd,["HH","mm","ss","sss"]),"HH:mm:ss.sss"),week:lb("week",nc,function(a,b){if(da(a))return a;if(F(a)){nc.lastIndex=0;var d=nc.exec(a);if(d){var c=+d[1],e=+d[2],f=d=0,g=
0,h=0,k=Hd(c),e=7*(e-1);b&&(d=b.getHours(),f=b.getMinutes(),g=b.getSeconds(),h=b.getMilliseconds());return new Date(c,0,k.getDate()+e,d,f,g,h)}}return NaN},"yyyy-Www"),month:lb("month",Ud,Mb(Ud,["yyyy","MM"]),"yyyy-MM"),number:function(a,b,d,c,e,f){Ld(a,b,d,c);kb(a,b,d,c,e,f);c.$$parserName="number";c.$parsers.push(function(a){return c.$isEmpty(a)?null:Cg.test(a)?parseFloat(a):w});c.$formatters.push(function(a){if(!c.$isEmpty(a)){if(!Q(a))throw mb("numfmt",a);a=a.toString()}return a});if(u(d.min)||
d.ngMin){var g;c.$validators.min=function(a){return c.$isEmpty(a)||q(g)||a>=g};d.$observe("min",function(a){u(a)&&!Q(a)&&(a=parseFloat(a,10));g=Q(a)&&!isNaN(a)?a:w;c.$validate()})}if(u(d.max)||d.ngMax){var h;c.$validators.max=function(a){return c.$isEmpty(a)||q(h)||a<=h};d.$observe("max",function(a){u(a)&&!Q(a)&&(a=parseFloat(a,10));h=Q(a)&&!isNaN(a)?a:w;c.$validate()})}},url:function(a,b,d,c,e,f){kb(a,b,d,c,e,f);lc(c);c.$$parserName="url";c.$validators.url=function(a,b){var d=a||b;return c.$isEmpty(d)||
Ag.test(d)}},email:function(a,b,d,c,e,f){kb(a,b,d,c,e,f);lc(c);c.$$parserName="email";c.$validators.email=function(a,b){var d=a||b;return c.$isEmpty(d)||Bg.test(d)}},radio:function(a,b,d,c){q(d.name)&&b.attr("name",++ob);b.on("click",function(a){b[0].checked&&c.$setViewValue(d.value,a&&a.type)});c.$render=function(){b[0].checked=d.value==c.$viewValue};d.$observe("value",c.$render)},checkbox:function(a,b,d,c,e,f,g,h){var k=Md(h,a,"ngTrueValue",d.ngTrueValue,!0),l=Md(h,a,"ngFalseValue",d.ngFalseValue,
!1);b.on("click",function(a){c.$setViewValue(b[0].checked,a&&a.type)});c.$render=function(){b[0].checked=c.$viewValue};c.$isEmpty=function(a){return!1===a};c.$formatters.push(function(a){return ka(a,k)});c.$parsers.push(function(a){return a?k:l})},hidden:z,button:z,submit:z,reset:z,file:z},Ec=["$browser","$sniffer","$filter","$parse",function(a,b,d,c){return{restrict:"E",require:["?ngModel"],link:{pre:function(e,f,g,h){h[0]&&(Wd[K(g.type)]||Wd.text)(e,f,g,h[0],b,a,d,c)}}}}],Dg=/^(true|false|\d+)$/,
Re=function(){return{restrict:"A",priority:100,compile:function(a,b){return Dg.test(b.ngValue)?function(a,b,e){e.$set("value",a.$eval(e.ngValue))}:function(a,b,e){a.$watch(e.ngValue,function(a){e.$set("value",a)})}}}},re=["$compile",function(a){return{restrict:"AC",compile:function(b){a.$$addBindingClass(b);return function(b,c,e){a.$$addBindingInfo(c,e.ngBind);c=c[0];b.$watch(e.ngBind,function(a){c.textContent=q(a)?"":a})}}}}],te=["$interpolate","$compile",function(a,b){return{compile:function(d){b.$$addBindingClass(d);
return function(c,d,f){c=a(d.attr(f.$attr.ngBindTemplate));b.$$addBindingInfo(d,c.expressions);d=d[0];f.$observe("ngBindTemplate",function(a){d.textContent=q(a)?"":a})}}}}],se=["$sce","$parse","$compile",function(a,b,d){return{restrict:"A",compile:function(c,e){var f=b(e.ngBindHtml),g=b(e.ngBindHtml,function(a){return(a||"").toString()});d.$$addBindingClass(c);return function(b,c,e){d.$$addBindingInfo(c,e.ngBindHtml);b.$watch(g,function(){c.html(a.getTrustedHtml(f(b))||"")})}}}}],Qe=na({restrict:"A",
require:"ngModel",link:function(a,b,d,c){c.$viewChangeListeners.push(function(){a.$eval(d.ngChange)})}}),ue=mc("",!0),we=mc("Odd",0),ve=mc("Even",1),xe=Ka({compile:function(a,b){b.$set("ngCloak",w);a.removeClass("ng-cloak")}}),ye=[function(){return{restrict:"A",scope:!0,controller:"@",priority:500}}],Jc={},Eg={blur:!0,focus:!0};n("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),function(a){var b=
va("ng-"+a);Jc[b]=["$parse","$rootScope",function(d,c){return{restrict:"A",compile:function(e,f){var g=d(f[b],null,!0);return function(b,d){d.on(a,function(d){var e=function(){g(b,{$event:d})};Eg[a]&&c.$$phase?b.$evalAsync(e):b.$apply(e)})}}}}]});var Be=["$animate",function(a){return{multiElement:!0,transclude:"element",priority:600,terminal:!0,restrict:"A",$$tlb:!0,link:function(b,d,c,e,f){var g,h,k;b.$watch(c.ngIf,function(b){b?h||f(function(b,e){h=e;b[b.length++]=W.createComment(" end ngIf: "+
c.ngIf+" ");g={clone:b};a.enter(b,d.parent(),d)}):(k&&(k.remove(),k=null),h&&(h.$destroy(),h=null),g&&(k=sb(g.clone),a.leave(k).then(function(){k=null}),g=null))})}}}],Ce=["$templateRequest","$anchorScroll","$animate",function(a,b,d){return{restrict:"ECA",priority:400,terminal:!0,transclude:"element",controller:$.noop,compile:function(c,e){var f=e.ngInclude||e.src,g=e.onload||"",h=e.autoscroll;return function(c,e,m,n,q){var s=0,y,w,p,x=function(){w&&(w.remove(),w=null);y&&(y.$destroy(),y=null);p&&
(d.leave(p).then(function(){w=null}),w=p,p=null)};c.$watch(f,function(f){var m=function(){!u(h)||h&&!c.$eval(h)||b()},H=++s;f?(a(f,!0).then(function(a){if(!c.$$destroyed&&H===s){var b=c.$new();n.template=a;a=q(b,function(a){x();d.enter(a,null,e).then(m)});y=b;p=a;y.$emit("$includeContentLoaded",f);c.$eval(g)}},function(){c.$$destroyed||H!==s||(x(),c.$emit("$includeContentError",f))}),c.$emit("$includeContentRequested",f)):(x(),n.template=null)})}}}}],Te=["$compile",function(a){return{restrict:"ECA",
priority:-400,require:"ngInclude",link:function(b,d,c,e){/SVG/.test(d[0].toString())?(d.empty(),a(Mc(e.template,W).childNodes)(b,function(a){d.append(a)},{futureParentElement:d})):(d.html(e.template),a(d.contents())(b))}}}],De=Ka({priority:450,compile:function(){return{pre:function(a,b,d){a.$eval(d.ngInit)}}}}),Pe=function(){return{restrict:"A",priority:100,require:"ngModel",link:function(a,b,d,c){var e=b.attr(d.$attr.ngList)||", ",f="false"!==d.ngTrim,g=f?T(e):e;c.$parsers.push(function(a){if(!q(a)){var b=
[];a&&n(a.split(g),function(a){a&&b.push(f?T(a):a)});return b}});c.$formatters.push(function(a){return E(a)?a.join(e):w});c.$isEmpty=function(a){return!a||!a.length}}}},nb="ng-valid",Nd="ng-invalid",Wa="ng-pristine",Lb="ng-dirty",Pd="ng-pending",mb=M("ngModel"),Fg=["$scope","$exceptionHandler","$attrs","$element","$parse","$animate","$timeout","$rootScope","$q","$interpolate",function(a,b,d,c,e,f,g,h,k,l){this.$modelValue=this.$viewValue=Number.NaN;this.$$rawModelValue=w;this.$validators={};this.$asyncValidators=
{};this.$parsers=[];this.$formatters=[];this.$viewChangeListeners=[];this.$untouched=!0;this.$touched=!1;this.$pristine=!0;this.$dirty=!1;this.$valid=!0;this.$invalid=!1;this.$error={};this.$$success={};this.$pending=w;this.$name=l(d.name||"",!1)(a);this.$$parentForm=Kb;var m=e(d.ngModel),r=m.assign,t=m,s=r,y=null,A,p=this;this.$$setOptions=function(a){if((p.$options=a)&&a.getterSetter){var b=e(d.ngModel+"()"),f=e(d.ngModel+"($$$p)");t=function(a){var c=m(a);B(c)&&(c=b(a));return c};s=function(a,
b){B(m(a))?f(a,{$$$p:p.$modelValue}):r(a,p.$modelValue)}}else if(!m.assign)throw mb("nonassign",d.ngModel,ua(c));};this.$render=z;this.$isEmpty=function(a){return q(a)||""===a||null===a||a!==a};var x=0;Kd({ctrl:this,$element:c,set:function(a,b){a[b]=!0},unset:function(a,b){delete a[b]},$animate:f});this.$setPristine=function(){p.$dirty=!1;p.$pristine=!0;f.removeClass(c,Lb);f.addClass(c,Wa)};this.$setDirty=function(){p.$dirty=!0;p.$pristine=!1;f.removeClass(c,Wa);f.addClass(c,Lb);p.$$parentForm.$setDirty()};
this.$setUntouched=function(){p.$touched=!1;p.$untouched=!0;f.setClass(c,"ng-untouched","ng-touched")};this.$setTouched=function(){p.$touched=!0;p.$untouched=!1;f.setClass(c,"ng-touched","ng-untouched")};this.$rollbackViewValue=function(){g.cancel(y);p.$viewValue=p.$$lastCommittedViewValue;p.$render()};this.$validate=function(){if(!Q(p.$modelValue)||!isNaN(p.$modelValue)){var a=p.$$rawModelValue,b=p.$valid,c=p.$modelValue,d=p.$options&&p.$options.allowInvalid;p.$$runValidators(a,p.$$lastCommittedViewValue,
function(e){d||b===e||(p.$modelValue=e?a:w,p.$modelValue!==c&&p.$$writeModelToScope())})}};this.$$runValidators=function(a,b,c){function d(){var c=!0;n(p.$validators,function(d,e){var g=d(a,b);c=c&&g;f(e,g)});return c?!0:(n(p.$asyncValidators,function(a,b){f(b,null)}),!1)}function e(){var c=[],d=!0;n(p.$asyncValidators,function(e,g){var h=e(a,b);if(!h||!B(h.then))throw mb("nopromise",h);f(g,w);c.push(h.then(function(){f(g,!0)},function(a){d=!1;f(g,!1)}))});c.length?k.all(c).then(function(){g(d)},
z):g(!0)}function f(a,b){h===x&&p.$setValidity(a,b)}function g(a){h===x&&c(a)}x++;var h=x;(function(){var a=p.$$parserName||"parse";if(q(A))f(a,null);else return A||(n(p.$validators,function(a,b){f(b,null)}),n(p.$asyncValidators,function(a,b){f(b,null)})),f(a,A),A;return!0})()?d()?e():g(!1):g(!1)};this.$commitViewValue=function(){var a=p.$viewValue;g.cancel(y);if(p.$$lastCommittedViewValue!==a||""===a&&p.$$hasNativeValidators)p.$$lastCommittedViewValue=a,p.$pristine&&this.$setDirty(),this.$$parseAndValidate()};
this.$$parseAndValidate=function(){var b=p.$$lastCommittedViewValue;if(A=q(b)?w:!0)for(var c=0;c<p.$parsers.length;c++)if(b=p.$parsers[c](b),q(b)){A=!1;break}Q(p.$modelValue)&&isNaN(p.$modelValue)&&(p.$modelValue=t(a));var d=p.$modelValue,e=p.$options&&p.$options.allowInvalid;p.$$rawModelValue=b;e&&(p.$modelValue=b,p.$modelValue!==d&&p.$$writeModelToScope());p.$$runValidators(b,p.$$lastCommittedViewValue,function(a){e||(p.$modelValue=a?b:w,p.$modelValue!==d&&p.$$writeModelToScope())})};this.$$writeModelToScope=
function(){s(a,p.$modelValue);n(p.$viewChangeListeners,function(a){try{a()}catch(c){b(c)}})};this.$setViewValue=function(a,b){p.$viewValue=a;p.$options&&!p.$options.updateOnDefault||p.$$debounceViewValueCommit(b)};this.$$debounceViewValueCommit=function(b){var c=0,d=p.$options;d&&u(d.debounce)&&(d=d.debounce,Q(d)?c=d:Q(d[b])?c=d[b]:Q(d["default"])&&(c=d["default"]));g.cancel(y);c?y=g(function(){p.$commitViewValue()},c):h.$$phase?p.$commitViewValue():a.$apply(function(){p.$commitViewValue()})};a.$watch(function(){var b=
t(a);if(b!==p.$modelValue&&(p.$modelValue===p.$modelValue||b===b)){p.$modelValue=p.$$rawModelValue=b;A=w;for(var c=p.$formatters,d=c.length,e=b;d--;)e=c[d](e);p.$viewValue!==e&&(p.$viewValue=p.$$lastCommittedViewValue=e,p.$render(),p.$$runValidators(b,e,z))}return b})}],Oe=["$rootScope",function(a){return{restrict:"A",require:["ngModel","^?form","^?ngModelOptions"],controller:Fg,priority:1,compile:function(b){b.addClass(Wa).addClass("ng-untouched").addClass(nb);return{pre:function(a,b,e,f){var g=
f[0];b=f[1]||g.$$parentForm;g.$$setOptions(f[2]&&f[2].$options);b.$addControl(g);e.$observe("name",function(a){g.$name!==a&&g.$$parentForm.$$renameControl(g,a)});a.$on("$destroy",function(){g.$$parentForm.$removeControl(g)})},post:function(b,c,e,f){var g=f[0];if(g.$options&&g.$options.updateOn)c.on(g.$options.updateOn,function(a){g.$$debounceViewValueCommit(a&&a.type)});c.on("blur",function(c){g.$touched||(a.$$phase?b.$evalAsync(g.$setTouched):b.$apply(g.$setTouched))})}}}}}],Gg=/(\s+|^)default(\s+|$)/,
Se=function(){return{restrict:"A",controller:["$scope","$attrs",function(a,b){var d=this;this.$options=Ma(a.$eval(b.ngModelOptions));u(this.$options.updateOn)?(this.$options.updateOnDefault=!1,this.$options.updateOn=T(this.$options.updateOn.replace(Gg,function(){d.$options.updateOnDefault=!0;return" "}))):this.$options.updateOnDefault=!0}]}},Ee=Ka({terminal:!0,priority:1E3}),Hg=M("ngOptions"),Ig=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/,
Me=["$compile","$parse",function(a,b){function d(a,c,d){function e(a,b,c,d,f){this.selectValue=a;this.viewValue=b;this.label=c;this.group=d;this.disabled=f}function l(a){var b;if(!q&&Aa(a))b=a;else{b=[];for(var c in a)a.hasOwnProperty(c)&&"$"!==c.charAt(0)&&b.push(c)}return b}var m=a.match(Ig);if(!m)throw Hg("iexp",a,ua(c));var n=m[5]||m[7],q=m[6];a=/ as /.test(m[0])&&m[1];var s=m[9];c=b(m[2]?m[1]:n);var y=a&&b(a)||c,u=s&&b(s),p=s?function(a,b){return u(d,b)}:function(a){return Da(a)},x=function(a,
b){return p(a,D(a,b))},v=b(m[2]||m[1]),w=b(m[3]||""),H=b(m[4]||""),A=b(m[8]),z={},D=q?function(a,b){z[q]=b;z[n]=a;return z}:function(a){z[n]=a;return z};return{trackBy:s,getTrackByValue:x,getWatchables:b(A,function(a){var b=[];a=a||[];for(var c=l(a),e=c.length,f=0;f<e;f++){var g=a===c?f:c[f],k=D(a[g],g),g=p(a[g],k);b.push(g);if(m[2]||m[1])g=v(d,k),b.push(g);m[4]&&(k=H(d,k),b.push(k))}return b}),getOptions:function(){for(var a=[],b={},c=A(d)||[],f=l(c),g=f.length,m=0;m<g;m++){var n=c===f?m:f[m],r=
D(c[n],n),q=y(d,r),n=p(q,r),t=v(d,r),u=w(d,r),r=H(d,r),q=new e(n,q,t,u,r);a.push(q);b[n]=q}return{items:a,selectValueMap:b,getOptionFromViewValue:function(a){return b[x(a)]},getViewValueFromOption:function(a){return s?$.copy(a.viewValue):a.viewValue}}}}}var c=W.createElement("option"),e=W.createElement("optgroup");return{restrict:"A",terminal:!0,require:["select","?ngModel"],link:{pre:function(a,b,c,d){d[0].registerOption=z},post:function(b,g,h,k){function l(a,b){a.element=b;b.disabled=a.disabled;
a.label!==b.label&&(b.label=a.label,b.textContent=a.label);a.value!==b.value&&(b.value=a.selectValue)}function m(a,b,c,d){b&&K(b.nodeName)===c?c=b:(c=d.cloneNode(!1),b?a.insertBefore(c,b):a.appendChild(c));return c}function r(a){for(var b;a;)b=a.nextSibling,Zb(a),a=b}function q(a){var b=x&&x[0],c=z&&z[0];if(b||c)for(;a&&(a===b||a===c||8===a.nodeType||"option"===oa(a)&&""===a.value);)a=a.nextSibling;return a}function s(){var a=B&&u.readValue();B=D.getOptions();var b={},d=g[0].firstChild;H&&g.prepend(x);
d=q(d);B.items.forEach(function(a){var f,h;a.group?(f=b[a.group],f||(f=m(g[0],d,"optgroup",e),d=f.nextSibling,f.label=a.group,f=b[a.group]={groupElement:f,currentOptionElement:f.firstChild}),h=m(f.groupElement,f.currentOptionElement,"option",c),l(a,h),f.currentOptionElement=h.nextSibling):(h=m(g[0],d,"option",c),l(a,h),d=h.nextSibling)});Object.keys(b).forEach(function(a){r(b[a].currentOptionElement)});r(d);y.$render();if(!y.$isEmpty(a)){var f=u.readValue();(D.trackBy||p?ka(a,f):a===f)||(y.$setViewValue(f),
y.$render())}}var y=k[1];if(y){var u=k[0],p=h.multiple,x;k=0;for(var v=g.children(),w=v.length;k<w;k++)if(""===v[k].value){x=v.eq(k);break}var H=!!x,z=A(c.cloneNode(!1));z.val("?");var B,D=d(h.ngOptions,g,b);p?(y.$isEmpty=function(a){return!a||0===a.length},u.writeValue=function(a){B.items.forEach(function(a){a.element.selected=!1});a&&a.forEach(function(a){(a=B.getOptionFromViewValue(a))&&!a.disabled&&(a.element.selected=!0)})},u.readValue=function(){var a=g.val()||[],b=[];n(a,function(a){(a=B.selectValueMap[a])&&
!a.disabled&&b.push(B.getViewValueFromOption(a))});return b},D.trackBy&&b.$watchCollection(function(){if(E(y.$viewValue))return y.$viewValue.map(function(a){return D.getTrackByValue(a)})},function(){y.$render()})):(u.writeValue=function(a){var b=B.getOptionFromViewValue(a);b&&!b.disabled?g[0].value!==b.selectValue&&(z.remove(),H||x.remove(),g[0].value=b.selectValue,b.element.selected=!0,b.element.setAttribute("selected","selected")):null===a||H?(z.remove(),H||g.prepend(x),g.val(""),x.prop("selected",
!0),x.attr("selected",!0)):(H||x.remove(),g.prepend(z),g.val("?"),z.prop("selected",!0),z.attr("selected",!0))},u.readValue=function(){var a=B.selectValueMap[g.val()];return a&&!a.disabled?(H||x.remove(),z.remove(),B.getViewValueFromOption(a)):null},D.trackBy&&b.$watch(function(){return D.getTrackByValue(y.$viewValue)},function(){y.$render()}));H?(x.remove(),a(x)(b),x.removeClass("ng-scope")):x=A(c.cloneNode(!1));s();b.$watchCollection(D.getWatchables,s)}}}}}],Fe=["$locale","$interpolate","$log",
function(a,b,d){var c=/{}/g,e=/^when(Minus)?(.+)$/;return{link:function(f,g,h){function k(a){g.text(a||"")}var l=h.count,m=h.$attr.when&&g.attr(h.$attr.when),r=h.offset||0,t=f.$eval(m)||{},s={},u=b.startSymbol(),w=b.endSymbol(),p=u+l+"-"+r+w,x=$.noop,v;n(h,function(a,b){var c=e.exec(b);c&&(c=(c[1]?"-":"")+K(c[2]),t[c]=g.attr(h.$attr[b]))});n(t,function(a,d){s[d]=b(a.replace(c,p))});f.$watch(l,function(b){var c=parseFloat(b),e=isNaN(c);e||c in t||(c=a.pluralCat(c-r));c===v||e&&Q(v)&&isNaN(v)||(x(),
e=s[c],q(e)?(null!=b&&d.debug("ngPluralize: no rule defined for '"+c+"' in "+m),x=z,k()):x=f.$watch(e,k),v=c)})}}}],Ge=["$parse","$animate",function(a,b){var d=M("ngRepeat"),c=function(a,b,c,d,k,l,m){a[c]=d;k&&(a[k]=l);a.$index=b;a.$first=0===b;a.$last=b===m-1;a.$middle=!(a.$first||a.$last);a.$odd=!(a.$even=0===(b&1))};return{restrict:"A",multiElement:!0,transclude:"element",priority:1E3,terminal:!0,$$tlb:!0,compile:function(e,f){var g=f.ngRepeat,h=W.createComment(" end ngRepeat: "+g+" "),k=g.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
if(!k)throw d("iexp",g);var l=k[1],m=k[2],r=k[3],q=k[4],k=l.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);if(!k)throw d("iidexp",l);var s=k[3]||k[1],u=k[2];if(r&&(!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(r)||/^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(r)))throw d("badident",r);var z,p,x,v,B={$id:Da};q?z=a(q):(x=function(a,b){return Da(b)},v=function(a){return a});return function(a,e,f,k,l){z&&(p=function(b,c,d){u&&(B[u]=b);B[s]=c;B.$index=
d;return z(a,B)});var q=ea();a.$watchCollection(m,function(f){var k,m,t=e[0],z,B=ea(),D,F,G,E,I,J,K;r&&(a[r]=f);if(Aa(f))I=f,m=p||x;else for(K in m=p||v,I=[],f)ra.call(f,K)&&"$"!==K.charAt(0)&&I.push(K);D=I.length;K=Array(D);for(k=0;k<D;k++)if(F=f===I?k:I[k],G=f[F],E=m(F,G,k),q[E])J=q[E],delete q[E],B[E]=J,K[k]=J;else{if(B[E])throw n(K,function(a){a&&a.scope&&(q[a.id]=a)}),d("dupes",g,E,G);K[k]={id:E,scope:w,clone:w};B[E]=!0}for(z in q){J=q[z];E=sb(J.clone);b.leave(E);if(E[0].parentNode)for(k=0,m=
E.length;k<m;k++)E[k].$$NG_REMOVED=!0;J.scope.$destroy()}for(k=0;k<D;k++)if(F=f===I?k:I[k],G=f[F],J=K[k],J.scope){z=t;do z=z.nextSibling;while(z&&z.$$NG_REMOVED);J.clone[0]!=z&&b.move(sb(J.clone),null,A(t));t=J.clone[J.clone.length-1];c(J.scope,k,s,G,u,F,D)}else l(function(a,d){J.scope=d;var e=h.cloneNode(!1);a[a.length++]=e;b.enter(a,null,A(t));t=e;J.clone=a;B[J.id]=J;c(J.scope,k,s,G,u,F,D)});q=B})}}}}],He=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(b,d,c){b.$watch(c.ngShow,
function(b){a[b?"removeClass":"addClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],Ae=["$animate",function(a){return{restrict:"A",multiElement:!0,link:function(b,d,c){b.$watch(c.ngHide,function(b){a[b?"addClass":"removeClass"](d,"ng-hide",{tempClasses:"ng-hide-animate"})})}}}],Ie=Ka(function(a,b,d){a.$watch(d.ngStyle,function(a,d){d&&a!==d&&n(d,function(a,c){b.css(c,"")});a&&b.css(a)},!0)}),Je=["$animate",function(a){return{require:"ngSwitch",controller:["$scope",function(){this.cases={}}],
link:function(b,d,c,e){var f=[],g=[],h=[],k=[],l=function(a,b){return function(){a.splice(b,1)}};b.$watch(c.ngSwitch||c.on,function(b){var c,d;c=0;for(d=h.length;c<d;++c)a.cancel(h[c]);c=h.length=0;for(d=k.length;c<d;++c){var q=sb(g[c].clone);k[c].$destroy();(h[c]=a.leave(q)).then(l(h,c))}g.length=0;k.length=0;(f=e.cases["!"+b]||e.cases["?"])&&n(f,function(b){b.transclude(function(c,d){k.push(d);var e=b.element;c[c.length++]=W.createComment(" end ngSwitchWhen: ");g.push({clone:c});a.enter(c,e.parent(),
e)})})})}}}],Ke=Ka({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,b,d,c,e){c.cases["!"+d.ngSwitchWhen]=c.cases["!"+d.ngSwitchWhen]||[];c.cases["!"+d.ngSwitchWhen].push({transclude:e,element:b})}}),Le=Ka({transclude:"element",priority:1200,require:"^ngSwitch",multiElement:!0,link:function(a,b,d,c,e){c.cases["?"]=c.cases["?"]||[];c.cases["?"].push({transclude:e,element:b})}}),Ne=Ka({restrict:"EAC",link:function(a,b,d,c,e){if(!e)throw M("ngTransclude")("orphan",
ua(b));e(function(a){b.empty();b.append(a)})}}),ne=["$templateCache",function(a){return{restrict:"E",terminal:!0,compile:function(b,d){"text/ng-template"==d.type&&a.put(d.id,b[0].text)}}}],Jg={$setViewValue:z,$render:z},Kg=["$element","$scope","$attrs",function(a,b,d){var c=this,e=new Sa;c.ngModelCtrl=Jg;c.unknownOption=A(W.createElement("option"));c.renderUnknownOption=function(b){b="? "+Da(b)+" ?";c.unknownOption.val(b);a.prepend(c.unknownOption);a.val(b)};b.$on("$destroy",function(){c.renderUnknownOption=
z});c.removeUnknownOption=function(){c.unknownOption.parent()&&c.unknownOption.remove()};c.readValue=function(){c.removeUnknownOption();return a.val()};c.writeValue=function(b){c.hasOption(b)?(c.removeUnknownOption(),a.val(b),""===b&&c.emptyOption.prop("selected",!0)):null==b&&c.emptyOption?(c.removeUnknownOption(),a.val("")):c.renderUnknownOption(b)};c.addOption=function(a,b){Ra(a,'"option value"');""===a&&(c.emptyOption=b);var d=e.get(a)||0;e.put(a,d+1);c.ngModelCtrl.$render();b[0].hasAttribute("selected")&&
(b[0].selected=!0)};c.removeOption=function(a){var b=e.get(a);b&&(1===b?(e.remove(a),""===a&&(c.emptyOption=w)):e.put(a,b-1))};c.hasOption=function(a){return!!e.get(a)};c.registerOption=function(a,b,d,e,l){if(e){var m;d.$observe("value",function(a){u(m)&&c.removeOption(m);m=a;c.addOption(a,b)})}else l?a.$watch(l,function(a,e){d.$set("value",a);e!==a&&c.removeOption(e);c.addOption(a,b)}):c.addOption(d.value,b);b.on("$destroy",function(){c.removeOption(d.value);c.ngModelCtrl.$render()})}}],oe=function(){return{restrict:"E",
require:["select","?ngModel"],controller:Kg,priority:1,link:{pre:function(a,b,d,c){var e=c[1];if(e){var f=c[0];f.ngModelCtrl=e;b.on("change",function(){a.$apply(function(){e.$setViewValue(f.readValue())})});if(d.multiple){f.readValue=function(){var a=[];n(b.find("option"),function(b){b.selected&&a.push(b.value)});return a};f.writeValue=function(a){var c=new Sa(a);n(b.find("option"),function(a){a.selected=u(c.get(a.value))})};var g,h=NaN;a.$watch(function(){h!==e.$viewValue||ka(g,e.$viewValue)||(g=
ha(e.$viewValue),e.$render());h=e.$viewValue});e.$isEmpty=function(a){return!a||0===a.length}}}},post:function(a,b,d,c){var e=c[1];if(e){var f=c[0];e.$render=function(){f.writeValue(e.$viewValue)}}}}}},qe=["$interpolate",function(a){return{restrict:"E",priority:100,compile:function(b,d){if(u(d.value))var c=a(d.value,!0);else{var e=a(b.text(),!0);e||d.$set("value",b.text())}return function(a,b,d){var k=b.parent();(k=k.data("$selectController")||k.parent().data("$selectController"))&&k.registerOption(a,
b,d,c,e)}}}}],pe=na({restrict:"E",terminal:!1}),Gc=function(){return{restrict:"A",require:"?ngModel",link:function(a,b,d,c){c&&(d.required=!0,c.$validators.required=function(a,b){return!d.required||!c.$isEmpty(b)},d.$observe("required",function(){c.$validate()}))}}},Fc=function(){return{restrict:"A",require:"?ngModel",link:function(a,b,d,c){if(c){var e,f=d.ngPattern||d.pattern;d.$observe("pattern",function(a){F(a)&&0<a.length&&(a=new RegExp("^"+a+"$"));if(a&&!a.test)throw M("ngPattern")("noregexp",
f,a,ua(b));e=a||w;c.$validate()});c.$validators.pattern=function(a,b){return c.$isEmpty(b)||q(e)||e.test(b)}}}}},Ic=function(){return{restrict:"A",require:"?ngModel",link:function(a,b,d,c){if(c){var e=-1;d.$observe("maxlength",function(a){a=Z(a);e=isNaN(a)?-1:a;c.$validate()});c.$validators.maxlength=function(a,b){return 0>e||c.$isEmpty(b)||b.length<=e}}}}},Hc=function(){return{restrict:"A",require:"?ngModel",link:function(a,b,d,c){if(c){var e=0;d.$observe("minlength",function(a){e=Z(a)||0;c.$validate()});
c.$validators.minlength=function(a,b){return c.$isEmpty(b)||b.length>=e}}}}};S.angular.bootstrap?console.log("WARNING: Tried to load angular more than once."):(ge(),ie($),$.module("ngLocale",[],["$provide",function(a){function b(a){a+="";var b=a.indexOf(".");return-1==b?0:a.length-b-1}a.value("$locale",{DATETIME_FORMATS:{AMPMS:["AM","PM"],DAY:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),ERANAMES:["Before Christ","Anno Domini"],ERAS:["BC","AD"],FIRSTDAYOFWEEK:6,MONTH:"January February March April May June July August September October November December".split(" "),
SHORTDAY:"Sun Mon Tue Wed Thu Fri Sat".split(" "),SHORTMONTH:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),STANDALONEMONTH:"January February March April May June July August September October November December".split(" "),WEEKENDRANGE:[5,6],fullDate:"EEEE, MMMM d, y",longDate:"MMMM d, y",medium:"MMM d, y h:mm:ss a",mediumDate:"MMM d, y",mediumTime:"h:mm:ss a","short":"M/d/yy h:mm a",shortDate:"M/d/yy",shortTime:"h:mm a"},NUMBER_FORMATS:{CURRENCY_SYM:"$",DECIMAL_SEP:".",GROUP_SEP:",",
PATTERNS:[{gSize:3,lgSize:3,maxFrac:3,minFrac:0,minInt:1,negPre:"-",negSuf:"",posPre:"",posSuf:""},{gSize:3,lgSize:3,maxFrac:2,minFrac:2,minInt:1,negPre:"-\u00a4",negSuf:"",posPre:"\u00a4",posSuf:""}]},id:"en-us",pluralCat:function(a,c){var e=a|0,f=c;w===f&&(f=Math.min(b(a),3));Math.pow(10,f);return 1==e&&0==f?"one":"other"}})}]),A(W).ready(function(){ce(W,zc)}))})(window,document);!window.angular.$$csp().noInlineStyle&&window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');


(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Qs = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var replace=String.prototype.replace,percentTwenties=/%20/g,Format={RFC1738:"RFC1738",RFC3986:"RFC3986"};module.exports={default:Format.RFC3986,formatters:{RFC1738:function(e){return replace.call(e,percentTwenties,"+")},RFC3986:function(e){return String(e)}},RFC1738:Format.RFC1738,RFC3986:Format.RFC3986};

},{}],2:[function(require,module,exports){
"use strict";var stringify=require(4),parse=require(3),formats=require(1);module.exports={formats:formats,parse:parse,stringify:stringify};

},{"1":1,"3":3,"4":4}],3:[function(require,module,exports){
"use strict";var utils=require(5),has=Object.prototype.hasOwnProperty,isArray=Array.isArray,defaults={allowDots:!1,allowEmptyArrays:!1,allowPrototypes:!1,allowSparse:!1,arrayLimit:20,charset:"utf-8",charsetSentinel:!1,comma:!1,decodeDotInKeys:!1,decoder:utils.decode,delimiter:"&",depth:5,duplicates:"combine",ignoreQueryPrefix:!1,interpretNumericEntities:!1,parameterLimit:1e3,parseArrays:!0,plainObjects:!1,strictDepth:!1,strictNullHandling:!1},interpretNumericEntities=function(e){return e.replace(/&#(\d+);/g,(function(e,t){return String.fromCharCode(parseInt(t,10))}))},parseArrayValue=function(e,t){return e&&"string"==typeof e&&t.comma&&e.indexOf(",")>-1?e.split(","):e},isoSentinel="utf8=%26%2310003%3B",charsetSentinel="utf8=%E2%9C%93",parseValues=function parseQueryStringValues(e,t){var r={__proto__:null},a=t.ignoreQueryPrefix?e.replace(/^\?/,""):e;a=a.replace(/%5B/gi,"[").replace(/%5D/gi,"]");var i,o=t.parameterLimit===1/0?void 0:t.parameterLimit,l=a.split(t.delimiter,o),s=-1,n=t.charset;if(t.charsetSentinel)for(i=0;i<l.length;++i)0===l[i].indexOf("utf8=")&&(l[i]===charsetSentinel?n="utf-8":l[i]===isoSentinel&&(n="iso-8859-1"),s=i,i=l.length);for(i=0;i<l.length;++i)if(i!==s){var p,c,d=l[i],u=d.indexOf("]="),f=-1===u?d.indexOf("="):u+1;-1===f?(p=t.decoder(d,defaults.decoder,n,"key"),c=t.strictNullHandling?null:""):(p=t.decoder(d.slice(0,f),defaults.decoder,n,"key"),c=utils.maybeMap(parseArrayValue(d.slice(f+1),t),(function(e){return t.decoder(e,defaults.decoder,n,"value")}))),c&&t.interpretNumericEntities&&"iso-8859-1"===n&&(c=interpretNumericEntities(String(c))),d.indexOf("[]=")>-1&&(c=isArray(c)?[c]:c);var y=has.call(r,p);y&&"combine"===t.duplicates?r[p]=utils.combine(r[p],c):y&&"last"!==t.duplicates||(r[p]=c)}return r},parseObject=function(e,t,r,a){for(var i=a?t:parseArrayValue(t,r),o=e.length-1;o>=0;--o){var l,s=e[o];if("[]"===s&&r.parseArrays)l=r.allowEmptyArrays&&(""===i||r.strictNullHandling&&null===i)?[]:[].concat(i);else{l=r.plainObjects?{__proto__:null}:{};var n="["===s.charAt(0)&&"]"===s.charAt(s.length-1)?s.slice(1,-1):s,p=r.decodeDotInKeys?n.replace(/%2E/g,"."):n,c=parseInt(p,10);r.parseArrays||""!==p?!isNaN(c)&&s!==p&&String(c)===p&&c>=0&&r.parseArrays&&c<=r.arrayLimit?(l=[])[c]=i:"__proto__"!==p&&(l[p]=i):l={0:i}}i=l}return i},parseKeys=function parseQueryStringKeys(e,t,r,a){if(e){var i=r.allowDots?e.replace(/\.([^.[]+)/g,"[$1]"):e,o=/(\[[^[\]]*])/g,l=r.depth>0&&/(\[[^[\]]*])/.exec(i),s=l?i.slice(0,l.index):i,n=[];if(s){if(!r.plainObjects&&has.call(Object.prototype,s)&&!r.allowPrototypes)return;n.push(s)}for(var p=0;r.depth>0&&null!==(l=o.exec(i))&&p<r.depth;){if(p+=1,!r.plainObjects&&has.call(Object.prototype,l[1].slice(1,-1))&&!r.allowPrototypes)return;n.push(l[1])}if(l){if(!0===r.strictDepth)throw new RangeError("Input depth exceeded depth option of "+r.depth+" and strictDepth is true");n.push("["+i.slice(l.index)+"]")}return parseObject(n,t,r,a)}},normalizeParseOptions=function normalizeParseOptions(e){if(!e)return defaults;if(void 0!==e.allowEmptyArrays&&"boolean"!=typeof e.allowEmptyArrays)throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");if(void 0!==e.decodeDotInKeys&&"boolean"!=typeof e.decodeDotInKeys)throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");if(null!==e.decoder&&void 0!==e.decoder&&"function"!=typeof e.decoder)throw new TypeError("Decoder has to be a function.");if(void 0!==e.charset&&"utf-8"!==e.charset&&"iso-8859-1"!==e.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var t=void 0===e.charset?defaults.charset:e.charset,r=void 0===e.duplicates?defaults.duplicates:e.duplicates;if("combine"!==r&&"first"!==r&&"last"!==r)throw new TypeError("The duplicates option must be either combine, first, or last");return{allowDots:void 0===e.allowDots?!0===e.decodeDotInKeys||defaults.allowDots:!!e.allowDots,allowEmptyArrays:"boolean"==typeof e.allowEmptyArrays?!!e.allowEmptyArrays:defaults.allowEmptyArrays,allowPrototypes:"boolean"==typeof e.allowPrototypes?e.allowPrototypes:defaults.allowPrototypes,allowSparse:"boolean"==typeof e.allowSparse?e.allowSparse:defaults.allowSparse,arrayLimit:"number"==typeof e.arrayLimit?e.arrayLimit:defaults.arrayLimit,charset:t,charsetSentinel:"boolean"==typeof e.charsetSentinel?e.charsetSentinel:defaults.charsetSentinel,comma:"boolean"==typeof e.comma?e.comma:defaults.comma,decodeDotInKeys:"boolean"==typeof e.decodeDotInKeys?e.decodeDotInKeys:defaults.decodeDotInKeys,decoder:"function"==typeof e.decoder?e.decoder:defaults.decoder,delimiter:"string"==typeof e.delimiter||utils.isRegExp(e.delimiter)?e.delimiter:defaults.delimiter,depth:"number"==typeof e.depth||!1===e.depth?+e.depth:defaults.depth,duplicates:r,ignoreQueryPrefix:!0===e.ignoreQueryPrefix,interpretNumericEntities:"boolean"==typeof e.interpretNumericEntities?e.interpretNumericEntities:defaults.interpretNumericEntities,parameterLimit:"number"==typeof e.parameterLimit?e.parameterLimit:defaults.parameterLimit,parseArrays:!1!==e.parseArrays,plainObjects:"boolean"==typeof e.plainObjects?e.plainObjects:defaults.plainObjects,strictDepth:"boolean"==typeof e.strictDepth?!!e.strictDepth:defaults.strictDepth,strictNullHandling:"boolean"==typeof e.strictNullHandling?e.strictNullHandling:defaults.strictNullHandling}};module.exports=function(e,t){var r=normalizeParseOptions(t);if(""===e||null==e)return r.plainObjects?{__proto__:null}:{};for(var a="string"==typeof e?parseValues(e,r):e,i=r.plainObjects?{__proto__:null}:{},o=Object.keys(a),l=0;l<o.length;++l){var s=o[l],n=parseKeys(s,a[s],r,"string"==typeof e);i=utils.merge(i,n,r)}return!0===r.allowSparse?i:utils.compact(i)};

},{"5":5}],4:[function(require,module,exports){
"use strict";var getSideChannel=require(29),utils=require(5),formats=require(1),has=Object.prototype.hasOwnProperty,arrayPrefixGenerators={brackets:function brackets(e){return e+"[]"},comma:"comma",indices:function indices(e,r){return e+"["+r+"]"},repeat:function repeat(e){return e}},isArray=Array.isArray,push=Array.prototype.push,pushToArray=function(e,r){push.apply(e,isArray(r)?r:[r])},toISO=Date.prototype.toISOString,defaultFormat=formats.default,defaults={addQueryPrefix:!1,allowDots:!1,allowEmptyArrays:!1,arrayFormat:"indices",charset:"utf-8",charsetSentinel:!1,commaRoundTrip:!1,delimiter:"&",encode:!0,encodeDotInKeys:!1,encoder:utils.encode,encodeValuesOnly:!1,filter:void 0,format:defaultFormat,formatter:formats.formatters[defaultFormat],indices:!1,serializeDate:function serializeDate(e){return toISO.call(e)},skipNulls:!1,strictNullHandling:!1},isNonNullishPrimitive=function isNonNullishPrimitive(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e||"symbol"==typeof e||"bigint"==typeof e},sentinel={},stringify=function stringify(e,r,t,o,a,n,i,l,s,f,u,d,y,c,p,m,h,v){for(var g=e,w=v,b=0,A=!1;void 0!==(w=w.get(sentinel))&&!A;){var D=w.get(e);if(b+=1,void 0!==D){if(D===b)throw new RangeError("Cyclic object value");A=!0}void 0===w.get(sentinel)&&(b=0)}if("function"==typeof f?g=f(r,g):g instanceof Date?g=y(g):"comma"===t&&isArray(g)&&(g=utils.maybeMap(g,(function(e){return e instanceof Date?y(e):e}))),null===g){if(n)return s&&!m?s(r,defaults.encoder,h,"key",c):r;g=""}if(isNonNullishPrimitive(g)||utils.isBuffer(g))return s?[p(m?r:s(r,defaults.encoder,h,"key",c))+"="+p(s(g,defaults.encoder,h,"value",c))]:[p(r)+"="+p(String(g))];var S,E=[];if(void 0===g)return E;if("comma"===t&&isArray(g))m&&s&&(g=utils.maybeMap(g,s)),S=[{value:g.length>0?g.join(",")||null:void 0}];else if(isArray(f))S=f;else{var N=Object.keys(g);S=u?N.sort(u):N}var T=l?String(r).replace(/\./g,"%2E"):String(r),O=o&&isArray(g)&&1===g.length?T+"[]":T;if(a&&isArray(g)&&0===g.length)return O+"[]";for(var k=0;k<S.length;++k){var I=S[k],P="object"==typeof I&&I&&void 0!==I.value?I.value:g[I];if(!i||null!==P){var x=d&&l?String(I).replace(/\./g,"%2E"):String(I),z=isArray(g)?"function"==typeof t?t(O,x):O:O+(d?"."+x:"["+x+"]");v.set(e,b);var K=getSideChannel();K.set(sentinel,v),pushToArray(E,stringify(P,z,t,o,a,n,i,l,"comma"===t&&m&&isArray(g)?null:s,f,u,d,y,c,p,m,h,K))}}return E},normalizeStringifyOptions=function normalizeStringifyOptions(e){if(!e)return defaults;if(void 0!==e.allowEmptyArrays&&"boolean"!=typeof e.allowEmptyArrays)throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");if(void 0!==e.encodeDotInKeys&&"boolean"!=typeof e.encodeDotInKeys)throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");if(null!==e.encoder&&void 0!==e.encoder&&"function"!=typeof e.encoder)throw new TypeError("Encoder has to be a function.");var r=e.charset||defaults.charset;if(void 0!==e.charset&&"utf-8"!==e.charset&&"iso-8859-1"!==e.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var t=formats.default;if(void 0!==e.format){if(!has.call(formats.formatters,e.format))throw new TypeError("Unknown format option provided.");t=e.format}var o,a=formats.formatters[t],n=defaults.filter;if(("function"==typeof e.filter||isArray(e.filter))&&(n=e.filter),o=e.arrayFormat in arrayPrefixGenerators?e.arrayFormat:"indices"in e?e.indices?"indices":"repeat":defaults.arrayFormat,"commaRoundTrip"in e&&"boolean"!=typeof e.commaRoundTrip)throw new TypeError("`commaRoundTrip` must be a boolean, or absent");var i=void 0===e.allowDots?!0===e.encodeDotInKeys||defaults.allowDots:!!e.allowDots;return{addQueryPrefix:"boolean"==typeof e.addQueryPrefix?e.addQueryPrefix:defaults.addQueryPrefix,allowDots:i,allowEmptyArrays:"boolean"==typeof e.allowEmptyArrays?!!e.allowEmptyArrays:defaults.allowEmptyArrays,arrayFormat:o,charset:r,charsetSentinel:"boolean"==typeof e.charsetSentinel?e.charsetSentinel:defaults.charsetSentinel,commaRoundTrip:!!e.commaRoundTrip,delimiter:void 0===e.delimiter?defaults.delimiter:e.delimiter,encode:"boolean"==typeof e.encode?e.encode:defaults.encode,encodeDotInKeys:"boolean"==typeof e.encodeDotInKeys?e.encodeDotInKeys:defaults.encodeDotInKeys,encoder:"function"==typeof e.encoder?e.encoder:defaults.encoder,encodeValuesOnly:"boolean"==typeof e.encodeValuesOnly?e.encodeValuesOnly:defaults.encodeValuesOnly,filter:n,format:t,formatter:a,serializeDate:"function"==typeof e.serializeDate?e.serializeDate:defaults.serializeDate,skipNulls:"boolean"==typeof e.skipNulls?e.skipNulls:defaults.skipNulls,sort:"function"==typeof e.sort?e.sort:null,strictNullHandling:"boolean"==typeof e.strictNullHandling?e.strictNullHandling:defaults.strictNullHandling}};module.exports=function(e,r){var t,o=e,a=normalizeStringifyOptions(r);"function"==typeof a.filter?o=(0,a.filter)("",o):isArray(a.filter)&&(t=a.filter);var n=[];if("object"!=typeof o||null===o)return"";var i=arrayPrefixGenerators[a.arrayFormat],l="comma"===i&&a.commaRoundTrip;t||(t=Object.keys(o)),a.sort&&t.sort(a.sort);for(var s=getSideChannel(),f=0;f<t.length;++f){var u=t[f],d=o[u];a.skipNulls&&null===d||pushToArray(n,stringify(d,u,i,l,a.allowEmptyArrays,a.strictNullHandling,a.skipNulls,a.encodeDotInKeys,a.encode?a.encoder:null,a.filter,a.sort,a.allowDots,a.serializeDate,a.format,a.formatter,a.encodeValuesOnly,a.charset,s))}var y=n.join(a.delimiter),c=!0===a.addQueryPrefix?"?":"";return a.charsetSentinel&&("iso-8859-1"===a.charset?c+="utf8=%26%2310003%3B&":c+="utf8=%E2%9C%93&"),y.length>0?c+y:""};

},{"1":1,"29":29,"5":5}],5:[function(require,module,exports){
"use strict";var formats=require(1),has=Object.prototype.hasOwnProperty,isArray=Array.isArray,hexTable=function(){for(var e=[],r=0;r<256;++r)e.push("%"+((r<16?"0":"")+r.toString(16)).toUpperCase());return e}(),compactQueue=function compactQueue(e){for(;e.length>1;){var r=e.pop(),t=r.obj[r.prop];if(isArray(t)){for(var o=[],n=0;n<t.length;++n)void 0!==t[n]&&o.push(t[n]);r.obj[r.prop]=o}}},arrayToObject=function arrayToObject(e,r){for(var t=r&&r.plainObjects?{__proto__:null}:{},o=0;o<e.length;++o)void 0!==e[o]&&(t[o]=e[o]);return t},merge=function merge(e,r,t){if(!r)return e;if("object"!=typeof r&&"function"!=typeof r){if(isArray(e))e.push(r);else{if(!e||"object"!=typeof e)return[e,r];(t&&(t.plainObjects||t.allowPrototypes)||!has.call(Object.prototype,r))&&(e[r]=!0)}return e}if(!e||"object"!=typeof e)return[e].concat(r);var o=e;return isArray(e)&&!isArray(r)&&(o=arrayToObject(e,t)),isArray(e)&&isArray(r)?(r.forEach((function(r,o){if(has.call(e,o)){var n=e[o];n&&"object"==typeof n&&r&&"object"==typeof r?e[o]=merge(n,r,t):e.push(r)}else e[o]=r})),e):Object.keys(r).reduce((function(e,o){var n=r[o];return has.call(e,o)?e[o]=merge(e[o],n,t):e[o]=n,e}),o)},assign=function assignSingleSource(e,r){return Object.keys(r).reduce((function(e,t){return e[t]=r[t],e}),e)},decode=function(e,r,t){var o=e.replace(/\+/g," ");if("iso-8859-1"===t)return o.replace(/%[0-9a-f]{2}/gi,unescape);try{return decodeURIComponent(o)}catch(e){return o}},limit=1024,encode=function encode(e,r,t,o,n){if(0===e.length)return e;var a=e;if("symbol"==typeof e?a=Symbol.prototype.toString.call(e):"string"!=typeof e&&(a=String(e)),"iso-8859-1"===t)return escape(a).replace(/%u[0-9a-f]{4}/gi,(function(e){return"%26%23"+parseInt(e.slice(2),16)+"%3B"}));for(var c="",i=0;i<a.length;i+=limit){for(var u=a.length>=limit?a.slice(i,i+limit):a,p=[],f=0;f<u.length;++f){var s=u.charCodeAt(f);45===s||46===s||95===s||126===s||s>=48&&s<=57||s>=65&&s<=90||s>=97&&s<=122||n===formats.RFC1738&&(40===s||41===s)?p[p.length]=u.charAt(f):s<128?p[p.length]=hexTable[s]:s<2048?p[p.length]=hexTable[192|s>>6]+hexTable[128|63&s]:s<55296||s>=57344?p[p.length]=hexTable[224|s>>12]+hexTable[128|s>>6&63]+hexTable[128|63&s]:(f+=1,s=65536+((1023&s)<<10|1023&u.charCodeAt(f)),p[p.length]=hexTable[240|s>>18]+hexTable[128|s>>12&63]+hexTable[128|s>>6&63]+hexTable[128|63&s])}c+=p.join("")}return c},compact=function compact(e){for(var r=[{obj:{o:e},prop:"o"}],t=[],o=0;o<r.length;++o)for(var n=r[o],a=n.obj[n.prop],c=Object.keys(a),i=0;i<c.length;++i){var u=c[i],p=a[u];"object"==typeof p&&null!==p&&-1===t.indexOf(p)&&(r.push({obj:a,prop:u}),t.push(p))}return compactQueue(r),e},isRegExp=function isRegExp(e){return"[object RegExp]"===Object.prototype.toString.call(e)},isBuffer=function isBuffer(e){return!(!e||"object"!=typeof e||!(e.constructor&&e.constructor.isBuffer&&e.constructor.isBuffer(e)))},combine=function combine(e,r){return[].concat(e,r)},maybeMap=function maybeMap(e,r){if(isArray(e)){for(var t=[],o=0;o<e.length;o+=1)t.push(r(e[o]));return t}return r(e)};module.exports={/* common-shake removed: arrayToObject:arrayToObject *//* common-shake removed: assign:assign */combine:combine,compact:compact,decode:decode,encode:encode,isBuffer:isBuffer,isRegExp:isRegExp,maybeMap:maybeMap,merge:merge};

},{"1":1}],29:[function(require,module,exports){
"use strict";var GetIntrinsic=require(20),callBound=require(7),inspect=require(27),$TypeError=require(16),$WeakMap=GetIntrinsic("%WeakMap%",!0),$Map=GetIntrinsic("%Map%",!0),$weakMapGet=callBound("WeakMap.prototype.get",!0),$weakMapSet=callBound("WeakMap.prototype.set",!0),$weakMapHas=callBound("WeakMap.prototype.has",!0),$mapGet=callBound("Map.prototype.get",!0),$mapSet=callBound("Map.prototype.set",!0),$mapHas=callBound("Map.prototype.has",!0),listGetNode=function(e,t){for(var n,a=e;null!==(n=a.next);a=n)if(n.key===t)return a.next=n.next,n.next=e.next,e.next=n,n},listGet=function(e,t){var n=listGetNode(e,t);return n&&n.value},listSet=function(e,t,n){var a=listGetNode(e,t);a?a.value=n:e.next={key:t,next:e.next,value:n}},listHas=function(e,t){return!!listGetNode(e,t)};module.exports=function getSideChannel(){var e,t,n,a={assert:function(e){if(!a.has(e))throw new $TypeError("Side channel does not contain "+inspect(e))},get:function(a){if($WeakMap&&a&&("object"==typeof a||"function"==typeof a)){if(e)return $weakMapGet(e,a)}else if($Map){if(t)return $mapGet(t,a)}else if(n)return listGet(n,a)},has:function(a){if($WeakMap&&a&&("object"==typeof a||"function"==typeof a)){if(e)return $weakMapHas(e,a)}else if($Map){if(t)return $mapHas(t,a)}else if(n)return listHas(n,a);return!1},set:function(a,r){$WeakMap&&a&&("object"==typeof a||"function"==typeof a)?(e||(e=new $WeakMap),$weakMapSet(e,a,r)):$Map?(t||(t=new $Map),$mapSet(t,a,r)):(n||(n={key:{},next:null}),listSet(n,a,r))}};return a};

},{"16":16,"20":20,"27":27,"7":7}],6:[function(require,module,exports){

},{}],7:[function(require,module,exports){
"use strict";var GetIntrinsic=require(20),callBind=require(8),$indexOf=callBind(GetIntrinsic("String.prototype.indexOf"));module.exports=function callBoundIntrinsic(i,n){var t=GetIntrinsic(i,!!n);return"function"==typeof t&&$indexOf(i,".prototype.")>-1?callBind(t):t};

},{"20":20,"8":8}],20:[function(require,module,exports){
"use strict";var undefined,$Error=require(12),$EvalError=require(11),$RangeError=require(13),$ReferenceError=require(14),$SyntaxError=require(15),$TypeError=require(16),$URIError=require(17),$Function=Function,getEvalledConstructor=function(r){try{return $Function('"use strict"; return ('+r+").constructor;")()}catch(r){}},$gOPD=Object.getOwnPropertyDescriptor;if($gOPD)try{$gOPD({},"")}catch(r){$gOPD=null}var throwTypeError=function(){throw new $TypeError},ThrowTypeError=$gOPD?function(){try{return throwTypeError}catch(r){try{return $gOPD(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError,hasSymbols=require(24)(),hasProto=require(23)(),getProto=Object.getPrototypeOf||(hasProto?function(r){return r.__proto__}:null),needsEval={},TypedArray="undefined"!=typeof Uint8Array&&getProto?getProto(Uint8Array):undefined,INTRINSICS={__proto__:null,"%AggregateError%":"undefined"==typeof AggregateError?undefined:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?undefined:ArrayBuffer,"%ArrayIteratorPrototype%":hasSymbols&&getProto?getProto([][Symbol.iterator]()):undefined,"%AsyncFromSyncIteratorPrototype%":undefined,"%AsyncFunction%":needsEval,"%AsyncGenerator%":needsEval,"%AsyncGeneratorFunction%":needsEval,"%AsyncIteratorPrototype%":needsEval,"%Atomics%":"undefined"==typeof Atomics?undefined:Atomics,"%BigInt%":"undefined"==typeof BigInt?undefined:BigInt,"%BigInt64Array%":"undefined"==typeof BigInt64Array?undefined:BigInt64Array,"%BigUint64Array%":"undefined"==typeof BigUint64Array?undefined:BigUint64Array,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?undefined:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":$Error,"%eval%":eval,"%EvalError%":$EvalError,"%Float32Array%":"undefined"==typeof Float32Array?undefined:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?undefined:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?undefined:FinalizationRegistry,"%Function%":$Function,"%GeneratorFunction%":needsEval,"%Int8Array%":"undefined"==typeof Int8Array?undefined:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?undefined:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?undefined:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":hasSymbols&&getProto?getProto(getProto([][Symbol.iterator]())):undefined,"%JSON%":"object"==typeof JSON?JSON:undefined,"%Map%":"undefined"==typeof Map?undefined:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&hasSymbols&&getProto?getProto((new Map)[Symbol.iterator]()):undefined,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?undefined:Promise,"%Proxy%":"undefined"==typeof Proxy?undefined:Proxy,"%RangeError%":$RangeError,"%ReferenceError%":$ReferenceError,"%Reflect%":"undefined"==typeof Reflect?undefined:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?undefined:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&hasSymbols&&getProto?getProto((new Set)[Symbol.iterator]()):undefined,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?undefined:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":hasSymbols&&getProto?getProto(""[Symbol.iterator]()):undefined,"%Symbol%":hasSymbols?Symbol:undefined,"%SyntaxError%":$SyntaxError,"%ThrowTypeError%":ThrowTypeError,"%TypedArray%":TypedArray,"%TypeError%":$TypeError,"%Uint8Array%":"undefined"==typeof Uint8Array?undefined:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?undefined:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?undefined:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?undefined:Uint32Array,"%URIError%":$URIError,"%WeakMap%":"undefined"==typeof WeakMap?undefined:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?undefined:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?undefined:WeakSet};if(getProto)try{null.error}catch(r){var errorProto=getProto(getProto(r));INTRINSICS["%Error.prototype%"]=errorProto}var doEval=function doEval(r){var e;if("%AsyncFunction%"===r)e=getEvalledConstructor("async function () {}");else if("%GeneratorFunction%"===r)e=getEvalledConstructor("function* () {}");else if("%AsyncGeneratorFunction%"===r)e=getEvalledConstructor("async function* () {}");else if("%AsyncGenerator%"===r){var t=doEval("%AsyncGeneratorFunction%");t&&(e=t.prototype)}else if("%AsyncIteratorPrototype%"===r){var o=doEval("%AsyncGenerator%");o&&getProto&&(e=getProto(o.prototype))}return INTRINSICS[r]=e,e},LEGACY_ALIASES={__proto__:null,"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},bind=require(19),hasOwn=require(26),$concat=bind.call(Function.call,Array.prototype.concat),$spliceApply=bind.call(Function.apply,Array.prototype.splice),$replace=bind.call(Function.call,String.prototype.replace),$strSlice=bind.call(Function.call,String.prototype.slice),$exec=bind.call(Function.call,RegExp.prototype.exec),rePropName=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,reEscapeChar=/\\(\\)?/g,stringToPath=function stringToPath(r){var e=$strSlice(r,0,1),t=$strSlice(r,-1);if("%"===e&&"%"!==t)throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");if("%"===t&&"%"!==e)throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");var o=[];return $replace(r,rePropName,(function(r,e,t,n){o[o.length]=t?$replace(n,reEscapeChar,"$1"):e||r})),o},getBaseIntrinsic=function getBaseIntrinsic(r,e){var t,o=r;if(hasOwn(LEGACY_ALIASES,o)&&(o="%"+(t=LEGACY_ALIASES[o])[0]+"%"),hasOwn(INTRINSICS,o)){var n=INTRINSICS[o];if(n===needsEval&&(n=doEval(o)),void 0===n&&!e)throw new $TypeError("intrinsic "+r+" exists, but is not available. Please file an issue!");return{alias:t,name:o,value:n}}throw new $SyntaxError("intrinsic "+r+" does not exist!")};module.exports=function GetIntrinsic(r,e){if("string"!=typeof r||0===r.length)throw new $TypeError("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof e)throw new $TypeError('"allowMissing" argument must be a boolean');if(null===$exec(/^%?[^%]*%?$/,r))throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");var t=stringToPath(r),o=t.length>0?t[0]:"",n=getBaseIntrinsic("%"+o+"%",e),a=n.name,y=n.value,i=!1,p=n.alias;p&&(o=p[0],$spliceApply(t,$concat([0,1],p)));for(var d=1,s=!0;d<t.length;d+=1){var f=t[d],u=$strSlice(f,0,1),l=$strSlice(f,-1);if(('"'===u||"'"===u||"`"===u||'"'===l||"'"===l||"`"===l)&&u!==l)throw new $SyntaxError("property names with quotes must have matching quotes");if("constructor"!==f&&s||(i=!0),hasOwn(INTRINSICS,a="%"+(o+="."+f)+"%"))y=INTRINSICS[a];else if(null!=y){if(!(f in y)){if(!e)throw new $TypeError("base intrinsic for "+r+" exists, but the property is not available.");return}if($gOPD&&d+1>=t.length){var c=$gOPD(y,f);y=(s=!!c)&&"get"in c&&!("originalValue"in c.get)?c.get:y[f]}else s=hasOwn(y,f),y=y[f];s&&!i&&(INTRINSICS[a]=y)}}return y};

},{"11":11,"12":12,"13":13,"14":14,"15":15,"16":16,"17":17,"19":19,"23":23,"24":24,"26":26}],8:[function(require,module,exports){
"use strict";var bind=require(19),GetIntrinsic=require(20),setFunctionLength=require(28),$TypeError=require(16),$apply=GetIntrinsic("%Function.prototype.apply%"),$call=GetIntrinsic("%Function.prototype.call%"),$reflectApply=GetIntrinsic("%Reflect.apply%",!0)||bind.call($call,$apply),$defineProperty=require(10),$max=GetIntrinsic("%Math.max%");module.exports=function callBind(e){if("function"!=typeof e)throw new $TypeError("a function is required");var n=$reflectApply(bind,$call,arguments);return setFunctionLength(n,1+$max(0,e.length-(arguments.length-1)),!0)};var applyBind=function applyBind(){return $reflectApply(bind,$apply,arguments)};$defineProperty?$defineProperty(module.exports,"apply",{value:applyBind}):module.exports.apply=applyBind;

},{"10":10,"16":16,"19":19,"20":20,"28":28}],16:[function(require,module,exports){
"use strict";module.exports=TypeError;

},{}],19:[function(require,module,exports){
"use strict";var implementation=require(18);module.exports=Function.prototype.bind||implementation;

},{"18":18}],10:[function(require,module,exports){
"use strict";var GetIntrinsic=require(20),$defineProperty=GetIntrinsic("%Object.defineProperty%",!0)||!1;if($defineProperty)try{$defineProperty({},"a",{value:1})}catch(e){$defineProperty=!1}module.exports=$defineProperty;

},{"20":20}],28:[function(require,module,exports){
"use strict";var GetIntrinsic=require(20),define=require(9),hasDescriptors=require(22)(),gOPD=require(21),$TypeError=require(16),$floor=GetIntrinsic("%Math.floor%");module.exports=function setFunctionLength(e,r){if("function"!=typeof e)throw new $TypeError("`fn` is not a function");if("number"!=typeof r||r<0||r>4294967295||$floor(r)!==r)throw new $TypeError("`length` must be a positive 32-bit integer");var t=arguments.length>2&&!!arguments[2],i=!0,n=!0;if("length"in e&&gOPD){var o=gOPD(e,"length");o&&!o.configurable&&(i=!1),o&&!o.writable&&(n=!1)}return(i||n||!t)&&(hasDescriptors?define(e,"length",r,!0,!0):define(e,"length",r)),e};

},{"16":16,"20":20,"21":21,"22":22,"9":9}],9:[function(require,module,exports){
"use strict";var $defineProperty=require(10),$SyntaxError=require(15),$TypeError=require(16),gopd=require(21);module.exports=function defineDataProperty(e,r,o){if(!e||"object"!=typeof e&&"function"!=typeof e)throw new $TypeError("`obj` must be an object or a function`");if("string"!=typeof r&&"symbol"!=typeof r)throw new $TypeError("`property` must be a string or a symbol`");if(arguments.length>3&&"boolean"!=typeof arguments[3]&&null!==arguments[3])throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");if(arguments.length>4&&"boolean"!=typeof arguments[4]&&null!==arguments[4])throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");if(arguments.length>5&&"boolean"!=typeof arguments[5]&&null!==arguments[5])throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");if(arguments.length>6&&"boolean"!=typeof arguments[6])throw new $TypeError("`loose`, if provided, must be a boolean");var n=arguments.length>3?arguments[3]:null,l=arguments.length>4?arguments[4]:null,t=arguments.length>5?arguments[5]:null,i=arguments.length>6&&arguments[6],a=!!gopd&&gopd(e,r);if($defineProperty)$defineProperty(e,r,{configurable:null===t&&a?a.configurable:!t,enumerable:null===n&&a?a.enumerable:!n,value:o,writable:null===l&&a?a.writable:!l});else{if(!i&&(n||l||t))throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");e[r]=o}};

},{"10":10,"15":15,"16":16,"21":21}],15:[function(require,module,exports){
"use strict";module.exports=SyntaxError;

},{}],21:[function(require,module,exports){
"use strict";var GetIntrinsic=require(20),$gOPD=GetIntrinsic("%Object.getOwnPropertyDescriptor%",!0);if($gOPD)try{$gOPD([],"length")}catch(t){$gOPD=null}module.exports=$gOPD;

},{"20":20}],11:[function(require,module,exports){
"use strict";module.exports=EvalError;

},{}],12:[function(require,module,exports){
"use strict";module.exports=Error;

},{}],13:[function(require,module,exports){
"use strict";module.exports=RangeError;

},{}],14:[function(require,module,exports){
"use strict";module.exports=ReferenceError;

},{}],17:[function(require,module,exports){
"use strict";module.exports=URIError;

},{}],18:[function(require,module,exports){
"use strict";var ERROR_MESSAGE="Function.prototype.bind called on incompatible ",toStr=Object.prototype.toString,max=Math.max,funcType="[object Function]",concatty=function concatty(t,n){for(var r=[],o=0;o<t.length;o+=1)r[o]=t[o];for(var e=0;e<n.length;e+=1)r[e+t.length]=n[e];return r},slicy=function slicy(t,n){for(var r=[],o=n||0,e=0;o<t.length;o+=1,e+=1)r[e]=t[o];return r},joiny=function(t,n){for(var r="",o=0;o<t.length;o+=1)r+=t[o],o+1<t.length&&(r+=n);return r};module.exports=function bind(t){var n=this;if("function"!=typeof n||toStr.apply(n)!==funcType)throw new TypeError(ERROR_MESSAGE+n);for(var r,o=slicy(arguments,1),e=max(0,n.length-o.length),i=[],c=0;c<e;c++)i[c]="$"+c;if(r=Function("binder","return function ("+joiny(i,",")+"){ return binder.apply(this,arguments); }")((function(){if(this instanceof r){var e=n.apply(this,concatty(o,arguments));return Object(e)===e?e:this}return n.apply(t,concatty(o,arguments))})),n.prototype){var p=function Empty(){};p.prototype=n.prototype,r.prototype=new p,p.prototype=null}return r};

},{}],23:[function(require,module,exports){
"use strict";var test={__proto__:null,foo:{}},$Object=Object;module.exports=function hasProto(){return{__proto__:test}.foo===test.foo&&!(test instanceof $Object)};

},{}],26:[function(require,module,exports){
"use strict";var call=Function.prototype.call,$hasOwn=Object.prototype.hasOwnProperty,bind=require(19);module.exports=bind.call(call,$hasOwn);

},{"19":19}],24:[function(require,module,exports){
"use strict";var origSymbol="undefined"!=typeof Symbol&&Symbol,hasSymbolSham=require(25);module.exports=function hasNativeSymbols(){return"function"==typeof origSymbol&&"function"==typeof Symbol&&"symbol"==typeof origSymbol("foo")&&"symbol"==typeof Symbol("bar")&&hasSymbolSham()};

},{"25":25}],22:[function(require,module,exports){
"use strict";var $defineProperty=require(10),hasPropertyDescriptors=function hasPropertyDescriptors(){return!!$defineProperty};hasPropertyDescriptors.hasArrayLengthDefineBug=function hasArrayLengthDefineBug(){if(!$defineProperty)return null;try{return 1!==$defineProperty([],"length",{value:1}).length}catch(r){return!0}},module.exports=hasPropertyDescriptors;

},{"10":10}],25:[function(require,module,exports){
"use strict";module.exports=function hasSymbols(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var t={},e=Symbol("test"),r=Object(e);if("string"==typeof e)return!1;if("[object Symbol]"!==Object.prototype.toString.call(e))return!1;if("[object Symbol]"!==Object.prototype.toString.call(r))return!1;for(e in t[e]=42,t)return!1;if("function"==typeof Object.keys&&0!==Object.keys(t).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(t).length)return!1;var o=Object.getOwnPropertySymbols(t);if(1!==o.length||o[0]!==e)return!1;if(!Object.prototype.propertyIsEnumerable.call(t,e))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var n=Object.getOwnPropertyDescriptor(t,e);if(42!==n.value||!0!==n.enumerable)return!1}return!0};

},{}],27:[function(require,module,exports){
(function (global){(function (){
var hasMap="function"==typeof Map&&Map.prototype,mapSizeDescriptor=Object.getOwnPropertyDescriptor&&hasMap?Object.getOwnPropertyDescriptor(Map.prototype,"size"):null,mapSize=hasMap&&mapSizeDescriptor&&"function"==typeof mapSizeDescriptor.get?mapSizeDescriptor.get:null,mapForEach=hasMap&&Map.prototype.forEach,hasSet="function"==typeof Set&&Set.prototype,setSizeDescriptor=Object.getOwnPropertyDescriptor&&hasSet?Object.getOwnPropertyDescriptor(Set.prototype,"size"):null,setSize=hasSet&&setSizeDescriptor&&"function"==typeof setSizeDescriptor.get?setSizeDescriptor.get:null,setForEach=hasSet&&Set.prototype.forEach,hasWeakMap="function"==typeof WeakMap&&WeakMap.prototype,weakMapHas=hasWeakMap?WeakMap.prototype.has:null,hasWeakSet="function"==typeof WeakSet&&WeakSet.prototype,weakSetHas=hasWeakSet?WeakSet.prototype.has:null,hasWeakRef="function"==typeof WeakRef&&WeakRef.prototype,weakRefDeref=hasWeakRef?WeakRef.prototype.deref:null,booleanValueOf=Boolean.prototype.valueOf,objectToString=Object.prototype.toString,functionToString=Function.prototype.toString,$match=String.prototype.match,$slice=String.prototype.slice,$replace=String.prototype.replace,$toUpperCase=String.prototype.toUpperCase,$toLowerCase=String.prototype.toLowerCase,$test=RegExp.prototype.test,$concat=Array.prototype.concat,$join=Array.prototype.join,$arrSlice=Array.prototype.slice,$floor=Math.floor,bigIntValueOf="function"==typeof BigInt?BigInt.prototype.valueOf:null,gOPS=Object.getOwnPropertySymbols,symToString="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?Symbol.prototype.toString:null,hasShammedSymbols="function"==typeof Symbol&&"object"==typeof Symbol.iterator,toStringTag="function"==typeof Symbol&&Symbol.toStringTag&&(Symbol.toStringTag,1)?Symbol.toStringTag:null,isEnumerable=Object.prototype.propertyIsEnumerable,gPO=("function"==typeof Reflect?Reflect.getPrototypeOf:Object.getPrototypeOf)||([].__proto__===Array.prototype?function(t){return t.__proto__}:null);function addNumericSeparator(t,e){if(t===1/0||t===-1/0||t!=t||t&&t>-1e3&&t<1e3||$test.call(/e/,e))return e;var r=/[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;if("number"==typeof t){var n=t<0?-$floor(-t):$floor(t);if(n!==t){var o=String(n),i=$slice.call(e,o.length+1);return $replace.call(o,r,"$&_")+"."+$replace.call($replace.call(i,/([0-9]{3})/g,"$&_"),/_$/,"")}}return $replace.call(e,r,"$&_")}var utilInspect=require(6),inspectCustom=utilInspect.custom,inspectSymbol=isSymbol(inspectCustom)?inspectCustom:null,quotes={__proto__:null,double:'"',single:"'"},quoteREs={__proto__:null,double:/(["\\])/g,single:/(['\\])/g};function wrapQuotes(t,e,r){var n=r.quoteStyle||e,o=quotes[n];return o+t+o}function quote(t){return $replace.call(String(t),/"/g,"&quot;")}function isArray(t){return!("[object Array]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isDate(t){return!("[object Date]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isRegExp(t){return!("[object RegExp]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isError(t){return!("[object Error]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isString(t){return!("[object String]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isNumber(t){return!("[object Number]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isBoolean(t){return!("[object Boolean]"!==toStr(t)||toStringTag&&"object"==typeof t&&toStringTag in t)}function isSymbol(t){if(hasShammedSymbols)return t&&"object"==typeof t&&t instanceof Symbol;if("symbol"==typeof t)return!0;if(!t||"object"!=typeof t||!symToString)return!1;try{return symToString.call(t),!0}catch(t){}return!1}function isBigInt(t){if(!t||"object"!=typeof t||!bigIntValueOf)return!1;try{return bigIntValueOf.call(t),!0}catch(t){}return!1}module.exports=function inspect_(t,e,r,n){var o=e||{};if(has(o,"quoteStyle")&&!has(quotes,o.quoteStyle))throw new TypeError('option "quoteStyle" must be "single" or "double"');if(has(o,"maxStringLength")&&("number"==typeof o.maxStringLength?o.maxStringLength<0&&o.maxStringLength!==1/0:null!==o.maxStringLength))throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');var i=!has(o,"customInspect")||o.customInspect;if("boolean"!=typeof i&&"symbol"!==i)throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");if(has(o,"indent")&&null!==o.indent&&"\t"!==o.indent&&!(parseInt(o.indent,10)===o.indent&&o.indent>0))throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');if(has(o,"numericSeparator")&&"boolean"!=typeof o.numericSeparator)throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');var a=o.numericSeparator;if(void 0===t)return"undefined";if(null===t)return"null";if("boolean"==typeof t)return t?"true":"false";if("string"==typeof t)return inspectString(t,o);if("number"==typeof t){if(0===t)return 1/0/t>0?"0":"-0";var c=String(t);return a?addNumericSeparator(t,c):c}if("bigint"==typeof t){var l=String(t)+"n";return a?addNumericSeparator(t,l):l}var p=void 0===o.depth?5:o.depth;if(void 0===r&&(r=0),r>=p&&p>0&&"object"==typeof t)return isArray(t)?"[Array]":"[Object]";var u=getIndent(o,r);if(void 0===n)n=[];else if(indexOf(n,t)>=0)return"[Circular]";function inspect(t,e,i){if(e&&(n=$arrSlice.call(n)).push(e),i){var a={depth:o.depth};return has(o,"quoteStyle")&&(a.quoteStyle=o.quoteStyle),inspect_(t,a,r+1,n)}return inspect_(t,o,r+1,n)}if("function"==typeof t&&!isRegExp(t)){var s=nameOf(t),f=arrObjKeys(t,inspect);return"[Function"+(s?": "+s:" (anonymous)")+"]"+(f.length>0?" { "+$join.call(f,", ")+" }":"")}if(isSymbol(t)){var y=hasShammedSymbols?$replace.call(String(t),/^(Symbol\(.*\))_[^)]*$/,"$1"):symToString.call(t);return"object"!=typeof t||hasShammedSymbols?y:markBoxed(y)}if(isElement(t)){for(var S="<"+$toLowerCase.call(String(t.nodeName)),g=t.attributes||[],b=0;b<g.length;b++)S+=" "+g[b].name+"="+wrapQuotes(quote(g[b].value),"double",o);return S+=">",t.childNodes&&t.childNodes.length&&(S+="..."),S+"</"+$toLowerCase.call(String(t.nodeName))+">"}if(isArray(t)){if(0===t.length)return"[]";var m=arrObjKeys(t,inspect);return u&&!singleLineValues(m)?"["+indentedJoin(m,u)+"]":"[ "+$join.call(m,", ")+" ]"}if(isError(t)){var h=arrObjKeys(t,inspect);return"cause"in Error.prototype||!("cause"in t)||isEnumerable.call(t,"cause")?0===h.length?"["+String(t)+"]":"{ ["+String(t)+"] "+$join.call(h,", ")+" }":"{ ["+String(t)+"] "+$join.call($concat.call("[cause]: "+inspect(t.cause),h),", ")+" }"}if("object"==typeof t&&i){if(inspectSymbol&&"function"==typeof t[inspectSymbol]&&utilInspect)return utilInspect(t,{depth:p-r});if("symbol"!==i&&"function"==typeof t.inspect)return t.inspect()}if(isMap(t)){var d=[];return mapForEach&&mapForEach.call(t,(function(e,r){d.push(inspect(r,t,!0)+" => "+inspect(e,t))})),collectionOf("Map",mapSize.call(t),d,u)}if(isSet(t)){var j=[];return setForEach&&setForEach.call(t,(function(e){j.push(inspect(e,t))})),collectionOf("Set",setSize.call(t),j,u)}if(isWeakMap(t))return weakCollectionOf("WeakMap");if(isWeakSet(t))return weakCollectionOf("WeakSet");if(isWeakRef(t))return weakCollectionOf("WeakRef");if(isNumber(t))return markBoxed(inspect(Number(t)));if(isBigInt(t))return markBoxed(inspect(bigIntValueOf.call(t)));if(isBoolean(t))return markBoxed(booleanValueOf.call(t));if(isString(t))return markBoxed(inspect(String(t)));if("undefined"!=typeof window&&t===window)return"{ [object Window] }";if("undefined"!=typeof globalThis&&t===globalThis||"undefined"!=typeof global&&t===global)return"{ [object globalThis] }";if(!isDate(t)&&!isRegExp(t)){var O=arrObjKeys(t,inspect),w=gPO?gPO(t)===Object.prototype:t instanceof Object||t.constructor===Object,$=t instanceof Object?"":"null prototype",k=!w&&toStringTag&&Object(t)===t&&toStringTag in t?$slice.call(toStr(t),8,-1):$?"Object":"",v=(w||"function"!=typeof t.constructor?"":t.constructor.name?t.constructor.name+" ":"")+(k||$?"["+$join.call($concat.call([],k||[],$||[]),": ")+"] ":"");return 0===O.length?v+"{}":u?v+"{"+indentedJoin(O,u)+"}":v+"{ "+$join.call(O,", ")+" }"}return String(t)};var hasOwn=Object.prototype.hasOwnProperty||function(t){return t in this};function has(t,e){return hasOwn.call(t,e)}function toStr(t){return objectToString.call(t)}function nameOf(t){if(t.name)return t.name;var e=$match.call(functionToString.call(t),/^function\s*([\w$]+)/);return e?e[1]:null}function indexOf(t,e){if(t.indexOf)return t.indexOf(e);for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}function isMap(t){if(!mapSize||!t||"object"!=typeof t)return!1;try{mapSize.call(t);try{setSize.call(t)}catch(t){return!0}return t instanceof Map}catch(t){}return!1}function isWeakMap(t){if(!weakMapHas||!t||"object"!=typeof t)return!1;try{weakMapHas.call(t,weakMapHas);try{weakSetHas.call(t,weakSetHas)}catch(t){return!0}return t instanceof WeakMap}catch(t){}return!1}function isWeakRef(t){if(!weakRefDeref||!t||"object"!=typeof t)return!1;try{return weakRefDeref.call(t),!0}catch(t){}return!1}function isSet(t){if(!setSize||!t||"object"!=typeof t)return!1;try{setSize.call(t);try{mapSize.call(t)}catch(t){return!0}return t instanceof Set}catch(t){}return!1}function isWeakSet(t){if(!weakSetHas||!t||"object"!=typeof t)return!1;try{weakSetHas.call(t,weakSetHas);try{weakMapHas.call(t,weakMapHas)}catch(t){return!0}return t instanceof WeakSet}catch(t){}return!1}function isElement(t){return!(!t||"object"!=typeof t)&&("undefined"!=typeof HTMLElement&&t instanceof HTMLElement||"string"==typeof t.nodeName&&"function"==typeof t.getAttribute)}function inspectString(t,e){if(t.length>e.maxStringLength){var r=t.length-e.maxStringLength,n="... "+r+" more character"+(r>1?"s":"");return inspectString($slice.call(t,0,e.maxStringLength),e)+n}var o=quoteREs[e.quoteStyle||"single"];return o.lastIndex=0,wrapQuotes($replace.call($replace.call(t,o,"\\$1"),/[\x00-\x1f]/g,lowbyte),"single",e)}function lowbyte(t){var e=t.charCodeAt(0),r={8:"b",9:"t",10:"n",12:"f",13:"r"}[e];return r?"\\"+r:"\\x"+(e<16?"0":"")+$toUpperCase.call(e.toString(16))}function markBoxed(t){return"Object("+t+")"}function weakCollectionOf(t){return t+" { ? }"}function collectionOf(t,e,r,n){return t+" ("+e+") {"+(n?indentedJoin(r,n):$join.call(r,", "))+"}"}function singleLineValues(t){for(var e=0;e<t.length;e++)if(indexOf(t[e],"\n")>=0)return!1;return!0}function getIndent(t,e){var r;if("\t"===t.indent)r="\t";else{if(!("number"==typeof t.indent&&t.indent>0))return null;r=$join.call(Array(t.indent+1)," ")}return{base:r,prev:$join.call(Array(e+1),r)}}function indentedJoin(t,e){if(0===t.length)return"";var r="\n"+e.prev+e.base;return r+$join.call(t,","+r)+"\n"+e.prev}function arrObjKeys(t,e){var r=isArray(t),n=[];if(r){n.length=t.length;for(var o=0;o<t.length;o++)n[o]=has(t,o)?e(t[o],t):""}var i,a="function"==typeof gOPS?gOPS(t):[];if(hasShammedSymbols){i={};for(var c=0;c<a.length;c++)i["$"+a[c]]=a[c]}for(var l in t)has(t,l)&&(r&&String(Number(l))===l&&l<t.length||hasShammedSymbols&&i["$"+l]instanceof Symbol||($test.call(/[^\w$]/,l)?n.push(e(l,t)+": "+e(t[l],t)):n.push(l+": "+e(t[l],t))));if("function"==typeof gOPS)for(var p=0;p<a.length;p++)isEnumerable.call(t,a[p])&&n.push("["+e(a[p])+"]: "+e(t[a[p]],t));return n}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"6":6}]},{},[2])(2)
});

/*
 AngularJS v1.5.2
 (c) 2010-2016 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(r,d,C){'use strict';function x(s,h,g){return{restrict:"ECA",terminal:!0,priority:400,transclude:"element",link:function(a,c,b,f,y){function k(){n&&(g.cancel(n),n=null);l&&(l.$destroy(),l=null);m&&(n=g.leave(m),n.then(function(){n=null}),m=null)}function z(){var b=s.current&&s.current.locals;if(d.isDefined(b&&b.$template)){var b=a.$new(),f=s.current;m=y(b,function(b){g.enter(b,null,m||c).then(function(){!d.isDefined(u)||u&&!a.$eval(u)||h()});k()});l=f.scope=b;l.$emit("$viewContentLoaded");
l.$eval(v)}else k()}var l,m,n,u=b.autoscroll,v=b.onload||"";a.$on("$routeChangeSuccess",z);z()}}}function A(d,h,g){return{restrict:"ECA",priority:-400,link:function(a,c){var b=g.current,f=b.locals;c.html(f.$template);var y=d(c.contents());if(b.controller){f.$scope=a;var k=h(b.controller,f);b.controllerAs&&(a[b.controllerAs]=k);c.data("$ngControllerController",k);c.children().data("$ngControllerController",k)}a[b.resolveAs||"$resolve"]=f;y(a)}}}r=d.module("ngRoute",["ng"]).provider("$route",function(){function s(a,
c){return d.extend(Object.create(a),c)}function h(a,d){var b=d.caseInsensitiveMatch,f={originalPath:a,regexp:a},g=f.keys=[];a=a.replace(/([().])/g,"\\$1").replace(/(\/)?:(\w+)(\*\?|[\?\*])?/g,function(a,d,b,c){a="?"===c||"*?"===c?"?":null;c="*"===c||"*?"===c?"*":null;g.push({name:b,optional:!!a});d=d||"";return""+(a?"":d)+"(?:"+(a?d:"")+(c&&"(.+?)"||"([^/]+)")+(a||"")+")"+(a||"")}).replace(/([\/$\*])/g,"\\$1");f.regexp=new RegExp("^"+a+"$",b?"i":"");return f}var g={};this.when=function(a,c){var b=
d.copy(c);d.isUndefined(b.reloadOnSearch)&&(b.reloadOnSearch=!0);d.isUndefined(b.caseInsensitiveMatch)&&(b.caseInsensitiveMatch=this.caseInsensitiveMatch);g[a]=d.extend(b,a&&h(a,b));if(a){var f="/"==a[a.length-1]?a.substr(0,a.length-1):a+"/";g[f]=d.extend({redirectTo:a},h(f,b))}return this};this.caseInsensitiveMatch=!1;this.otherwise=function(a){"string"===typeof a&&(a={redirectTo:a});this.when(null,a);return this};this.$get=["$rootScope","$location","$routeParams","$q","$injector","$templateRequest",
"$sce",function(a,c,b,f,h,k,r){function l(b){var e=t.current;(x=(p=n())&&e&&p.$$route===e.$$route&&d.equals(p.pathParams,e.pathParams)&&!p.reloadOnSearch&&!v)||!e&&!p||a.$broadcast("$routeChangeStart",p,e).defaultPrevented&&b&&b.preventDefault()}function m(){var w=t.current,e=p;if(x)w.params=e.params,d.copy(w.params,b),a.$broadcast("$routeUpdate",w);else if(e||w)v=!1,(t.current=e)&&e.redirectTo&&(d.isString(e.redirectTo)?c.path(u(e.redirectTo,e.params)).search(e.params).replace():c.url(e.redirectTo(e.pathParams,
c.path(),c.search())).replace()),f.when(e).then(function(){if(e){var a=d.extend({},e.resolve),b,c;d.forEach(a,function(b,e){a[e]=d.isString(b)?h.get(b):h.invoke(b,null,null,e)});d.isDefined(b=e.template)?d.isFunction(b)&&(b=b(e.params)):d.isDefined(c=e.templateUrl)&&(d.isFunction(c)&&(c=c(e.params)),d.isDefined(c)&&(e.loadedTemplateUrl=r.valueOf(c),b=k(c)));d.isDefined(b)&&(a.$template=b);return f.all(a)}}).then(function(c){e==t.current&&(e&&(e.locals=c,d.copy(e.params,b)),a.$broadcast("$routeChangeSuccess",
e,w))},function(b){e==t.current&&a.$broadcast("$routeChangeError",e,w,b)})}function n(){var a,b;d.forEach(g,function(f,g){var q;if(q=!b){var h=c.path();q=f.keys;var l={};if(f.regexp)if(h=f.regexp.exec(h)){for(var k=1,n=h.length;k<n;++k){var m=q[k-1],p=h[k];m&&p&&(l[m.name]=p)}q=l}else q=null;else q=null;q=a=q}q&&(b=s(f,{params:d.extend({},c.search(),a),pathParams:a}),b.$$route=f)});return b||g[null]&&s(g[null],{params:{},pathParams:{}})}function u(a,b){var c=[];d.forEach((a||"").split(":"),function(a,
d){if(0===d)c.push(a);else{var f=a.match(/(\w+)(?:[?*])?(.*)/),g=f[1];c.push(b[g]);c.push(f[2]||"");delete b[g]}});return c.join("")}var v=!1,p,x,t={routes:g,reload:function(){v=!0;var b={defaultPrevented:!1,preventDefault:function(){this.defaultPrevented=!0;v=!1}};a.$evalAsync(function(){l(b);b.defaultPrevented||m()})},updateParams:function(a){if(this.current&&this.current.$$route)a=d.extend({},this.current.params,a),c.path(u(this.current.$$route.originalPath,a)),c.search(a);else throw B("norout");
}};a.$on("$locationChangeStart",l);a.$on("$locationChangeSuccess",m);return t}]}).run(["$route",d.noop]);var B=d.$$minErr("ngRoute");r.provider("$routeParams",function(){this.$get=function(){return{}}});r.directive("ngView",x);r.directive("ngView",A);x.$inject=["$route","$anchorScroll","$animate"];A.$inject=["$compile","$controller","$route"]})(window,window.angular);


/*
 AngularJS v1.4.10
 (c) 2010-2015 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(J,f,C){'use strict';function D(t,e){e=e||{};f.forEach(e,function(f,k){delete e[k]});for(var k in t)!t.hasOwnProperty(k)||"$"===k.charAt(0)&&"$"===k.charAt(1)||(e[k]=t[k]);return e}var y=f.$$minErr("$resource"),B=/^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;f.module("ngResource",["ng"]).provider("$resource",function(){var t=/^https?:\/\/[^\/]*/,e=this;this.defaults={stripTrailingSlashes:!0,actions:{get:{method:"GET"},save:{method:"POST"},query:{method:"GET",isArray:!0},remove:{method:"DELETE"},"delete":{method:"DELETE"}}};
this.$get=["$http","$log","$q",function(k,F,G){function w(f,g){this.template=f;this.defaults=r({},e.defaults,g);this.urlParams={}}function z(l,g,s,h){function c(a,q){var c={};q=r({},g,q);u(q,function(b,q){x(b)&&(b=b());var m;if(b&&b.charAt&&"@"==b.charAt(0)){m=a;var d=b.substr(1);if(null==d||""===d||"hasOwnProperty"===d||!B.test("."+d))throw y("badmember",d);for(var d=d.split("."),n=0,g=d.length;n<g&&f.isDefined(m);n++){var e=d[n];m=null!==m?m[e]:C}}else m=b;c[q]=m});return c}function H(a){return a.resource}
function d(a){D(a||{},this)}var t=new w(l,h);s=r({},e.defaults.actions,s);d.prototype.toJSON=function(){var a=r({},this);delete a.$promise;delete a.$resolved;return a};u(s,function(a,q){var g=/^(POST|PUT|PATCH)$/i.test(a.method);d[q]=function(b,A,m,e){var n={},h,l,s;switch(arguments.length){case 4:s=e,l=m;case 3:case 2:if(x(A)){if(x(b)){l=b;s=A;break}l=A;s=m}else{n=b;h=A;l=m;break}case 1:x(b)?l=b:g?h=b:n=b;break;case 0:break;default:throw y("badargs",arguments.length);}var w=this instanceof d,p=w?
h:a.isArray?[]:new d(h),v={},z=a.interceptor&&a.interceptor.response||H,B=a.interceptor&&a.interceptor.responseError||C;u(a,function(a,b){switch(b){default:v[b]=I(a);break;case "params":case "isArray":case "interceptor":break;case "timeout":a&&!f.isNumber(a)&&F.debug("ngResource:\n  Only numeric values are allowed as `timeout`.\n  Promises are not supported in $resource, because the same value would be used for multiple requests.\n  If you need support for cancellable $resource actions, you should upgrade to version 1.5 or higher.")}});
g&&(v.data=h);t.setUrlParams(v,r({},c(h,a.params||{}),n),a.url);n=k(v).then(function(b){var c=b.data,m=p.$promise;if(c){if(f.isArray(c)!==!!a.isArray)throw y("badcfg",q,a.isArray?"array":"object",f.isArray(c)?"array":"object",v.method,v.url);a.isArray?(p.length=0,u(c,function(b){"object"===typeof b?p.push(new d(b)):p.push(b)})):(D(c,p),p.$promise=m)}p.$resolved=!0;b.resource=p;return b},function(b){p.$resolved=!0;(s||E)(b);return G.reject(b)});n=n.then(function(b){var a=z(b);(l||E)(a,b.headers);return a},
B);return w?n:(p.$promise=n,p.$resolved=!1,p)};d.prototype["$"+q]=function(b,a,c){x(b)&&(c=a,a=b,b={});b=d[q].call(this,b,this,a,c);return b.$promise||b}});d.bind=function(a){return z(l,r({},g,a),s)};return d}var E=f.noop,u=f.forEach,r=f.extend,I=f.copy,x=f.isFunction;w.prototype={setUrlParams:function(l,g,e){var h=this,c=e||h.template,k,d,r="",a=h.urlParams={};u(c.split(/\W/),function(d){if("hasOwnProperty"===d)throw y("badname");!/^\d+$/.test(d)&&d&&(new RegExp("(^|[^\\\\]):"+d+"(\\W|$)")).test(c)&&
(a[d]=!0)});c=c.replace(/\\:/g,":");c=c.replace(t,function(a){r=a;return""});g=g||{};u(h.urlParams,function(a,e){k=g.hasOwnProperty(e)?g[e]:h.defaults[e];f.isDefined(k)&&null!==k?(d=encodeURIComponent(k).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"%20").replace(/%26/gi,"&").replace(/%3D/gi,"=").replace(/%2B/gi,"+"),c=c.replace(new RegExp(":"+e+"(\\W|$)","g"),function(b,a){return d+a})):c=c.replace(new RegExp("(/?):"+e+"(\\W|$)","g"),function(b,
a,c){return"/"==c.charAt(0)?c:a+c})});h.defaults.stripTrailingSlashes&&(c=c.replace(/\/+$/,"")||"/");c=c.replace(/\/\.(?=\w+($|\?))/,".");l.url=r+c.replace(/\/\\\./,"/.");u(g,function(a,c){h.urlParams[c]||(l.params=l.params||{},l.params[c]=a)})}};return z}]})})(window,window.angular);


/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.10
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
!function(e,n){"use strict";var r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],l=e.module("oc.lazyLoad",["ng"]);l.provider("$ocLazyLoad",["$controllerProvider","$provide","$compileProvider","$filterProvider","$injector","$animateProvider",function(l,f,p,m,v,y){function L(n,o,t){if(o){var i,s,l,f=[];for(i=o.length-1;i>=0;i--)if(s=o[i],e.isString(s)||(s=E(s)),s&&-1===d.indexOf(s)&&(!w[s]||-1!==a.indexOf(s))){var h=-1===r.indexOf(s);if(l=g(s),h&&(r.push(s),L(n,l.requires,t)),l._runBlocks.length>0)for(c[s]=[];l._runBlocks.length>0;)c[s].push(l._runBlocks.shift());e.isDefined(c[s])&&(h||t.rerun)&&(f=f.concat(c[s])),j(n,l._invokeQueue,s,t.reconfig),j(n,l._configBlocks,s,t.reconfig),u(h?"ocLazyLoad.moduleLoaded":"ocLazyLoad.moduleReloaded",s),o.pop(),d.push(s)}var p=n.getInstanceInjector();e.forEach(f,function(e){p.invoke(e)})}}function $(n,r){function t(n,r){var o,t=!0;return r.length&&(o=i(n),e.forEach(r,function(e){t=t&&i(e)!==o})),t}function i(n){return e.isArray(n)?M(n.toString()):e.isObject(n)?M(S(n)):e.isDefined(n)&&null!==n?M(n.toString()):n}var a=n[2][0],s=n[1],c=!1;e.isUndefined(o[r])&&(o[r]={}),e.isUndefined(o[r][s])&&(o[r][s]={});var d=function(e,n){o[r][s].hasOwnProperty(e)||(o[r][s][e]=[]),t(n,o[r][s][e])&&(c=!0,o[r][s][e].push(n),u("ocLazyLoad.componentLoaded",[r,s,e]))};if(e.isString(a))d(a,n[2][1]);else{if(!e.isObject(a))return!1;e.forEach(a,function(n,r){e.isString(n)?d(n,a[1]):d(r,n)})}return c}function j(n,r,o,i){if(r){var a,s,u,c;for(a=0,s=r.length;s>a;a++)if(u=r[a],e.isArray(u)){if(null!==n){if(!n.hasOwnProperty(u[0]))throw new Error("unsupported provider "+u[0]);c=n[u[0]]}var d=$(u,o);if("invoke"!==u[1])d&&e.isDefined(c)&&c[u[1]].apply(c,u[2]);else{var l=function(n){var r=t.indexOf(o+"-"+n);(-1===r||i)&&(-1===r&&t.push(o+"-"+n),e.isDefined(c)&&c[u[1]].apply(c,u[2]))};if(e.isFunction(u[2][0]))l(u[2][0]);else if(e.isArray(u[2][0]))for(var f=0,h=u[2][0].length;h>f;f++)e.isFunction(u[2][0][f])&&l(u[2][0][f])}}}}function E(n){var r=null;return e.isString(n)?r=n:e.isObject(n)&&n.hasOwnProperty("name")&&e.isString(n.name)&&(r=n.name),r}function _(n){if(!e.isString(n))return!1;try{return g(n)}catch(r){if(/No module/.test(r)||r.message.indexOf("$injector:nomod")>-1)return!1}}var w={},O={$controllerProvider:l,$compileProvider:p,$filterProvider:m,$provide:f,$injector:v,$animateProvider:y},x=!1,b=!1,z=[],D={};z.push=function(e){-1===this.indexOf(e)&&Array.prototype.push.apply(this,arguments)},this.config=function(n){e.isDefined(n.modules)&&(e.isArray(n.modules)?e.forEach(n.modules,function(e){w[e.name]=e}):w[n.modules.name]=n.modules),e.isDefined(n.debug)&&(x=n.debug),e.isDefined(n.events)&&(b=n.events)},this._init=function(o){if(0===i.length){var t=[o],a=["ng:app","ng-app","x-ng-app","data-ng-app"],u=/\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,c=function(e){return e&&t.push(e)};e.forEach(a,function(n){a[n]=!0,c(document.getElementById(n)),n=n.replace(":","\\:"),"undefined"!=typeof o[0]&&o[0].querySelectorAll&&(e.forEach(o[0].querySelectorAll("."+n),c),e.forEach(o[0].querySelectorAll("."+n+"\\:"),c),e.forEach(o[0].querySelectorAll("["+n+"]"),c))}),e.forEach(t,function(n){if(0===i.length){var r=" "+o.className+" ",t=u.exec(r);t?i.push((t[2]||"").replace(/\s+/g,",")):e.forEach(n.attributes,function(e){0===i.length&&a[e.name]&&i.push(e.value)})}})}0!==i.length||(n.jasmine||n.mocha)&&e.isDefined(e.mock)||console.error("No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.");var d=function l(n){if(-1===r.indexOf(n)){r.push(n);var o=e.module(n);j(null,o._invokeQueue,n),j(null,o._configBlocks,n),e.forEach(o.requires,l)}};e.forEach(i,function(e){d(e)}),i=[],s.pop()};var S=function(n){try{return JSON.stringify(n)}catch(r){var o=[];return JSON.stringify(n,function(n,r){if(e.isObject(r)&&null!==r){if(-1!==o.indexOf(r))return;o.push(r)}return r})}},M=function(e){var n,r,o,t=0;if(0==e.length)return t;for(n=0,o=e.length;o>n;n++)r=e.charCodeAt(n),t=(t<<5)-t+r,t|=0;return t};this.$get=["$log","$rootElement","$rootScope","$cacheFactory","$q",function(n,t,a,c,l){function f(e){var r=l.defer();return n.error(e.message),r.reject(e),r.promise}var p,m=c("ocLazyLoad");return x||(n={},n.error=e.noop,n.warn=e.noop,n.info=e.noop),O.getInstanceInjector=function(){return p?p:p=t.data("$injector")||e.injector()},u=function(e,r){b&&a.$broadcast(e,r),x&&n.info(e,r)},{_broadcast:u,_$log:n,_getFilesCache:function(){return m},toggleWatch:function(e){e?s.push(!0):s.pop()},getModuleConfig:function(n){if(!e.isString(n))throw new Error("You need to give the name of the module to get");return w[n]?e.copy(w[n]):null},setModuleConfig:function(n){if(!e.isObject(n))throw new Error("You need to give the module config object to set");return w[n.name]=n,n},getModules:function(){return r},isLoaded:function(n){var o=function(e){var n=r.indexOf(e)>-1;return n||(n=!!_(e)),n};if(e.isString(n)&&(n=[n]),e.isArray(n)){var t,i;for(t=0,i=n.length;i>t;t++)if(!o(n[t]))return!1;return!0}throw new Error("You need to define the module(s) name(s)")},_getModuleName:E,_getModule:function(e){try{return g(e)}catch(n){throw(/No module/.test(n)||n.message.indexOf("$injector:nomod")>-1)&&(n.message='The module "'+S(e)+'" that you are trying to load does not exist. '+n.message),n}},moduleExists:_,_loadDependencies:function(n,r){var o,t,i,a=[],s=this;if(n=s._getModuleName(n),null===n)return l.when();try{o=s._getModule(n)}catch(u){return f(u)}return t=s.getRequires(o),e.forEach(t,function(o){if(e.isString(o)){var t=s.getModuleConfig(o);if(null===t)return void z.push(o);o=t,t.name=void 0}if(s.moduleExists(o.name))return i=o.files.filter(function(e){return s.getModuleConfig(o.name).files.indexOf(e)<0}),0!==i.length&&s._$log.warn('Module "',n,'" attempted to redefine configuration for dependency. "',o.name,'"\n Additional Files Loaded:',i),e.isDefined(s.filesLoader)?void a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)})):f(new Error("Error: New dependencies need to be loaded from external files ("+o.files+"), but no loader has been defined."));if(e.isArray(o)){var u=[];e.forEach(o,function(e){var n=s.getModuleConfig(e);null===n?u.push(e):n.files&&(u=u.concat(n.files))}),u.length>0&&(o={files:u})}else e.isObject(o)&&o.hasOwnProperty("name")&&o.name&&(s.setModuleConfig(o),z.push(o.name));if(e.isDefined(o.files)&&0!==o.files.length){if(!e.isDefined(s.filesLoader))return f(new Error('Error: the module "'+o.name+'" is defined in external files ('+o.files+"), but no loader has been defined."));a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)}))}}),l.all(a)},inject:function(n){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],o=arguments.length<=2||void 0===arguments[2]?!1:arguments[2],t=this,a=l.defer();if(e.isDefined(n)&&null!==n){if(e.isArray(n)){var s=[];return e.forEach(n,function(e){s.push(t.inject(e,r,o))}),l.all(s)}t._addToLoadList(t._getModuleName(n),!0,o)}if(i.length>0){var u=i.slice(),c=function f(e){z.push(e),D[e]=a.promise,t._loadDependencies(e,r).then(function(){try{d=[],L(O,z,r)}catch(e){return t._$log.error(e.message),void a.reject(e)}i.length>0?f(i.shift()):a.resolve(u)},function(e){a.reject(e)})};c(i.shift())}else{if(r&&r.name&&D[r.name])return D[r.name];a.resolve()}return a.promise},getRequires:function(n){var o=[];return e.forEach(n.requires,function(e){-1===r.indexOf(e)&&o.push(e)}),o},_invokeQueue:j,_registerInvokeList:$,_register:L,_addToLoadList:h,_unregister:function(n){e.isDefined(n)&&e.isArray(n)&&e.forEach(n,function(e){o[e]=void 0})}}}],this._init(e.element(n.document))}]);var f=e.bootstrap;e.bootstrap=function(n,l,g){return r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],e.forEach(l.slice(),function(e){h(e,!0,!0)}),f(n,l,g)};var h=function(n,r,o){(s.length>0||r)&&e.isString(n)&&-1===i.indexOf(n)&&(i.push(n),o&&a.push(n))},g=e.module;e.module=function(e,n,r){return h(e,!1,!0),g(e,n,r)},"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="oc.lazyLoad")}(angular,window),function(e){"use strict";e.module("oc.lazyLoad").directive("ocLazyLoad",["$ocLazyLoad","$compile","$animate","$parse","$timeout",function(n,r,o,t,i){return{restrict:"A",terminal:!0,priority:1e3,compile:function(i,a){var s=i[0].innerHTML;return i.html(""),function(i,a,u){var c=t(u.ocLazyLoad);i.$watch(function(){return c(i)||u.ocLazyLoad},function(t){e.isDefined(t)&&n.load(t).then(function(){o.enter(s,a),r(a.contents())(i)})},!0)}}}}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q","$window","$interval",function(n,r,o,t){var i=!1,a=!1,s=o.document.getElementsByTagName("head")[0]||o.document.getElementsByTagName("body")[0];return n.buildElement=function(u,c,d){var l,f,h=r.defer(),g=n._getFilesCache(),p=function(e){var n=(new Date).getTime();return e.indexOf("?")>=0?"&"===e.substring(0,e.length-1)?e+"_dc="+n:e+"&_dc="+n:e+"?_dc="+n};switch(e.isUndefined(g.get(c))&&g.put(c,h.promise),u){case"css":l=o.document.createElement("link"),l.type="text/css",l.rel="stylesheet",l.href=d.cache===!1?p(c):c;break;case"js":l=o.document.createElement("script"),l.src=d.cache===!1?p(c):c;break;default:g.remove(c),h.reject(new Error('Requested type "'+u+'" is not known. Could not inject "'+c+'"'))}l.onload=l.onreadystatechange=function(e){l.readyState&&!/^c|loade/.test(l.readyState)||f||(l.onload=l.onreadystatechange=null,f=1,n._broadcast("ocLazyLoad.fileLoaded",c),h.resolve(l))},l.onerror=function(){g.remove(c),h.reject(new Error("Unable to load "+c))},l.async=d.serie?0:1;var m=s.lastChild;if(d.insertBefore){var v=e.element(e.isDefined(window.jQuery)?d.insertBefore:document.querySelector(d.insertBefore));v&&v.length>0&&(m=v[0])}if(m.parentNode.insertBefore(l,m),"css"==u){if(!i){var y=o.navigator.userAgent.toLowerCase();if(y.indexOf("phantomjs/1.9")>-1)a=!0;else if(/iP(hone|od|ad)/.test(o.navigator.platform)){var L=o.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),$=parseFloat([parseInt(L[1],10),parseInt(L[2],10),parseInt(L[3]||0,10)].join("."));a=6>$}else if(y.indexOf("android")>-1){var j=parseFloat(y.slice(y.indexOf("android")+8));a=4.4>j}else if(y.indexOf("safari")>-1){var E=y.match(/version\/([\.\d]+)/i);a=E&&E[1]&&parseFloat(E[1])<6}}if(a)var _=1e3,w=t(function(){try{l.sheet.cssRules,t.cancel(w),l.onload()}catch(e){--_<=0&&l.onerror()}},20)}return h.promise},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.filesLoader=function(o){var t=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],i=[],a=[],s=[],u=[],c=null,d=n._getFilesCache();n.toggleWatch(!0),e.extend(t,o);var l=function(r){var o,l=null;if(e.isObject(r)&&(l=r.type,r=r.path),c=d.get(r),e.isUndefined(c)||t.cache===!1){if(null!==(o=/^(css|less|html|htm|js)?(?=!)/.exec(r))&&(l=o[1],r=r.substr(o[1].length+1,r.length)),!l)if(null!==(o=/[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(r)))l=o[1];else{if(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||!n.jsLoader.hasOwnProperty("requirejs"))return void n._$log.error("File type could not be determined. "+r);l="js"}"css"!==l&&"less"!==l||-1!==i.indexOf(r)?"html"!==l&&"htm"!==l||-1!==a.indexOf(r)?"js"===l||-1===s.indexOf(r)?s.push(r):n._$log.error("File type is not valid. "+r):a.push(r):i.push(r)}else c&&u.push(c)};if(t.serie?l(t.files.shift()):e.forEach(t.files,function(e){l(e)}),i.length>0){var f=r.defer();n.cssLoader(i,function(r){e.isDefined(r)&&n.cssLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),f.reject(r)):f.resolve()},t),u.push(f.promise)}if(a.length>0){var h=r.defer();n.templatesLoader(a,function(r){e.isDefined(r)&&n.templatesLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),h.reject(r)):h.resolve()},t),u.push(h.promise)}if(s.length>0){var g=r.defer();n.jsLoader(s,function(r){e.isDefined(r)&&(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||n.jsLoader.hasOwnProperty("requirejs"))?(n._$log.error(r),g.reject(r)):g.resolve()},t),u.push(g.promise)}if(0===u.length){var p=r.defer(),m="Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";return n._$log.error(m),p.reject(m),p.promise}return t.serie&&t.files.length>0?r.all(u).then(function(){return n.filesLoader(o,t)}):r.all(u)["finally"](function(e){return n.toggleWatch(!1),e})},n.load=function(o){var t,i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],a=this,s=null,u=[],c=r.defer(),d=e.copy(o),l=e.copy(i);if(e.isArray(d))return e.forEach(d,function(e){u.push(a.load(e,l))}),r.all(u).then(function(e){c.resolve(e)},function(e){c.reject(e)}),c.promise;if(e.isString(d)?(s=a.getModuleConfig(d),s||(s={files:[d]})):e.isObject(d)&&(s=e.isDefined(d.path)&&e.isDefined(d.type)?{files:[d]}:a.setModuleConfig(d)),null===s){var f=a._getModuleName(d);return t='Module "'+(f||"unknown")+'" is not configured, cannot load.',n._$log.error(t),c.reject(new Error(t)),c.promise}e.isDefined(s.template)&&(e.isUndefined(s.files)&&(s.files=[]),e.isString(s.template)?s.files.push(s.template):e.isArray(s.template)&&s.files.concat(s.template));var h=e.extend({},l,s);return e.isUndefined(s.files)&&e.isDefined(s.name)&&n.moduleExists(s.name)?n.inject(s.name,h,!0):(n.filesLoader(s,h).then(function(){n.inject(null,h).then(function(e){c.resolve(e)},function(e){c.reject(e)})},function(e){c.reject(e)}),c.promise)},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.cssLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("css",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.cssLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.jsLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("js",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.jsLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$templateCache","$q","$http",function(n,r,o,t){return n.templatesLoader=function(i,a,s){var u=[],c=n._getFilesCache();return e.forEach(i,function(n){var i=o.defer();u.push(i.promise),t.get(n,s).then(function(o){var t=o.data;e.isString(t)&&t.length>0&&e.forEach(e.element(t),function(e){"SCRIPT"===e.nodeName&&"text/ng-template"===e.type&&r.put(e.id,e.innerHTML)}),e.isUndefined(c.get(n))&&c.put(n,!0),i.resolve()})["catch"](function(e){i.reject(new Error('Unable to load template file "'+n+'": '+e.data))})}),o.all(u).then(function(){a()},function(e){a(e)})},n.templatesLoader.ocLazyLoadLoader=!0,n}])}])}(angular),Array.prototype.indexOf||(Array.prototype.indexOf=function(e,n){var r;if(null==this)throw new TypeError('"this" is null or not defined');var o=Object(this),t=o.length>>>0;if(0===t)return-1;var i=+n||0;if(Math.abs(i)===1/0&&(i=0),i>=t)return-1;for(r=Math.max(i>=0?i:t-Math.abs(i),0);t>r;){if(r in o&&o[r]===e)return r;r++}return-1});
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.dropdown","ui.bootstrap.multiMap","ui.bootstrap.position","ui.bootstrap.modal","ui.bootstrap.stackedMap","ui.bootstrap.popover","ui.bootstrap.tooltip","ui.bootstrap.tabs","ui.bootstrap.typeahead","ui.bootstrap.debounce"]),angular.module("ui.bootstrap.tpls",["uib/template/modal/window.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.dropdown",["ui.bootstrap.multiMap","ui.bootstrap.position"]).constant("uibDropdownConfig",{appendToOpenClass:"uib-dropdown-open",openClass:"open"}).service("uibDropdownService",["$document","$rootScope","$$multiMap",function(e,t,o){var n=null,i=o.createNew();this.isOnlyOpen=function(e,t){var o=i.get(t);if(o){var n=o.reduce(function(t,o){return o.scope===e?o:t},{});if(n)return 1===o.length}return!1},this.open=function(t,o,r){if(n||e.on("click",a),n&&n!==t&&(n.isOpen=!1),n=t,r){var l=i.get(r);if(l){var p=l.map(function(e){return e.scope});-1===p.indexOf(t)&&i.put(r,{scope:t})}else i.put(r,{scope:t})}},this.close=function(t,o,r){if(n===t&&(e.off("click",a),e.off("keydown",this.keybindFilter),n=null),r){var l=i.get(r);if(l){var p=l.reduce(function(e,o){return o.scope===t?o:e},{});p&&i.remove(r,p)}}};var a=function(e){if(n&&n.isOpen&&!(e&&"disabled"===n.getAutoClose()||e&&3===e.which)){var o=n.getToggleElement();if(!(e&&o&&o[0].contains(e.target))){var i=n.getDropdownElement();e&&"outsideClick"===n.getAutoClose()&&i&&i[0].contains(e.target)||(n.focusToggleElement(),n.isOpen=!1,t.$$phase||n.$apply())}}};this.keybindFilter=function(e){if(n){var t=n.getDropdownElement(),o=n.getToggleElement(),i=t&&t[0].contains(e.target),r=o&&o[0].contains(e.target);27===e.which?(e.stopPropagation(),n.focusToggleElement(),a()):n.isKeynavEnabled()&&-1!==[38,40].indexOf(e.which)&&n.isOpen&&(i||r)&&(e.preventDefault(),e.stopPropagation(),n.focusDropdownEntry(e.which))}}}]).controller("UibDropdownController",["$scope","$element","$attrs","$parse","uibDropdownConfig","uibDropdownService","$animate","$uibPosition","$document","$compile","$templateRequest",function(e,t,o,n,i,a,r,l,p,u,s){function c(){t.append(m.dropdownMenu)}var d,f,m=this,h=e.$new(),b=i.appendToOpenClass,v=i.openClass,g=angular.noop,$=o.onToggle?n(o.onToggle):angular.noop,w=!1,y=p.find("body");t.addClass("dropdown"),this.init=function(){o.isOpen&&(f=n(o.isOpen),g=f.assign,e.$watch(f,function(e){h.isOpen=!!e})),w=angular.isDefined(o.keyboardNav)},this.toggle=function(e){return h.isOpen=arguments.length?!!e:!h.isOpen,angular.isFunction(g)&&g(h,h.isOpen),h.isOpen},this.isOpen=function(){return h.isOpen},h.getToggleElement=function(){return m.toggleElement},h.getAutoClose=function(){return o.autoClose||"always"},h.getElement=function(){return t},h.isKeynavEnabled=function(){return w},h.focusDropdownEntry=function(e){var o=m.dropdownMenu?angular.element(m.dropdownMenu).find("a"):t.find("ul").eq(0).find("a");switch(e){case 40:m.selectedOption=angular.isNumber(m.selectedOption)?m.selectedOption===o.length-1?m.selectedOption:m.selectedOption+1:0;break;case 38:m.selectedOption=angular.isNumber(m.selectedOption)?0===m.selectedOption?0:m.selectedOption-1:o.length-1}o[m.selectedOption].focus()},h.getDropdownElement=function(){return m.dropdownMenu},h.focusToggleElement=function(){m.toggleElement&&m.toggleElement[0].focus()},h.$watch("isOpen",function(i,f){var w=null,C=!1;if(angular.isDefined(o.dropdownAppendTo)){var T=n(o.dropdownAppendTo)(h);T&&(w=angular.element(T))}if(angular.isDefined(o.dropdownAppendToBody)){var k=n(o.dropdownAppendToBody)(h);k!==!1&&(C=!0)}if(C&&!w&&(w=y),w&&m.dropdownMenu&&(i?(w.append(m.dropdownMenu),t.on("$destroy",c)):(t.off("$destroy",c),c())),w&&m.dropdownMenu){var x,O,E,M=l.positionElements(t,m.dropdownMenu,"bottom-left",!0),D=0;if(x={top:M.top+"px",display:i?"block":"none"},O=m.dropdownMenu.hasClass("dropdown-menu-right"),O?(x.left="auto",E=l.scrollbarPadding(w),E.heightOverflow&&E.scrollbarWidth&&(D=E.scrollbarWidth),x.right=window.innerWidth-D-(M.left+t.prop("offsetWidth"))+"px"):(x.left=M.left+"px",x.right="auto"),!C){var S=l.offset(w);x.top=M.top-S.top+"px",O?x.right=window.innerWidth-(M.left-S.left+t.prop("offsetWidth"))+"px":x.left=M.left-S.left+"px"}m.dropdownMenu.css(x)}var I=w?w:t,A=w?b:v,P=I.hasClass(A),U=a.isOnlyOpen(e,w);if(P===!i){var N;N=w?U?"removeClass":"addClass":i?"addClass":"removeClass",r[N](I,A).then(function(){angular.isDefined(i)&&i!==f&&$(e,{open:!!i})})}if(i)m.dropdownMenuTemplateUrl?s(m.dropdownMenuTemplateUrl).then(function(e){d=h.$new(),u(e.trim())(d,function(e){var t=e;m.dropdownMenu.replaceWith(t),m.dropdownMenu=t,p.on("keydown",a.keybindFilter)})}):p.on("keydown",a.keybindFilter),h.focusToggleElement(),a.open(h,t,w);else{if(a.close(h,t,w),m.dropdownMenuTemplateUrl){d&&d.$destroy();var F=angular.element('<ul class="dropdown-menu"></ul>');m.dropdownMenu.replaceWith(F),m.dropdownMenu=F}m.selectedOption=null}angular.isFunction(g)&&g(e,i)})}]).directive("uibDropdown",function(){return{controller:"UibDropdownController",link:function(e,t,o,n){n.init()}}}).directive("uibDropdownMenu",function(){return{restrict:"A",require:"?^uibDropdown",link:function(e,t,o,n){if(n&&!angular.isDefined(o.dropdownNested)){t.addClass("dropdown-menu");var i=o.templateUrl;i&&(n.dropdownMenuTemplateUrl=i),n.dropdownMenu||(n.dropdownMenu=t)}}}}).directive("uibDropdownToggle",function(){return{require:"?^uibDropdown",link:function(e,t,o,n){if(n){t.addClass("dropdown-toggle"),n.toggleElement=t;var i=function(i){i.preventDefault(),t.hasClass("disabled")||o.disabled||e.$apply(function(){n.toggle()})};t.on("click",i),t.attr({"aria-haspopup":!0,"aria-expanded":!1}),e.$watch(n.isOpen,function(e){t.attr("aria-expanded",!!e)}),e.$on("$destroy",function(){t.off("click",i)})}}}}),angular.module("ui.bootstrap.multiMap",[]).factory("$$multiMap",function(){return{createNew:function(){var e={};return{entries:function(){return Object.keys(e).map(function(t){return{key:t,value:e[t]}})},get:function(t){return e[t]},hasKey:function(t){return!!e[t]},keys:function(){return Object.keys(e)},put:function(t,o){e[t]||(e[t]=[]),e[t].push(o)},remove:function(t,o){var n=e[t];if(n){var i=n.indexOf(o);-1!==i&&n.splice(i,1),n.length||delete e[t]}}}}}}),angular.module("ui.bootstrap.position",[]).factory("$uibPosition",["$document","$window",function(e,t){var o,n,i={normal:/(auto|scroll)/,hidden:/(auto|scroll|hidden)/},a={auto:/\s?auto?\s?/i,primary:/^(top|bottom|left|right)$/,secondary:/^(top|bottom|left|right|center)$/,vertical:/^(top|bottom)$/},r=/(HTML|BODY)/;return{getRawNode:function(e){return e.nodeName?e:e[0]||e},parseStyle:function(e){return e=parseFloat(e),isFinite(e)?e:0},offsetParent:function(o){function n(e){return"static"===(t.getComputedStyle(e).position||"static")}o=this.getRawNode(o);for(var i=o.offsetParent||e[0].documentElement;i&&i!==e[0].documentElement&&n(i);)i=i.offsetParent;return i||e[0].documentElement},scrollbarWidth:function(i){if(i){if(angular.isUndefined(n)){var a=e.find("body");a.addClass("uib-position-body-scrollbar-measure"),n=t.innerWidth-a[0].clientWidth,n=isFinite(n)?n:0,a.removeClass("uib-position-body-scrollbar-measure")}return n}if(angular.isUndefined(o)){var r=angular.element('<div class="uib-position-scrollbar-measure"></div>');e.find("body").append(r),o=r[0].offsetWidth-r[0].clientWidth,o=isFinite(o)?o:0,r.remove()}return o},scrollbarPadding:function(e){e=this.getRawNode(e);var o=t.getComputedStyle(e),n=this.parseStyle(o.paddingRight),i=this.parseStyle(o.paddingBottom),a=this.scrollParent(e,!1,!0),l=this.scrollbarWidth(r.test(a.tagName));return{scrollbarWidth:l,widthOverflow:a.scrollWidth>a.clientWidth,right:n+l,originalRight:n,heightOverflow:a.scrollHeight>a.clientHeight,bottom:i+l,originalBottom:i}},isScrollable:function(e,o){e=this.getRawNode(e);var n=o?i.hidden:i.normal,a=t.getComputedStyle(e);return n.test(a.overflow+a.overflowY+a.overflowX)},scrollParent:function(o,n,a){o=this.getRawNode(o);var r=n?i.hidden:i.normal,l=e[0].documentElement,p=t.getComputedStyle(o);if(a&&r.test(p.overflow+p.overflowY+p.overflowX))return o;var u="absolute"===p.position,s=o.parentElement||l;if(s===l||"fixed"===p.position)return l;for(;s.parentElement&&s!==l;){var c=t.getComputedStyle(s);if(u&&"static"!==c.position&&(u=!1),!u&&r.test(c.overflow+c.overflowY+c.overflowX))break;s=s.parentElement}return s},position:function(o,n){o=this.getRawNode(o);var i=this.offset(o);if(n){var a=t.getComputedStyle(o);i.top-=this.parseStyle(a.marginTop),i.left-=this.parseStyle(a.marginLeft)}var r=this.offsetParent(o),l={top:0,left:0};return r!==e[0].documentElement&&(l=this.offset(r),l.top+=r.clientTop-r.scrollTop,l.left+=r.clientLeft-r.scrollLeft),{width:Math.round(angular.isNumber(i.width)?i.width:o.offsetWidth),height:Math.round(angular.isNumber(i.height)?i.height:o.offsetHeight),top:Math.round(i.top-l.top),left:Math.round(i.left-l.left)}},offset:function(o){o=this.getRawNode(o);var n=o.getBoundingClientRect();return{width:Math.round(angular.isNumber(n.width)?n.width:o.offsetWidth),height:Math.round(angular.isNumber(n.height)?n.height:o.offsetHeight),top:Math.round(n.top+(t.pageYOffset||e[0].documentElement.scrollTop)),left:Math.round(n.left+(t.pageXOffset||e[0].documentElement.scrollLeft))}},viewportOffset:function(o,n,i){o=this.getRawNode(o),i=i!==!1?!0:!1;var a=o.getBoundingClientRect(),r={top:0,left:0,bottom:0,right:0},l=n?e[0].documentElement:this.scrollParent(o),p=l.getBoundingClientRect();if(r.top=p.top+l.clientTop,r.left=p.left+l.clientLeft,l===e[0].documentElement&&(r.top+=t.pageYOffset,r.left+=t.pageXOffset),r.bottom=r.top+l.clientHeight,r.right=r.left+l.clientWidth,i){var u=t.getComputedStyle(l);r.top+=this.parseStyle(u.paddingTop),r.bottom-=this.parseStyle(u.paddingBottom),r.left+=this.parseStyle(u.paddingLeft),r.right-=this.parseStyle(u.paddingRight)}return{top:Math.round(a.top-r.top),bottom:Math.round(r.bottom-a.bottom),left:Math.round(a.left-r.left),right:Math.round(r.right-a.right)}},parsePlacement:function(e){var t=a.auto.test(e);return t&&(e=e.replace(a.auto,"")),e=e.split("-"),e[0]=e[0]||"top",a.primary.test(e[0])||(e[0]="top"),e[1]=e[1]||"center",a.secondary.test(e[1])||(e[1]="center"),e[2]=t?!0:!1,e},positionElements:function(e,o,n,i){e=this.getRawNode(e),o=this.getRawNode(o);var r=angular.isDefined(o.offsetWidth)?o.offsetWidth:o.prop("offsetWidth"),l=angular.isDefined(o.offsetHeight)?o.offsetHeight:o.prop("offsetHeight");n=this.parsePlacement(n);var p=i?this.offset(e):this.position(e),u={top:0,left:0,placement:""};if(n[2]){var s=this.viewportOffset(e,i),c=t.getComputedStyle(o),d={width:r+Math.round(Math.abs(this.parseStyle(c.marginLeft)+this.parseStyle(c.marginRight))),height:l+Math.round(Math.abs(this.parseStyle(c.marginTop)+this.parseStyle(c.marginBottom)))};if(n[0]="top"===n[0]&&d.height>s.top&&d.height<=s.bottom?"bottom":"bottom"===n[0]&&d.height>s.bottom&&d.height<=s.top?"top":"left"===n[0]&&d.width>s.left&&d.width<=s.right?"right":"right"===n[0]&&d.width>s.right&&d.width<=s.left?"left":n[0],n[1]="top"===n[1]&&d.height-p.height>s.bottom&&d.height-p.height<=s.top?"bottom":"bottom"===n[1]&&d.height-p.height>s.top&&d.height-p.height<=s.bottom?"top":"left"===n[1]&&d.width-p.width>s.right&&d.width-p.width<=s.left?"right":"right"===n[1]&&d.width-p.width>s.left&&d.width-p.width<=s.right?"left":n[1],"center"===n[1])if(a.vertical.test(n[0])){var f=p.width/2-r/2;s.left+f<0&&d.width-p.width<=s.right?n[1]="left":s.right+f<0&&d.width-p.width<=s.left&&(n[1]="right")}else{var m=p.height/2-d.height/2;s.top+m<0&&d.height-p.height<=s.bottom?n[1]="top":s.bottom+m<0&&d.height-p.height<=s.top&&(n[1]="bottom")}}switch(n[0]){case"top":u.top=p.top-l;break;case"bottom":u.top=p.top+p.height;break;case"left":u.left=p.left-r;break;case"right":u.left=p.left+p.width}switch(n[1]){case"top":u.top=p.top;break;case"bottom":u.top=p.top+p.height-l;break;case"left":u.left=p.left;break;case"right":u.left=p.left+p.width-r;break;case"center":a.vertical.test(n[0])?u.left=p.left+p.width/2-r/2:u.top=p.top+p.height/2-l/2}return u.top=Math.round(u.top),u.left=Math.round(u.left),u.placement="center"===n[1]?n[0]:n[0]+"-"+n[1],u},adjustTop:function(e,t,o,n){return-1!==e.indexOf("top")&&o!==n?{top:t.top-n+"px"}:void 0},positionArrow:function(e,o){e=this.getRawNode(e);var n=e.querySelector(".tooltip-inner, .popover-inner");if(n){var i=angular.element(n).hasClass("tooltip-inner"),r=e.querySelector(i?".tooltip-arrow":".arrow");if(r){var l={top:"",bottom:"",left:"",right:""};if(o=this.parsePlacement(o),"center"===o[1])return void angular.element(r).css(l);var p="border-"+o[0]+"-width",u=t.getComputedStyle(r)[p],s="border-";s+=a.vertical.test(o[0])?o[0]+"-"+o[1]:o[1]+"-"+o[0],s+="-radius";var c=t.getComputedStyle(i?n:e)[s];switch(o[0]){case"top":l.bottom=i?"0":"-"+u;break;case"bottom":l.top=i?"0":"-"+u;break;case"left":l.right=i?"0":"-"+u;break;case"right":l.left=i?"0":"-"+u}l[o[1]]=c,angular.element(r).css(l)}}}}}]),angular.module("ui.bootstrap.modal",["ui.bootstrap.multiMap","ui.bootstrap.stackedMap","ui.bootstrap.position"]).provider("$uibResolve",function(){var e=this;this.resolver=null,this.setResolver=function(e){this.resolver=e},this.$get=["$injector","$q",function(t,o){var n=e.resolver?t.get(e.resolver):null;return{resolve:function(e,i,a,r){if(n)return n.resolve(e,i,a,r);var l=[];return angular.forEach(e,function(e){l.push(angular.isFunction(e)||angular.isArray(e)?o.resolve(t.invoke(e)):angular.isString(e)?o.resolve(t.get(e)):o.resolve(e))}),o.all(l).then(function(t){var o={},n=0;return angular.forEach(e,function(e,i){o[i]=t[n++]}),o})}}}]}).directive("uibModalBackdrop",["$animate","$injector","$uibModalStack",function(e,t,o){function n(t,n,i){i.modalInClass&&(e.addClass(n,i.modalInClass),t.$on(o.NOW_CLOSING_EVENT,function(o,a){var r=a();t.modalOptions.animation?e.removeClass(n,i.modalInClass).then(r):r()}))}return{restrict:"A",compile:function(e,t){return e.addClass(t.backdropClass),n}}}]).directive("uibModalWindow",["$uibModalStack","$q","$animateCss","$document",function(e,t,o,n){return{scope:{index:"@"},restrict:"A",transclude:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/modal/window.html"},link:function(i,a,r){a.addClass(r.windowTopClass||""),i.size=r.size,i.close=function(t){var o=e.getTop();o&&o.value.backdrop&&"static"!==o.value.backdrop&&t.target===t.currentTarget&&(t.preventDefault(),t.stopPropagation(),e.dismiss(o.key,"backdrop click"))},a.on("click",i.close),i.$isRendered=!0;var l=t.defer();i.$$postDigest(function(){l.resolve()}),l.promise.then(function(){var l=null;r.modalInClass&&(l=o(a,{addClass:r.modalInClass}).start(),i.$on(e.NOW_CLOSING_EVENT,function(e,t){var n=t();o(a,{removeClass:r.modalInClass}).start().then(n)})),t.when(l).then(function(){var t=e.getTop();if(t&&e.modalRendered(t.key),!n[0].activeElement||!a[0].contains(n[0].activeElement)){var o=a[0].querySelector("[autofocus]");o?o.focus():a[0].focus()}})})}}}]).directive("uibModalAnimationClass",function(){return{compile:function(e,t){t.modalAnimation&&e.addClass(t.uibModalAnimationClass)}}}).directive("uibModalTransclude",["$animate",function(e){return{link:function(t,o,n,i,a){a(t.$parent,function(t){o.empty(),e.enter(t,o)})}}}]).factory("$uibModalStack",["$animate","$animateCss","$document","$compile","$rootScope","$q","$$multiMap","$$stackedMap","$uibPosition",function(e,t,o,n,i,a,r,l,p){function u(e){var t="-";return e.replace(S,function(e,o){return(o?t:"")+e.toLowerCase()})}function s(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)}function c(){for(var e=-1,t=T.keys(),o=0;o<t.length;o++)T.get(t[o]).value.backdrop&&(e=o);return e>-1&&O>e&&(e=O),e}function d(e,t){var o=T.get(e).value,n=o.appendTo;T.remove(e),E=T.top(),E&&(O=parseInt(E.value.modalDomEl.attr("index"),10)),h(o.modalDomEl,o.modalScope,function(){var t=o.openedClass||C;k.remove(t,e);var i=k.hasKey(t);n.toggleClass(t,i),!i&&y&&y.heightOverflow&&y.scrollbarWidth&&(n.css(y.originalRight?{paddingRight:y.originalRight+"px"}:{paddingRight:""}),y=null),f(!0)},o.closedDeferred),m(),t&&t.focus?t.focus():n.focus&&n.focus()}function f(e){var t;T.length()>0&&(t=T.top().value,t.modalDomEl.toggleClass(t.windowTopClass||"",e))}function m(){if($&&-1===c()){var e=w;h($,w,function(){e=null}),$=void 0,w=void 0}}function h(t,o,n,i){function r(){r.done||(r.done=!0,e.leave(t).then(function(){n&&n(),t.remove(),i&&i.resolve()}),o.$destroy())}var l,p=null,u=function(){return l||(l=a.defer(),p=l.promise),function(){l.resolve()}};return o.$broadcast(x.NOW_CLOSING_EVENT,u),a.when(p).then(r)}function b(e){if(e.isDefaultPrevented())return e;var t=T.top();if(t)switch(e.which){case 27:t.value.keyboard&&(e.preventDefault(),i.$apply(function(){x.dismiss(t.key,"escape key press")}));break;case 9:var o=x.loadFocusElementList(t),n=!1;e.shiftKey?(x.isFocusInFirstItem(e,o)||x.isModalFocused(e,t))&&(n=x.focusLastFocusableElement(o)):x.isFocusInLastItem(e,o)&&(n=x.focusFirstFocusableElement(o)),n&&(e.preventDefault(),e.stopPropagation())}}function v(e,t,o){return!e.value.modalScope.$broadcast("modal.closing",t,o).defaultPrevented}function g(){Array.prototype.forEach.call(document.querySelectorAll("["+M+"]"),function(e){var t=parseInt(e.getAttribute(M),10),o=t-1;e.setAttribute(M,o),o||(e.removeAttribute(M),e.removeAttribute("aria-hidden"))})}var $,w,y,C="modal-open",T=l.createNew(),k=r.createNew(),x={NOW_CLOSING_EVENT:"modal.stack.now-closing"},O=0,E=null,M="data-bootstrap-modal-aria-hidden-count",D="a[href], area[href], input:not([disabled]):not([tabindex='-1']), button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']), textarea:not([disabled]):not([tabindex='-1']), iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]",S=/[A-Z]/g;return i.$watch(c,function(e){w&&(w.index=e)}),o.on("keydown",b),i.$on("$destroy",function(){o.off("keydown",b)}),x.open=function(t,a){function r(e){function t(e){var t=e.parent()?e.parent().children():[];return Array.prototype.filter.call(t,function(t){return t!==e[0]})}if(e&&"BODY"!==e[0].tagName)return t(e).forEach(function(e){var t="true"===e.getAttribute("aria-hidden"),o=parseInt(e.getAttribute(M),10);o||(o=t?1:0),e.setAttribute(M,o+1),e.setAttribute("aria-hidden","true")}),r(e.parent())}var l=o[0].activeElement,s=a.openedClass||C;f(!1),E=T.top(),T.add(t,{deferred:a.deferred,renderDeferred:a.renderDeferred,closedDeferred:a.closedDeferred,modalScope:a.scope,backdrop:a.backdrop,keyboard:a.keyboard,openedClass:a.openedClass,windowTopClass:a.windowTopClass,animation:a.animation,appendTo:a.appendTo}),k.put(s,t);var d=a.appendTo,m=c();m>=0&&!$&&(w=i.$new(!0),w.modalOptions=a,w.index=m,$=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'),$.attr({"class":"modal-backdrop","ng-style":"{'z-index': 1040 + (index && 1 || 0) + index*10}","uib-modal-animation-class":"fade","modal-in-class":"in"}),a.backdropClass&&$.addClass(a.backdropClass),a.animation&&$.attr("modal-animation","true"),n($)(w),e.enter($,d),p.isScrollable(d)&&(y=p.scrollbarPadding(d),y.heightOverflow&&y.scrollbarWidth&&d.css({paddingRight:y.right+"px"})));var h;a.component?(h=document.createElement(u(a.component.name)),h=angular.element(h),h.attr({resolve:"$resolve","modal-instance":"$uibModalInstance",close:"$close($value)",dismiss:"$dismiss($value)"})):h=a.content,O=E?parseInt(E.value.modalDomEl.attr("index"),10)+1:0;var b=angular.element('<div uib-modal-window="modal-window"></div>');b.attr({"class":"modal","template-url":a.windowTemplateUrl,"window-top-class":a.windowTopClass,role:"dialog","aria-labelledby":a.ariaLabelledBy,"aria-describedby":a.ariaDescribedBy,size:a.size,index:O,animate:"animate","ng-style":"{'z-index': 1050 + $$topModalIndex*10, display: 'block'}",tabindex:-1,"uib-modal-animation-class":"fade","modal-in-class":"in"}).append(h),a.windowClass&&b.addClass(a.windowClass),a.animation&&b.attr("modal-animation","true"),d.addClass(s),a.scope&&(a.scope.$$topModalIndex=O),e.enter(n(b)(a.scope),d),T.top().value.modalDomEl=b,T.top().value.modalOpener=l,r(b)},x.close=function(e,t){var o=T.get(e);return g(),o&&v(o,t,!0)?(o.value.modalScope.$$uibDestructionScheduled=!0,o.value.deferred.resolve(t),d(e,o.value.modalOpener),!0):!o},x.dismiss=function(e,t){var o=T.get(e);return g(),o&&v(o,t,!1)?(o.value.modalScope.$$uibDestructionScheduled=!0,o.value.deferred.reject(t),d(e,o.value.modalOpener),!0):!o},x.dismissAll=function(e){for(var t=this.getTop();t&&this.dismiss(t.key,e);)t=this.getTop()},x.getTop=function(){return T.top()},x.modalRendered=function(e){var t=T.get(e);t&&t.value.renderDeferred.resolve()},x.focusFirstFocusableElement=function(e){return e.length>0?(e[0].focus(),!0):!1},x.focusLastFocusableElement=function(e){return e.length>0?(e[e.length-1].focus(),!0):!1},x.isModalFocused=function(e,t){if(e&&t){var o=t.value.modalDomEl;if(o&&o.length)return(e.target||e.srcElement)===o[0]}return!1},x.isFocusInFirstItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[0]:!1},x.isFocusInLastItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[t.length-1]:!1},x.loadFocusElementList=function(e){if(e){var t=e.value.modalDomEl;if(t&&t.length){var o=t[0].querySelectorAll(D);return o?Array.prototype.filter.call(o,function(e){return s(e)}):o}}},x}]).provider("$uibModal",function(){var e={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$rootScope","$q","$document","$templateRequest","$controller","$uibResolve","$uibModalStack",function(t,o,n,i,a,r,l){function p(e){return e.template?o.when(e.template):i(angular.isFunction(e.templateUrl)?e.templateUrl():e.templateUrl)}var u={},s=null;return u.getPromiseChain=function(){return s},u.open=function(i){function u(){return b}var c=o.defer(),d=o.defer(),f=o.defer(),m=o.defer(),h={result:c.promise,opened:d.promise,closed:f.promise,rendered:m.promise,close:function(e){return l.close(h,e)},dismiss:function(e){return l.dismiss(h,e)}};if(i=angular.extend({},e.options,i),i.resolve=i.resolve||{},i.appendTo=i.appendTo||n.find("body").eq(0),!i.appendTo.length)throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");if(!i.component&&!i.template&&!i.templateUrl)throw new Error("One of component or template or templateUrl options is required.");var b;b=i.component?o.when(r.resolve(i.resolve,{},null,null)):o.all([p(i),r.resolve(i.resolve,{},null,null)]);var v;return v=s=o.all([s]).then(u,u).then(function(e){function o(t,o,n,i){t.$scope=r,t.$scope.$resolve={},n?t.$scope.$uibModalInstance=h:t.$uibModalInstance=h;var a=o?e[1]:e;angular.forEach(a,function(e,o){i&&(t[o]=e),t.$scope.$resolve[o]=e})}var n=i.scope||t,r=n.$new();r.$close=h.close,r.$dismiss=h.dismiss,r.$on("$destroy",function(){r.$$uibDestructionScheduled||r.$dismiss("$uibUnscheduledDestruction")});var p,u,s={scope:r,deferred:c,renderDeferred:m,closedDeferred:f,animation:i.animation,backdrop:i.backdrop,keyboard:i.keyboard,backdropClass:i.backdropClass,windowTopClass:i.windowTopClass,windowClass:i.windowClass,windowTemplateUrl:i.windowTemplateUrl,ariaLabelledBy:i.ariaLabelledBy,ariaDescribedBy:i.ariaDescribedBy,size:i.size,openedClass:i.openedClass,appendTo:i.appendTo},b={},v={};i.component?(o(b,!1,!0,!1),b.name=i.component,s.component=b):i.controller&&(o(v,!0,!1,!0),u=a(i.controller,v,!0,i.controllerAs),i.controllerAs&&i.bindToController&&(p=u.instance,p.$close=r.$close,p.$dismiss=r.$dismiss,angular.extend(p,{$resolve:v.$scope.$resolve},n)),p=u(),angular.isFunction(p.$onInit)&&p.$onInit()),i.component||(s.content=e[0]),l.open(h,s),d.resolve(!0)},function(e){d.reject(e),c.reject(e)})["finally"](function(){s===v&&(s=null)}),h},u}]};return e}),angular.module("ui.bootstrap.stackedMap",[]).factory("$$stackedMap",function(){return{createNew:function(){var e=[];return{add:function(t,o){e.push({key:t,value:o})},get:function(t){for(var o=0;o<e.length;o++)if(t===e[o].key)return e[o]},keys:function(){for(var t=[],o=0;o<e.length;o++)t.push(e[o].key);return t},top:function(){return e[e.length-1]},remove:function(t){for(var o=-1,n=0;n<e.length;n++)if(t===e[n].key){o=n;break}return e.splice(o,1)[0]},removeTop:function(){return e.pop()},length:function(){return e.length}}}}}),angular.module("ui.bootstrap.popover",["ui.bootstrap.tooltip"]).directive("uibPopoverTemplatePopup",function(){return{restrict:"A",scope:{uibTitle:"@",contentExp:"&",originScope:"&"},templateUrl:"uib/template/popover/popover-template.html"}}).directive("uibPopoverTemplate",["$uibTooltip",function(e){return e("uibPopoverTemplate","popover","click",{useContentExp:!0})}]).directive("uibPopoverHtmlPopup",function(){return{restrict:"A",scope:{contentExp:"&",uibTitle:"@"},templateUrl:"uib/template/popover/popover-html.html"}}).directive("uibPopoverHtml",["$uibTooltip",function(e){return e("uibPopoverHtml","popover","click",{useContentExp:!0})}]).directive("uibPopoverPopup",function(){return{restrict:"A",scope:{uibTitle:"@",content:"@"},templateUrl:"uib/template/popover/popover.html"}}).directive("uibPopover",["$uibTooltip",function(e){return e("uibPopover","popover","click")}]),angular.module("ui.bootstrap.tooltip",["ui.bootstrap.position","ui.bootstrap.stackedMap"]).provider("$uibTooltip",function(){function e(e){var t=/[A-Z]/g,o="-";return e.replace(t,function(e,t){return(t?o:"")+e.toLowerCase()})}var t={placement:"top",placementClassPrefix:"",animation:!0,popupDelay:0,popupCloseDelay:0,useContentExp:!1},o={mouseenter:"mouseleave",click:"click",outsideClick:"outsideClick",focus:"blur",none:""},n={};this.options=function(e){angular.extend(n,e)},this.setTriggers=function(e){angular.extend(o,e)},this.$get=["$window","$compile","$timeout","$document","$uibPosition","$interpolate","$rootScope","$parse","$$stackedMap",function(i,a,r,l,p,u,s,c,d){function f(e){if(27===e.which){var t=m.top();t&&(t.value.close(),t=null)}}var m=d.createNew();return l.on("keyup",f),s.$on("$destroy",function(){l.off("keyup",f)}),function(i,s,d,f){function h(e){var t=(e||f.trigger||d).split(" "),n=t.map(function(e){return o[e]||e});return{show:t,hide:n}}f=angular.extend({},t,n,f);var b=e(i),v=u.startSymbol(),g=u.endSymbol(),$="<div "+b+'-popup uib-title="'+v+"title"+g+'" '+(f.useContentExp?'content-exp="contentExp()" ':'content="'+v+"content"+g+'" ')+'origin-scope="origScope" class="uib-position-measure '+s+'" tooltip-animation-class="fade"uib-tooltip-classes ng-class="{ in: isOpen }" ></div>';return{compile:function(){var e=a($);return function(t,o,n){function a(){L.isOpen?d():u()}function u(){(!W||t.$eval(n[s+"Enable"]))&&($(),C(),L.popupDelay?A||(A=r(b,L.popupDelay,!1)):b())}function d(){v(),L.popupCloseDelay?P||(P=r(g,L.popupCloseDelay,!1)):g()}function b(){return v(),$(),L.content?(w(),void L.$evalAsync(function(){L.isOpen=!0,T(!0),_()})):angular.noop}function v(){A&&(r.cancel(A),A=null),U&&(r.cancel(U),U=null)}function g(){L&&L.$evalAsync(function(){L&&(L.isOpen=!1,T(!1),L.animation?I||(I=r(y,150,!1)):y())})}function $(){P&&(r.cancel(P),P=null),I&&(r.cancel(I),I=null)}function w(){D||(S=L.$new(),D=e(S,function(e){R?l.find("body").append(e):o.after(e)}),m.add(L,{close:g}),k())}function y(){v(),$(),x(),D&&(D.remove(),D=null,N&&r.cancel(N)),m.remove(L),S&&(S.$destroy(),S=null)}function C(){L.title=n[s+"Title"],L.content=j?j(t):n[i],L.popupClass=n[s+"Class"],L.placement=angular.isDefined(n[s+"Placement"])?n[s+"Placement"]:f.placement;var e=p.parsePlacement(L.placement);F=e[1]?e[0]+"-"+e[1]:e[0];var o=parseInt(n[s+"PopupDelay"],10),a=parseInt(n[s+"PopupCloseDelay"],10);L.popupDelay=isNaN(o)?f.popupDelay:o,L.popupCloseDelay=isNaN(a)?f.popupCloseDelay:a}function T(e){B&&angular.isFunction(B.assign)&&B.assign(t,e)}function k(){V.length=0,j?(V.push(t.$watch(j,function(e){L.content=e,!e&&L.isOpen&&g()})),V.push(S.$watch(function(){H||(H=!0,S.$$postDigest(function(){H=!1,L&&L.isOpen&&_()}))}))):V.push(n.$observe(i,function(e){L.content=e,!e&&L.isOpen?g():_()})),V.push(n.$observe(s+"Title",function(e){L.title=e,L.isOpen&&_()})),V.push(n.$observe(s+"Placement",function(e){L.placement=e?e:f.placement,L.isOpen&&_()}))}function x(){V.length&&(angular.forEach(V,function(e){e()}),V.length=0)}function O(e){L&&L.isOpen&&D&&(o[0].contains(e.target)||D[0].contains(e.target)||d())}function E(e){27===e.which&&d()}function M(){var e=[],i=[],r=t.$eval(n[s+"Trigger"]);z(),angular.isObject(r)?(Object.keys(r).forEach(function(t){e.push(t),i.push(r[t])}),q={show:e,hide:i}):q=h(r),"none"!==q.show&&q.show.forEach(function(e,t){"outsideClick"===e?(o.on("click",a),l.on("click",O)):e===q.hide[t]?o.on(e,a):e&&(o.on(e,u),o.on(q.hide[t],d)),o.on("keypress",E)})}var D,S,I,A,P,U,N,F,R=angular.isDefined(f.appendToBody)?f.appendToBody:!1,q=h(void 0),W=angular.isDefined(n[s+"Enable"]),L=t.$new(!0),H=!1,B=angular.isDefined(n[s+"IsOpen"])?c(n[s+"IsOpen"]):!1,j=f.useContentExp?c(n[i]):!1,V=[],_=function(){D&&D.html()&&(U||(U=r(function(){var e=p.positionElements(o,D,L.placement,R),t=angular.isDefined(D.offsetHeight)?D.offsetHeight:D.prop("offsetHeight"),n=R?p.offset(o):p.position(o);D.css({top:e.top+"px",left:e.left+"px"});var i=e.placement.split("-");D.hasClass(i[0])||(D.removeClass(F.split("-")[0]),D.addClass(i[0])),D.hasClass(f.placementClassPrefix+e.placement)||(D.removeClass(f.placementClassPrefix+F),D.addClass(f.placementClassPrefix+e.placement)),N=r(function(){var e=angular.isDefined(D.offsetHeight)?D.offsetHeight:D.prop("offsetHeight"),o=p.adjustTop(i,n,t,e);o&&D.css(o),N=null},0,!1),D.hasClass("uib-position-measure")?(p.positionArrow(D,e.placement),D.removeClass("uib-position-measure")):F!==e.placement&&p.positionArrow(D,e.placement),F=e.placement,U=null},0,!1)))};L.origScope=t,L.isOpen=!1,L.contentExp=function(){return L.content},n.$observe("disabled",function(e){e&&v(),e&&L.isOpen&&g()}),B&&t.$watch(B,function(e){L&&!e===L.isOpen&&a()});var z=function(){q.show.forEach(function(e){"outsideClick"===e?o.off("click",a):(o.off(e,u),o.off(e,a)),o.off("keypress",E)}),q.hide.forEach(function(e){"outsideClick"===e?l.off("click",O):o.off(e,d)})};M();var Y=t.$eval(n[s+"Animation"]);L.animation=angular.isDefined(Y)?!!Y:f.animation;var K,X=s+"AppendToBody";K=X in n&&void 0===n[X]?!0:t.$eval(n[X]),R=angular.isDefined(K)?K:R,t.$on("$destroy",function(){z(),y(),L=null})}}}}}]}).directive("uibTooltipTemplateTransclude",["$animate","$sce","$compile","$templateRequest",function(e,t,o,n){return{link:function(i,a,r){var l,p,u,s=i.$eval(r.tooltipTemplateTranscludeScope),c=0,d=function(){p&&(p.remove(),p=null),l&&(l.$destroy(),l=null),u&&(e.leave(u).then(function(){p=null}),p=u,u=null)};i.$watch(t.parseAsResourceUrl(r.uibTooltipTemplateTransclude),function(t){var r=++c;t?(n(t,!0).then(function(n){if(r===c){var i=s.$new(),p=n,f=o(p)(i,function(t){d(),e.enter(t,a)});l=i,u=f,l.$emit("$includeContentLoaded",t)}},function(){r===c&&(d(),i.$emit("$includeContentError",t))}),i.$emit("$includeContentRequested",t)):d()}),i.$on("$destroy",d)}}}]).directive("uibTooltipClasses",["$uibPosition",function(e){return{restrict:"A",link:function(t,o,n){if(t.placement){var i=e.parsePlacement(t.placement);o.addClass(i[0])}t.popupClass&&o.addClass(t.popupClass),t.animation&&o.addClass(n.tooltipAnimationClass)}}}]).directive("uibTooltipPopup",function(){return{restrict:"A",scope:{content:"@"},templateUrl:"uib/template/tooltip/tooltip-popup.html"}}).directive("uibTooltip",["$uibTooltip",function(e){return e("uibTooltip","tooltip","mouseenter")}]).directive("uibTooltipTemplatePopup",function(){return{restrict:"A",scope:{contentExp:"&",originScope:"&"},templateUrl:"uib/template/tooltip/tooltip-template-popup.html"}}).directive("uibTooltipTemplate",["$uibTooltip",function(e){return e("uibTooltipTemplate","tooltip","mouseenter",{useContentExp:!0})}]).directive("uibTooltipHtmlPopup",function(){return{restrict:"A",scope:{contentExp:"&"},templateUrl:"uib/template/tooltip/tooltip-html-popup.html"}
}).directive("uibTooltipHtml",["$uibTooltip",function(e){return e("uibTooltipHtml","tooltip","mouseenter",{useContentExp:!0})}]),angular.module("ui.bootstrap.tabs",[]).controller("UibTabsetController",["$scope",function(e){function t(e){for(var t=0;t<n.tabs.length;t++)if(n.tabs[t].index===e)return t}var o,n=this;n.tabs=[],n.select=function(e,a){if(!i){var r=t(o),l=n.tabs[r];if(l){if(l.tab.onDeselect({$event:a,$selectedIndex:e}),a&&a.isDefaultPrevented())return;l.tab.active=!1}var p=n.tabs[e];p?(p.tab.onSelect({$event:a}),p.tab.active=!0,n.active=p.index,o=p.index):!p&&angular.isDefined(o)&&(n.active=null,o=null)}},n.addTab=function(e){if(n.tabs.push({tab:e,index:e.index}),n.tabs.sort(function(e,t){return e.index>t.index?1:e.index<t.index?-1:0}),e.index===n.active||!angular.isDefined(n.active)&&1===n.tabs.length){var o=t(e.index);n.select(o)}},n.removeTab=function(e){for(var t,o=0;o<n.tabs.length;o++)if(n.tabs[o].tab===e){t=o;break}if(n.tabs[t].index===n.active){var i=t===n.tabs.length-1?t-1:t+1%n.tabs.length;n.select(i)}n.tabs.splice(t,1)},e.$watch("tabset.active",function(e){angular.isDefined(e)&&e!==o&&n.select(t(e))});var i;e.$on("$destroy",function(){i=!0})}]).directive("uibTabset",function(){return{transclude:!0,replace:!0,scope:{},bindToController:{active:"=?",type:"@"},controller:"UibTabsetController",controllerAs:"tabset",templateUrl:function(e,t){return t.templateUrl||"uib/template/tabs/tabset.html"},link:function(e,t,o){e.vertical=angular.isDefined(o.vertical)?e.$parent.$eval(o.vertical):!1,e.justified=angular.isDefined(o.justified)?e.$parent.$eval(o.justified):!1}}}).directive("uibTab",["$parse",function(e){return{require:"^uibTabset",replace:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/tabs/tab.html"},transclude:!0,scope:{heading:"@",index:"=?",classes:"@?",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},controllerAs:"tab",link:function(t,o,n,i,a){t.disabled=!1,n.disable&&t.$parent.$watch(e(n.disable),function(e){t.disabled=!!e}),angular.isUndefined(n.index)&&(t.index=i.tabs&&i.tabs.length?Math.max.apply(null,i.tabs.map(function(e){return e.index}))+1:0),angular.isUndefined(n.classes)&&(t.classes=""),t.select=function(e){if(!t.disabled){for(var o,n=0;n<i.tabs.length;n++)if(i.tabs[n].tab===t){o=n;break}i.select(o,e)}},i.addTab(t),t.$on("$destroy",function(){i.removeTab(t)}),t.$transcludeFn=a}}}]).directive("uibTabHeadingTransclude",function(){return{restrict:"A",require:"^uibTab",link:function(e,t){e.$watch("headingElement",function(e){e&&(t.html(""),t.append(e))})}}}).directive("uibTabContentTransclude",function(){function e(e){return e.tagName&&(e.hasAttribute("uib-tab-heading")||e.hasAttribute("data-uib-tab-heading")||e.hasAttribute("x-uib-tab-heading")||"uib-tab-heading"===e.tagName.toLowerCase()||"data-uib-tab-heading"===e.tagName.toLowerCase()||"x-uib-tab-heading"===e.tagName.toLowerCase()||"uib:tab-heading"===e.tagName.toLowerCase())}return{restrict:"A",require:"^uibTabset",link:function(t,o,n){var i=t.$eval(n.uibTabContentTransclude).tab;i.$transcludeFn(i.$parent,function(t){angular.forEach(t,function(t){e(t)?i.headingElement=t:o.append(t)})})}}}),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.debounce","ui.bootstrap.position"]).factory("uibTypeaheadParser",["$parse",function(e){var t=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(o){var n=o.match(t);if(!n)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+o+'".');return{itemName:n[3],source:e(n[4]),viewMapper:e(n[2]||n[1]),modelMapper:e(n[1])}}}}]).controller("UibTypeaheadController",["$scope","$element","$attrs","$compile","$parse","$q","$timeout","$document","$window","$rootScope","$$debounce","$uibPosition","uibTypeaheadParser",function(e,t,o,n,i,a,r,l,p,u,s,c,d){function f(){H.moveInProgress||(H.moveInProgress=!0,H.$digest()),J()}function m(){H.position=I?c.offset(t):c.position(t),H.position.top+=t.prop("offsetHeight")}function h(e){var t;return angular.version.minor<6?(t=e.$options||{},t.getOption=function(e){return t[e]}):t=e.$options,t}var b,v,g=[9,13,27,38,40],$=200,w=e.$eval(o.typeaheadMinLength);w||0===w||(w=1),e.$watch(o.typeaheadMinLength,function(e){w=e||0===e?e:1});var y=e.$eval(o.typeaheadWaitMs)||0,C=e.$eval(o.typeaheadEditable)!==!1;e.$watch(o.typeaheadEditable,function(e){C=e!==!1});var T,k,x=i(o.typeaheadLoading).assign||angular.noop,O=o.typeaheadShouldSelect?i(o.typeaheadShouldSelect):function(e,t){var o=t.$event;return 13===o.which||9===o.which},E=i(o.typeaheadOnSelect),M=angular.isDefined(o.typeaheadSelectOnBlur)?e.$eval(o.typeaheadSelectOnBlur):!1,D=i(o.typeaheadNoResults).assign||angular.noop,S=o.typeaheadInputFormatter?i(o.typeaheadInputFormatter):void 0,I=o.typeaheadAppendToBody?e.$eval(o.typeaheadAppendToBody):!1,A=o.typeaheadAppendTo?e.$eval(o.typeaheadAppendTo):null,P=e.$eval(o.typeaheadFocusFirst)!==!1,U=o.typeaheadSelectOnExact?e.$eval(o.typeaheadSelectOnExact):!1,N=i(o.typeaheadIsOpen).assign||angular.noop,F=e.$eval(o.typeaheadShowHint)||!1,R=i(o.ngModel),q=i(o.ngModel+"($$$p)"),W=function(t,o){return angular.isFunction(R(e))&&v.getOption("getterSetter")?q(t,{$$$p:o}):R.assign(t,o)},L=d.parse(o.uibTypeahead),H=e.$new(),B=e.$on("$destroy",function(){H.$destroy()});H.$on("$destroy",B);var j="typeahead-"+H.$id+"-"+Math.floor(1e4*Math.random());t.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":j});var V,_;F&&(V=angular.element("<div></div>"),V.css("position","relative"),t.after(V),_=t.clone(),_.attr("placeholder",""),_.attr("tabindex","-1"),_.val(""),_.css({position:"absolute",top:"0px",left:"0px","border-color":"transparent","box-shadow":"none",opacity:1,background:"none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",color:"#999"}),t.css({position:"relative","vertical-align":"top","background-color":"transparent"}),_.attr("id")&&_.removeAttr("id"),V.append(_),_.after(t));var z=angular.element("<div uib-typeahead-popup></div>");z.attr({id:j,matches:"matches",active:"activeIdx",select:"select(activeIdx, evt)","move-in-progress":"moveInProgress",query:"query",position:"position","assign-is-open":"assignIsOpen(isOpen)",debounce:"debounceUpdate"}),angular.isDefined(o.typeaheadTemplateUrl)&&z.attr("template-url",o.typeaheadTemplateUrl),angular.isDefined(o.typeaheadPopupTemplateUrl)&&z.attr("popup-template-url",o.typeaheadPopupTemplateUrl);var Y=function(){F&&_.val("")},K=function(){H.matches=[],H.activeIdx=-1,t.attr("aria-expanded",!1),Y()},X=function(e){return j+"-option-"+e};H.$watch("activeIdx",function(e){0>e?t.removeAttr("aria-activedescendant"):t.attr("aria-activedescendant",X(e))});var G=function(e,t){return H.matches.length>t&&e?e.toUpperCase()===H.matches[t].label.toUpperCase():!1},Z=function(o,n){var i={$viewValue:o};x(e,!0),D(e,!1),a.when(L.source(e,i)).then(function(a){var r=o===b.$viewValue;if(r&&T)if(a&&a.length>0){H.activeIdx=P?0:-1,D(e,!1),H.matches.length=0;for(var l=0;l<a.length;l++)i[L.itemName]=a[l],H.matches.push({id:X(l),label:L.viewMapper(H,i),model:a[l]});if(H.query=o,m(),t.attr("aria-expanded",!0),U&&1===H.matches.length&&G(o,0)&&(angular.isNumber(H.debounceUpdate)||angular.isObject(H.debounceUpdate)?s(function(){H.select(0,n)},angular.isNumber(H.debounceUpdate)?H.debounceUpdate:H.debounceUpdate["default"]):H.select(0,n)),F){var p=H.matches[0].label;_.val(angular.isString(o)&&o.length>0&&p.slice(0,o.length).toUpperCase()===o.toUpperCase()?o+p.slice(o.length):"")}}else K(),D(e,!0);r&&x(e,!1)},function(){K(),x(e,!1),D(e,!0)})};I&&(angular.element(p).on("resize",f),l.find("body").on("scroll",f));var J=s(function(){H.matches.length&&m(),H.moveInProgress=!1},$);H.moveInProgress=!1,H.query=void 0;var Q,et=function(e){Q=r(function(){Z(e)},y)},tt=function(){Q&&r.cancel(Q)};K(),H.assignIsOpen=function(t){N(e,t)},H.select=function(n,i){var a,l,p={};k=!0,p[L.itemName]=l=H.matches[n].model,a=L.modelMapper(e,p),W(e,a),b.$setValidity("editable",!0),b.$setValidity("parse",!0),E(e,{$item:l,$model:a,$label:L.viewMapper(e,p),$event:i}),K(),H.$eval(o.typeaheadFocusOnSelect)!==!1&&r(function(){t[0].focus()},0,!1)},t.on("keydown",function(t){if(0!==H.matches.length&&-1!==g.indexOf(t.which)){var o=O(e,{$event:t});if(-1===H.activeIdx&&o||9===t.which&&t.shiftKey)return K(),void H.$digest();t.preventDefault();var n;switch(t.which){case 27:t.stopPropagation(),K(),e.$digest();break;case 38:H.activeIdx=(H.activeIdx>0?H.activeIdx:H.matches.length)-1,H.$digest(),n=z[0].querySelectorAll(".uib-typeahead-match")[H.activeIdx],n.parentNode.scrollTop=n.offsetTop;break;case 40:H.activeIdx=(H.activeIdx+1)%H.matches.length,H.$digest(),n=z[0].querySelectorAll(".uib-typeahead-match")[H.activeIdx],n.parentNode.scrollTop=n.offsetTop;break;default:o&&H.$apply(function(){angular.isNumber(H.debounceUpdate)||angular.isObject(H.debounceUpdate)?s(function(){H.select(H.activeIdx,t)},angular.isNumber(H.debounceUpdate)?H.debounceUpdate:H.debounceUpdate["default"]):H.select(H.activeIdx,t)})}}}),t.on("focus",function(e){T=!0,0!==w||b.$viewValue||r(function(){Z(b.$viewValue,e)},0)}),t.on("blur",function(e){M&&H.matches.length&&-1!==H.activeIdx&&!k&&(k=!0,H.$apply(function(){angular.isObject(H.debounceUpdate)&&angular.isNumber(H.debounceUpdate.blur)?s(function(){H.select(H.activeIdx,e)},H.debounceUpdate.blur):H.select(H.activeIdx,e)})),!C&&b.$error.editable&&(b.$setViewValue(),H.$apply(function(){b.$setValidity("editable",!0),b.$setValidity("parse",!0)}),t.val("")),T=!1,k=!1});var ot=function(o){t[0]!==o.target&&3!==o.which&&0!==H.matches.length&&(K(),u.$$phase||e.$digest())};l.on("click",ot),e.$on("$destroy",function(){l.off("click",ot),(I||A)&&nt.remove(),I&&(angular.element(p).off("resize",f),l.find("body").off("scroll",f)),z.remove(),F&&V.remove()});var nt=n(z)(H);I?l.find("body").append(nt):A?angular.element(A).eq(0).append(nt):t.after(nt),this.init=function(t){b=t,v=h(b),H.debounceUpdate=i(v.getOption("debounce"))(e),b.$parsers.unshift(function(t){return T=!0,0===w||t&&t.length>=w?y>0?(tt(),et(t)):Z(t):(x(e,!1),tt(),K()),C?t:t?void b.$setValidity("editable",!1):(b.$setValidity("editable",!0),null)}),b.$formatters.push(function(t){var o,n,i={};return C||b.$setValidity("editable",!0),S?(i.$model=t,S(e,i)):(i[L.itemName]=t,o=L.viewMapper(e,i),i[L.itemName]=void 0,n=L.viewMapper(e,i),o!==n?o:t)})}}]).directive("uibTypeahead",function(){return{controller:"UibTypeaheadController",require:["ngModel","uibTypeahead"],link:function(e,t,o,n){n[1].init(n[0])}}}).directive("uibTypeaheadPopup",["$$debounce",function(e){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&",assignIsOpen:"&",debounce:"&"},replace:!0,templateUrl:function(e,t){return t.popupTemplateUrl||"uib/template/typeahead/typeahead-popup.html"},link:function(t,o,n){t.templateUrl=n.templateUrl,t.isOpen=function(){var e=t.matches.length>0;return t.assignIsOpen({isOpen:e}),e},t.isActive=function(e){return t.active===e},t.selectActive=function(e){t.active=e},t.selectMatch=function(o,n){var i=t.debounce();angular.isNumber(i)||angular.isObject(i)?e(function(){t.select({activeIdx:o,evt:n})},angular.isNumber(i)?i:i["default"]):t.select({activeIdx:o,evt:n})}}}}]).directive("uibTypeaheadMatch",["$templateRequest","$compile","$parse",function(e,t,o){return{scope:{index:"=",match:"=",query:"="},link:function(n,i,a){var r=o(a.templateUrl)(n.$parent)||"uib/template/typeahead/typeahead-match.html";e(r).then(function(e){var o=angular.element(e.trim());i.replaceWith(o),t(o)(n)})}}}]).filter("uibTypeaheadHighlight",["$sce","$injector","$log",function(e,t,o){function n(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function i(e){return/<.*>/g.test(e)}var a;return a=t.has("$sanitize"),function(t,r){return!a&&i(t)&&o.warn("Unsafe use of typeahead please use ngSanitize"),t=r?(""+t).replace(new RegExp(n(r),"gi"),"<strong>$&</strong>"):t,a||(t=e.trustAsHtml(t)),t}}]),angular.module("ui.bootstrap.debounce",[]).factory("$$debounce",["$timeout",function(e){return function(t,o){var n;return function(){var i=this,a=Array.prototype.slice.call(arguments);n&&e.cancel(n),n=e(function(){t.apply(i,a)},o)}}}]),angular.module("uib/template/modal/window.html",[]).run(["$templateCache",function(e){e.put("uib/template/modal/window.html","<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n")}]),angular.module("uib/template/popover/popover-html.html",[]).run(["$templateCache",function(e){e.put("uib/template/popover/popover-html.html",'<div class="arrow"></div>\n\n<div class="popover-inner">\n    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>\n    <div class="popover-content" ng-bind-html="contentExp()"></div>\n</div>\n')}]),angular.module("uib/template/popover/popover-template.html",[]).run(["$templateCache",function(e){e.put("uib/template/popover/popover-template.html",'<div class="arrow"></div>\n\n<div class="popover-inner">\n    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>\n    <div class="popover-content"\n      uib-tooltip-template-transclude="contentExp()"\n      tooltip-template-transclude-scope="originScope()"></div>\n</div>\n')}]),angular.module("uib/template/popover/popover.html",[]).run(["$templateCache",function(e){e.put("uib/template/popover/popover.html",'<div class="arrow"></div>\n\n<div class="popover-inner">\n    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>\n    <div class="popover-content" ng-bind="content"></div>\n</div>\n')}]),angular.module("uib/template/tooltip/tooltip-html-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/tooltip/tooltip-html-popup.html",'<div class="tooltip-arrow"></div>\n<div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n')}]),angular.module("uib/template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/tooltip/tooltip-popup.html",'<div class="tooltip-arrow"></div>\n<div class="tooltip-inner" ng-bind="content"></div>\n')}]),angular.module("uib/template/tooltip/tooltip-template-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/tooltip/tooltip-template-popup.html",'<div class="tooltip-arrow"></div>\n<div class="tooltip-inner"\n  uib-tooltip-template-transclude="contentExp()"\n  tooltip-template-transclude-scope="originScope()"></div>\n')}]),angular.module("uib/template/tabs/tab.html",[]).run(["$templateCache",function(e){e.put("uib/template/tabs/tab.html",'<li ng-class="[{active: active, disabled: disabled}, classes]" class="uib-tab nav-item">\n  <a href ng-click="select($event)" class="nav-link" uib-tab-heading-transclude>{{heading}}</a>\n</li>\n')}]),angular.module("uib/template/tabs/tabset.html",[]).run(["$templateCache",function(e){e.put("uib/template/tabs/tabset.html",'<div>\n  <ul class="nav nav-{{tabset.type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane"\n         ng-repeat="tab in tabset.tabs"\n         ng-class="{active: tabset.active === tab.index}"\n         uib-tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n')}]),angular.module("uib/template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-match.html",'<a href\n   tabindex="-1"\n   ng-bind-html="match.label | uibTypeaheadHighlight:query"\n   ng-attr-title="{{match.label}}"></a>\n')}]),angular.module("uib/template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),angular.module("ui.bootstrap.position").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibPositionCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'),angular.$$uibPositionCss=!0}),angular.module("ui.bootstrap.tooltip").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTooltipCss&&angular.element(document).find("head").prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'),angular.$$uibTooltipCss=!0}),angular.module("ui.bootstrap.typeahead").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTypeaheadCss&&angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'),angular.$$uibTypeaheadCss=!0});
/*
 AngularJS v1.4.9
 (c) 2010-2015 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(n,h,p){'use strict';function E(a){var f=[];r(f,h.noop).chars(a);return f.join("")}function g(a,f){var d={},c=a.split(","),b;for(b=0;b<c.length;b++)d[f?h.lowercase(c[b]):c[b]]=!0;return d}function F(a,f){function d(a,b,d,l){b=h.lowercase(b);if(s[b])for(;e.last()&&t[e.last()];)c("",e.last());u[b]&&e.last()==b&&c("",b);(l=v[b]||!!l)||e.push(b);var m={};d.replace(G,function(b,a,f,c,d){m[a]=q(f||c||d||"")});f.start&&f.start(b,m,l)}function c(b,a){var c=0,d;if(a=h.lowercase(a))for(c=e.length-
1;0<=c&&e[c]!=a;c--);if(0<=c){for(d=e.length-1;d>=c;d--)f.end&&f.end(e[d]);e.length=c}}"string"!==typeof a&&(a=null===a||"undefined"===typeof a?"":""+a);var b,k,e=[],m=a,l;for(e.last=function(){return e[e.length-1]};a;){l="";k=!0;if(e.last()&&w[e.last()])a=a.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*"+e.last()+"[^>]*>","i"),function(a,b){b=b.replace(H,"$1").replace(I,"$1");f.chars&&f.chars(q(b));return""}),c("",e.last());else{if(0===a.indexOf("\x3c!--"))b=a.indexOf("--",4),0<=b&&a.lastIndexOf("--\x3e",
b)===b&&(f.comment&&f.comment(a.substring(4,b)),a=a.substring(b+3),k=!1);else if(x.test(a)){if(b=a.match(x))a=a.replace(b[0],""),k=!1}else if(J.test(a)){if(b=a.match(y))a=a.substring(b[0].length),b[0].replace(y,c),k=!1}else K.test(a)&&((b=a.match(z))?(b[4]&&(a=a.substring(b[0].length),b[0].replace(z,d)),k=!1):(l+="<",a=a.substring(1)));k&&(b=a.indexOf("<"),l+=0>b?a:a.substring(0,b),a=0>b?"":a.substring(b),f.chars&&f.chars(q(l)))}if(a==m)throw L("badparse",a);m=a}c()}function q(a){if(!a)return"";A.innerHTML=
a.replace(/</g,"&lt;");return A.textContent}function B(a){return a.replace(/&/g,"&amp;").replace(M,function(a){var d=a.charCodeAt(0);a=a.charCodeAt(1);return"&#"+(1024*(d-55296)+(a-56320)+65536)+";"}).replace(N,function(a){return"&#"+a.charCodeAt(0)+";"}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}function r(a,f){var d=!1,c=h.bind(a,a.push);return{start:function(a,k,e){a=h.lowercase(a);!d&&w[a]&&(d=a);d||!0!==C[a]||(c("<"),c(a),h.forEach(k,function(d,e){var k=h.lowercase(e),g="img"===a&&"src"===k||
"background"===k;!0!==O[k]||!0===D[k]&&!f(d,g)||(c(" "),c(e),c('="'),c(B(d)),c('"'))}),c(e?"/>":">"))},end:function(a){a=h.lowercase(a);d||!0!==C[a]||(c("</"),c(a),c(">"));a==d&&(d=!1)},chars:function(a){d||c(B(a))}}}var L=h.$$minErr("$sanitize"),z=/^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,y=/^<\/\s*([\w:-]+)[^>]*>/,G=/([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,K=/^</,J=/^<\//,H=/\x3c!--(.*?)--\x3e/g,x=/<!DOCTYPE([^>]*?)>/i,
I=/<!\[CDATA\[(.*?)]]\x3e/g,M=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,N=/([^\#-~| |!])/g,v=g("area,br,col,hr,img,wbr");n=g("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr");p=g("rp,rt");var u=h.extend({},p,n),s=h.extend({},n,g("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul")),t=h.extend({},p,g("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
n=g("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,stop,svg,switch,text,title,tspan,use");var w=g("script,style"),C=h.extend({},v,s,t,u,n),D=g("background,cite,href,longdesc,src,usemap,xlink:href");n=g("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,valign,value,vspace,width");
p=g("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan",
!0);var O=h.extend({},D,p,n),A=document.createElement("pre");h.module("ngSanitize",[]).provider("$sanitize",function(){this.$get=["$$sanitizeUri",function(a){return function(f){var d=[];F(f,r(d,function(c,b){return!/^unsafe/.test(a(c,b))}));return d.join("")}}]});h.module("ngSanitize").filter("linky",["$sanitize",function(a){var f=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,d=/^mailto:/i;return function(c,b){function k(a){a&&g.push(E(a))}function e(a,
c){g.push("<a ");h.isDefined(b)&&g.push('target="',b,'" ');g.push('href="',a.replace(/"/g,"&quot;"),'">');k(c);g.push("</a>")}if(!c)return c;for(var m,l=c,g=[],n,p;m=l.match(f);)n=m[0],m[2]||m[4]||(n=(m[3]?"http://":"mailto:")+n),p=m.index,k(l.substr(0,p)),e(n,m[0].replace(d,"")),l=l.substring(p+m[0].length);k(l);return a(g.join(""))}}])})(window,window.angular);


/*
 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
 */
(function(window, angular, undefined) {
'use strict';

angular.module("matchmedia-ng", []).
    provider('matchmedia', function (){

        ///////////////////////////////////////////////////////////////////////
        // Configuration
        ///////////////////////////////////////////////////////////////////////
        /**
         *
         * these settings can be changed by injecting matchmediaProvider into
         * the config function of your module and
         * changing the matchmediaProvider.rules with your own rule key value
         * pairs E.G.

         *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
         *  }]);
         *
         * default values taken from twitter bootstrap :
         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
         */
        var matchmedia = {
            rules: {
                print : "print",
                screen : "screen",
                phone : "(max-width: 767px)",
                tablet : "(min-width: 768px) and (max-width: 979px)",
                desktop : "(min-width: 980px)",
                portrait : "(orientation: portrait)",
                landscape : "(orientation: landscape)"
            }
        };
        matchmedia.$get = ['$window','safeApply', 'logger', function($window, safeApply, logger) {

            logger.log('Creating matchmedia');

            ///////////////////////////////////////////////////////////////////////
            // Private Methods
            ///////////////////////////////////////////////////////////////////////
            function createSafeListener(cb, $scope){
                return function(mediaQueryList){
                    safeApply(function() {
                        cb(mediaQueryList);
                    },$scope);
                };
            }

            ///////////////////////////////////////////////////////////////////////
            // Public Methods
            ///////////////////////////////////////////////////////////////////////
            //should never be called directly, but is available for custom calls.
            var matchmediaService = {};

            /**
             * @param {string} query media query to listen on.
             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            matchmediaService.on = function(query, listener, $scope) {
                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia('all').addListener;
                if(supportsMatchMedia) {
                    logger.log('adding listener for query: '+ query);
                    var mediaQueryList = $window.matchMedia(query);
                    var handler = createSafeListener(listener, $scope);
                    mediaQueryList.addListener(handler);
                    //immediately return the current mediaQueryList;
                    handler(mediaQueryList);

                    return function() {
                        logger.log('removing listener from query: '+ query);
                        mediaQueryList.removeListener(handler);

                    };
                }
            };
            /**
             * @param {string} query media query to test.
             * @returns {mediaQueryList} Returns a boolean.
             */
            matchmediaService.is = function(query) {
                logger.log('test query: '+ query);
                return $window.matchMedia(query).matches;
            };



            ///////////////////////////////////////////////////////////////////////
            // Aliased Methods
            ///////////////////////////////////////////////////////////////////////
            matchmediaService.onPrint = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.print,listener, $scope);
            };
            matchmediaService.onScreen = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.screen,listener, $scope);
            };
            matchmediaService.onPhone = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.phone,listener, $scope);
            };
            matchmediaService.onTablet = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.tablet,listener, $scope);
            };
            matchmediaService.onDesktop = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.desktop,listener, $scope);
            };
            matchmediaService.onPortrait = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.portrait,listener, $scope);
            };
            matchmediaService.onLandscape = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.landscape,listener, $scope);
            };

            matchmediaService.isPrint = function(){
                return matchmediaService.is(matchmedia.rules.print);
            };
            matchmediaService.isScreen = function(){
                return matchmediaService.is(matchmedia.rules.screen);
            };
            matchmediaService.isPhone = function(){
                return matchmediaService.is(matchmedia.rules.phone);
            };
            matchmediaService.isTablet = function(){
                return matchmediaService.is(matchmedia.rules.tablet);
            };
            matchmediaService.isDesktop = function(){
                return matchmediaService.is(matchmedia.rules.desktop);
            };
            matchmediaService.isPortrait = function(){
                return matchmediaService.is(matchmedia.rules.portrait);
            };
            matchmediaService.isLandscape = function(){
                return matchmediaService.is(matchmedia.rules.landscape);
            };
            return matchmediaService;
        }];
        return matchmedia;
    })
    .directive('ajMatchmedia', ['matchmedia', function(matchmedia) {
        return {
            restrict: 'E',
            scope: {
                'queryListener': '&',
                'queryMatches': '='
            },
            link: function(scope, element, attrs, controllers) {
                var deregister;

                if (attrs.on && attrs.queryListener) {
                    if (attrs.on.slice(0, 2) === 'on' && matchmedia[attrs.on] !== 'undefined') {
                        deregister = matchmedia[attrs.on](function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    } else {
                        deregister = matchmedia.on(attrs.on, function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    }
                    scope.$on('$destroy', deregister);
                } else if (attrs.is && attrs.queryMatches) {
                    if (attrs.is.slice(0, 2) === 'is' && matchmedia[attrs.is] !== 'undefined') {
                        scope.queryMatches = matchmedia[attrs.is]();
                    } else {
                        scope.queryMatches = matchmedia.is(attrs.is);
                    }
                }
            }
        };
    }])
    .factory('safeApply', ['$rootScope',function($rootScope) {
        return function(fn, $scope) {
            $scope = $scope || $rootScope;
            var phase = $scope.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
                if (fn) {
                    $scope.$eval(fn);
                }
            } else {
                if (fn) {
                    $scope.$apply(fn);
                } else {
                    $scope.$apply();
                }
            }
        };
    }])
    .provider('logger', function(){
        this.DEVMODE = false;

        this.setDEVMODE = function(devmode){
            this.DEVMODE = devmode;
        };

        this.$get = ['$window', '$log', function($window, $log) {
            var DEVMODE = this.DEVMODE;
            var logger = {};
            logger.log = function(){
                if (DEVMODE) $log.info(arguments);
            };
            logger.always = function(){
                $log.info(arguments);
            };
            return logger;
        }];
    });
})(window, window.angular);

// All the code in this module is
// enclosed in closure
(function(exports) {

    // Data object models that can be used in both client and server

    // Product
    var PRODUCT_STATUS = {
        LIVE: 'LIVE',
        DRAFT: 'DRAFT',
        DISCONTINUED: 'DISCONTINUED'
    }

    var SUPPLIER_TYPE = {
        GARMENT: 'Garment',
        PRINTER: 'Printer'
    }

    var PRINT_TYPES = {
        SCREEN_PRINT: 'Screen Print',
        DTG: 'DTG',
        DFT: 'DFT',
        VINYL: 'Vinyl',
        EMBROIDERY: 'Embroidery'
    }

    var PROMO_PRINT_NAME = {
        SCREEN_PRINT: 'Screen Print',
        PAD_PRINT: 'Pad Print',
        LASER: 'Laser',
        LASER_PLUS: 'Laser Plus',
        DEBOSS: 'Deboss',
        EMBROIDERY: 'Embroidery',
        // DIGITAL: 'Digital Colour Print',
        // DIGITAL_TRANSFER: 'DFT',
        SUBLIMATION: 'Sublimation'
    }

    var PROMO_PRODUCT_RUNCHARGE_TYPE = {
        STEP: 'step',
        PER_COLOUR: 'perColour',
        STATIC: 'static',
    }

    var OTHER_SERVICES = {
        PRESSING: 'Pressing',
        SEWING: 'Sewing'
    }

    var SPECIALTY_PRINTS = {
        APPLIQUE: 'Applique',
        SUBLIMATED_PATCH: 'Sublimated Patch',
        WOVEN_PATCH: 'Woven Patch',
        WOVEN_LABEL: 'Woven Label',
        EMBROIDERED_PATCH: 'Embroidered Patch',
        LEATHER_PATCH: 'Leather Patch',
        LEATHER_LABEL: 'Leather Label',
        PUFF_EMBROIDERY: 'Puff Embroidery',
        SPOT_PROCESS: 'Spot Process',
        PUFF_PRINT: "Puff",
    }

    var PRINT_GROUPS = {
        SCREEN_PRINT: {
            key: PRINT_TYPES.SCREEN_PRINT,
            list: [
                PRINT_TYPES.SCREEN_PRINT,
                SPECIALTY_PRINTS.PUFF_PRINT,
                SPECIALTY_PRINTS.SPOT_PROCESS
            ]
        },
        EMBROIDERY: {
            key: PRINT_TYPES.EMBROIDERY,
            hasCustomizations: true,
            list: [
                PRINT_TYPES.EMBROIDERY,
                SPECIALTY_PRINTS.PUFF_EMBROIDERY,
                SPECIALTY_PRINTS.APPLIQUE
            ]
        },
        DFT: {
            key: PRINT_TYPES.DFT,
            hasCustomizations: true,
            list: [
                PRINT_TYPES.DFT
            ]
        },
        SEWING: {
            key: OTHER_SERVICES.SEWING,
            individualTagging: true,
            list: [
                SPECIALTY_PRINTS.WOVEN_LABEL,
                SPECIALTY_PRINTS.LEATHER_LABEL,
            ]
        },
        PATCH_APPLICATION: {
            key: 'Patch Application',
            list: [
                SPECIALTY_PRINTS.SUBLIMATED_PATCH,
                SPECIALTY_PRINTS.WOVEN_PATCH,
                SPECIALTY_PRINTS.EMBROIDERED_PATCH,
                SPECIALTY_PRINTS.LEATHER_PATCH,
            ]
        },
        IN_HOUSE: {
            key: "In House",
            list: [],
            hasCustomizations: true,
            individualTagging: true
        },
        OUTSOURCED: {
            key: "Outsourced",
            isOutsourced: true,
            list: [],
        }
    }

    var ALL_PRODUCT_TYPES = {
        CLOTHING: 'Clothing',
        PROMO_PRODUCT: 'Promotional Product',
        STICKER: 'Sticker',
        PATCH: 'Patch'
    }

    // Admin
    var ADMIN_TYPES = {
        CSR:'CSR', // external
        PRODUCTION: 'PRODUCTION',
        WAREHOUSE: 'WAREHOUSE',
        ORDERER: 'ORDERER', // external
        PURCHASER: 'PURCHASER',
        SETUP: 'SETUP', // external
        ADMIN: 'ADMIN',
        SYSTEM: 'SYSTEM',
        MARKETING: 'MARKETING',
        DATA_ENTRY: 'DATAENTRY', // external
        ACCOUNTING: 'ACCOUNTING' // external
    };

    // Page Templates
    var PAGE_TEMPLATE_STATUS = {
        LIVE: 'LIVE',
        APPROVAL: 'APPROVAL',
        DRAFT: 'DRAFT',
    }

    var PAGE_SECTIONS = {
        BEST_SELLERS: 'BestSellers',
        BANNER: 'Banner',
        LEFT_ALIGNED_TEXT: 'LeftAlignedText',
        LEFT_ALIGNED_IMAGE: 'LeftAlignedImage',
        PRODUCTS: 'Products',
        FEATURED_PRODUCTS: 'FeaturedProducts',
        FAQ: 'FAQ',
        VERTICAL_ITEM_LIST: 'VerticalItemList',
        IMAGE_ROW: 'ImageRow',
        LEFT_COLUMNED: 'LeftColumn',
        RIGHT_COLUMNED: 'RightColumn',
        CONFIGURABLE_BRANDS: 'ConfigurableBrands',
        POPULAR_CATEGORIES: 'PopularCategories',
        OUR_COMPASS: 'OurCompass',
        TURNAROUND_PROPOSITION: 'TurnaroundProp',
        VALUE_PROPOSITIONS:  'ValuePropositions',
        EXPERT_DESIGN_REVIEW: 'ExpertDesignReview',
        SHIPPING_VALUE_PROP: 'ShippingValue',
        MERCH_VALUE_PROP: 'Merch',
        BRANDS_OFFERED: 'Brands',
        CLIENTS: 'Clients',
        REVIEWS: 'Reviews',
        MAP: 'Map',
        LOCATION: 'Location'
    }

    var PAGE_DATA_TYPES = {
        TEXT: 'TEXT',
        RICH_TEXT: 'RICH_TEXT',
        IMAGE: 'IMAGE',
        BOOLEAN: 'BOOLEAN',
        PRODUCT: 'PRODUCT',
        PRODUCT_SKU: 'PRODUCT_SKU',
        LIST: 'LIST',
    }

    var URL_TYPES = {
        PAGE_TEMPLATE_REF: 'PAGE_TEMPLATE',
        HYPERLINK: 'HYPER_LINK'
    }

    var PAGE_TEMPLATE_LOCATION_TOKENS = {
        LOCATION_CITY: 'LCITY',
        LOCATION_STATE: 'LSTATE'
    }

    var PAGE_TEMPLATE_URL_LOCATION_SEPARATORS = {
        IN: '-in-',
        SLASH: '/'
    }

    // Marketing Types
    var MARKETING_TYPES = {
        SEARCHENGINE: 'Search Engine (Google, Yahoo, etc)',
        RECOMMENDATIONBYFRIEND: 'Recommended by friend or colleague',
        INSTAGRAM: 'Instagram',
        LINKEDIN: 'LinkedIn',
        FACEBOOK: 'Facebook',
        BLOG: 'Blog or Publication',
        OTHER: 'Other'
    }

    // Shipment Types
    var SHIPMENT_MODAL_STATES = {
        CUSTOM: 'CUSTOM', // 1111 shipments
        SHIP: 'SHIP', // regular ship orders
        WAREHOUSE: 'WAREHOUSE', // warehouse shipments (internal)
        SPLIT_SHIP: 'SPLIT_SHIP' // split shipment
    }

    var BOX_PAGE_STATES = {
        EDIT: 'EDIT',
        VIEW: 'VIEW',
        SELECT: 'SELECT'
    }

    var ITEM_COMPACT_VIEW_STATES = {
        EDIT: 'EDIT',
        VIEW: 'VIEW',
        SELECT: 'SELECT'
    }

    var SPLIT_SHIPMENT_PAGE_STATES = {
        ORDER: 'ORDER',
        PRINT: 'PRINT'
    }

    var SHIPMENT_STATUS = {
        PURCHASED: 'PURCHASED',
        REFUNDED: 'REFUNDED',
    }

    var TRACK_SHIPMENT_GRID = {
        BOX: 'BOX',
        SHIPMENT: 'SHIPMENT',
        SPLIT_SHIP: 'SPLIT_SHIP'
    }


    // Customer
    var CUSTOMER_TYPES = {
        BUSINESS: {value :'Business' , deprecated : false},
        CONSTRUCTION: {value :'Construction', deprecated : false},
        GOVERNMENT: {value :'Government', deprecated : false},
        NON_PROFIT: {value :'Non Profit', deprecated : false},
        OTHER: {value :'Other', deprecated : false},
        SCHOOL: {value :'School', deprecated : false},
        SPORT: {value :'Sport', deprecated : false},
        DART: {value :'Dart Jersey', deprecated : true},
        ULTIMATE: {value : 'Ultimate Frisbee Team', deprecated : true},
        PERSONAL: {value: 'Personal Use', deprecated : true},
        GIFT: {value : 'Gift', deprecated : true},
        PROMO: {value :'Promo', deprecated : true}
    }

    // Custom URL link fragments
    // TODO: replace all string usages in code with this model
    var CUSTOM_URL_LINK_FRAGMENTS = {
        T_SHIRT_PRINTING: '/custom-products/custom-clothing/t-shirts/',
        SCREEN_PRINTING: '/print-methods/screen-printing/',
        EMBROIDERY: '/print-methods/embroidery/'
    }

    var SHIPPING_PROVIDERS = {
        UPS: 'UPS',
        USPS: 'USPS',
        CANPAR: 'Canpar',
        CANADA_POST: 'Canada Post',
        PUROLATOR: 'Purolator',
        FED_EX: 'FedEx',
        DHL: 'DHL',
        DICOM: 'Dicom',
        OTHER: 'OTHER'
    }

    var ORDER_CURRENCY = {
        CAD: 'CAD',
        USD: 'USD'
    }

    // locations
    var OFFICE_LOCATIONS = {
        VAN: 'VANCOUVER',
        TOR: 'TORONTO'
    }

    var REFUND_STATUS = {
        SUBMITTED: 'SUBMITTED',
        REFUNDED: 'REFUNDED',
        REJECTED: 'REJECTED',
        FAILED: 'FAILED'
    }

    var MANIFEST_STATUS = {
        SUBMITTED: 'SUBMITTED',
        CREATED: 'CREATED',
        FAILED: 'FAILED',
    }

    var FULFILLMENT_TYPE = {
        GARMENT: 'GARMENT',
        PRINT: 'PRINT',
        APPLIQUE: 'APPLIQUE',
        PATCH: 'PATCH',
        WOVEN_PATCH: 'WOVEN_PATCH',
        LEATHER_PATCH: 'LEATHER_PATCH'
    }

    var FULFILL_STATUS = {
        PENDING: 'PENDING',
        FULFILLED: 'FULFILLED'
    }

    var SUPPLIER_CURRENCY = {
        CAD: 'cad',
        USD: 'usd'
    }

    // shipment boxes
    var SHIP_BOX_SIZES = {
        BAG: 'BAG',
        S: 'SMALL',
        M: 'MEDIUM',
        L: 'LARGE',
        XL: 'XLARGE',
        SWAG_BOX: 'SWAGBOX',
        CUSTOM: 'CUSTOM'
    }

    //product list sort types
    var PAYMENT_TYPES = {
        CREDITCARD: 'Credit Card',
        WIRE: 'Wire Transfer',
        ETRANSFER: 'Etransfer',
        CHEQUE : 'Cheque'
    }


    //product list sort types
    var PRODUCT_SORT_TYPES = {
        RELEVANCE: 'Relevance',
        DELIVERY: 'Fastest Delivery',
        RECOMMENDED: 'Recommended',
        PRICE_ASC: 'Price Low to High',
        PRICE_DESC: 'Price High to Low',
        MINIMUM_ORDER_QTY: 'Minimum Order Quantity',
        CUSTOM: 'Custom',
    }

    //Order
    var ORDER_STATUSES = {
        QUOTING: "Quoting",
        CREATING_MOCKUP: "Creating Mockup",
        PENDING_APPROVAL: "Pending Mockup Approval",
        PRINTING: "Printing",
        SHIPPED: "Shipped",
        ARCHIVED: "Archived",
        DRAFT: "Draft"
    }

    var ORDER_CREATION_TYPES = {
        ADMIN_ORDER: "Web Order",
        INTERNAL_ORDER: "Internal Order",
        LIGHTNING_ORDER: "Minimum Order"
    }

    var ORDER_SHIPPING_TYPES = {
        PICK_UP: "Pick Up",
        SHIP: "Ship",
        SPLIT_SHIP: "Split Ship"
    }

    var PRODUCT_TAGS = {
        CORPORATE: 'Corporate',
        ECO_FRIENDLY: 'Eco Friendly',
        MADE_IN_CANADA: 'Made in Canada',
        MADE_IN_USA: 'Made In USA',
        MOST_POPULAR: 'Most Popular',
        WORK_WEAR: 'Work Wear',
        PERFORMANCE: 'Performance',
        BUDGET_FRIENDLY: 'Budget Friendly', // deprec
        QUICK_DELIVERY: 'Quick Delivery', // deprec
        PREMIUM: 'Premium', // deprec
        STAFF_PICK: 'Staff Pick' // deprec
    }

    var PRODUCT_COLOUR_FAMILIES = {
        RED: {
            name: 'Red',
            hex: '#FF0000'
        },
        ORANGE: {
            name: 'Orange',
            hex: '#FFA500'
        },
        YELLOW: {
            name: 'Yellow',
            hex: '#FFFF00'
        },
        GREEN: {
            name: 'Green',
            hex: '#008000'
        },
        BLUE: {
            name: 'Blue',
            hex: '#0000FF'
        },
        PURPLE: {
            name: 'Purple',
            hex: '#6600FF'
        },
        PINK: {
            name: 'Pink',
            hex: '#FFC0CB'
        },
        BROWN: {
            name: "Brown",
            hex: '#8b4513'
        },
        BLACK: {
            name: "Black",
            hex: '#000000'
        },
        GREY: {
            name: "Grey",
            hex: '#808080'
        },
        WHITE: {
            name: "White",
            hex: '#FFFFFF'
        },
        MULTI: {
            name: 'Multi-Colour',
            image: 'https://image.coastalreign.com/icons/colour_wheel.png',
        },
        CAMO: {
            name: 'Camo',
            image: 'https://image.coastalreign.com/icons/camof.png'
        },
        TIE_DYE: {
            name: "Tie Dye",
            image: 'https://image.coastalreign.com/icons/tdye.png'
        },
        FULL_COLOUR: {
            name: 'Full Colour',
            image: 'https://image.coastalreign.com/icons/colour_wheel.png'
        }
    }

    var PROMO_PRODUCT_DISCOUNT_CODES = {
        NET: 'Net',

        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
        H: 'H',
        I: 'I',

        P: 'P',
        Q: 'Q',
        R: 'R',
        S: 'S',
        T: 'T',
        U: 'U',
        V: 'V',
        W: 'W',
        X: 'X'
    }

    // Admin Tasks

    var MY_TASKS_SORT = {
        DUE_NEW: 'New',
        OVERDUE: 'Overdue',
        ORDER_VALUE: 'Order Value',
        CUSTOMER_VALUE: 'Customer Paid Value',
        COMPLETED: 'Completed Date',
    }

    var TASK_TYPES = {
        FOLLOW_UP_PROOF: 'Mockup Follow-up',
        FOLLOW_UP_QUOTE: 'Quote Follow-up',
        ASK_FOR_REVIEW: 'Review/Referral Request',
        TOUCH_BASE: 'Touch Base'
    }

    var TASK_STATUS = {
        COMPLETE: 'Completed',
        ARCHIVED: 'Archived'
    }

    var DASHBOARD_DATE_FILTERS = {
        THIS_MONTH: {
            name: 'This Month',
            period: 'month'
        },
        LAST_MONTH: {
            name: 'Last Month',
            period: 'month'
        },
        TWO_MONTHS_AGO: {
            name: '2 Months Ago',
            monthsBack: 2,
            period: 'month'
        },
        THREE_MONTHS_AGO: {
            name: '3 Months Ago',
            monthsBack: 3,
            period: 'month'
        },
        FOUR_MONTHS_AGO: {
            name: '4 Months Ago',
            monthsBack: 4,
            period: 'month'
        },
        FIVE_MONTHS_AGO: {
            name: '5 Months Ago',
            monthsBack: 5,
            period: 'month'
        },
        SIX_MONTHS_AGO: {
            name: '6 Months Ago',
            monthsBack: 6,
            period: 'month'
        },
        LAST_YEAR: {
            name: 'Last Year',
            period: 'year'
        },
        LAST_7_DAYS: {
            name: 'Last 7 Days'
        },
        LAST_30_DAYS: {
            name: 'Last 30 Days'
        },
        LAST_90_DAYS: {
            name: 'Last 90 Days'
        },
        TODAY: {
            name: 'Today'
        },
        YESTERDAY: {
            name: 'Yesterday'
        },
        SAME_DAY_LAST_YEAR: {
            name: 'Last Year - Today'
        },
        YESTERDAY_LAST_YEAR: {
            name: 'Last Year - Yesterday'
        },
        THIS_MONTH_LAST_YEAR: {
            name: 'Last Year - This Month',
            period: 'month'
        },
        CUSTOM_RANGE: {
            name: 'Custom'
        }
    }

    var DASHBOARD_DRILLDOWN_OPTIONS = {
        CSR: 'CSR',
        // CUSTOMER_TYPE: 'Customer Type',
        COUNTRY: 'Country',
        STATE: 'State',
        SHIP_TYPE: 'Shipping Type',
        // Line Item Drilldown
        PRODUCT_TYPE: 'Product Type',
        PRODUCT_CATEGORY: 'Product Category',
        PRODUCT_SKU: 'Product SKU',
        PRODUCT_NAME: 'Product Name',
        PRODUCT_BASE_PRICE: 'Garment Base Price',
        GARMENT_QUANTITY: 'Garment Quantity',
        GARMENT_SUPPLIER: 'Garment Supplier',
        PRINT_SUPPLIER: 'Print Supplier',
        // Print drilldown,
        PRINT_TYPE: 'Print Type',
    }

    var DASHBOARD_GARMENT_QUANTITY_BUCKET = {
        ONE_FIVE: '1 - 5',
        FIVE_TEN: '5 - 10',
        TEN_TWENTYFIVE: '10 - 25',
        TWENTYFIVE_FIFTY: '25 - 50',
        FIFTY_HUNDRED: '50 - 100',
        HUNDRED_TWOHUNDRED: '100 - 200',
        TWOHUNDRED_FIVEHUNDRED: '200 - 500',
        FIVEHUNDRED_THOUSAND: '500 - 1000',
        OVER_ONE_THOUSAND: '1000+',
        UNCATEGORIZED: 'Other'
    }

    var DASHBOARD_PRODUCT_BASE_PRICE_BUCKET = {
        ZERO_TWO: '0 - $2',
        TWO_FIVE: '2 - $5',
        FIVE_TWENTY: '5 - $20',
        TWENTY_THIRTY: '20 - $30',
        THIRTY_FOURTY: '30 - $40',
        FOURTY_FIFTY: '40 - $50',
        FIFTY_SEVENTY: '50 - $70',
        SEVENTY_HUNDRED: '70 - $100',
        HUNDRED_ONEFIFTY: '100 - $150',
        OVER_ONEFIFTY: 'Over $150',
        UNCATEGORIZED: 'Other'
    }

    // Export the function to exports
    // In node.js this will be exports
    // the module.exports
    // In browser this will be function in
    // the global object sharedModule
    exports.PRODUCT_STATUSES = PRODUCT_STATUS;
    exports.ALL_PRODUCT_TYPES = ALL_PRODUCT_TYPES;
    exports.PAGE_TEMPLATE_STATUSES = PAGE_TEMPLATE_STATUS;
    exports.ADMIN_TYPES = ADMIN_TYPES;
    exports.PAGE_SECTIONS = PAGE_SECTIONS;
    exports.PAGE_DATA_TYPES = PAGE_DATA_TYPES;
    exports.PAGE_TEMPLATE_LOCATION_TOKENS = PAGE_TEMPLATE_LOCATION_TOKENS;
    exports.PAGE_TEMPLATE_URL_LOCATION_SEPARATORS = PAGE_TEMPLATE_URL_LOCATION_SEPARATORS;
    exports.CUSTOM_URL_LINK_FRAGMENTS = CUSTOM_URL_LINK_FRAGMENTS
    exports.URL_TYPES = URL_TYPES;
    exports.CUSTOMER_TYPES = CUSTOMER_TYPES;
    exports.MARKETING_TYPES = MARKETING_TYPES;
    exports.OFFICE_LOCATIONS = OFFICE_LOCATIONS;
    exports.BOX_PAGE_STATES = BOX_PAGE_STATES;
    exports.SPLIT_SHIPMENT_PAGE_STATES = SPLIT_SHIPMENT_PAGE_STATES;
    exports.SHIP_BOX_SIZES = SHIP_BOX_SIZES;
    exports.SHIPMENT_STATUS = SHIPMENT_STATUS;
    exports.SHIPMENT_MODAL_STATES = SHIPMENT_MODAL_STATES;
    exports.PRODUCT_SORT_TYPES = PRODUCT_SORT_TYPES;
    exports.PAYMENT_TYPES = PAYMENT_TYPES
    exports.ORDER_STATUSES = ORDER_STATUSES;
    exports.ORDER_SHIPPING_TYPES = ORDER_SHIPPING_TYPES;
    exports.TRACK_SHIPMENT_GRID = TRACK_SHIPMENT_GRID;
    exports.PROMO_PRINT_NAME = PROMO_PRINT_NAME;
    exports.PRINT_TYPES = PRINT_TYPES;
    exports.ORDER_CREATION_TYPES = ORDER_CREATION_TYPES;
    exports.ITEM_COMPACT_VIEW_STATES = ITEM_COMPACT_VIEW_STATES;
    exports.SUPPLIER_TYPE = SUPPLIER_TYPE;
    exports.PRODUCT_TAGS = PRODUCT_TAGS;
    exports.PROMO_PRODUCT_DISCOUNT_CODES = PROMO_PRODUCT_DISCOUNT_CODES;
    exports.PROMO_PRODUCT_RUNCHARGE_TYPE = PROMO_PRODUCT_RUNCHARGE_TYPE;
    exports.SHIPPING_PROVIDERS = SHIPPING_PROVIDERS;
    exports.SPECIALTY_PRINTS = SPECIALTY_PRINTS;
    exports.OTHER_SERVICES = OTHER_SERVICES;
    exports.TASK_TYPES = TASK_TYPES;
    exports.TASK_STATUS = TASK_STATUS;
    exports.MY_TASKS_SORT = MY_TASKS_SORT;
    exports.DASHBOARD_DATE_FILTERS = DASHBOARD_DATE_FILTERS;
    exports.DASHBOARD_DRILLDOWN_OPTIONS = DASHBOARD_DRILLDOWN_OPTIONS;
    exports.DASHBOARD_GARMENT_QUANTITY_BUCKET = DASHBOARD_GARMENT_QUANTITY_BUCKET;
    exports.DASHBOARD_PRODUCT_BASE_PRICE_BUCKET = DASHBOARD_PRODUCT_BASE_PRICE_BUCKET;
    exports.PRINT_GROUPS = PRINT_GROUPS;
    exports.ORDER_CURRENCY = ORDER_CURRENCY;
    exports.PRODUCT_COLOUR_FAMILIES = PRODUCT_COLOUR_FAMILIES;
    exports.FULFILLMENT_TYPE = FULFILLMENT_TYPE;
    exports.FULFILL_STATUS = FULFILL_STATUS;
    exports.SUPPLIER_CURRENCY = SUPPLIER_CURRENCY;
    exports.REFUND_STATUS = REFUND_STATUS;
    exports.MANIFEST_STATUS = MANIFEST_STATUS;


})(typeof exports === 'undefined'?
    this['modelService']={}: exports);
/**
 * Created by eddisonng on 2017-05-12.
 */

// All the code in this module is
// enclosed in closure
(function(exports) {

    var jan = 0, feb = 1, mar = 2, apr = 3, may = 4, jun = 5, jul = 6, aug = 7, sep = 8, oct = 9, nov = 10, dec = 11


    //BC : https://www.statutoryholidays.com/bc.php
    //ON : https://www.statutoryholidays.com/ontario.php

    var statHolidays2016 = [    //month/day/year/vancouver/toronto
        [jan, 2, 2017 ],
        [feb, 8, 2017],
        [mar, 25, 2017],
        [mar, 28, 2017],
        [apr, 22, 2017],
        [jun, 1, 2017],
        [jul, 1, 2017],
        [aug, 4, 2017],
        [oct, 9, 2017],
        [nov, 11, 2017],
        [dec, 25, 2017],
        [dec, 26, 2017],
        [jan, 1, 2018],
        [feb, 12, 2018],
        [mar, 30, 2018],
        [may, 21, 2018],
        [jul, 2, 2018],
        [aug, 6, 2018],
        [sep, 3, 2018],
        [oct, 8, 2018],
        [nov, 12, 2018],
        [dec, 25, 2018],
        [jan, 1, 2019],
        [feb, 11, 2019],
        [apr, 19, 2019],
        [may, 20, 2019],
        [jul, 1, 2019],
        [aug, 5, 2019],
        [sep, 2, 2019],
        [oct, 14, 2019],
        [nov, 11, 2019],
        [dec, 25, 2019],
        [jan, 1, 2020],
        [feb, 17, 2020],
        [apr, 10, 2020],
        [may, 18, 2020],
        [jul, 1, 2020],
        [aug, 3, 2020],
        [sep, 7, 2020],
        [oct, 12, 2020],
        [nov, 11, 2020],
        [dec, 25, 2020],
        [jan, 1, 2021],
        [feb, 15, 2021],
        [apr, 2, 2021],
        [may, 24, 2021],
        [jul, 1, 2021],
        [aug, 2, 2021],
        [sep, 6, 2021],
        [oct, 11, 2021],
        [nov, 11, 2021],
        [dec, 25, 2021],
        [dec, 27, 2021],
        [jan, 3, 2022, "New Years Day"],
        [feb, 21, 2022, "Family Day"],
        [apr, 15, 2022, "Good Friday"],
        [may, 23, 2022, "Victoria Day"],
        [jul, 1, 2022,"Canada Day"],
        [aug, 8, 2022,"BC Day"],
        [sep, 5, 2022,"Labour Day"],
        [oct, 10, 2022,"Thanksgiving"],
        [nov, 11, 2022,"Remembrance Day"],
        [dec, 26, 2022,"Christmas Day"],
        [jan, 2, 2023, "New Years Day", true, true],
        [feb, 20, 2023, "Family Day", true, true],
        [apr, 7, 2023, "Good Friday", true, true],
        [may, 22, 2023, "Victoria Day", true, true],
        [jul, 3, 2023,"Canada Day", true, true],
        [aug, 7, 2023,"BC Day", true, true],
        [sep, 4, 2023,"Labour Day", true, true],
        [oct, 2, 2023,"National Day for Truth and Reconciliation", true, true],
        [oct, 9, 2023,"Thanksgiving", true, true],
        [nov, 13, 2023,"Remembrance Day", true, true],
        [dec, 25, 2023,"Christmas Day", true, true],
        [dec, 26, 2023,"Boxing Day", true, true],
        [jan, 1, 2024, "New Years Day", true, true],
        [feb, 19, 2024, "Family Day", true, true],
        [mar, 29, 2024, "Good Friday", true, true],
        [may, 20, 2024, "Victoria Day", true, true],
        [jul, 1, 2024,"Canada Day", true, true],
        [aug, 5, 2024,"BC Day / Civic Holiday", true, true],
        [sep, 2, 2024,"Labour Day", true, true],
        [sep, 30, 2024,"National Day for Truth and Reconciliation", true, false],
        [oct, 14, 2024,"Thanksgiving", true, true],
        [nov, 11, 2024,"Remembrance Day", true, false],
        [dec, 25, 2024,"Christmas Day", true, true],
        [dec, 26, 2024,"Boxing Day", false, true],
        [jan, 1, 2025, "New Years Day", true, true],
        [feb, 17, 2025, "Family Day", true, true],
        [apr, 18, 2025, "Good Friday", true, true],
        [may, 19, 2025, "Victoria Day", true, true],
        [jul, 1, 2025,"Canada Day", true, true],
        [aug, 4, 2025,"BC Day / Civic Holiday", true, true],
        [sep, 1, 2025,"Labour Day", true, true],
        [sep, 30, 2025,"National Day for Truth and Reconciliation", true, false],
        [oct, 13, 2025,"Thanksgiving", true, true],
        [nov, 11, 2025,"Remembrance Day", true, false],
        [dec, 25, 2025,"Christmas Day", true, true],
        [dec, 26, 2025,"Boxing Day", false, true],
        [jan, 1, 2026, "New Years Day", true, true],
        [feb, 16, 2026, "Family Day", true, true],
        [apr, 3, 2026, "Good Friday", true, true],
        [may, 18, 2026, "Victoria Day", true, true],
        [jul, 1, 2026,"Canada Day", true, true],
        [aug, 3, 2026,"BC Day / Civic Holiday", true, true],
        [sep, 7, 2026,"Labour Day", true, true],
        [sep, 30, 2026,"National Day for Truth and Reconciliation", true, false],
        [oct, 12, 2026,"Thanksgiving", true, true],
        [nov, 11, 2026,"Remembrance Day", true, false],
        [dec, 25, 2026,"Christmas Day", true, true],
        [dec, 26, 2026,"Boxing Day", false, true]
    ];

    // for db
    var statHolidayDates = statHolidays2016.map(function(dateObject) {
        return {
            $dateFromParts: {
                year: dateObject[2],
                month: dateObject[0] + 1,
                day: dateObject[1]
            }
        }
    });

    function getBusinessDaysLeft(businessDays,startDate,comparisonDate) {

        var tmp = new Date(startDate);
        for(var businessDays = businessDays;businessDays > 0;){
            tmp.setDate( tmp.getDate() + 1);
            if (!(tmp.getDay()== 0 || tmp.getDay() == 6|| isStatHoliday(tmp.getMonth(),tmp.getDate(), tmp.getFullYear()))){
                businessDays--
            }
        }
        var date = new Date()
        if (comparisonDate){
            date = new Date(comparisonDate)
        }
        var businessDaysLeft = 0;

        if (date < tmp) {
            while(!(tmp.getFullYear() == date.getFullYear() && tmp.getDate()==date.getDate() && tmp.getMonth()== date.getMonth())){
                tmp.setDate( tmp.getDate() - 1);
                if ((tmp.getDay()== 0 || tmp.getDay() == 6|| isStatHoliday(tmp.getMonth(),tmp.getDate(),tmp.getFullYear()))){
                    //do nothing
                } else{
                    businessDaysLeft = businessDaysLeft + 1;
                }
            }
        } else {
            while(!(tmp.getFullYear() == date.getFullYear() &&  date.getDate()==tmp.getDate() && date.getMonth()== tmp.getMonth())){
                date.setDate( date.getDate() - 1);
                if ((date.getDay()== 0 || date.getDay() == 6|| isStatHoliday(date.getMonth(),date.getDate(),date.getFullYear()))){
                    //do nothing
                } else{
                    businessDaysLeft = businessDaysLeft - 1;
                }
            }

        }

        return businessDaysLeft
    }

    function isStatHoliday(month, day, year) {
        for (var i = 0; i < statHolidays2016.length; i++) {
            if (statHolidays2016[i][0] == month && statHolidays2016[i][1] == day && statHolidays2016[i][2] == year) {
                return true
            }
        }
        return false;
    }

    function addBusinessDayUnformatted(businessDays, startDate) {
        var tmp = new Date(startDate);

        for (var businessDays = businessDays; businessDays > 0;) {
            tmp.setDate(tmp.getDate() + 1);
            if (!(tmp.getDay() == 6 || tmp.getDay() == 0 || isStatHoliday(tmp.getMonth(), tmp.getDate(), tmp.getFullYear()))) {
                businessDays = businessDays - 1;
            }
        }
        return tmp;
    }


    function addBusinessDays(businessDays, startDate, format) {

        var tmp = addBusinessDayUnformatted(businessDays, startDate);
        if (!format){
            format = "ddd MMM Do YYYY"
        }

        var tmpString = moment(tmp).format(format);
        return tmpString;

    }

    // Export the function to exports
    // In node.js this will be exports
    // the module.exports
    // In browser this will be function in
    // the global object sharedModule
    exports.isStatHoliday = isStatHoliday;
    exports.statHolidays2016 = statHolidays2016;
    exports.statHolidayDates = statHolidayDates;
    exports.addBusinessDayUnformatted = addBusinessDayUnformatted;
    exports.addBusinessDays = addBusinessDays;
    exports.getBusinessDaysLeft = getBusinessDaysLeft;

})(typeof exports === 'undefined'?
    this['dateService']={}: exports);


(function(exports) {
    var _
    var mS
    var merge
    if (typeof window !== 'undefined') {
        mS = modelService
        _ = window._
        merge = deepmerge;
    } else {
        _ = require("../../../node_modules/underscore")
        mS = require("../services/models")
        merge = require('deepmerge');
    }

var sizeCodeToName = {
    "XS": "X-Small",
    "S": "Small",
    "M": "Medium",
    "L": "Large",
    "XL": "X-Large",
    "2XL": "XX-Large",
    "3XL": "XXX-Large",
    "4XL": "XXXX-Large",
    "5XL": "XXXXX-Large",
}

    // against CAD,
    var fxMap = {
        'CAD': 1,
        'USD': 0.85, // update this if need to change
        'LEGACY_USD': 0.85 // DO NOT UPDATE - legacy orders used 0.85 as rate
    }

var QUOTING_STARTING_QTY = 25;
var shippingPercentageWithinRange = 10;
var shippingChargesOver300 = 0.507 //annual increase prone
var csrFeeBlank = 15.68 //annual increase prone
var csrFeePrint = 40.60 //annual increase prone
var customizationCostPerUnit = 7.50; //annual increase prone MAYBE NOT
var splitShipmentHandlingCost = 8.6275; //annual increase prone
var USDToCADExchange = 1.39; //https://www.google.com/search?q=usd+to+cad&oq=usd+to+cad&gs_lcrp=EgZjaHJvbWUqDggAEEUYJxg7GIAEGIoFMg4IABBFGCcYOxiABBiKBTISCAEQABhDGIMBGLEDGIAEGIoFMhIIAhAAGEMYgwEYsQMYgAQYigUyDwgDEAAYQxixAxiABBiKBTISCAQQABhDGIMBGLEDGIAEGIoFMgwIBRAAGEMYgAQYigUyDwgGEAAYQxixAxiABBiKBTIPCAcQABhDGLEDGIAEGIoFMg8ICBAAGEMYsQMYgAQYigUyDwgJEAAYQxixAxiABBiKBdIBBzc1MGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8
var borderDutiesFixed = 41.81; //annual increase prone
var dutiesAndTaxMarkup = 1.2; //https://docs.google.com/spreadsheets/d/1ZvxJtKsOhCoeNcJNtARK0Z6hiAwGUg6pZY7ygOiq-Jg/edit#gid=0
var pressCost = 4.704 //annual increase prone
var perimeterSewingCost = 5.23 //annual increase prone
var individualPackagingCost = 2; //annual increase prone MAYBE NOT
var sewnOnTagsCost = 2; //annual increase prone MAYBE NOT
var USD_INVOICING_CONVERSION = 0.25;
var US_SHIPMENT_SIZE_VALUE = 800;
var NON_GUARANTEED_EXTRA_DAYS = 3;

////////////////////
// Promo Products (PCNA) //
////////////////////

var PCNAShippingMarkup = 1.05;
var PCNAPromoProductRushProductionFee = 55; // flat fee of 50 treat as markup
var PCNAPromoProductMinimumOrderFlatFee = 81; // april 21, 2025

// todo: should be own model in db
var promoProductDecorationGrouping = {
    print: {
        name: 'Print',
        list: [
            mS.PROMO_PRINT_NAME.SCREEN_PRINT,
            mS.PROMO_PRINT_NAME.PAD_PRINT
        ]},
    laser: {
        name: 'Laser',
        list: [
            mS.PROMO_PRINT_NAME.LASER,
            mS.PROMO_PRINT_NAME.LASER_PLUS
        ]},
    deboss: {
        name: "Deboss",
        list: [
            mS.PROMO_PRINT_NAME.DEBOSS
        ]
    },
    embroidery: {
        name: 'Embroidery',
        list: [
            mS.PROMO_PRINT_NAME.EMBROIDERY
        ]
    }
}

function getDiscountedPriceFromCode(code) {
    switch(code) {
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.A:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.P:
            return 0.50;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.B:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.Q:
            return 0.55;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.C:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.R:
            return 0.60;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.D:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.S:
            return 0.65;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.E:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.T:
            return 0.70;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.F:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.U:
            return 0.75;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.G:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.V:
            return 0.80;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.H:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.W:
            return 0.85;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.I:
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.X:
            return 0.90;
        case mS.PROMO_PRODUCT_DISCOUNT_CODES.NET:
            return 1;
        default:
            return 1;
    }
}
// april 21 2025
var promoProductSetupFees = {
    code: "G",
    default: {
        single: 75.00,
        multi: 127.50
    },
    deboss: {
        single: 100.00,
        multi: 100.00,
    },
    laser: {
        single: 75.00,
        multi: 75.00,
    },
    embroidery: {
        single: 75.00,
        multi: 75.00,
    }

    // lpp: {
    //     laser: {
    //         single: 68.75,
    //         multi: 118.75
    //     },
    //     screenPrint: {
    //         single: 68.75,
    //         multi: 118.75
    //     }
    // },
    // bpp: {
    //     laser: {
    //         single: 68.75,
    //         multi: 118.75
    //     },
    //     screenPrint: {
    //         single: 68.75,
    //         multi: 118.75
    //     }
    // }
}
// april 21 2025
var promoProductRunCharges = {
    code: "G",
    lpp: {
        print: {
            // todo digital
            screenprint: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.PER_COLOUR,
                pricePerColour: 1.08
            },
            padprint: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.PER_COLOUR,
                pricePerColour: 1.08
            }
        },
        laser: {
            laser: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 1.08
            },
            laserplus: {
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 1.35
            }
        },
        deboss: {
            deboss: {
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 1.08
            }
        },
        embroidery: {
            embroidery: {
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 3.38
            }
        }
    },
    bpp: {
        print: {
            // todo digital
            screenprint: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.PER_COLOUR,
                pricePerColour: 0.51
            },
            padprint: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.PER_COLOUR,
                pricePerColour: 0.51
            }
        },
        // none for laser
        laser: {
            laser: {
                firstColourIncluded: true,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 0.51
            },
            laserplus: {
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 1.08
            }
        },
        deboss: {
            deboss: { //uses leeds
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 1.08
            }
        },
        embroidery: {
            embroidery: {
                firstColourIncluded: false,
                runChargeType: mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC,
                staticPrice: 3.38
            }
        }
    }
}

var products;
// todo cacheproducts dependency workaround
var getProductCache = function() {
    if (products) {
        return products
    } else {
        products = getProducts();
        return products;
    }
}

isASignageProduct = function(product) {
    if (product) {
        return product.type == "Sticker"
    } else {
        return false
    }
}

    isAPatchProduct = function(product){
        if (product){
            return product.type == "Patch"
        } else {
            return false
        }
    }




function createPrint(type,location,numberOfColours,width,height, forceDtg, forceScreenPrint, forceVinyl,forceDft, screenPrintOptions){
    return{
        printType: type,
        forceDtg: forceDtg,
        forceDft: forceDft,
        forceScreenPrint: forceScreenPrint,
        forceVinyl : forceVinyl,
        location: location,
        numberOfColours: numberOfColours,
        width: width,
        height: height,
        screenPrintOptions :screenPrintOptions
    }
}

function createEmbroidery(type,location,width,height, applique, appliqueColours, patch, puff, subpatch, leather,leatherlabel, wovenlabel,wovenpatch){
    return{
        printType: type,
        location: location,
        width: width,
        height: height,
        puff : puff,
        applique : applique,
        appliqueColours : appliqueColours,
        patch : patch,
        subpatch:subpatch,
        leather : leather,
        leatherlabel : leatherlabel,
        wovenlabel : wovenlabel,
        wovenpatch : wovenpatch
    }
}

// to treat print types as 'Print' for suggestion calculations
function allPrintsToCalculate(allPrints){
    var data = []
    _.each(allPrints,function(location, index){
        var nameToUse = location.name ? location.name : index;
        if(location.printColours){
            data.push(createPrint("Print", nameToUse ,Number(location.printColours),location.width, location.height, location.forceDtg, location.forceScreenPrint, location.forceVinyl, location.forceDft, location.screenPrintOptions))
        }
        if (location.embroidery && location.embroidery.length > 0){
            _.each(location.embroidery, function(emb){
                data.push(createEmbroidery("Embroidery",nameToUse ,Number(emb.width),Number(emb.height),  emb.applique, emb.appliqueColours, emb.patch, emb.puff, emb.subpatch, emb.leather, emb.leatherlabel,emb.wovenlabel, emb.wovenpatch))
            })
        }
    })
    return data
}

var taxRate = {
    ab : {
        gst : 0.05,
        pst: 0
    },
    bc : {
        gst : 0.05,
        pst : 0.07
    },
    nl : {
        gst : 0.15,
        pst: 0
    },
    mb : {
        gst : 0.05,
        pst: 0
    },
    nb : {
        gst : 0.15,
        pst: 0
    },
    ns : {
        gst : 0.15,
        pst: 0
    },
    nu : {
        gst : 0.05,
        pst: 0
    },
    nt : {
        gst : 0.05,
        pst: 0
    },
    on : {
        gst : 0.13,
        pst: 0
    },
    pe : {
        gst : 0.15,
        pst: 0
    },
    qc : {
        gst : 0.05,
        pst: 0
    },
    sk : {
        gst : 0.05,
        pst: 0
    },
    yt : {
        gst : 0.05,
        pst: 0
    },
    notax : {
        gst : 0,
        pst: 0
    }
}

function getCanadianTaxRate (order, taxableAmount, province){
    function applyTaxRate(taxRate, order){
        if (taxRate.gst && !order.gstExempt){
            order.gst = taxRate.gst * taxableAmount
        } else {
            order.gst = 0
        }

        if (taxRate.pst && !order.pstExempt){
            order.pst = taxRate.pst * taxableAmount
        } else {
            order.pst = 0
        }
    }

    if (order.shippingType == "Pick Up" ){
        if (order.pickUpLocation == "VANCOUVER"){
            var bcTaxRate = taxRate["bc"]
            applyTaxRate(bcTaxRate, order)
        } else if (order.pickUpLocation == "TORONTO"){
            var onTaxRate = taxRate["on"]
            applyTaxRate(onTaxRate, order)
        }
    } else if (order.shippingType == "Ship" || order.shippingType == "Split Ship"){
        if (order.shippingAddress.country.toLowerCase() == "ca"){
            province = province.toLowerCase().trim()
            var stateTaxRate = taxRate[province]
            if (stateTaxRate) {
                applyTaxRate(stateTaxRate, order)
            } else {
                applyTaxRate(taxRate["notax"],order)
            }
        } else {
            applyTaxRate(taxRate["notax"],order)
        }
    } else {
        applyTaxRate(taxRate["notax"],order)
    }
}

function onlyTransfersAllowed (category){
    return !category.printAllowed.screenPrint  && category.printAllowed.transfer
}

function onlyEmbroideryAllowed(category){
    if(category && category.printAllowed && !category.printAllowed.screenPrint && !category.printAllowed.transfer){
        return true
    } else {
        return false
    }
}

function createDummyItemLine(product, quantity) {
    // Initialize default values
    var colorToUse = null;
    var colorPrice = null;
    
    // Get the first color for reference (for name, etc.)
    if (product && product.colours && product.colours.length > 0) {
        colorToUse = product.colours[0];
        
        // If pre-calculated cheapest price exists, use it directly
        if (product.productPricing && product.productPricing.cheapestColorPrice !== undefined) {
            colorPrice = product.productPricing.cheapestColorPrice;
        } else {
            colorPrice = colorToUse.price;
        }
    }
    
    return {
        details: {
            colourName: colorToUse ? colorToUse.name : '',
            size: product.sizes && product.sizes.length > 0 ? [product.sizes[0]] : [],
            quantity: [quantity],
            // Pass the cheapest color price to be used in calculate later
            colourPriceOverride: colorPrice
        },
        print: [],
        customization: {},
        price: 0,
        totalQty: quantity,
        sku: product.sku,
        productName: product.name,
        printSupplier: 'In House'
    }
}

function calculateAveragePricePromo(product, quantity) {
    // get cheapest print method available for the promotional product
    var prices = _.map(product.promoPrintMethods, function(printMethod) {
        var itemLine = createDummyItemLine(product, quantity);
        itemLine.print.push({
            name: 'Test',
            printType: printMethod,
            printColours: 1,
            embroidery: []
        });
        var calculationObject = recalculateCart([itemLine], [product]);
        return {
            printMethod: printMethod,
            error : calculationObject.error,
            quantity: quantity,
            price: itemLine.price
        };
    })
    var sortedPrices = _.sortBy(prices, function(priceObject) {
        return priceObject.price;
    })

    return {
        price : sortedPrices[0].price,
        description : "For a one colour print on one location.",
        error :sortedPrices[0].error
    }
}

function createStickerPrint(width, height) {
    return {
        name: 'Sticker Print',
        width: width,
        height: height,
        printType: "Vinyl",
        printColours: 30,
        forceVinyl: true,
        embroidery: []
    }
}

function createPatchPrint(sku, width, height) {
    var print = [];
    if (sku === "PATCH"){
        print = [{
            name : "Patch",
            printType: "Embroidery",
            pmsColours: [],
            embroidery :[{width:width, height:height, patch: true}]
        }]
    } else if (sku === "SUBPATCH"){
        print = [{
            name : "Patch",
            printType: "Embroidery",
            pmsColours: [],
            embroidery :[{width:width, height:height, subpatch: true}]
        }]
    } else if (sku === "LEATHERPATCH"){
        print = [{
            name : "Patch",
            printType: "Embroidery",
            pmsColours: [],
            embroidery :[{width:width, height:height, leather: true}]
        }]
    } else if (sku === "WOVENPATCH"){
        print = [{
            name : "Patch",
            printType: "Embroidery",
            pmsColours: [],
            embroidery :[{width:width, height:height, wovenpatch: true}]
        }]
    }

    return print;
}

function calculateAveragePrice(product, quantity, category) {
    if (!product){
        return
    }

    if (product.type == "Promotional Product") {
        return calculateAveragePricePromo(product, quantity);
    } else {
        var description
        var price
        var error
        var itemLines = [createDummyItemLine(product, quantity)];

        if (product.type == "Sticker") {
            itemLines[0].print.push(createStickerPrint(3, 3))
            description = "For a 3 by 3 inch sticker."
        } else if(product.category == "Patches") {
            itemLines[0].print = createPatchPrint(product.sku, 3, 3);
            description = "For a 3 by 3 inch patch."
        } else if (product.category == "Sublimation") {
            description = "For a full colour product."

        } else if (onlyEmbroideryAllowed(category)) {
            description = "For a standard sized embroidery on one location."
            itemLines[0].print.push({
                name: "front",
                width: 3,
                height: 2,
                embroidery: [{}]
            })
        } else {
            description = "For a standard one colour print on one location."
            itemLines[0].print.push({
                name: "front",
                printColours: 1,
                width: 3,
                height: 2,
                embroidery: []
            })
        }
        var details = recalculateCart(itemLines, [product], null, null, [category])
        error = details.error
        price = itemLines[0].price

        return {
            price : price,
            description : description,
            error : error
        }
    }


}

/**
 *
 * @param width
 * @param height
 * @param numberOfColours
 * @param totalQty
 * @param complexity - a number from 1 - 2, 2 should be the maximum you can "multiply" the design by. Customer service reps judgement on how complex artwork is.
 */

function checkMeasurementAndRoundAccuracy(measurement,height){
    if (_.isUndefined(measurement) || _.isNaN(measurement) || _.isNull(measurement) || measurement <= 0){
        if (height){
            measurement = 2
        } else {
            measurement = 3
        }

    }
    return Math.ceil(measurement)
}

function dftPrintC(qty, product, type, width, height){
    //https://docs.google.com/spreadsheets/d/1TJWZCPCw7Wni0lvbJv1GTDF8TNczC4YrKE-5sMxUUag/edit#gid=0
    width = checkMeasurementAndRoundAccuracy(width)
    height = checkMeasurementAndRoundAccuracy(height, true)

    var areaOfPrint = width * height
    var setup = 20.91; //annual increase prone
    var consumablesOfFullFront = 2.09 //annual increase prone
    var areaOfFullfront = 12 * 12
    var printCost = pressCost + (areaOfPrint / areaOfFullfront) * consumablesOfFullFront
    var variableCost = printCost + setup/qty
    // console.log("DTF COST : " + variableCost)
    return variableCost
}

function dtgPrintC(qty, product, type, width, height){
    width = checkMeasurementAndRoundAccuracy(width)
    height = checkMeasurementAndRoundAccuracy(height, true)

    var areaOfPrint = width * height
    var setup = 5.69; //annual increase prone
    var pT
    var ppI
    var bC;


    type = "black"


    if (type.toLowerCase() == "white"){
        bC = 5.00  //$3.32 -> $4.00 (Labour Increase) Feb 14th 2021
        pT = 1.5
        ppI = 0.02
    } else {
        bC = 5.00 //$3.32 -> $4.00 (Labour Increase) Feb 14th 2021
        pT = 1.5
        ppI = 0.03 * 0.8 // average 80% coverage on an order
    }
    //https://docs.google.com/spreadsheets/d/1NtnInO4wHNzDjilfZd86T0x8OmHD5Lujo-y8MC8F4fU/edit#gid=0
    var printCost = bC + (areaOfPrint * ppI) + pT
    return printCost + setup/qty
}

function qtyCategory(qty) {
    var QTYCAT = 0;
    if (qty >= 1 && qty <= 49) {
        QTYCAT = 1;
    }
    if (qty >= 50 && qty <= 99) {
        QTYCAT = 2;
    }
    if (qty >= 100 && qty <= 299) {
        QTYCAT = 3;
    }
    if (qty >= 300 && qty <= 599) {
        QTYCAT = 4;
    }
    if (qty >= 600) {
        QTYCAT = 5;
    }
    return QTYCAT;
}

//type: deprecated
function calculateScreenPrint(numberOfColours, type, numberOfPrints, screenPrintOptions) {
    if (numberOfColours == 0) {
        return {
            runCharge: 0,
            fixedCost: 0
        }
    }

    var printType = mS.PRINT_TYPES.SCREEN_PRINT;
    var runCharge = 0;
    var fixedCost = 0;
    var filmAndScreen = 20.91; //annual increase prone

    if (numberOfPrints){
    } else {
        numberOfPrints = 1
    }

    var designFee = 31.36 / numberOfPrints; //annual increase prone
    numberOfColours = numberOfColours + 1

    runCharge = (0.96) + (numberOfColours * 0.3248); //annual increase prone
    fixedCost = ((numberOfColours) * filmAndScreen) + designFee;

    if (screenPrintOptions){
        if(screenPrintOptions.puff){
            var puffCharge = 3.045 //annual increase prone
            runCharge = runCharge + ( (numberOfColours - 1) * puffCharge)
            printType = mS.SPECIALTY_PRINTS.PUFF_PRINT;
        } else if (screenPrintOptions.spotProcess){
            var spotProcessSurcharge = 1.2
            var spotProcessSetupsSurcharge = 2
            runCharge = runCharge * spotProcessSurcharge //20% more for spot process.
            fixedCost = fixedCost * spotProcessSetupsSurcharge
            printType = mS.SPECIALTY_PRINTS.SPOT_PROCESS;
        }
    }
    return  {
        printType: printType,
        runCharge: runCharge,
        fixedCost: fixedCost
    }
}

function calculateApplique (numberOfColours){
    return {
        printType: mS.SPECIALTY_PRINTS.APPLIQUE,
        runCharge: numberOfColours * 10.45 ,  //annual increase prone
        fixedCost: 57.49,  //annual increase prone
        errors: []
    }
}

function calculateWovenLabel(width, height, totalQty, wovenlabel, wovenpatch){
//https://docs.google.com/spreadsheets/d/1Pnsrw6L7YS_hKHKKwjJC4kb9WMiq_vD5qA3VkYaG624/edit#gid=0
    var applicationFee
    var errors = [];
    var printType;
    if(wovenlabel){
        printType = mS.SPECIALTY_PRINTS.WOVEN_LABEL;
        applicationFee = sewnOnTagsCost
    } else if (wovenpatch) {
        printType = mS.SPECIALTY_PRINTS.WOVEN_PATCH;
        applicationFee = pressCost
    } else {
        // default
        printType = mS.SPECIALTY_PRINTS.WOVEN_PATCH;
        applicationFee = pressCost
    }
    var labelcost = 0
    var setupCost = 26.13 //annual increase prone
    var grid
    var minOrder = 25

    if (height > 3.5 || width > 3.5) {
        errors.push({
            message: 'Max dimensions for a woven patch is 3.5 inches',
            showModal: true
        })
    }

    if (totalQty < 50){
        grid = [
            {size : 1 , price : 5.17},
            {size : 1.5 , price : 5.33},
            {size : 2 , price : 6.34},
            {size : 2.5 , price : 7.30},
            {size : 3 , price : 7.46},
            {size : 3.5 , price : 11.79}
        ]
    } else if (totalQty >= 50 && totalQty < 100){
        grid = [
            {size : 1 , price : 3.36},
            {size : 1.5 , price : 4.16},
            {size : 2 , price : 5.23},
            {size : 2.5 , price : 5.33},
            {size : 3 , price : 6.02},
            {size : 3.5 , price : 7.30}
        ]
    } else if (totalQty >= 100  && totalQty < 200){
        grid = [
            {size : 1 , price : 1.94},
            {size : 1.5 , price : 2.16},
            {size : 2 , price : 2.75},
            {size : 2.5 , price : 2.90},
            {size : 3 , price : 3.17},
            {size : 3.5 , price : 3.70}
        ]
    } else if (totalQty >= 200 && totalQty < 500 ){
        grid = [
            {size : 1 , price : 1.33},
            {size : 1.5 , price : 1.42},
            {size : 2 , price : 1.58},
            {size : 2.5 , price : 1.70},
            {size : 3 , price : 1.79},
            {size : 3.5 , price : 1.97}
        ]
    } else if (totalQty >= 500 && totalQty < 1000){
        grid = [
            {size : 1 , price : 0.83},
            {size : 1.5 , price : 0.88},
            {size : 2 , price : 0.99},
            {size : 2.5 , price : 1.02},
            {size : 3 , price : 1.09},
            {size : 3.5 , price : 1.18}
        ]
    } else if (totalQty >= 1000) {
        grid = [
            {size : 1 , price : 0.53},
            {size : 1.5 , price : 0.54},
            {size : 2 , price : 0.62},
            {size : 2.5 , price : 0.64},
            {size : 3 , price : 0.67},
            {size : 3.5 , price : 0.69}
        ]
    }

    var measurementDevice = (width + height) / 2
    var correctGrid = _.find(grid, function(object){
        return     measurementDevice <= object.size
    })
    if (correctGrid) {
        labelcost = correctGrid.price
    }

    if (labelcost <= 0 || _.isUndefined(labelcost) || _.isNull(labelcost)){
        labelcost = 0
    }

    if (totalQty < minOrder){
        labelcost = labelcost * minOrder / totalQty
    }

    return {
        printType: printType,
        runCharge: labelcost + applicationFee,
        fixedCost: setupCost,
        errors: errors
    }
}

function calculateEmbroidery(options) {

    var width = options.width;
    var height = options.height;
    var totalQty = options.totalQty;
    var patch = options.patch;
    var puff = options.puff;
    var subpatch = options.subpatch;
    var leather = options.leather;
    var leatherlabel = options.leatherlabel;
    var wovenlabel = options.wovenlabel;
    var wovenpatch = options.wovenpatch;

    var printType = mS.PRINT_TYPES.EMBROIDERY; // default
    var roundedWidth = checkMeasurementAndRoundAccuracy(width)
    var roundedHeight = checkMeasurementAndRoundAccuracy(height, true)
    var standardLeftChestStitchCount = 15000
    var embroideryLoadingCost = 2.87 //annual increase prone
    var costForStandardLeftChest = 1.71 //annual increase prone
    var leftChestArea = 8 // 4 inches wide by 2 inches tall.
    var areaOfDesign = roundedWidth * roundedHeight
    var minStitchCount = 10000 // it costs money to setup the embroidery design
    var maxStitchCount = 50000 //andrew chus designs are around 40,000 stitch count and thats rare.
    var fixedCost = 0;
    var maxSetupFee = 80.49 //annual increase prone
    var fixedCostPerThousandStitchCount = 4.02 //annual increase prone
    //4 by 2 inches is 7000 stitches
    var stitchCount = Math.max((areaOfDesign / leftChestArea) * standardLeftChestStitchCount, minStitchCount ); //min stitch count is 5000
    stitchCount = Math.min(stitchCount, maxStitchCount)  //max stitch count is 70,000
    fixedCost = ((stitchCount / 1000) * fixedCostPerThousandStitchCount); //
    fixedCost = Math.min(maxSetupFee, fixedCost); //max fixed cost is 100 for embroidery
    var runCharge = (costForStandardLeftChest * (stitchCount/standardLeftChestStitchCount)) + embroideryLoadingCost
    var patchSurcharge = 0
    var puffSurcharge = 0
    if (patch || subpatch || leather || leatherlabel){
        if (patch) {
            printType = mS.SPECIALTY_PRINTS.EMBROIDERED_PATCH;
        }
        if (subpatch) {
            printType = mS.SPECIALTY_PRINTS.SUBLIMATED_PATCH;
        }
        if (leather) {
            printType = mS.SPECIALTY_PRINTS.LEATHER_PATCH;
        }
        if (leatherlabel) {
            printType = mS.SPECIALTY_PRINTS.LEATHER_LABEL;
        }
        patchSurcharge = 3.65  //annual increase prone
    }

    if (wovenlabel || wovenpatch){
        return calculateWovenLabel(width, height, totalQty, wovenlabel, wovenpatch)
    }

    if (puff){
        printType = mS.SPECIALTY_PRINTS.PUFF_EMBROIDERY;
        puffSurcharge = 3.13 //annual increase prone
    }
    return {
        printType: printType,
        runCharge: runCharge + patchSurcharge + puffSurcharge,
        fixedCost: fixedCost,
        errors: [],
    }
}


//// selections: [name,colourType,qtyBreakdown,name,price]
function calculateSublimationPrice(selection, product){
    var indexOf2XL = product.sizes.indexOf("2XL");
    var garmentTotals = calculateGarmentCost(selection, indexOf2XL, product);
    var totalQty = garmentTotals.totalQty
    var garmentCost = garmentTotals.garmentCost + product.setupCost
    var errors = [];

    if (product && product.minimumOrder && (totalQty <  product.minimumOrder) ){
        var errorMsg = product.name + " has a minimum order of " + product.minimumOrder + " units. Please add more units than the minimum order."
        errors.push({
            message: errorMsg
        })
    }

    var sublimationSetupCost = 20.90  //annual increase prone
    var sublimationMarkup = 1.8975

    return {
        totalQty: totalQty,
        totalSetup : 0,
        totalCost: (sublimationMarkup * (garmentCost + sublimationSetupCost)).toFixed(2),
        errors: errors,
    }
}

/**
 *   Calculate promo pricing. Consists of:
 *      1) Product Price, which is pricing matrix metadata found from the product itself
 *      2) Run Charge, depending on which print was selected --> object found in promoProductRunCharges
 *      3) Setup Charge, depending on which print was selected --> found in promoProductSetupFees
 *
 * @param product
 * @param selection //[name,colourType,qtyBreakdown,name,price]
 * @param allPrints
 */
function calculatePromoProductPrice(product, selection, allPrints) {
    var productCost = 0;
    var totalQty = 0;
    var totalSetup = 0;
    var runCharge = 0;

    for (var a = 0; a < selection[2].length; a++) {
        totalQty += selection[2][a];
    }

    let foundColour = _.find(product.colours, function(colour) {
        return colour.name === selection[3];
    });

    // Validation

    // 1) if any print location ha  s more than max colours, throw
    _.forEach(allPrints, function(print) {
        var maxPrintColours = 4;
        if (print.printType === mS.PROMO_PRINT_NAME.EMBROIDERY) {
            maxPrintColours = 12;
        }
        if (print.printColours > maxPrintColours) {
            throw Error(print.name + ' location contains ' +  print.printColours + ' colours which exceeds the limit of ' + maxPrintColours + '. Please reduce the number of colours in your print.');
        }
    });
    if (_.isEmpty(foundColour)) {
        throw Error('Color was not found');
    }

    var priceMatrix;
    if (_.isEmpty(foundColour.customPrice)) {
        throw Error('Color is missing a pricing table');
    } else {
        priceMatrix = foundColour.customPrice.priceThresholds;
    }

    var belowMinOrderMarkup = 0;
    var columnIndex = _.findLastIndex(priceMatrix, function (priceThreshold) {
        return totalQty >= priceThreshold.qty;
    });
    if (columnIndex === -1) {
        //Add flat min fee if less than first column, then treat as first qty column
        belowMinOrderMarkup += PCNAPromoProductMinimumOrderFlatFee
        columnIndex = 0;
    }

    var matchingPriceThreshold = priceMatrix[columnIndex];
    var quantityPricing = matchingPriceThreshold.cost;
    // lpp bpp EQP
    if (product.sCode === 'lpp' || product.sCode === 'bpp') {
        quantityPricing = priceMatrix[priceMatrix.length - 1].cost;
    }

    // Product cost
    productCost = quantityPricing * totalQty * getDiscountedPriceFromCode(matchingPriceThreshold.pricingCode);

    // Setup + run charge costs
    // todo: print Suggestions do not recommend anything atm
    var printSuggestions = [];
    _.forEach(allPrints, function(print, printLocationIndex) {
        var decorationMethodCosts = calculateDecorationMethodCost(product, print, columnIndex, printLocationIndex)
        addPrintSuggestion(printSuggestions, print.name, decorationMethodCosts.printType, printLocationIndex);
        runCharge += decorationMethodCosts.runCost * totalQty;
        totalSetup += decorationMethodCosts.setUpCost;
    })

    // console.log('Markup: '+ markup);
    var promoMarkup = getPromoProductMarkup(totalQty);
    var chargePrice = (((productCost + runCharge + totalSetup + belowMinOrderMarkup) * promoMarkup * PCNAShippingMarkup) + PCNAPromoProductRushProductionFee);
    return {
        totalQty: totalQty,
        // do not have reorder discount for promo products
        totalSetup : 0,
        totalCost: chargePrice.toFixed(2),
        printSuggestions : printSuggestions
    }
}

/* for contract sku */
function calculatePromoProductNotOnSiteCost(promotionalPricingData, totalQty) {
    var currency = promotionalPricingData.currency ? promotionalPricingData.currency : 'CAD';
    var price = promotionalPricingData.price ? promotionalPricingData.price : 0;
    var priceCode = promotionalPricingData.priceCode ? promotionalPricingData.priceCode : "";
    var runCharge = promotionalPricingData.runCharge ? promotionalPricingData.runCharge : 0;
    var runChargeCode = promotionalPricingData.runChargeCode ? promotionalPricingData.runChargeCode : "";
    var setUpCost = promotionalPricingData.setUpCost? promotionalPricingData.setUpCost : 0;
    var setUpCostCode = promotionalPricingData.setUpCostCode ? promotionalPricingData.setUpCostCode : 0;
    var shippingCost = promotionalPricingData.shippingCost ? promotionalPricingData.shippingCost : 0;

    var totalCost = ((runCharge * (getDiscountedPriceFromCode(runChargeCode)) + price * (getDiscountedPriceFromCode(priceCode))) * totalQty) + (setUpCost * (getDiscountedPriceFromCode(setUpCostCode)));

    // duties
    if (currency === 'USD') {
        var percentDuties = promotionalPricingData.percentageDuties ? promotionalPricingData.percentageDuties : 0;
        var fixedDuties = promotionalPricingData.duties ? promotionalPricingData.duties: 0;

        if (promotionalPricingData.isFixedDuties) {
            totalCost += fixedDuties;
        } else {
            totalCost += (totalCost * (percentDuties / 100))
        }
    }

    return totalCost + shippingCost
}

function calculatePromoProductNotOnSitePrice(promotionalPricingData, totalQty) {
    var totalCost = calculatePromoProductNotOnSiteCost(promotionalPricingData, totalQty);
    var currencyConversion = promotionalPricingData.currency === 'USD' ? USDToCADExchange : 1;
    var promoMarkup = getPromoProductMarkup(totalQty);
    var chargePrice = totalCost * promoMarkup * currencyConversion;

    return {
        totalQty: totalQty,
        totalSetup : 0,
        totalCost: (chargePrice).toFixed(2),
        errors: []
    }
}

/**
 * Calculate setup and print fees for a given decoration method.
 * @param product
 * @param print
 * @param qtyColumnIndex
 * @param printLocationIndex
 * @return
 */
function calculateDecorationMethodCost(product, print, qtyColumnIndex, printLocationIndex) {
    var determinedPrintType;
    // If from public entry we need to switch from print group to to a specific print type
    var promoProductPrintGroup = promoProductDecorationGrouping[print.printType.toLowerCase()];
    if (promoProductPrintGroup) {
        if (!product.promoPrintMethods) {
            throw new Error('Product is not configured with any print methods');
        }
        // this is actually a print group, not a specific type --> return a default type
        var specificPrintType = _.find(promoProductPrintGroup.list, function (printType) {
            return product.promoPrintMethods.includes(printType);
        })
        if (!specificPrintType) {
            throw new Error('Product is not configured to be printed with ' + promoProductPrintGroup.name);
        }
        determinedPrintType = specificPrintType;
    } else {
        determinedPrintType = print.printType;
    }

    if (!product.promoPrintMethods.includes(determinedPrintType)) {
        throw new Error('Product is not configured to be printed with ' + determinedPrintType);
    }

    var supplierCode;
    if (product.sCode) {
        supplierCode = product.sCode;
    } else {
        // default to leeds
        supplierCode = 'lpp';
    }

    // multi or single
    var multiColour;
    if (print.printColours > 1) {
        multiColour = 'multi'
    } else {
        multiColour = 'single'
    }

    // get decoration group key
    var printGroupKey = _.findKey(promoProductDecorationGrouping, function (printMethodGroup) {
        return printMethodGroup.list.includes(determinedPrintType);
    });

    var setupMatrix = promoProductSetupFees[printGroupKey];
    if (!setupMatrix) {
        setupMatrix = promoProductSetupFees.default;
    }

    var setupCost = setupMatrix[multiColour] * getDiscountedPriceFromCode(promoProductSetupFees.code);
    var supplierRunCharge = promoProductRunCharges[supplierCode]
    if (!supplierRunCharge) {
        console.log('Promo Product: ' + product.sku + ' has unhandled supplier code ' + product.sCode);
        supplierRunCharge = promoProductRunCharges.lpp;
    }

    var printGroupRunCharge = supplierRunCharge[printGroupKey]
    if (!printGroupRunCharge) {
        throw new Error('Supplier: ' + supplierCode + ' is not configured to be printed with group ' + printGroupKey);
    }

    var printRunCharge = printGroupRunCharge[determinedPrintType.replace(/\s/g,'').toLowerCase()];
    if (!printRunCharge) {
        throw new Error('Supplier: ' + supplierCode + ' is not configured to be printed with ' + determinedPrintType);
    }

    var firstLocation = 0;
    if (printLocationIndex === 0) {
        firstLocation = 1;
    }

    var runCharge = 0;
    switch(printRunCharge.runChargeType) {
        case mS.PROMO_PRODUCT_RUNCHARGE_TYPE.PER_COLOUR:
            if (printRunCharge.firstColourIncluded && firstLocation && print.printColours === 1) {
                runCharge = 0;
            } else {
                runCharge = printRunCharge.pricePerColour * (firstLocation ? (print.printColours - 1): print.printColours);
            }
            break;
        case mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STATIC:
            if (printRunCharge.firstColourIncluded && firstLocation) {
                runCharge = 0;
            } else {
                runCharge = printRunCharge.staticPrice;
            }
            break;
        // todo:
        case mS.PROMO_PRODUCT_RUNCHARGE_TYPE.STEP:
        default:
            throw new Error('Supplier: ' + supplierCode + ' Print type: ' + determinedPrintType + ' run charge type ' + printRunCharge.type + ' is not configured');
    }
    var runCost = runCharge * getDiscountedPriceFromCode(promoProductRunCharges.code);
    // console.log('Run Charge Net: ' + runCost);
    return {
        printType: determinedPrintType,
        setUpCost: setupCost,
        runCost: runCost
    }
}

/**
 * Return percentage markup for promo. Sliding scale starting at 165% --> 148.5% from 100 units to 500 units
 * @param quantity
 */

function getPromoProductMarkup(quantity) {
    var lowestMarkup = 1.40
    const priceRanges = [
        { startQty: 0, finishQty: 100, startP: 1.65, finishP: 1.65 },
        { startQty: 100, finishQty: 500, startP: 1.65, finishP: lowestMarkup }
    ];
    for (const range of priceRanges) {
        if (quantity >= range.startQty && quantity <= range.finishQty) {
            const m = range.startP - ((range.startP - range.finishP) / (range.finishQty - range.startQty)) * (quantity - range.startQty);
            return m;
        }
    }
    return lowestMarkup
}

    function seeIfMisMatchSupplierAndProduct(product, suppliers) {
        var misMatchSuppliers = _.filter(suppliers, function (supplier) {
            var supplierCurrency = supplier.currency ? supplier.currency : supplier.supplierCurrency
            return (supplier && supplierCurrency && (supplierCurrency.toLowerCase() == "usd"))
                &&
                (product && product.countryOrigin && (product.countryOrigin.toLowerCase() == "ca"))
        })
        return misMatchSuppliers
    }

    // selection: [name,colourType,qtyBreakdown,name,price]
    // qtyBreakdown: [0, 2, 3, 4]
function calculateGarmentCost(selection, indexOf2XL, product, itemLine, suppliers, itemLinesInGroup) {
    var garmentCost = 0;
    var totalQty = 0;
    var usdQty = [];

    if (itemLine && itemLine.grmtSuppliers && suppliers) {
        var misMatchSuppliers = seeIfMisMatchSupplierAndProduct(product, itemLine.grmtSuppliers);
        if (misMatchSuppliers.length >= 1) {
            if (itemLine.grmtSuppliers.length === 1) {
                // if 1 garment supplier defined, assume garments coming from it
                usdQty = selection[2]
            } else {
                // count usd quantities
                _.forEach(misMatchSuppliers, function (misMatchSupplier) {
                    _.forEach(misMatchSupplier.sizeBreakdown.qty, function (qtyAmount, index) {
                        usdQty[index] ? usdQty[index] += qtyAmount : usdQty[index] = qtyAmount;
                    });
                })
            }
            // add fixed markup anytime usa supplier mismatch
            garmentCost += (borderDutiesFixed / itemLinesInGroup) //40 is the fixed cost to get someting over the border.
        }
    }

    for (var a = 0; a < selection[2].length; a++) {
        totalQty = totalQty + selection[2][a];
        var perUnitPrice = selection[4];
        if (selection[2][a] && indexOf2XL > 2){
            var additionalSizePrice = 0;
            if (a >= indexOf2XL) {
                additionalSizePrice = product.sizePricing.doubleXL
            }
            if (a > indexOf2XL && product.sizePricing.tripleXL) {
                additionalSizePrice = product.sizePricing.tripleXL
            }
            perUnitPrice += additionalSizePrice;
        }

        var usdSupplierMarkup = 0;
        if (usdQty && usdQty[a]) {
            // usdQty cannot exceed more than quantity defined in size breakdown
            var misMatchSupplierQty = _.min([usdQty[a], selection[2][a]])
            usdSupplierMarkup = ((perUnitPrice * dutiesAndTaxMarkup) - perUnitPrice) * misMatchSupplierQty
            // console.log('Markup for usa ' + misMatchSupplierQty + ' units: ' + usdSupplierMarkup);
        }

        garmentCost += (selection[2][a] * perUnitPrice) + usdSupplierMarkup
    }

    if (product && product.category && product.category.toLowerCase() == "masks"){
        // mask markup
        garmentCost = garmentCost + 1;
    }

    if (product && product.countryOrigin && (product.countryOrigin.toLowerCase() == "us")){
        garmentCost = garmentCost * dutiesAndTaxMarkup * USDToCADExchange //duties and taxes ~1.67, make sure this is the same in order places
    }


    return {
        garmentCost: garmentCost, // total accumulated value for this line
        totalQty: totalQty
    };
}

function getAmountWithinRange(startP, startQty, finishP, finishQty, quantity){
    var m
    if (quantity > finishQty){
        m = finishP
    } else if (quantity <= startQty) {
        m = startP
    } else {
        m = startP - (((startP - finishP)/(finishQty - startQty)) * (quantity - startQty))
    }
    return m
}

function getMGarment(priceOfItem, quantity){
    var startP = 1.947
    var startPrice = 15

    var secondP = 1.6938
    var secondTierPrice = 26

    var thirdP = 1.50
    var thirdTierPrice = 100

    var m
    if (priceOfItem < startPrice){
        m = startP
    } else if (priceOfItem >= startPrice && priceOfItem <= secondTierPrice){
        m = getAmountWithinRange(startP,startPrice, secondP,secondTierPrice,priceOfItem)
    } else if (priceOfItem >= secondTierPrice && priceOfItem <= thirdTierPrice) {
        m = getAmountWithinRange(secondP,secondTierPrice, thirdP, thirdTierPrice, priceOfItem)
    } else if (priceOfItem > thirdTierPrice){
        m = thirdP
    } else {
        m = startP
    }
    return Math.min(m,getM(quantity))
}

function getM(quantity) {
    var lowestMarkup = 1.40
    const priceRanges = [
        { startQty: 0, finishQty: 24, startP: 1.947, finishP: 1.947 },
        { startQty: 24, finishQty: 100, startP: 1.947, finishP: 1.87 },
        { startQty: 100, finishQty: 200, startP: 1.87, finishP: 1.87 },
        { startQty: 200, finishQty: 600, startP: 1.87, finishP: 1.595 },
        { startQty: 600, finishQty: 1000, startP: 1.595, finishP: 1.595 },
        { startQty: 1000, finishQty: 3000, startP: 1.595, finishP: lowestMarkup}
    ];
    for (const range of priceRanges) {
        if (quantity >= range.startQty && quantity <= range.finishQty) {
            const m = range.startP - ((range.startP - range.finishP) / (range.finishQty - range.startQty)) * (quantity - range.startQty);
            return m;
        }
    }
    return lowestMarkup
}

//selections: //[name,colourType,qtyBreakdown,name,price]
calculateStickerPricing = function(product, allPrints, selections){
    // https://docs.google.com/spreadsheets/d/1CwrRoH9PdZtVjPYcZHG0MiVNkVRrd6NrtDUkqkbv5ts/edit#gid=0
    var variablePriceOfSticker = product.colours[0].price
    var setupCost = product.setupCost
    var area = allPrints[0].width * allPrints[0].height
    var quantity = 0
    var errors = []

    _.each(selections, function (selection) {
        var garmentTotals = calculateGarmentCost(selection, 10000, product)
        quantity = garmentTotals.totalQty + quantity;
    })

    if (area === 0) {
        errors.push({
            message: 'Please enter a width and height greater than 0 for your print.'
        })
    }

    var totalCost = ((((variablePriceOfSticker * area) + 0.0625) * quantity) + setupCost) * 3.27777

    var stickerMarkup = 1.32 //Added September 24th 2022 to increase sticker pricing

    return {
        totalQty: quantity,
        totalSetup : 0,
        totalCost: (totalCost * stickerMarkup).toFixed(2), //
        errors: errors
    }

}

function addPrintSuggestion(printSuggestions, location, printType, printLocationIndex){
    if (printSuggestions) {
        if (!_.find(printSuggestions, function (printSuggestion) {
            return printSuggestion.location == location
                && printSuggestion.printType == printType
                && printSuggestion.printLocationIndex == printLocationIndex
        })) {
            printSuggestions.push({
                location: location,
                printLocationIndex: printLocationIndex,
                printType: printType
            })
        }
    }
}

function addPrintCharge(printChargeArray, location, printType, cost, print) {
    // treat + sum grouped prints as one total charge
    if (printChargeArray) {
        var existingPrintCharge = _.find(printChargeArray, function(printCharge) {
            return printCharge.metadata.location == location && printCharge.printType == printType
        });
        //
        if (!existingPrintCharge) {
            printChargeArray.push({
                printType: printType,
                totalCost: cost,
                metadata: print
            })
        } else {
            existingPrintCharge.totalCost += cost;
        }
    }
}

// selections: [[name,colourType,qtyBreakdown,name,price]]
calculatePrice = function (product, selections, allPrints, numberOfIndividualNames, numberOfIndividualNumbers,totalCsFeeForItem, itemLine, supplier, category) {
    var totalSetup = 0;

    //todo: this assumes 2xl index is always '2xl, does not work for toddler/kid sizes
    var indexOf2XL = product.sizes.indexOf("2XL");
    var garmentCost = 0
    var totalQty = 0
    var errors = [];
    // console.log("All Prints")
    // console.log(allPrints)

    _.each(selections, function (selection) {
        if (_.isNull(selection[4]) || _.isUndefined(selection[4])){
            var missingPrice = "Please enter a price for your product"
            errors.push({
                message: missingPrice,
            })
        }
        var garmentTotals = calculateGarmentCost(selection, indexOf2XL, product, itemLine, supplier, selections.length)
        totalQty = garmentTotals.totalQty + totalQty;
        garmentCost = garmentTotals.garmentCost + garmentCost;
    })

    if (product && product.countryOrigin && (product.countryOrigin.toLowerCase() == "us")){
        garmentCost = garmentCost + borderDutiesFixed //duties and taxes.
    }

    var QTYCAT = qtyCategory(totalQty)
    var embroideryFixedCost = 0
    var embroideryVariableCost = 0

    var printCost  = 0
    var printSuggestions = []
    var printCharges = [];

    // each group
    _.each(selections, function (selection) {
        var quantityForSelection = _.reduce(selection[2], function (memo, num) {
            return memo + num;
        }, 0);
        _.each(allPrints, function (currentPrint, printLocationIndex) {
            var numberOfScreenPrints = _.filter(allPrints, function(print){
                return print.printType == "Print"
            }).length

            if (currentPrint.printType == "Print") {
                var totalDtgPrintCost = 0
                var dtgCostForPrint = (dtgPrintC(totalQty, product,selection[1], currentPrint.width, currentPrint.height) * quantityForSelection);
                totalDtgPrintCost = totalDtgPrintCost + dtgCostForPrint;

                var totalDftPrintCost = 0
                var dtfCostForPrint = (dftPrintC(totalQty, product,selection[1], currentPrint.width, currentPrint.height) * quantityForSelection)
                totalDftPrintCost = totalDftPrintCost + dtfCostForPrint

                var totalScreenPrintCost = 0
                var spCost = calculateScreenPrint(currentPrint.numberOfColours, selection[1], numberOfScreenPrints, currentPrint.screenPrintOptions)
                var spCostForPrint = (spCost.fixedCost * (quantityForSelection/totalQty)) + (spCost.runCharge * quantityForSelection)
                totalScreenPrintCost = totalScreenPrintCost + spCostForPrint
                if (currentPrint.forceDtg){
                    printCost = printCost + totalDtgPrintCost
                    addPrintSuggestion(printSuggestions, currentPrint.location,"DTG", printLocationIndex)
                    addPrintCharge(printCharges, currentPrint.location, "DTG", dtfCostForPrint, currentPrint)
                } else if (currentPrint.forceScreenPrint) {
                    printCost = printCost + totalScreenPrintCost
                    addPrintSuggestion(printSuggestions, currentPrint.location,'Screen Print', printLocationIndex)
                    addPrintCharge(printCharges, currentPrint.location, spCost.printType, spCostForPrint, currentPrint)
                    totalSetup = totalSetup + spCost.fixedCost * (quantityForSelection/totalQty); // DTG has no setup cost.
                } else if (currentPrint.forceDft){
                    printCost = printCost + totalDftPrintCost
                    addPrintSuggestion(printSuggestions, currentPrint.location,"DFT", printLocationIndex)
                    addPrintCharge(printCharges, currentPrint.location, "DFT", dtfCostForPrint, currentPrint)
                }  else {
                    if (currentPrint.numberOfColours > 6 || (category && onlyTransfersAllowed(category))){
                        printCost = printCost + totalDftPrintCost   //02/14/2022 change to DTG, since vinyl was taken over by DTF printing.
                        addPrintSuggestion(printSuggestions, currentPrint.location,"DFT", printLocationIndex) //02/14/2022 change to DTG, since vinyl was taken over by DTF printing.
                        addPrintCharge(printCharges, currentPrint.location, "DFT", dtfCostForPrint, currentPrint)
                    } else {
                        if (totalDftPrintCost < totalScreenPrintCost){ //chooses the option that is the most economical. 20 percent additional has been added on. For instance, if screen printing is like 0.20 cents more than vinyl... we should just do screen print cause the quality is a lot better.
                            printCost = printCost + totalDftPrintCost
                            addPrintSuggestion(printSuggestions, currentPrint.location,"DFT", printLocationIndex) //02/14/2022 change to DTG, since vinyl was taken over by DTF printing.
                            addPrintCharge(printCharges, currentPrint.location, "DFT", dtfCostForPrint, currentPrint)
                        } else {
                            printCost = printCost + totalScreenPrintCost
                            addPrintSuggestion(printSuggestions, currentPrint.location, 'Screen Print', printLocationIndex)
                            addPrintCharge(printCharges, currentPrint.location, spCost.printType, spCostForPrint, currentPrint)
                            totalSetup = totalSetup + spCost.fixedCost * (quantityForSelection/totalQty); // DTG has no setup cost.
                        }
                    }
                }
            }

            if (currentPrint.printType == "Embroidery") {
                if (currentPrint.width <= 0 || currentPrint.height <= 0) {
                    errors.push({
                        message: "Please enter a width and height greater than 0 for your print.",
                    })
                }
                var cost

                if (currentPrint.applique){
                    cost = calculateApplique(currentPrint.appliqueColours)
                } else {
                    cost = calculateEmbroidery({
                        width: currentPrint.width,
                        height: currentPrint.height,
                        totalQty: totalQty,
                        patch: currentPrint.patch,
                        puff: currentPrint.puff,
                        subpatch: currentPrint.subpatch,
                        leather: currentPrint.leather,
                        leatherlabel: currentPrint.leatherlabel,
                        wovenlabel: currentPrint.wovenlabel,
                        wovenpatch: currentPrint.wovenpatch
                    });
                }

                if (cost.errors && cost.errors.length > 0) {
                    errors = errors.concat(cost.errors);
                }

                var printFixedCost = (cost.fixedCost * (quantityForSelection/totalQty));
                var printVariableCost = (cost.runCharge * quantityForSelection);

                totalSetup = totalSetup + printFixedCost
                embroideryFixedCost = embroideryFixedCost + printFixedCost;
                embroideryVariableCost = embroideryVariableCost + printVariableCost
                addPrintCharge(printCharges, currentPrint.location, cost.printType, (printFixedCost + printVariableCost), currentPrint);
            }
        })
    })

    var totalCost =
        (getM(totalQty) * (embroideryFixedCost + embroideryVariableCost + printCost))
        + (getMGarment(garmentCost/totalQty,totalQty) * garmentCost)
        + ((numberOfIndividualNumbers + numberOfIndividualNames) * customizationCostPerUnit)
    return {
        totalQty: totalQty,
        totalSetup : totalSetup,
        totalCost: (totalCost).toFixed(2),
        errors: errors,
        printSuggestions : printSuggestions,
        printCharges: printCharges,
    }
}

function getTotalQtyForItemLine(itemLines){
    return Number(_.reduce(itemLines, function(totalQty, itemLine){
        var quantityOnItemLine = _.reduce(itemLine.details.quantity, function(qty, sizeqty){
            return Number(qty) + Number(sizeqty)
        },0)
        return totalQty + quantityOnItemLine;
    },0))
}

function needsStockSwatchColours(print){
    return print.printType == "Screen Print" || (print.embroidery && print.embroidery.length > 0)
}

function getNumberOfCustomizations(namesAndNumbers) {
    var numberOfNumbers = 0;
    var numberOfNames = 0;

    _.forEach(namesAndNumbers, function(nameAndNumber) {
        if (nameAndNumber.number) {
            numberOfNumbers = numberOfNumbers + 1;
        }
        if (nameAndNumber.name) {
            numberOfNames = numberOfNames + 1;
        }
    });

    return {
        namesCount: numberOfNames,
        numbersCount: numberOfNumbers
    }
}

function recalculateCart(itemLines, products, placedThroughAdmin, suppliers, allCats, isBudgeting){

    var productList;
    if (products) {
        productList = products
    } else {
        productList = getProductCache();
    }

    var fixedAmount = 0;

    var itemGroup = _.groupBy(itemLines, function(item){
        return item.group
    })

    var itemLineChargeBreakdown = []
    var itemLineErrors = [];
    _.each(itemLines, function(item, i){
            var chargeBreakdown = {
                index: i,
                product: null,
                printSupplier: item.printSupplier,
                totalQty: null,
                group: item.group,
                groupQty: null,
                includeShippingCharge: null,
                csrCharge: {
                    printedItemLine: null,
                    totalCost: null,
                },
                printCharges: [],
                customizationCharges: []
            }
            itemLineChargeBreakdown[i] = chargeBreakdown;
            var itemsToLookUp = [item]
            if (item.group){
                itemsToLookUp = itemGroup[item.group]
            }
            var allPrints = allPrintsToCalculate(item.print)

            //totalCsFee
            var totalCsFee = csrFeePrint

            if (allPrints && allPrints.length == 0){
                totalCsFee = csrFeeBlank
                chargeBreakdown.csrCharge.printedItemLine = false;
            } else {
                chargeBreakdown.csrCharge.printedItemLine = true;
            }
            var totalQtyForItemLine = getTotalQtyForItemLine(itemsToLookUp);
            chargeBreakdown.groupQty = totalQtyForItemLine;
            var csFeePerUnit = 0
            if (totalQtyForItemLine > 0) {
                csFeePerUnit = totalCsFee / totalQtyForItemLine;
            }

            var quantity = _.reduce(item.details.quantity, function(sum, quantity){
                return Number(sum) + Number(quantity)
            },0)

            chargeBreakdown.totalQty = quantity;
            chargeBreakdown.csrCharge.totalCost = csFeePerUnit * quantity;

            var product = _.find(productList, function(individualProduct){
                return individualProduct.sku == item.sku
            })

            var currentColour

            if (product){
                currentColour = _.find(product.colours, function(colour){
                    return colour.name == item.details.colourName
                });
            } else if (item.sku === 'custom') {
                var productOrigin = 'CA';
                if (item.customProductPriceCurrency === 'USD') {
                    productOrigin = 'US'
                }
                product = {
                    "sCode" : "sm",
                    temp : true,
                    type: "Clothing",
                    "sku" : i + "_custom",
                    "name" : item.productName,
                    "category" : "Custom",
                    "fit" : "Unisex",
                    "usage" : "",
                    "sizes" : item.details.size,
                    "weight" : 0.3489583333333333,
                    "countryOrigin": productOrigin,
                    "colours" : [
                        {
                            "name" : item.details.colourName,
                            "price" :item.customProductPrice,
                            "hexVal" : "#ececec",
                            "type" : (item.details.colourName && item.details.colourName.trim().toLowerCase()) == "white" ? "white" : "black",
                            "front" : "https://s3-us-west-2.amazonaws.com/product-image/productPhotos/ATC1000_Form_Front_White.jpg",
                            "back" : "https://s3-us-west-2.amazonaws.com/product-image/productPhotos/ATC1000_Form_Back_White.jpg",
                        }
                    ],
                    "sizePricing" : {
                        "doubleXL" : 2,
                        "tripleXL" : 4
                    },
                    "multiplier" : 1,
                    "__v" : 2
                }
                currentColour = product.colours[0]
            } else if (item.sku === 'contract') {
                product = {
                    "sCode" : "sm",
                    temp : true,
                    type: "Promotional Product",
                    "sku" : i + "_contract",
                    "name" : item.productName,
                    "category" : "Custom",
                    "fit" : "Unisex",
                    "usage" : "",
                    "sizes" : item.details.size,
                    "weight" : 0.3489583333333333,
                    "colours" : [
                        {
                            "name" : item.details.colourName,
                            "price" : 0,
                            "hexVal" : "#ececec",
                            "type" : (item.details.colourName && item.details.colourName.trim().toLowerCase()) == "white" ? "white" : "black",
                        }
                    ],
                    "__v" : 2
                }
                currentColour = product.colours[0]
            } else {
                // Product not found
                if (isBudgeting) {
                    // use dummy product to retrieve print charges
                    product = {
                        "sCode" : "sm",
                        temp : true,
                        type: "Clothing",
                        "sku" : "DISCON_" + item.sku,
                        "name" : item.productName,
                        "category" : "Custom",
                        "fit" : "Unisex",
                        "usage" : "",
                        "sizes" : item.details.size,
                        "weight" : 0.3489583333333333,
                        "countryOrigin": 'CA',
                        "colours" : [
                            {
                                "name" : item.details.colourName,
                                "price" : 0,
                                "hexVal" : "#ececec",
                                "type" : (item.details.colourName && item.details.colourName.trim().toLowerCase()) == "white" ? "white" : "black",
                                "front" : "https://s3-us-west-2.amazonaws.com/product-image/productPhotos/ATC1000_Form_Front_White.jpg",
                                "back" : "https://s3-us-west-2.amazonaws.com/product-image/productPhotos/ATC1000_Form_Back_White.jpg",
                            }
                        ],
                        "sizePricing" : {
                            "doubleXL" : 2,
                            "tripleXL" : 4
                        },
                        "multiplier" : 1,
                        "__v" : 0
                    }
                    currentColour = product.colours[0]
                } else {
                    itemLineErrors.push({
                        lineItemIndex: i,
                        message: 'The product with the specified sku (' + item.sku + ') is discontinued',
                        showModal: true
                    });
                    return;
                }
            }

            chargeBreakdown.product = product;
            var selections = _.map(itemsToLookUp, function(currentItem){
                var productGroup;
                if (item.sku === 'custom' || item.sku === 'contract') {
                    productGroup = product;
                } else {
                    productGroup = _.find(productList, function(individualProduct){
                        return individualProduct.sku == product.sku
                    })
                }

                if (!productGroup && isBudgeting) {
                    productGroup = product;
                }

                if (productGroup){
                    if (!currentColour){
                        currentColour = productGroup.colours[productGroup.colours.length - 1]
                    }
                    
                    // Use the pre-calculated colourPrice from details if available, otherwise use currentColour.price
                    var priceToUse = currentItem.details.colourPriceOverride !== undefined && currentItem.details.colourPriceOverride ? currentItem.details.colourPriceOverride : currentColour.price;
                    
                    return ["", currentColour.type, _.map(currentItem.details.quantity, function(quantity){ return Number(quantity)}), currentItem.details.colourName, priceToUse ] //[name,colourType,qtyBreakdown,name,price]
                }
            })



            if (item.customization.numberSize > 0 || item.customization.nameSize > 0){
                _.each(item.customization.namesAndNumbers, function(customization){
                    if (!customization.size) {
                        itemLineErrors.push({
                            lineItemIndex: i,
                            message: "Product: " + product.name + ". One or more of your individual name/number customization does not have a size. Please choose a size and try again."
                        })
                    }
                })

                if (placedThroughAdmin) {
                    if (item.customization.numberSize && item.customization.numberSize < 0.35 && item.customization.numberType === 'Embroidery') {
                        itemLineErrors.push({
                            lineItemIndex: i,
                            message: "Product: " + product.name + ". Number Customization - Embroidery size recommended minimum is 0.35 inches"
                        })
                    }
                    if (item.customization.nameSize && item.customization.nameSize < 0.35 && item.customization.nameType === 'Embroidery') {
                        itemLineErrors.push({
                            lineItemIndex: i,
                            message: "Product: " + product.name + ". Name Customization - Embroidery size recommended minimum is 0.35 inches"
                        })
                    }
                }
            }

            var customizationCounts = getNumberOfCustomizations(item.customization.namesAndNumbers);
            var numberOfNames = item.customization.nameSize > 0 ? customizationCounts.namesCount: 0;
            var numberOfNumbers = item.customization.numberSize > 0 ?customizationCounts.numbersCount: 0;


            if (numberOfNames > 0) {
                chargeBreakdown.customizationCharges.push({
                    type: 'Name',
                    quantity: numberOfNames,
                    printType: item.customization.nameType,
                })
            }

            if (numberOfNumbers > 0) {
                chargeBreakdown.customizationCharges.push({
                    type: 'Number',
                    quantity: numberOfNumbers,
                    printType: item.customization.numberType
                })
            }

            var countOfSizes = _.map(item.details.size, function(){
                return 0
            })

            if (item.customization.nameSize > 0 || item.customization.numberSize > 0){
                _.each(item.customization.namesAndNumbers,function(details){
                    countOfSizes[item.details.size.indexOf(details.size)]++
                })
            }

            var notEnough = _.findIndex(countOfSizes, function(sizeCount, index){
                return sizeCount > item.details.quantity[index]
            })

            // contract products dont exist
            if (quantity < product.minimumOrder){
                itemLineErrors.push({
                    lineItemIndex: i,
                    showModal: true,
                    message: "Product: " + product.name + ". Please input more than the minimum order quantity of " + product.minimumOrder
                })
            }

            if (notEnough >= 0 ){
                itemLineErrors.push({
                    lineItemIndex: i,
                    message: "You have added names/numbers that are not in your current sizing breakdown. Please add " + (countOfSizes[notEnough] - item.details.quantity[notEnough] )  + " more \"" + item.details.size[notEnough] + "\" in your item breakdown above before continuing"
                })
            }

            var priceInformation
            var sFromSupp = 8;

            //todo: handle US currencies in other pricing methods
            if (product){
                if (product.type == "Sticker") {
                    priceInformation = calculateStickerPricing(product, item.print,selections)
                } else if (product.category.toLowerCase() === 'sublimation') {
                    priceInformation = calculateSublimationPrice(selections[0],product)
                } else if (product.type == "Promotional Product") {
                    if (item.sku === 'contract') {
                        priceInformation = calculatePromoProductNotOnSitePrice(item.promotionalPricingData, quantity);
                    } else {
                        try {
                            // todo: when us promo supplier support us currencies
                            priceInformation = calculatePromoProductPrice(product, selections[0], item.print);
                        } catch (error) {
                            var promoPricingError;
                            if (placedThroughAdmin) {
                                promoPricingError = error.message;
                            } else {
                                console.error(error);
                                promoPricingError = 'There was an unexpected error calculating the price for product ' + product.name + ' (' + product.sku + '), Colour: ' + selections[0][3] + '. Please contact us at sales@coastalreign.com for assistance!'
                            }
                            itemLineErrors.push({
                                lineItemIndex: i,
                                message: promoPricingError
                            })
                        }
                    }
                } else {
                    var category = _.find(allCats, function(cat){
                        return product.category == cat.name
                    })
                    priceInformation = calculatePrice(product, selections, allPrintsToCalculate(item.print), 0 ,0, totalCsFee , item, suppliers,category)
                }

                if (priceInformation && priceInformation.errors){
                    for (var calcPriceErrorIndex = 0; calcPriceErrorIndex < priceInformation.errors.length; calcPriceErrorIndex++) {
                        var calculatePriceError = priceInformation.errors[calcPriceErrorIndex];
                        calculatePriceError.lineItemIndex = i
                        itemLineErrors.push(calculatePriceError)
                    }
                }

                if (priceInformation && priceInformation.printSuggestions) {
                    _.each(priceInformation.printSuggestions, function(suggestion){
                        var print = _.find(item.print, function(print, index){
                            return suggestion.printLocationIndex === index;
                        })
                        if (print){
                            print.printType = suggestion.printType
                        }
                    })
                }
                if (priceInformation && priceInformation.printCharges) {
                    _.each(priceInformation.printCharges, function (printCharge) {
                        var charge = merge({}, printCharge);
                        var costPerUnit = printCharge.totalCost / totalQtyForItemLine;
                        charge['printCost'] = costPerUnit * quantity;
                        chargeBreakdown.printCharges.push(charge);
                    })
                }
            }

            if (placedThroughAdmin) {
                var invalidPrint = _.find(item.print, function (print, index) {
                    if (!print.name) {
                        return true;
                    }

                    if (print.printColours > 0) {
                        if (!print.width || print.width <= 0) {
                            return true
                        }

                        if (!print.height || print.height <= 0) {
                            return true
                        }
                    }

                    if (print.embroidery && print.embroidery.length > 0) {
                        var invalidEmbroidery = _.find(print.embroidery, function (embroidery) {
                            if (!embroidery.width || embroidery.width <= 0) {
                                return true;
                            }

                            if (!embroidery.height || embroidery.height <= 0) {
                                return true;
                            }

                            if (!print.pmsColours || print.pmsColours.length <= 0) {
                                return true;
                            }
                        })

                        if (invalidEmbroidery) {
                            return true;
                        }
                    } else {
                        if (!print.printColours) {
                            return true
                        }
                    }

                    if ((print.printType === 'Screen Print' || print.printType === "Embroidery") && print.printColours > 0
                        && (!print.pmsColours || print.pmsColours.length <= 0)) {
                        return true;
                    }

                    // vinyl check
                    if (print.printType === 'Vinyl'
                        && print.printColours === 1 &&
                        (!print.vinylColours || print.vinylColours.length <= 0)) {
                        return true;
                    }

                    return false

                })

                if (invalidPrint) {
                    itemLineErrors.push({
                        lineItemIndex: i,
                        message: item.productName + " - Please make sure that the location, width, height and print colours has been entered for all prints"
                    })
                }

            _.forEach(item.print, function (print) {
                // old embroidery prints also have type 'Screen Print' lol. we need to explicitly filter for screen print colours
                if (print.embroidery && print.embroidery.length === 0 && print.printType === 'Screen Print') {
                    if (print.pmsColours && print.printColours !== print.pmsColours.length) {
                        var hasSpotProcess = _.find(print.pmsColours, function (pmsColour) {
                            return pmsColour.name === 'Spot Process';
                        })
                        if (!hasSpotProcess) {
                            itemLineErrors.push({
                                lineItemIndex: i,
                                message: print.name + ' print requires ' + print.printColours + ' pms colours.'
                            })
                        }
                    }
                }

                if (print.printType === 'Embroidery' && print.pmsColours.length === 0) {
                    itemLineErrors.push({
                        lineItemIndex: i,
                        message: print.name + ' embroidery has no colours added'
                    })
                }
            })
        }

            if ((item.reorderDiscount && item.reorderDiscount != "false") && priceInformation && !item.fixedPrice){
                fixedAmount = fixedAmount + ((priceInformation.totalSetup / totalQtyForItemLine) + csFeePerUnit) * quantity
            }

            var itemIsNotValid = _.find(item.details.quantity, function(quantity){
                return quantity < 0
            })

            if (quantity > 0 && _.isUndefined(itemIsNotValid) && priceInformation){
                var price = (priceInformation.totalCost) / priceInformation.totalQty
                if (product && product.category && product.category.toLowerCase()!= "sublimation"){
                    price = price + ((numberOfNames + numberOfNumbers)/quantity) * customizationCostPerUnit
                }
                if (!itemLines[i].fixedPrice) {
                    var packagingFee = 0
                    if (itemLines[i] && itemLines[i].individualPackaging){
                        packagingFee = packagingFee + individualPackagingCost
                    }

                    if (itemLines[i] && itemLines[i].individualTagging){

                        packagingFee = packagingFee + sewnOnTagsCost
                    }
                    chargeBreakdown.includeShippingCharge = true;
                    itemLines[i].price = (price + csFeePerUnit + packagingFee + shippingChargesOver300)
                    itemLines[i].price = Number(itemLines[i].price.toFixed(2))
                }

                // contract pricing has custom formula
                if (itemLines[i].sku === 'contract' && !itemLines[i].fixedPrice) {
                    itemLines[i].price = price
                }
                itemLines[i].totalQty = quantity
            } else {
                if (!priceInformation){
                    // product not found.
                } else {
                    itemLines[i].totalQty = quantity;
                    if (!placedThroughAdmin) {
                        itemLineErrors.push({
                            lineItemIndex: i,
                            message: "Please enter more than 0 items."
                        })
                    }
                }
            }
        })


    return {
        error : itemLineErrors[itemLineErrors.length - 1] ? itemLineErrors[itemLineErrors.length - 1].message : undefined,
        allErrors: itemLineErrors,
        fixedAmount : fixedAmount,
        lineCostMetadata: itemLineChargeBreakdown
    }
}

function getStartingQuantityForProduct(product, quantityOverride){
    var startingPointForOrders;
    if (quantityOverride && quantityOverride > 0) {
        startingPointForOrders = quantityOverride
    } else {
        startingPointForOrders = QUOTING_STARTING_QTY
    }
    if (product.minimumOrder){
        return Math.max(product.minimumOrder , startingPointForOrders)
    } else {
        return startingPointForOrders
    }
}

function getSelections(selection, additionalSelection){
    var selections = [selection]
    if(additionalSelection.length > 0){
        selections = selections.concat(additionalSelection)
    }
    return selections
}

// modelServiceEnum is injected for function run against DB queries
    //todo needs to be manually synced with dashboardReportService
function getPrintType(print, modelServiceEnum) {
    var models = modelServiceEnum ? modelServiceEnum : mS;
    // handle funky ones first
    var embroideryArray = print.embroidery;
    if (embroideryArray && embroideryArray[0]) {
        var embroidery = embroideryArray[0];
        if (embroidery.subpatch) {
            return models.SPECIALTY_PRINTS.SUBLIMATED_PATCH
        } else if (embroidery.wovenpatch) {
            return models.SPECIALTY_PRINTS.WOVEN_PATCH
        } else if (embroidery.wovenlabel) {
            return models.SPECIALTY_PRINTS.WOVEN_LABEL
        } else if (embroidery.patch) {
            return models.SPECIALTY_PRINTS.EMBROIDERED_PATCH
        } else if (embroidery.applique) {
            return models.SPECIALTY_PRINTS.APPLIQUE
        } else if (embroidery.leather) {
            return models.SPECIALTY_PRINTS.LEATHER_PATCH
        } else if (embroidery.leatherlabel) {
            return models.SPECIALTY_PRINTS.LEATHER_LABEL
        } else if (embroidery.puff) {
            return models.SPECIALTY_PRINTS.PUFF_EMBROIDERY
        } else {
            return models.PRINT_TYPES.EMBROIDERY
        }
    } else {
        if (print.printType === models.PRINT_TYPES.SCREEN_PRINT) {
            if (print.screenPrintOptions) {
                if (print.screenPrintOptions.puff) {
                    return models.SPECIALTY_PRINTS.PUFF_PRINT
                } else if (print.screenPrintOptions.spotProcess) {
                    return models.SPECIALTY_PRINTS.SPOT_PROCESS
                }
            }
        }
        return print.printType;
    }
}


    function getProductCategoryUrl(product, allCats, fitOverride) {
        var foundCategory = _.find(allCats, function(cat) {
            return cat.name === product.category
        });

        var breadcrumbUrl = '/custom-products';

        var fit = product ? product.fit : fitOverride

        if (foundCategory.catUrlMap && fit) {
            var fitToTest = product.fit.toLowerCase();
            var urlToTest = foundCategory.catUrlMap[fitToTest];
            if (!urlToTest) {
                if (fitToTest === 'toddler') {
                    urlToTest = foundCategory.catUrlMap['youth'];
                } else {
                    // default
                    urlToTest = foundCategory.catUrlMap['unisex'];
                }
            }
            if (urlToTest) {
                breadcrumbUrl = urlToTest;
            }
        }

        if (foundCategory &&  foundCategory.categoryUrl) {
            breadcrumbUrl = foundCategory.categoryUrl
        }
        return breadcrumbUrl;
    }

// todo: run migration to set legacy orders
function getOrderCurrency(order) {
    // default
    var currencyObject = {
        currencyCode: mS.ORDER_CURRENCY.CAD,
        exchangeRate: 1
    }
    // once currency 'locked' in refetech only
    if (order.orderCurrency && order.orderCurrency.rateDate) {
        currencyObject = Object.assign({}, order.orderCurrency);
    } else if (order.shippingAddress && order.shippingAddress.country) {
        if (order.shippingAddress.country === 'CA' || order.shippingType === "Pick Up") {

        } else if (order.shippingAddress.country === 'US') {
            currencyObject.currencyCode = mS.ORDER_CURRENCY.USD;
            currencyObject.exchangeRate = fxMap[mS.ORDER_CURRENCY.USD];
            // overrides for legacy orders that have been paid for
            if (order.amountPaid > 0 || (order.currentStatus && (order.currentStatus.status === 'Printing' || order.currentStatus.status === 'Shipped'))) {
                currencyObject.exchangeRate = fxMap['LEGACY_USD']
                currencyObject.rateDate = new Date(null);
            }
        }
    }

    // console.log(currencyObject);
    return currencyObject;
}


// string display value
function getCurrencyValue(value, orderCurrencyObject) {
    return '$' + Math.abs(value * orderCurrencyObject.exchangeRate).toFixed(2) + ' ' + orderCurrencyObject.currencyCode;
}

//transform only
function ca2usOrder(value, orderCurrencyObject) {
    return Number(value) * orderCurrencyObject.exchangeRate;
}

// cannot be 0
function calcUSDCustomsValue(perUnitPrice, quantity) {
    return Math.max(1, ca2us(perUnitPrice * USD_INVOICING_CONVERSION * quantity, 'USD'));
}

function calcUSDCustomsDaysEstimate(usdVal) {
    if (usdVal < US_SHIPMENT_SIZE_VALUE) {
        return 0
    }
    var shipmentsChunks = usdVal / US_SHIPMENT_SIZE_VALUE;
    var buffer = -1;
    if (shipmentsChunks >= 1.5) {
        buffer += Math.floor(Math.ceil(shipmentsChunks) / 2)
    }

    //capped at 3
    buffer = Math.min(buffer, 3);

    return Math.ceil(shipmentsChunks + buffer);
}

// legacy function
// uses current currency map value
function ca2us(value, currency) {
    return Number(value) * fxMap[currency]
}

function buildProductUrl(product){
    function replaceSpaceWithHyphensAndLower(word){
        word = word.replace(/\s/g, "-")
        return word.toLowerCase()
    }
 // need to build special product urls for stickers and patches
   if (product.productUrlOverride) {
       return product.productUrlOverride;
   } else {
       return "/products/" + replaceSpaceWithHyphensAndLower(product.category) + "/" + replaceSpaceWithHyphensAndLower(product.name)
   }
}

exports.isAPatchProduct = isAPatchProduct;
exports.isASignageProduct = isASignageProduct;
exports.splitShipmentHandlingCost = splitShipmentHandlingCost
exports.sizeCodeToName = sizeCodeToName
exports.getNumberOfCustomizations = getNumberOfCustomizations
exports.promoProductDecorationGrouping = promoProductDecorationGrouping
exports.onlyEmbroideryAllowed = onlyEmbroideryAllowed;
exports.recalculateCart = recalculateCart;
exports.calculateAveragePrice = calculateAveragePrice;
exports.getDiscountedPriceFromCode = getDiscountedPriceFromCode
exports.getSelections = getSelections
exports.customizationCostPerUnit = customizationCostPerUnit
exports.seeIfMisMatchSupplierAndProduct = seeIfMisMatchSupplierAndProduct
exports.getCanadianTaxRate = getCanadianTaxRate
exports.createDummyItemLine = createDummyItemLine
exports.createStickerPrint = createStickerPrint
exports.createPatchPrint = createPatchPrint
exports.dftPrintC =dftPrintC
exports.dtgPrintC = dtgPrintC
exports.calculateScreenPrint = calculateScreenPrint
exports.calculateEmbroidery = calculateEmbroidery
exports.calculatePromoProductNotOnSiteCost = calculatePromoProductNotOnSiteCost
exports.needsStockSwatchColours = needsStockSwatchColours
exports.getStartingQuantityForProduct = getStartingQuantityForProduct
exports.getPrintType = getPrintType
exports.BLANK_LINE_FEE = csrFeeBlank;
exports.PRINT_LINE_FEE = csrFeePrint;
exports.SHIPPING_CHARGE = shippingChargesOver300;
exports.getOrderCurrency = getOrderCurrency;
exports.getCurrencyValue = getCurrencyValue;
exports.fxMap = fxMap;
exports.ca2us = ca2us;
exports.ca2usOrder= ca2usOrder;
exports.individualPackagingCost = individualPackagingCost;
exports.sewnOnTagsCost = sewnOnTagsCost;
exports.calcUSDCustomsValue = calcUSDCustomsValue;
exports.calcUSDCustomsDaysEstimate = calcUSDCustomsDaysEstimate;
exports.getProductCategoryUrl = getProductCategoryUrl;
exports.buildProductUrl = buildProductUrl;
exports.US_SHIPMENT_SIZE_VALUE = US_SHIPMENT_SIZE_VALUE;
exports.NON_GUARANTEED_EXTRA_DAYS = NON_GUARANTEED_EXTRA_DAYS;
exports.shippingPercentageWithinRange = shippingPercentageWithinRange;
exports.QUOTING_STARTING_QTY = QUOTING_STARTING_QTY;
exports.USDToCADExchange = USDToCADExchange;
exports.dutiesAndTaxMarkup = dutiesAndTaxMarkup;

})(typeof exports === 'undefined'?
    this['calculationService']={}: exports);

(function (exports) {
    var _
    var mS
    if (typeof window !== 'undefined') {
        _ = window._
    } else {
        _ = require("../../../node_modules/underscore")
        mS = require("../services/models")
    }


    var shirtBack = {
        name: "Back", //make this an enum of "Front", "Left", "Right", "Back"
        defaultDesignerImage: "../images/designerDefault/defaultBackShirt.svg"
    }

    var defaultFront = {
        name: "Front",
        defaultDesignerImage: ""
    }


    var shirtLeft = {
        name: "Left",
        defaultDesignerImage: "../images/designerDefault/leftSleeve.svg"
    }

    var shortSleeveLeft = {
        name: "Left",
        defaultDesignerImage: "../images/designerDefault/shortSleeveLeft.svg"
    }

    var shortSleeveRight = {
        name: "Right",
        defaultDesignerImage: "../images/designerDefault/shortSleeveRight.svg"
    }

    var shortSleeveBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/shortSleeveBack.svg"
    }

    var shirtRight = {
        name: "Right",
        defaultDesignerImage: "../images/designerDefault/rightSleeve.svg"
    }

    var hatBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/hatBack.svg"
    }

    var bagLeft = {
        name: "Left",
        defaultDesignerImage: "../images/designerDefault/blankSquareBack.svg"
    }

    var bagRight = {
        name: "Right",
        defaultDesignerImage: "../images/designerDefault/blankSquareBack.svg"
    }

    var drinkWareBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/drinkWareBack.svg"
    }


    var hatLeft = {
        name: "Left",
        defaultDesignerImage: "../images/designerDefault/hatLeft.svg"
    }

    var golfBallBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/golfBallBack.svg"
    }

    var hatRight = {
        name: "Right",
        defaultDesignerImage: "../images/designerDefault/hatRight.svg"
    }

    var toqueBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/toqueBack.svg"
    }

    var bucketHatBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/bucketHatBack.svg"
    }


    var blankSquareBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/blankSquareBack.svg"
    }

    var toteBagBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/toteBagBack.svg"
    }

    var notebookBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/notebookBack.svg"
    }

    var mugBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/mugBack.svg"
    }


    var pantsBack = {
        name: "Back",
        defaultDesignerImage: "../images/designerDefault/pantsBack.svg"
    }


    //**
    // filtering facets
    // facet metadata

    var listOfAllFits = [
        'Unisex',
        'Ladies',
        'Youth',
        'Toddler'
    ]

    var facetDefinitionsMap = {
        f_material: {
            name: 'Material',
            key: 'f_material',
            multiple: true,

            shoudSplitPunctuation: true,
        },
        f_bagFeatures: {
            key: 'f_bagFeatures',
            name: 'Bag Features',
            multiple: true
        },
        f_bagGussets: {
            key: 'f_bagGussets',
            name: 'Gusseted',
            manualAssign: true,
        },
        f_drinkwareFeature: {
            key: 'f_drinkwareFeature',
            name: 'Drinkware Features',
            multiple: true
        },
        f_penFeatures: {
            key: 'f_penFeatures',
            name: 'Pen Features',
            multiple: true
        },
        f_techFeatures: {
            key: 'f_techFeatures',
            name: 'Technology Features',
            multiple: true
        },
        f_productFeatures: {
            key: 'f_productFeatures',
            name: 'Product Features',
            multiple: true
        },
        f_garmentWeight: {
            key: 'f_garmentWeight',
            name: 'Weight'
        },
        f_topStyle: {
            key: 'f_topStyle',
            name: 'Style',
            multiple: true
        },
        f_garmentFit: {
            key: 'f_garmentFit',
            name: 'Fit'
        },
        f_bagSize: {
            key: 'f_bagSize',
            name: 'Bag Size',
            manualAssign: true
        },
        f_penClosure: {
            key: 'f_penClosure',
            name: 'Pen Opening Type',
        },
        f_penInkType: {
            key: 'f_penInkType',
            name: 'Pen Ink',
            multiple: true
        },
        f_bagClosure: {
            key: 'f_bagClosure',
            name: 'Bag Closure',
            manualAssign: true,
            multiple: true
        },
        f_topCollar: {
            key: 'f_topCollar',
            name: 'Neckline'
        },
        f_topPocket: {
            key: 'f_topPocket',
            name: 'Pockets',
            multiple: true
        },
        f_topSleeveLength: {
            key: 'f_topSleeveLength',
            name: 'Sleeve Length'
        },
        f_garmentTag: {
            key: 'f_garmentTag',
            name: 'Garment Tag',
            multiple: true
        },
        f_hatStructure: {
            key: 'f_hatStructure',
            name: 'Structure'
        },
        f_hatClosure: {
            key: 'f_hatClosure',
            name: 'Hat Closure',
        },
        f_hatProfile: {
            key: 'f_hatProfile',
            name: 'Hat Profile',
        },
        f_topCuffs: {
            key: 'f_topCuffs',
            name: 'Sleeve Cuffs',
            multiple: true
        },
        f_topHem: {
            key: 'f_topHem',
            name: 'Hem',
            multiple: true
        },
        f_legClosure:{
            key: 'f_legClosure',
            name: 'Leg Bottom',
            multiple: true
        },
        f_jacketHood: {
            key: 'f_jacketHood',
            name: 'Hood',
            manualAssign: true
        },
        f_topClosure: {
            key: 'f_topClosure',
            name: 'Fastener',
            manualAssign: true,
            multiple: true
        },
        f_bagTechSleeve: {
            key: 'f_bagTechSleeve',
            name: 'Max Tech Sleeve Size'
        },
        f_drinkwareConstruction: {
            key: 'f_drinkwareConstruction',
            name: 'Drinkware Construction'
        },
        f_drinkwareLid: {
            key: 'f_drinkwareLid',
            name: 'Drinkware Opening'
        },
        f_journalPages: {
            key: 'f_journalPages',
            name: 'Page Type'
        },
        f_journalBinding: {
            key: 'f_journalBinding',
            name: 'Notebook Binding'
        },
        f_journalClosure: {
            key: 'f_journalClosure',
            name: 'Notebook Closure'
        },
        f_journalNumPages: {
            key: 'f_journalNumPages',
            name: "Number Of Pages"
        },
        // safety wear
        f_safetyHighVisClass: {
            key: 'f_safetyHighVisClass',
            name: 'High-Visibility Safety Classes',
            multiple: true
        },
        f_safetyHighVisType: {
            key: 'f_safetyHighVisType',
            name: "High-Visibility Safety Types",
            manualAssign: true,
            multiple: true
        }
    }


    // default product
    var defaultFacets = [
        facetDefinitionsMap.f_material.key,
        facetDefinitionsMap.f_productFeatures.key,
    ]
    var journalFacets = [
        ...defaultFacets,
        facetDefinitionsMap.f_journalPages.key,
        facetDefinitionsMap.f_journalBinding.key,
        facetDefinitionsMap.f_journalClosure.key,
        facetDefinitionsMap.f_journalNumPages.key,
    ]

    var bagFacets = [
            ...defaultFacets,
        facetDefinitionsMap.f_garmentWeight.key,
        facetDefinitionsMap.f_bagTechSleeve.key,
        facetDefinitionsMap.f_bagClosure.key,
        facetDefinitionsMap.f_bagSize.key,
        facetDefinitionsMap.f_bagFeatures.key,
        facetDefinitionsMap.f_bagGussets.key,
    ]

    var drinkwareFacets = [
            ...defaultFacets,
        facetDefinitionsMap.f_drinkwareFeature.key,
        facetDefinitionsMap.f_drinkwareLid.key,
        facetDefinitionsMap.f_drinkwareConstruction.key
    ]

    var techFacets = [
        ...defaultFacets,
        facetDefinitionsMap.f_techFeatures.key
    ]

    var penFacets = [
            ...defaultFacets,
        facetDefinitionsMap.f_penFeatures.key,
        facetDefinitionsMap.f_penClosure.key,
        facetDefinitionsMap.f_penInkType.key
    ]

    var garmentFacets = [
        ...defaultFacets,
        facetDefinitionsMap.f_garmentWeight.key,
        facetDefinitionsMap.f_garmentTag.key
    ]

    var garmentTopFacets = [
        ...garmentFacets,
        facetDefinitionsMap.f_garmentFit.key,
        facetDefinitionsMap.f_topSleeveLength.key,
        facetDefinitionsMap.f_topStyle.key,
        facetDefinitionsMap.f_topCollar.key,
        facetDefinitionsMap.f_topPocket.key,
        facetDefinitionsMap.f_topCuffs.key,
        facetDefinitionsMap.f_topHem.key,
        facetDefinitionsMap.f_topClosure.key
    ]

    var jacketFacets = [
        ...garmentTopFacets,
        facetDefinitionsMap.f_jacketHood.key,
    ]

    var garmentBottomFacets = [
        ...garmentFacets,
        facetDefinitionsMap.f_legClosure.key
    ]

    var sublimationFacets = Array.from(new Set([
            ...garmentTopFacets,
            ...garmentBottomFacets
        ]))


    var headwearFacets = [
       ...garmentFacets,
        facetDefinitionsMap.f_hatStructure.key,
        facetDefinitionsMap.f_hatClosure.key,
        facetDefinitionsMap.f_hatProfile.key,
    ]

    var safetyTopFacets = [
        ...garmentTopFacets,
        facetDefinitionsMap.f_safetyHighVisClass.key,
        facetDefinitionsMap.f_safetyHighVisType.key
    ]

    var safetyBottomFacets = [
        ...garmentBottomFacets,
        facetDefinitionsMap.f_safetyHighVisClass.key,
        facetDefinitionsMap.f_safetyHighVisType.key
    ]

    var safetyHeadwearFacets = [
        ...headwearFacets,
        facetDefinitionsMap.f_safetyHighVisClass.key,
        facetDefinitionsMap.f_safetyHighVisType.key
    ]

    var defaultCategory = {
        name: "Default",
        designerMultiplier: 1,
        screenPrintAllowed: true,
        printAllowed: {screenPrint: true, transfer: true},
        defaultWeight: 0.8,
        printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
        facets: defaultFacets
    }

    var fitRootPath = {
        ladies: '/custom-products/custom-clothing/ladies',
        youth: '/custom-products/custom-clothing/youth',
        toddler: '/custom-products/custom-clothing/youth/toddlers'
    }

    var allCategories = [
        defaultCategory,
        {
            name: "Short Sleeve T Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shortSleeveBack, shortSleeveLeft, shortSleeveRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/t-shirts/short-sleeve',
                ladies: fitRootPath.ladies + '/t-shirts',
                youth: fitRootPath.youth + '/t-shirts'
            },
            hsCode: '6109.10.0004',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Long Sleeve T Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/t-shirts/long-sleeve',
                ladies: fitRootPath.ladies + '/long-sleeves',
                youth: fitRootPath.youth + '/long-sleeves'
            },
            hsCode: '6109.10.0004',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Tank Tops",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/t-shirts/tank-tops',
                ladies: fitRootPath.ladies + '/tank-tops',
                youth: fitRootPath.youth + '/all',
                toddler: fitRootPath.youth + '/toddlers',
            },
            hsCode: '6109.10.0004',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Hoodies",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/hoodies',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/hoodies',
            },
            hsCode: '6110.20.20.10',
            gCat: 5322,
            facets: garmentTopFacets
        },
        {
            name: "Fleece Quarter Zip Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/fleece',
                ladies: fitRootPath.ladies + '/jackets/fleece',
                youth: fitRootPath.youth + '/jackets',
            },
            facets: jacketFacets,
            gCat: 5322,
            hsCode: '6110.20.20.10',

        },
        {
            name: "Quarter Zip Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/quarter-zip-sweatshirts',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            facets: garmentTopFacets,
            gCat: 5322,
            hsCode: '6110.20.20.10',

        },
        {
            name: "Full Zip Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/full-zip-sweatshirts',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            facets: garmentTopFacets,
            gCat: 5322,
            hsCode: '6110.20.20.10',

        },
        {
            name: "Winter Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/winter',
                ladies: fitRootPath.ladies + '/jackets/winter',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 5598,
            facets: jacketFacets
        },
        {
            name: "Wind Breakers",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/lightweight',
                ladies: fitRootPath.ladies + '/jackets/lightweight-windbreakers',
                youth: fitRootPath.youth + '/jackets'
            },
            hsCode: '6210.30.50.10',
            gCat: 203,
            facets: jacketFacets
        },
        {
            name: "3 in 1 System Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/3-in-1-system',
                ladies: fitRootPath.ladies + '/jackets/3-in-1-system',
                youth: fitRootPath.youth + '/jackets'
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets

        },
        {
            name: "5 in 1 Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/jackets/5-in-1-system',
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/5-in-1-system',
                ladies: fitRootPath.ladies + '/jackets/3-in-1-system',
                youth: fitRootPath.youth + '/jackets'
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        {
            name: "Anorak Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/anorak',
                youth: fitRootPath.youth + '/jackets'
            },
            hsCode: '6210.30.50.10',
            gCat: 203,
            facets: jacketFacets
        },
        {
            name: "Raincoats",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/raincoat',
                ladies: fitRootPath.ladies + '/jackets/raincoat',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets

        },
        {
            name: "Accessories",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            hsCode: '6214.30.0000',
            gCat: 166,
            facets: defaultFacets
        },
        {
            name: "Kilt",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            hsCode: '6204.53.30.10',
            gCat: 1581,
            facets: garmentBottomFacets
        },
        {
            name: "Sweatpants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/pants-bottoms/sweatpants',
                ladies: fitRootPath.ladies + '/sweatpants-shorts',
                youth: fitRootPath.youth + '/sweatpants-shorts',
            },
            hsCode: '6110.20.20.10',
            gCat: 204,
            facets: garmentBottomFacets
        },
        {
            name: "Soft Shell Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/soft-shell',
                ladies: fitRootPath.ladies + '/jackets/soft-shell',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 203,
            facets: jacketFacets
        },
        {
            name: "Polos",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shortSleeveBack, shortSleeveLeft, shortSleeveRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/polos',
                ladies: fitRootPath.ladies + '/polos',
                youth: fitRootPath.youth + '/polos',
            },
            hsCode: '6105.10.0010',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Vests",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            categoryUrl: '/custom-products/custom-clothing/jackets/vests',
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/vests',
                ladies: fitRootPath.ladies + '/jackets/vests',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 1831,
            facets: jacketFacets
        },
        {
            name: "Tote Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: '/custom-products/custom-bags/tote-bags',
            hsCode: '4202.92.1500',
            gCat: 5608,
            facets: bagFacets
        },
        {
            name: "Backpacks",
            designerMultiplier: 2,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/custom-bags/custom-backpacks',
            hsCode: '4202.92.9100',
            gCat: 100,
            facets: bagFacets
        },
        {
            name: "Flat Brim Hats",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, hatBack, hatLeft, hatRight],
            categoryUrl: '/custom-products/custom-clothing/hats/flat-brimmed',
            hsCode: '6505.00.15.40',
            gCat: 173,
            facets: headwearFacets,
        },
        {
            name: "Curved Brim Hats",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, hatBack, hatLeft, hatRight],
            categoryUrl: '/custom-products/custom-clothing/hats/dad-hats',
            hsCode: '6505.00.15.40',
            gCat: 173,
            facets: headwearFacets,
        },
        {
            name: "Toques",
            designerMultiplier: 5,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toqueBack],
            categoryUrl: '/custom-products/custom-clothing/hats/toques',
            hsCode: '6505.00.15.40',
            gCat: 173,
            facets: headwearFacets,
        },
        {
            name: "Fleece Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/fleece',
                ladies: fitRootPath.ladies + '/jackets/fleece',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6110.20.20.10',
            facets: jacketFacets,

        },
        {
            name: "Fleece Vests",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/vests',
                ladies: fitRootPath.ladies + '/jackets/vests',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 1831,
            facets: jacketFacets,
        },
        {
            name: "Puffer Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/puffer',
                ladies: fitRootPath.ladies + '/jackets/puffer',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        {
            name: "Zip Hoodies",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/zip-hoodies',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            hsCode: '6110.20.20.10',
            gCat: 5322,
            facets: garmentTopFacets

        },
        {
            name: "Shorts",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/pants-bottoms/shorts',
                ladies: fitRootPath.ladies + '/sweatpants-shorts',
                youth: fitRootPath.youth + '/sweatpants-shorts',
            },
            hsCode: '6103.42.10.50',
            gCat: 207,
            facets: garmentBottomFacets
        },
        {
            name: "Long Sleeve Button Down Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/button-downs',
                youth: fitRootPath.youth + '/all',
            },
            hsCode: '6105.10.0010',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Short Sleeve Button Down Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shortSleeveBack, shortSleeveLeft, shortSleeveRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/button-downs',
                youth: fitRootPath.youth + '/all',
            },
            hsCode: '6105.10.0010',
            gCat: 212,
            facets: garmentTopFacets
        },
        {
            name: "Crewneck Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/crewneck-sweatshirts',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            hsCode: '6110.20.20.10',
            gCat: 5322,
            facets: garmentTopFacets

        },
        {
            name: "Uniforms",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear',
            hsCode: '6103.22.00.10',
            gCat: 2306,
            facets: garmentTopFacets
        },
        {
            name: "Long Sleeve Polos",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/polos',
                ladies: fitRootPath.ladies + '/polos',
                youth: fitRootPath.youth + '/polos',
            },
            hsCode: '6105.10.0010',
            gCat: 212,
            facets: garmentTopFacets
        },
        //todo: fix sublimation bread crumb
        {
            name: "Sublimation",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/jerseys/sublimated-apparel/all',
            hsCode: '6114.30.3060',
            gCat: 5322,
            facets: sublimationFacets
        },
        {
            name: "Luggage",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '',
            hsCode: '4202.92.9100',
            gCat: 5181,
            facets: bagFacets
        },
        {
            name: "Golf Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '',
            hsCode: '4202.92.9100',
            gCat: 1044,
            facets: bagFacets
        },
        {
            name: "Fanny Packs",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/custom-bags/custom-fanny-packs',
            hsCode: '4202.92.9100',
            gCat: 104,
            facets: bagFacets
        },
        {
            name: "Casual Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/casual',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        // {
        //     name: "Leather Jackets",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: false, transfer: false},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
        //     categoryUrl: '/custom-products/custom-clothing/jackets/all'
        // },
        {
            name: "Laptop Bags",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/custom-bags/custom-laptop-bags',
            hsCode: '4202.92.9100',
            gCat: 279,
            facets: bagFacets
        },
        {
            name: "Casual Sweaters",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/casual-sweaters',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            hsCode: '6110.20.20.10',
            gCat: 203,
            facets: garmentTopFacets
        },
        {
            name: "Pants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/pants-bottoms/pants',
                youth: fitRootPath.youth + '/all',
            },
            hsCode: '6103.42.10.50',
            gCat: 204,
            facets: garmentBottomFacets
        },
        {
            name: "Safety Pants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/pants',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: garmentBottomFacets
        },
        {
            name: "Puffer Vests",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/vests',
                ladies: fitRootPath.ladies + '/jackets/vests',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 1831,
            facets: jacketFacets
        },
        {
            name: "Roller Bag",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/custom-bags/custom-roller-bags',
            hsCode: '4202.92.9100',
            gCat: 5181,
            facets: bagFacets
        },
        {
            name: "Safety Uniforms",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/overalls-coveralls',
            hsCode: '6103.22.00.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Short Sleeve T Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shortSleeveBack, shortSleeveLeft, shortSleeveRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/t-shirts',
            hsCode: '6109.10.0004',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Long Sleeve T Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/long-sleeve',
            hsCode: '6109.10.0004',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Hoodies",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/hoodies',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Zippered Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts',
            },
            hsCode: '6110.20.20.10',
            gCat: 5322,
            facets: garmentTopFacets

        },
        {
            name: "Safety Zippered Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/zip-hoodies',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Sweatpants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/pants',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyBottomFacets
        },
        {
            name: "Lightweight Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/lightweight',
                ladies: fitRootPath.ladies + '/jackets/lightweight-windbreakers',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        {
            name: "Safety Lightweight Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/jackets',
            hsCode: '6210.30.50.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Soft Shell Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/jackets',
            hsCode: '6210.30.50.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Vests",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/vests',
            hsCode: '6210.30.50.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Flat Brim Hats",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, hatBack, hatLeft, hatRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety',
            hsCode: '6505.00.15.40',
            gCat: 2047,
            facets: safetyHeadwearFacets
        },
        {
            name: "Safety Curved Brim Hats",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, hatBack, hatLeft, hatRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety',
            hsCode: '6505.00.15.40',
            gCat: 2047,
            facets: safetyHeadwearFacets
        },
        {
            name: "Safety Toques",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toqueBack],
            categoryUrl: '/custom-products/custom-clothing/hats/toques/embroidered',
            hsCode: '6505.00.15.40',
            gCat: 2047,
            facets: safetyHeadwearFacets
        },
        {
            name: "Safety Fleece Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/jackets',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Fleece Vests",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/vests',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Puffer Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/jackets',
            hsCode: '6210.30.50.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Insulated Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/insulated',
                ladies: fitRootPath.ladies + '/jackets/insulated',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        {
            name: "Safety Insulated Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/jackets',
            hsCode: '6210.30.50.10',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Zip Hoodies",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/zip-hoodies',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets

        },
        {
            name: "Safety Shorts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/pants',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyBottomFacets

        },
        {
            name: "Safety Long Sleeve Button Down Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/long-sleeve',
            hsCode: '6105.10.0010',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Short Sleeve Button Down Shirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/t-shirts',
            hsCode: '6105.10.0010',
            gCat: 2047,
            facets: safetyTopFacets
        },
        {
            name: "Safety Crewneck Sweatshirts",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/safety/hoodies',
            hsCode: '6110.20.20.10',
            gCat: 2047,
            facets: safetyTopFacets

        },
        {
            name: "Track Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/track',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6110.20.20.10',
            gCat: 5322,
            facets: jacketFacets

        },
        {
            name: "Bucket Hats",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, bucketHatBack],
            categoryUrl: '/custom-products/custom-clothing/hats/bucket-hats',
            hsCode: '6505.00.15.40',
            gCat: 173,
            facets: headwearFacets
        },
        {
            name: "Leggings",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            categoryUrl: '/custom-products/custom-clothing/pants-bottoms',
            hsCode: '6115.22.0000',
            gCat: 204,
            facets: garmentBottomFacets
        },
        {
            name: "Dress",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            // categoryUrl: '/custom-products/custom-clothing/dresses',
            hsCode: '6204.42.3060',
            gCat: 2271,
            facets: garmentTopFacets
        },
        {
            name: "Bras",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: fitRootPath.ladies + '/all',
            hsCode: '6212.10.9020',
            gCat: 214,
            facets: defaultFacets
        },
        {
            name: "Cinch Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/custom-bags/custom-cinch-bags',
            hsCode: '4202.92.9100',
            gCat: 3032,
            facets: bagFacets
        },
        {
            name: "Duffle Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, bagRight, bagLeft, blankSquareBack],
            categoryUrl: '/custom-products/custom-bags/duffel-bags',
            hsCode: '4202.92.9100',
            gCat: 103,
            facets: bagFacets

        },
        {
            name: "Collared Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/casual',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 203,
            facets: jacketFacets
        },
        {
            name: "Varsity Jackets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/varsity',
                youth: fitRootPath.youth + '/jackets',
            },
            hsCode: '6210.30.50.10',
            gCat: 203,
            facets: jacketFacets
        },
        {
            name: "Scarves",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            categoryUrl: '/custom-products/custom-clothing/scarves/embroidered-scarves',
            hsCode: '6214.30.0000',
            gCat: 543673,
            facets: defaultFacets
        },
        {
            name: "Lunch Coolers",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, bagRight, bagLeft, blankSquareBack],
            categoryUrl: '/custom-products/custom-bags/coolers',
            hsCode: '4202.92.9100',
            gCat: 1017,
            facets: bagFacets

        },
        {
            name: "Laptop and Tablet Cases",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/custom-bags/custom-laptop-tablet-sleeves',
            hsCode: '4202.92.9100',
            gCat: 279,
            facets: garmentTopFacets
        },
        {
            name: "Drink and Bottle Bags",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/custom-bags/custom-drink-and-bottle-bags',
            hsCode: '4202.92.1500',
            gCat: 2920,
            facets: garmentTopFacets
        },
        {
            name: "Aprons",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront,],
            categoryUrl: '/custom-products/custom-clothing/work-wear/restaurant/aprons',
            hsCode: '6103.22.00.10',
            gCat: 639,
            facets: defaultFacets
        },
        {
            name: "Chef Coats",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/restaurant/chef-coats',
            hsCode: '6103.22.00.10',
            gCat: 2396,
            facets: garmentTopFacets
        },
        {
            name: "Bomber Jacket",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/jackets/bomber-jacket',
                youth: fitRootPath.youth + '/jackets',
            },
            gCat: 5598,
            hsCode: '6210.30.50.10',
            facets: jacketFacets
        },
        {
            name: "Overall",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack],
            categoryUrl: '/custom-products/custom-clothing/pants-bottoms/overalls',
            hsCode: '6103.42.20.25',
            gCat: 7132,
            facets: safetyTopFacets
        },
        {
            name: "Visor",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, hatBack, hatLeft, hatRight],
            categoryUrl: '/custom-products/custom-clothing/hats/visors',
            hsCode: '6505.00.15.40',
            gCat: 173,
            facets: headwearFacets
        },
        {
            name: "Blankets",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/blankets',
            hsCode: '6301.40.0010',
            gCat: 5910,
            facets: defaultFacets
        },
        {
            name: "Socks",
            designerMultiplier: 4,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/custom-clothing/socks/basic-print',
            hsCode: '6115.30.9010',
            gCat: 209,
            facets: defaultFacets
        },
        {
            name: "Chef Wear",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/custom-clothing/work-wear/restaurant',
            hsCode: '6103.22.00.10',
            gCat: 7235,
            facets: garmentTopFacets
        },
        {
            name: "Dog Wear",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            hsCode: '4201.00.6000',
            gCat: 5004,
            facets: defaultFacets
        },
        // {
        //     name: "Blouse",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront]
        // },
        // {
        //     name: "Pyjamas",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront]
        // },
        {
            name: "Golf Towels",
            designerMultiplier: 2,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/jerseys/sports/golf/towels',
            hsCode: '6302.60.0020',
            gCat: 4467,
            facets: defaultFacets
        },
        {
            name: "Sports Towels",
            designerMultiplier: 2,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/jerseys/sports/towels',
            hsCode: '6302.60.0020',
            gCat: 4126,
            facets: defaultFacets
        },
        {
            name: "Beach Towels",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/towels/beach-towels',
            hsCode: '6302.60.0020',
            gCat: 4126,
            facets: defaultFacets
        },
        {
            name: "Hand Towels",
            designerMultiplier: 2,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/towels/hand-towels',
            hsCode: '6302.60.0020',
            gCat: 576,
            facets: defaultFacets
        },
        {
            name: "Bath Towels",
            designerMultiplier: 1,
            printAllowed: {screenPrint: false, transfer: false},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/towels/bath-towels',
            hsCode: '6302.60.0020',
            gCat: 576,
            facets: defaultFacets
        },
        {
            name: "Cardigans",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/hoodies-sweaters/casual-sweaters',
                ladies: fitRootPath.ladies + '/sweatshirts',
                youth: fitRootPath.youth + '/sweatshirts'
            },
            hsCode: '6110.20.20.10',
            gCat: 203,
            facets: garmentTopFacets

        },
        // {
        //     name: "Knit Sweaters",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
        //     categoryUrl: '/custom-products/custom-clothing/hoodies-sweaters'
        // },
        // {
        //     name: "Jumpers",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight]
        // },
        // {
        //     name: "Skirt",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, pantsBack],
        //     categoryUrl: '/custom-products/custom-clothing/ladies'
        // },
        // {
        //     name: "Skort",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, pantsBack],
        //     categoryUrl: '/custom-products/custom-clothing/ladies'
        // },
        {
            name: "Short Pants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            catUrlMap: {
                unisex: '/custom-products/custom-clothing/pants-bottoms/shorts',
                youth: fitRootPath.youth + '/sweatpants-shorts'
            },
            hsCode: '6103.42.10.50',
            gCat: 204,
            facets: garmentBottomFacets
        },
        {
            name: "Athletic Pants",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, pantsBack],
            catUrlMap: {
                unisex: '/custom-products/jerseys/pants',
                youth: fitRootPath.youth + '/jerseys/pants-shorts'
            },
            hsCode: '6114.30.3060',
            gCat: 204,
            facets: garmentBottomFacets
        },
        // {
        //     name: "Blazers",
        //     designerMultiplier: 1,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
        //     categoryUrl: '/custom-products/custom-clothing/jackets'
        // },
        {
            name: "Bibs",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/custom-clothing/youth/all',
            hsCode: '6111.20.6020',
            gCat: 2125,
            facets: defaultFacets
        },
        {
            name: "Onesies",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/youth/onesies',
            hsCode: '6111.20.6020',
            gCat: 182,
            facets: garmentTopFacets
        },
        {
            name: "Masks",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/face-masks',
            hsCode: '9505.90.60.00',
            gCat: 5194,
            facets: defaultFacets
        },
        {
            name: "Gloves",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            hsCode: '6116.93.94.00',
            gCat: 1604,
            facets: defaultFacets
        },
        {
            name: "Journals",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.25,
            printLocations: [defaultFront, notebookBack],
            categoryUrl: '/custom-products/promotional/office-supplies/notebooks',
            hsCode: '4820.10.20.20',
            gCat: 961,
            facets: journalFacets
        },
        {
            name: "Bottles",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, drinkWareBack],
            categoryUrl: '/custom-products/promotional/drinkware/custom-bottles',
            hsCode: '7615.10.91.00',
            gCat: 3809,
            facets: drinkwareFacets
        },
        {
            name: "Tumblers",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, mugBack],
            categoryUrl: '/custom-products/promotional/drinkware/tumblers',
            hsCode: '7615.10.91.00',
            gCat: 2951,
            facets: drinkwareFacets
        },
        {
            name: "Mugs",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, mugBack],
            categoryUrl: '/custom-products/promotional/drinkware/mugs',
            hsCode: '6912.00.4400',
            gCat: 2169,
            facets: drinkwareFacets
        },
        {
            name: "Insulated Mugs",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, mugBack],
            categoryUrl: '/custom-products/promotional/drinkware/mugs',
            hsCode: '7615.10.91.00',
            gCat: 2169,
            facets: drinkwareFacets
        },
        {
            name: "Bottle Openers",
            designerMultiplier: 4,
            defaultWeight: 0.1,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/bottle-opener',
            hsCode: '7616.99.51.60',
            gCat: 3427,
            facets: defaultFacets
        },
        {
            name: "Pens",
            designerMultiplier: 3,
            defaultWeight: 0.025,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/office-supplies/custom-pens',
            hsCode: '9608.10.0000',
            gCat: 6065,
            facets: penFacets
        },
        {
            name: "Stickers",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products',
            hsCode: '4911.91.2040',
            gCat: 4054,
            facets: defaultFacets
        },
        {
            name: "Patches",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.1,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/patches',
            hsCode: '5810.91.0010',
            gCat: 6955,
            facets: defaultFacets
        },
        {
            name: "Padfolios",
            designerMultiplier: 3,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/office-supplies/padfolio',
            hsCode: '4820.10.20.20',
            gCat: 543641,
            facets: bagFacets
        },
        {
            name: "USB",
            designerMultiplier: 4,
            defaultWeight: 0.025,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/tech/usb',
            hsCode: '8523.51.0000',
            gCat: 3712,
            facets: techFacets
        },
        {
            name: "Chargers",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/tech/portable-chargers',
            hsCode: '8504.40.8500',
            gCat: 505295,
            facets: techFacets
        },
        {
            name: "Power Banks",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/tech/portable-chargers',
            hsCode: '8504.40.8500',
            gCat: 505295,
            facets: defaultFacets
        },
        {
            name: "Headphones",
            designerMultiplier: 3,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/tech/headphones',
            hsCode: '8518.30.2000',
            gCat: 505771,
            facets: techFacets
        },
        {
            name: 'Toys',
            designerMultiplier: 3,
            defaultWeight: 1,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            hsCode: '9503.00.00.90',
            gCat: 1253,
            facets: defaultFacets
        },
        {
            name: "Lanyards",
            designerMultiplier: 3,
            defaultWeight: 0.065,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/office-supplies/lanyards',
            hsCode: '6307.90.40.20',
            gCat: 6277,
            facets: defaultFacets
        },
        {
            name: 'Mousepads',
            designerMultiplier: 1,
            defaultWeight: 0.5,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            hsCode: '8473.30.91.00',
            gCat: 1993,
            facets: defaultFacets
        },
        {
            name: 'Pillows',
            designerMultiplier: 1,
            defaultWeight: 0.5,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, defaultFront],
            hsCode: '9404.90.10.30',
            gCat: 2700,
            facets: defaultFacets
        },
        {
            name: "Stress Relievers",
            designerMultiplier: 4,
            defaultWeight: 0.065,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/office-supplies/stress-balls',
            hsCode: '9503.00.00.90',
            gCat: 1253,
            facets: defaultFacets
        },
        {
            name: "Umbrellas",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/umbrellas',
            hsCode: '6601.10.0000',
            gCat: 4358,
            facets: defaultFacets
        },
        {
            name: "Sunglasses",
            designerMultiplier: 3,
            defaultWeight: 0.05,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/sunglasses',
            hsCode: '9004.10.00.00',
            gCat: 178,
            facets: defaultFacets
        },
        {
            name: "Coasters",
            designerMultiplier: 3,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/coasters',
            hsCode: '4419.90.91.00',
            gCat: 2363,
            facets: defaultFacets
        },
        {
            name: "Sticky Notes",
            designerMultiplier: 3,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: '/custom-products/promotional/office-supplies/sticky-notes',
            hsCode: '4820.10.20.20',
            gCat: 2689,
            facets: defaultFacets
        },
        {
            name: "Keychains",
            designerMultiplier: 4,
            defaultWeight: 0.05,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront],
            hsCode: '7616.99.51.60',
            gCat: 175,
            facets: defaultFacets
        },
        {
            name: "Koozies",
            designerMultiplier: 4,
            defaultWeight: 0.02,
            printAllowed: {screenPrint: true, transfer: true},
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/drinkware/beer-koozies',
            hsCode: '3924.10.4000',
            gCat: 4520,
            facets: defaultFacets
        },
        {
            name: "Candles",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.5,
            printLocations: [defaultFront, blankSquareBack],
            categoryUrl: '/custom-products/promotional/outdoor-leisure/candles',
            hsCode: '3406.00.0000',
            gCat: 588,
            facets: defaultFacets

        },
        {
            name: "Speakers",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront],
            categoryUrl: "/custom-products/promotional/tech/speakers",
            hsCode: '8517.62.0090',
            gCat: 249,
            facets: techFacets
        },
        {
            name: "Non-woven Shopping Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: '/custom-products/custom-bags/shopping/non-woven',
            gCat: 5608,
            hsCode: '4202.92.9100',
            facets: bagFacets

        },
        {
            name: "Grocery Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: '/custom-products/custom-bags/shopping/grocery',
            hsCode: '4202.92.1500',
            gCat: 5608,
            facets: bagFacets
        },
        {
            name: "Recycled Shopping Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: "/custom-products/custom-bags/shopping/recycled",
            hsCode: '4202.92.9100',
            gCat: 5608,
            facets: bagFacets
        },
        {
            name: "Laminated Shopping Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: '/custom-products/custom-bags/shopping/laminated',
            hsCode: '4202.92.9100',
            gCat: 5608,
            facets: bagFacets
        },
        {
            name: "Insulated Shopping Bags",
            designerMultiplier: 2,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, toteBagBack],
            categoryUrl: "/custom-products/custom-bags/shopping/insulated",
            hsCode: '4202.92.9100',
            gCat: 5608,
            facets: bagFacets
        },
        {
            name: "Golf Balls",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 1,
            printLocations: [defaultFront, golfBallBack],
            categoryUrl: '/custom-products/jerseys/sports/golf/balls',
            hsCode: '9506.32.0000',
            gCat: 1045,
            facets: defaultFacets
        },
        {
            name: "Hockey Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports/hockey',
                youth: fitRootPath.youth + '/jerseys/hockey'
            },
            hsCode: '6114.30.3060',
            gCat: 3958,
            facets: garmentTopFacets
        },
        {
            name: "Football Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports',
                youth: fitRootPath.youth + '/jerseys/all'
            },
            hsCode: '6114.30.3060',
            gCat: 3888,
            facets: garmentTopFacets
        },
        {
            name: "Volleyball Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports/volleyball',
                youth: fitRootPath.youth + '/jerseys/volleyball'
            },
            hsCode: '6114.30.3060',
            gCat: 3598,
            facets: garmentTopFacets
        },
        {
            name: "Basketball Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports/basketball',
                youth: fitRootPath.youth + '/jerseys/basketball'
            },
            hsCode: '6114.30.3060',
            gCat: 3439,
            facets: garmentTopFacets
        },
        {
            name: "Baseball Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports/baseball',
                youth: fitRootPath.youth + '/jerseys/baseball'
            },
            hsCode: '6114.30.3060',
            gCat: 3191,
            facets: garmentTopFacets
        },
        {
            name: "Soccer Jerseys",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            catUrlMap: {
                unisex: '/custom-products/jerseys/sports/soccer',
                youth: fitRootPath.youth + '/jerseys/soccer'
            },
            hsCode: '6114.30.3060',
            gCat: 5564,
            facets: garmentTopFacets
        },
        // {
        //     name: "Lunch Boxes",
        //     designerMultiplier: 4,
        //     printAllowed: {screenPrint: true, transfer: true},
        //     defaultWeight: 0.8,
        //     printLocations: [defaultFront, bagRight, bagLeft]
        // },
        {
            name: "Scrubs",
            designerMultiplier: 1,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.8,
            printLocations: [defaultFront, shirtBack, shirtLeft, shirtRight],
            categoryUrl: '/custom-products/custom-clothing/work-wear/scrubs',
            hsCode: '6103.22.00.10',
            gCat: 2928,
            facets: garmentTopFacets
        },
        {
            name: "Swag Boxes",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.5,
            printLocations: [defaultFront],
            hsCode: '4819.10.0040',
            gCat: 166,
            facets: defaultFacets
        },
        {
            name: "Greeting Cards",
            designerMultiplier: 4,
            printAllowed: {screenPrint: true, transfer: true},
            defaultWeight: 0.06,
            printLocations: [defaultFront],
            hsCode: '4909.00.4000',
            gCat: 95,
            facets: defaultFacets
        },
    ]

//DESIGNER STUFF AND TOOLS

// standard print locations
    var leftChest = 'Left Chest'
    var rightChest = 'Right Chest'
    var front = 'Front'
    var back = 'Back'
    var upperLeftSleeve = 'Left Sleeve'
    var upperRightSleeve = 'Right Sleeve'
    var leftCuff = 'Left Cuff'
    var rightCuff = 'Right Cuff'
    var backNape = 'Back Nape'
    var leftSide = 'Left Side'
    var rightSide = 'Right Side'
    var leftThigh = 'Left Thigh'
    var rightThigh = 'Right Thigh';

    var standardPrintLocations = [
        leftChest, rightChest, front, back, upperLeftSleeve, upperRightSleeve, leftCuff, rightCuff, backNape, leftSide, rightSide, leftThigh, rightThigh
    ]
    var standardEmbroideryFonts = [
        'Arial', 'Athletic', 'Constania', 'Microsoft Sans Serif', 'Market', 'Handy Script', 'Block 2', 'Old English Font', 'Oswald', 'Tinos', 'Script 2'
    ]

    function autoTagAllProductFacets(product, facetOptionsMap) {
        if (product.category) {
            var foundCategory = _.find(allCategories, function(cat) {
                return cat.name === product.category
            })
            if (foundCategory) {
                _.forEach(foundCategory.facets, function(facetKey) {
                    var foundFacet;
                    if (product.facets) {
                        foundFacet = _.find(product.facets, function(productFacet) {
                            return productFacet.key === facetKey
                        })
                    }
                    if (!foundFacet){
                        if (!product.facets) {
                            product.facets = []
                        }
                        product.facets.push({
                            key: facetKey,
                            selectedOptions: [],
                            manuallyAssigned: [],
                            blacklistOptions: []
                        })

                    }
                })
            }

            _.forEach(product.facets, function(productFacet){
                // keep manual assigned attributes
                productFacet.selectedOptions = _.filter(productFacet.selectedOptions, function(selectedOption) {
                    var manuallyAssigned = _.find(productFacet.manuallyAssigned, function(manual) {
                        return manual === selectedOption
                    })
                    return manuallyAssigned
                });
                var foundFacetDefinition = facetDefinitionsMap[productFacet.key];
                if (foundFacetDefinition) {
                    // console.log('Tagging product facet: ' + productFacet.key);
                    // console.log(productFacet);
                    if (facetOptionsMap) {
                        foundFacetDefinition.options = facetOptionsMap[productFacet.key]
                    } else {
                        foundFacetDefinition.options = [];
                    }
                    autoTagProductFacet(product, productFacet, foundFacetDefinition)
                } else {
                    console.error('did not find ' + productFacet.key)
                }
            });

            // keep filled out facets
            var filteredFacets =  _.filter(product.facets, function(productFacet) {
                return productFacet.selectedOptions.length > 0 || productFacet.blacklistOptions.length > 0
            })
            product.facets = filteredFacets;

        }
    }

    // phrase = [['drawcord','drawstring'], ['waist', 'hip']]
    // combinations =
    // 1) drawcord and waist
    // 2) drawcord and hip
    // 3) drawstring and waist
    // 4) drawstring and hip
    function getAllPhraseCombination(phrases) {
        var normalizedPhrases = phrases.map(keyword =>
            Array.isArray(keyword) ? keyword.map(k => k.toLowerCase()) : [keyword.toLowerCase()]
        );

        function cartesianProduct(arrays) {
            if (arrays.length === 0) return [[]]; // Base case: Return empty array
            const firstArray = arrays[0];
            const rest = cartesianProduct(arrays.slice(1));
            return firstArray.flatMap(item =>
                rest.map(combination => [item, ...combination])
            );
        }


        var combinations = cartesianProduct(normalizedPhrases);

        return combinations;
    }

    function getAllTaggableMetadata(product) {
        // 1. must test each description individually for existence of all text in phrase
        // within description, split by comma, periods and line breaks
        var descriptions = (_.map(product.description, function(descriptionLine) {
            return descriptionLine.split(/\.\s+|\n/)
        })).flat()
        var stringsToCheck = [product.name, product.category, ...descriptions, ...product.tags]
        stringsToCheck = _.map(stringsToCheck, function(stringPhrase) {
            return ' ' + stringPhrase.toLowerCase() + ' ';
        })
        return stringsToCheck;
    }

    function autoTagProductFacet(product, productFacet, facetDefinition) {
        if (facetDefinition.manualAssign) {
            // console.log(facetDefinition.name + ' facet attribute is manually assigned.');
            return;
        } else {
            var stringsToCheck = getAllTaggableMetadata(product);
            _.forEach(facetDefinition.options, function(facetAttribute) {
                var match;
                if (facetAttribute.noAutoAssign) {
                    // console.log(facetAttribute.name + ' no auto assign allowed');
                    return;
                }
                // blacklist certain categories
                if (facetAttribute.blacklistCategories && facetAttribute.blacklistCategories.includes(product.category)) {
                    // console.log(facetAttribute.name + ' do not match on category ' + product.category);
                    return;
                }
                // legacy
                if (facetAttribute.keywords) {
                    match = _.some(facetAttribute.keywords, function (keyword) {
                        return productHasKeyword(stringsToCheck, keyword.toLowerCase());
                    })
                } else if (facetAttribute.phrase) {

                    var combinations = getAllPhraseCombination(facetAttribute.phrase);
                    match = _.some(combinations, function (combination) {
                        return _.some(stringsToCheck, function (sentence) {
                            return _.every(combination, function (keyword) {
                                if (keyword) {
                                    return productHasKeyword([sentence], keyword, facetDefinition.shoudSplitPunctuation)
                                }
                            })

                        })
                    });
                } else {
                    // use product name
                    match = productHasKeyword(stringsToCheck, facetAttribute.name.toLowerCase())
                }

                if (match) {
                    if (productFacet.blacklistOptions) {
                        if (productFacet.blacklistOptions.includes(facetAttribute.name)){
                            // console.log(facetAttribute.name + ' is blacklisted');
                            return;
                        }
                    }
                    // console.log('Match on tag: ' + facetAttribute.name)
                    if (!facetDefinition.multiple && productFacet.selectedOptions.length > 0) {
                        // console.log('Already has a match - Skip tagging: ' + facetAttribute.name);
                        return;
                    }

                    if (productFacet.manuallyAssigned.includes(facetAttribute.name)) {
                        return;
                    }
                    // console.log(facetAttribute.name +  ' ' + facetDefinition.name);
                    productFacet.selectedOptions.push(facetAttribute.name);
                }
            })
        }
    }

    // should split punctuation - descriptors usually pack in multiple matching keywords within the same description line, split by punctuation ',' should
    // treat them as separate strings to check
    function productHasKeyword(stringsToCheck, keyword, shouldSplitPunctuation) {
        if (shouldSplitPunctuation) {
            stringsToCheck = (_.map(stringsToCheck, function(descriptionLine) {
                return descriptionLine.split(/, /)
            })).flat()
        }
        var match = _.some(stringsToCheck, function (sentence) {
            function isNegated(keyword) {
                var regex = new RegExp(`\\b(no|not)\\s+${keyword}\\b`, 'i');
                return regex.test(sentence);
            }
            return sentence.includes(keyword) && !isNegated(keyword)
        });

        return match
    }

    exports.standardPrintLocations = standardPrintLocations;
    exports.standardEmbroideryFonts = standardEmbroideryFonts;
    exports.allCategories = allCategories;
    exports.listOfAllFits = listOfAllFits;
    exports.defaultCategory = defaultCategory;
    exports.facetDefinitionsMap = facetDefinitionsMap;
    exports.autoTagAllProductFacets = autoTagAllProductFacets;
    exports.getAllPhraseCombination = getAllPhraseCombination;
    exports.getAllTaggableMetadata = getAllTaggableMetadata;
})(typeof exports === 'undefined' ?
    this['categoryService'] = {} : exports);




'use strict';

/* jshint ignore:start */
(function (app) {

    var that;
    var fromClient;
    var _
    if (app.name) {
        app = {};
        fromClient = true;

        that = window;
    } else {
        that = app;
    }

    var fromClient


    /**
     * Created by eddisonng on 2016-11-06.
     */

    app.orderTotalMinusTax = function(order, subtotalOverride) {

        return order.subTotalPrice - order.discountAmount + order.shippingCost
    }
//includes tax
    app.orderTotal = function(order){
        return order.subTotalPrice - order.discountAmount + order.shippingCost + order.gst + order.pst
    }

    app.recalculateOrderSubtotal = function(order) {
        //subtotal
        var newSubTotal = 0;
        for (var i = 0; i < order.listOfItems.length; i++) {
            newSubTotal = order.listOfItems[i].totalQty * order.listOfItems[i].price + newSubTotal
        }
        order.subTotalPrice = newSubTotal
    }

    app.recalculateDiscountAmount = function(order) {
        var setupDiscount = order.setupDiscountExempt ? 0 : order.fixedSetupDiscount;
        if (order.discountPercentage <= 1){
            order.discountAmount = order.fixedDiscountAmount +  setupDiscount + ((order.subTotalPrice - order.fixedDiscountAmount - setupDiscount) * order.discountPercentage)
        }
    }

    app.getAmountOwing = function(order){
        return app.orderTotal(order) - order.amountPaid;
    }

    app.createStatus = function(status, user, message){
        var username
        if (user && user.username){
            username = user.username
        }

        return {
            status :status,
            timeStamp : new Date(),
            username : username,
            message: message
        }
    }

    app.getLastStatusDate = function(order){
        if (order && order.status && order.status.length){
            return order.status[order.status.length - 1].timeStamp
        } else {
            return false
        }
    }

    app.getTrackOrderLink = function(order){
        if (order){
            var orderNumberParam = "?order=" + order.number;
            var postalCodeParam = "";
            if (order.shippingAddress) {
                postalCodeParam = order.shippingAddress.zip ? "&pc=" + order.shippingAddress.zip : "";
            }
            return encodeURI("/track-order" + orderNumberParam + postalCodeParam);
        }
    }



    app.getOrderStatus = function(order){
        if (order && order.status && order.status.length){
            return order.status[order.status.length - 1].status
        } else {
            return false
        }
    }

    app.setOrderStatus = function(order, status,user, message){
        if (order){
            var statusArray = [app.createStatus(status,user, message)]
            if (order.status && Array.isArray(order.status)){
                order.status = order.status.concat(statusArray)
            } else {
                order.status = statusArray
            }
        }
    }

    app.obfuscateNumber =  function (order){
        if (order && order.number) {
            var numberString = String(order.number);
            var obfuscatedChar = String.fromCharCode((new Date(order.datePlaced).getTime()) % 26 + 65); // 65 is the char code for 'A'
            return "CR" + obfuscatedChar + "-" + numberString;
        } else {
            return order.number;
        }
    }

    app.getAddressTooltipHelper = function(address) {
        if (address) {
            var phoneLine = address.phone ? '<div>' + address.phone + '</div>': '';
            var nameLine = address.name? '<div>' + address.name + '</div>': '';
            var street1 = '<div>' + address.street1 + '</div>';
            var street2 = '';
            if (address.street2) {
                street2 = '<div>' + address.street2 + '</div>';
            }
            var addressLine = '<div>' + address.city + ' ' + address.state + ' ' + address.zip + ' ' + address.country + '</div>'
            return phoneLine + nameLine + street1 + street2 + addressLine;
        }
    }


    if (fromClient) {
        for (var functionName in app) {
            window[functionName] = app[functionName]
        }
    }


})(typeof app === 'undefined' ? this : app);




// shared module used by both public and admin
(function () {
    'use strict';
    angular.module('sharedModule', [])
})();
(function () {
    'use strict';


    angular.module('landingPageModule', [])
        .directive('landingPage', LandingPageDirective)
        .directive('bannerSection', BannerSectionDirective)
        .directive('leftAlignedImageSection', LeftAlignedImageSection)
        .directive('leftAlignedTextSection', LeftAlignedTextSection)
        .directive('shippingValuePropSection', ShippingValuePropSection)
        .directive('faqSection', FAQSection)
        .directive('imageRowSection', ImageRowSection)
        .directive('leftColumnSection', LeftColumnSection)
        .directive('rightColumnSection', RightColumnSection)
        .directive('productListSection', ProductListSection)
        .directive('valuePropSection', ValuePropositionSection)
        .directive('turnaroundPropSection', TurnaroundPropositionSection)
        .directive('bestSellersSection', BestSellersSection)
        .directive('configurableBrandsSection', ConfigurableBrandsSection)
        // Static
        .directive('merchSection', MerchSection)
        .directive('clientsSection', ClientsSection)
        .directive('reviewsSection', ReviewsSection)
        .directive('brandsSection', BrandsSection)
        .directive('popularCategoriesSection', PopularCategoriesSection)
        .directive('mapSection', MapSection)
        .directive('designReviewSection', DesignReviewSection)
        .directive('verticalItemList', VerticalItemList)
        .directive('locationSection', LocationSection)
        .directive('ourCompassSection', OurCompassSection)

    // other
        .directive('richtext', RichTextDirective);

    RichTextDirective.$inject = ['$rootScope']

    function RichTextDirective($rootScope) {
        var directive = {
            link: link,
            templateUrl: 'shared/js/widget/pageTemplate/rich-text-directive.html',
            restrict: 'EA',
            scope: {
                richHtml: '='
            }
        };
        return directive;

        function link($scope, element, attrs) {
        }
    }

    LandingPageDirective.$inject = ['CommonUtilService', '$rootScope', '$location', '$timeout'];

    function LandingPageDirective(CommonUtilService, $rootScope, $location, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                pageTemplate: '=',
                locationMetadata: '=',
                currentLocale: '=',
                fromAdmin: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/landing-page.html',
            link: link
        };

        function link($scope, elem, attr) {
            activate();

            $scope.recSkus;
            $scope.disableProductSort;

            function activate() {
                var HEADER_SECTIONS = [
                    modelService.PAGE_SECTIONS.BANNER,
                    modelService.PAGE_SECTIONS.IMAGE_ROW,
                    modelService.PAGE_SECTIONS.LEFT_ALIGNED_TEXT,
                    modelService.PAGE_SECTIONS.LEFT_COLUMNED,
                    modelService.PAGE_SECTIONS.PRODUCTS,
                    modelService.PAGE_SECTIONS.FEATURED_PRODUCTS,
                    modelService.PAGE_SECTIONS.BEST_SELLERS
                ]

                var multipleProducts = _.filter($scope.pageTemplate.sections, function(section) {
                    return section.sectionProps.sectionType === modelService.PAGE_SECTIONS.PRODUCTS
                });
                $scope.disableProductFilters = multipleProducts.length > 1;


                var featuredProducts = _.find($scope.pageTemplate.sections, function(section) {
                    return section.sectionProps.sectionType === modelService.PAGE_SECTIONS.FEATURED_PRODUCTS
                })
                if (featuredProducts) {
                   $scope.recSkus = _.filter(_.map(featuredProducts.sectionProps.skus.dataProps.dataTypeList, function (productDataType) {
                        return productDataType.dataProps.sku;
                    }));
                }

                var headerIndex;
                var searchIndex = 0;
                while(!_.isNumber(headerIndex)) {
                    if (searchIndex >= $scope.pageTemplate.sections.length) {
                        break;
                    }

                    var sectionToCheck = $scope.pageTemplate.sections[searchIndex]
                    if (!sectionToCheck) {
                        break;
                    }
                    if (sectionToCheck.sectionVisible && HEADER_SECTIONS.includes(sectionToCheck.sectionProps.sectionType)) {
                        if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.BANNER) {
                            var bannerProps = sectionToCheck.sectionProps;
                            if (bannerProps.sectionHeader.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.IMAGE_ROW) {
                            // sometimes image section has no text, if so the next section should be considered
                            var imageProps = sectionToCheck.sectionProps;
                            if (imageProps.title.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.LEFT_ALIGNED_TEXT) {
                            var textProps = sectionToCheck.sectionProps;
                            if (textProps.sectionTitle.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.FEATURED_PRODUCTS) {
                           // continue - deprecated
                        } else {
                            headerIndex = searchIndex;
                        }
                    }
                    searchIndex++;
                }

                if(_.isNumber(headerIndex)) {
                    $scope.headerSectionIndex = headerIndex;
                } else {
                    var foundSectionIndex = _.findIndex($scope.pageTemplate.sections, function(section) {
                        return section.sectionVisible;
                    })
                    if (foundSectionIndex > -1) {
                        $scope.headerSectionIndex = foundSectionIndex;
                    } else {
                        $scope.$emit('headerSectionLoaded');
                    }
                }
            }

            $scope.whenSectionReady = function(index) {
                    // console.log('Loaded: section ' + index + ' ' + $scope.pageTemplate.sections[index].sectionProps.sectionType);
                    if (index === $scope.headerSectionIndex) {
                        $scope.$emit('headerSectionLoaded');
                    }
            }

            $scope.sectionStyles = function(sectionStyles) {
                var styles = {}
                if (sectionStyles.backgroundColour) {
                    styles['background-color'] = sectionStyles.backgroundColour
                }
                return styles;
            }
        }
    }

    function BannerSectionDirective($timeout, $rootScope, matchmedia) {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                bannerProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/banner-section.html',
            link: function($scope){
                $scope.banner = {
                    backgroundImage: ""
                }

                $scope.$watch('bannerProps', function(newValue, oldValue) {
                    if (oldValue) {
                        handleMediaChange();
                    }
                }, true)

                $scope.watchers = [];

                $scope.watchers.push(
                    matchmedia.onPhone(function(mediaQuery) {
                        if(matchmedia.isPhone()) {
                            handleMediaChange();
                        }
                    })
                )

                $scope.watchers.push(
                    matchmedia.onTablet(function(mediaQuery) {
                        if (matchmedia.isTablet()) {
                            handleMediaChange();
                        }
                    })
                )

                $scope.watchers.push(
                    matchmedia.onDesktop(function(mediaQuery) {
                        if (matchmedia.isDesktop()) {
                            handleMediaChange();
                        }
                    })
                )

                function handleMediaChange() {
                    if (matchmedia.isPhone() && $scope.bannerProps.backgroundImageMobile.dataProps.imageUrl) {
                        $scope.banner.deviceType = 'PHONE';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImageMobile.dataProps.imageUrl;
                    } else if (matchmedia.isTablet() && $scope.bannerProps.backgroundImageTablet.dataProps.imageUrl) {
                        $scope.banner.deviceType = 'TABLET';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImageTablet.dataProps.imageUrl;
                    } else {
                        $scope.banner.deviceType = 'DESKTOP';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImage.dataProps.imageUrl;
                    }
                    $scope.banner.noImageSrcSet = $scope.banner.deviceType === 'DESKTOP';
                    $scope.banner.backgroundImage = $rootScope.compressImage($scope.banner.backgroundImage);
                    // update scope after digest
                    $timeout(function() {
                       $scope.$apply()
                    })
                }

                $scope.$on('$destroy', function() {
                    _.forEach($scope.watchers, function(watcher){
                        watcher();
                    })
                })

                // banner styles
                $scope.mainBannerStyle = function() {
                    return {
                        'padding-top': !$scope.banner.backgroundImage ? '1vh' : '',
                        'padding-bottom': !$scope.banner.backgroundImage ? '1vh' : '',
                    }
                }
            }
        };
    }

    function LeftAlignedImageSection() {
        return {
            restrict: 'EA',
            scope: {
                laiProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-aligned-image-section.html',
            link: function($scope){
                $scope.isHeaderStyle = {};
                $scope.isBlogStyle = {};
                $scope.imageContainerStyle = {};
                $scope.aspectRatioStyle = {};

                try {
                    var isBlog = $scope.laiProps.isBlog.dataProps.booleanValue;
                    if (isBlog) {
                        if ($scope.isHeading) {
                            $scope.isHeaderStyle = {
                                'padding-left': '0px',
                                'padding-right': '0px'
                            }
                            $scope.isBlogStyle = {
                                'margin': 'auto',
                                'max-width': '1600px',
                                'overflow': 'hidden',
                                'max-height': '50vh'
                            }
                        } else {
                            $scope.isBlogStyle = {
                                'margin': 'auto'
                            }
                        }
                    }

                    var imageWidth = $scope.laiProps.imageWidth.dataProps.textValue;
                    var imageHeight = $scope.laiProps.imageHeight.dataProps.textValue;



                    if (imageWidth && imageHeight) {
                        // $scope.imageContainerStyle = {
                            // 'max-width' : imageWidth + 'px',
                            // 'max-height' : imageHeight + 'px',
                        // }
                        var aspectRatio = Number(imageHeight) / Number(imageWidth);
                        if (aspectRatio) {
                            $scope.aspectRatioStyle = {
                                'padding-bottom': 'calc(' + aspectRatio + ' * 100%)'
                            }
                        }
                    }

                } catch(e) {

                }

            }
        };
    }

    function LeftAlignedTextSection() {
        return {
            restrict: 'EA',
            scope: {
                latProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-aligned-text-section.html',
            link: function($scope){
                try {
                    $scope.isBlogStyle;
                    $scope.sectionStyle;

                    var isBlog = $scope.latProps.isBlog.dataProps.booleanValue;
                    if (isBlog) {
                        $scope.isBlogStyle = {
                            'margin': 'auto',
                        }

                        $scope.sectionStyle = {
                            'padding-top': $scope.latProps.disableTopPadding.dataProps.booleanValue ? '0': '25px',
                            'padding-bottom': $scope.latProps.disableBottomPadding.dataProps.booleanValue ? '0': '25px'
                        }
                    } else {
                        $scope.sectionStyle = {
                            'padding-top': $scope.latProps.disableTopPadding.dataProps.booleanValue ? '0': '5vw',
                            'padding-bottom': $scope.latProps.disableBottomPadding.dataProps.booleanValue ? '0': '5vw'
                        }
                    }
                } catch(e) {

                }
            }
        };
    }

    function ShippingValuePropSection() {
        return {
            restrict: 'EA',
            scope: {
                shipProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/shipping-value-prop-section.html',
            link : function($scope){
                $scope.getDueDate = function(shippingTimeOverride){
                    var shipTime;
                    if (shippingTimeOverride) {
                        shipTime = parseInt(shippingTimeOverride);
                    } else {
                        shipTime = 3;
                    }
                    var today = new Date()
                    var dueDate = moment(dateService.addBusinessDays(shipTime, today),"ddd MMM Do YYYY")
                    return {
                        month : moment(dueDate).format("MMM"),
                        date : moment(dueDate).format("D")
                    }
                };
            }
        };
    }

    function VerticalItemList() {
        return {
            restrict: 'EA',
            scope: {
                itemListProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/vertical-item-list-section.html',
            link: function($scope){
                $scope.itemList = []

                activate();

                function activate() {
                    getItemList();
                    // $scope.$watch("itemListProps", function() {
                    //     getItemList();
                    // }, true)
                }

                function getItemList() {
                    var images = $scope.itemListProps.images.dataProps.dataTypeList;
                    var headers = $scope.itemListProps.headers.dataProps.dataTypeList;
                    var descriptions = $scope.itemListProps.descriptions.dataProps.dataTypeList;

                    $scope.itemList = _.map(headers, function(header, index) {
                        return {
                            header: header,
                            image: images[index],
                            description: descriptions[index]
                        }
                    });
                }
            }
        };
    }

    function MapSection($rootScope, $sce, SEOService) {
        return {
            restrict: 'EA',
            scope: {
                mapProps: '=',
                city : '@city',
                province : '@province'
            },
            templateUrl: 'shared/js/widget/pageTemplate/map-section.html',
            link: function($scope){
                // console.log($scope.city)
                // console.log($scope.province)
                $scope.mapMetadata = {
                    mapUrl: "",
                    localPhone: "",
                    street1: "",
                    street2: "",
                    city: "",
                    province: "",
                    zip: "",
                    hours: ""
                }

                var vancouverMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2606.7053090474706!2d-123.11972988475807!3d49.20614968411198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486769f38599947%3A0xfab5117abf828aea!2sCoastal%20Reign%20Printing!5e0!3m2!1sen!2sca!4v1613157174603!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.local : "",
                    street1: "8793 Cambie Street",
                    city: "Vancouver",
                    province: "BC",
                    zip: "V6P3J9",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (PST)"
                }

                var torontoMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11554.753761632093!2d-79.5144381!3d43.6130283!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xebbcec353dd53df7!2sCoastal%20Reign%20Printing%20Ltd!5e0!3m2!1sen!2sca!4v1644950179406!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localToronto : "",
                    street1: "310 Judson Street",
                    street2: "Unit 3",
                    city: "Toronto",
                    province: "ON",
                    zip: "M8Z5T6",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (EST)"
                }

                var calgaryMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.401557435896!2d-114.08397068439176!3d51.04596007956624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716fe76e972825%3A0xf73991494c057f87!2sCoastal%20Reign%20Printing!5e0!3m2!1sen!2sca!4v1648166666666!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localCalgary : "",
                    street1: "903 8 Ave SW",
                    street2: "9th Floor, Suite 900",
                    city: "Calgary",
                    province: "AB",
                    zip: "T2P0P7",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (MST)"
                }

                var newYorkMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3695.7445298284647!2d-73.98700572349871!3d40.74623973551804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2593957bcef7f%3A0xd89dedda4cab9127!2sCoastal%20Reign%20Printing!5e1!3m2!1sen!2sca!4v1740423326197!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localNewYork : "",
                    street1: "136 Madison Avenue",
                    street2: "Suite 555-03",
                    city: "New York",
                    province: "NY",
                    zip: "10016",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (EST)"
                }

                var locationOverride = !_.isEmpty($scope.mapProps) ? $scope.mapProps.locationOverride.dataProps.textValue: null;
                if(locationOverride) {
                    if (locationOverride.toLowerCase() == 'vancouver') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = vancouverMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'toronto') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = torontoMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'calgary') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = calgaryMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'new york') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = newYorkMapMetadata;
                    }
                } else {
                    if ($scope.city == "Vancouver" && $scope.province == "BC") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = vancouverMapMetadata
                    }
                    if ($scope.city == "Toronto" && $scope.province == "ON") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = torontoMapMetadata
                    }
                    if ($scope.city == "Calgary" && $scope.province == "AB") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = calgaryMapMetadata
                    }
                    if ($scope.city == "New York City" && $scope.province == "NY") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = newYorkMapMetadata
                    }
                }
                if ($scope.locationInformation) {
                    $scope.jsonld = SEOService.localeBusinessSchema($scope.mapMetadata.city);
                }

                $scope.getStreet = function() {
                    var street2 = $scope.mapMetadata.street2 ? $scope.mapMetadata.street2 + " - ": "";
                    return street2 + $scope.mapMetadata.street1
                }
            }
        };
    }

    function ValuePropositionSection() {
        return {
            restrict: 'EA',
            scope: {
                valueProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/value-prop-section.html',
            link: function(){}
        };
    }

    function TurnaroundPropositionSection() {
        return {
            restrict: 'EA',
            scope: {
                turnaroundProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/turnaround-prop-section.html',
            link: function(){}
        };
    }

    DesignReviewSection.$inject = ['CountryService']
    function DesignReviewSection(CountryService) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/design-review-section.html',
            link: function($scope){
                $scope.popoverText = CountryService.textFindAndReplace('Our artists will send you over a high quality mockup with the placement, print size and specific colours used in your print. Your final print will match your mockup specifications, guaranteed.');
            }
        };
    }

    function PopularCategoriesSection($rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/popular-categories-section.html',
            link: function($scope){

                $scope.madeInLabel =  {
                    "dataProps": {
                        "textValue": $rootScope.fromUS() ? 'Made in USA' : "Made In Canada",
                        "url": $rootScope.fromUS() ? "custom-products/custom-clothing/made-in-usa": "custom-products/custom-clothing/made-in-canada",
                    },
                }

                $scope.madeInImage =   {
                    "dataProps": {
                        "imageUrl":
                            $rootScope.fromUS() ?
                                "https://file-uploads-cr.s3.amazonaws.com/Clothing%20Made%20in%20USA_1737065897561.png":
                                "https://file-uploads-cr.s3.amazonaws.com/Made%20in%20Canada%20clothing_1683050559479.jpg",
                        "imageHyperLink": $rootScope.fromUS() ? "custom-products/custom-clothing/made-in-usa": "custom-products/custom-clothing/made-in-canada",
                        "altText": "Browse products manufactured in " + $rootScope.fromUS() ? " the USA": "Canada",
                    },
                }
                $scope.genericCategories =
                    [
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": "Most Popular Categories"
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Stormtech%20Shirts_1683153552764.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/t-shirts",
                                                    "altText": "An image of custom t-shirts that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Jerzees%20Hoodies%20and%20Sweatshirts__1683064248197.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/hoodies-sweaters",
                                                    "altText": "An image of custom hoodies and crewnecks that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Hats_1691771024734.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/hats",
                                                    "altText": "An image of custom hats that you can embroider your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Ecofriendly%20tote%20bags_1683050415972.jpg",
                                                    "imageHyperLink": "custom-products/custom-bags/tote-bags",
                                                    "altText": "An image of custom tote bags that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "T-Shirts",
                                                    "url": "custom-products/custom-clothing/t-shirts"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Hoodies and Crewnecks",
                                                    "url": "custom-products/custom-clothing/hoodies-sweaters"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Hats",
                                                    "url": "custom-products/custom-clothing/hats"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Tote Bags",
                                                    "url": "custom-products/custom-bags/tote-bags"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            },
                            "_id": "6451499deafa0da4c842e88b"
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Coal%20Harbour%20Jackets_1683064324620.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/jackets",
                                                    "altText": "An image of custom jackets that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Vests%20copy_1687556439978.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/jackets/vests",
                                                    "altText": "An image of custom vests that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Custom%20Sport%20jerseys_1683050491889.jpg",
                                                    "imageHyperLink": "custom-products/jerseys",
                                                    "altText": "An image of custom jerseys that you can print your team's design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Drinkware_1697739528054.jpg",
                                                    "imageHyperLink": "custom-products/promotional/drinkware",
                                                    "altText": "An image of custom drinkware that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "Jackets",
                                                    "url": "custom-products/custom-clothing/jackets"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Vests",
                                                    "url": "custom-products/custom-clothing/jackets/vests"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Jerseys",
                                                    "url": "custom-products/jerseys"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Drinkware",
                                                    "url": "custom-products/promotional/drinkware"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            $scope.madeInImage,
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Christmas%20Gift_1683064440263.jpg",
                                                    "imageHyperLink": "custom-products/promotional/company-swag-box",
                                                    "altText": "An image of custom swag boxes that you can build and order for your company!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Ecofriendly_1687556390798.jpg",
                                                    "imageHyperLink": "custom-products/eco-friendly-products",
                                                    "altText": "An image of eco friendly sign, we offer a variety of eco friendly products that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Notebooks_1683820761894.jpg",
                                                    "imageHyperLink": "custom-products/promotional/office-supplies/notebooks",
                                                    "altText": "An image of custom notebooks that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            $scope.madeInLabel,
                                            {
                                                "dataProps": {
                                                    "textValue": "Swag Boxes",
                                                    "url": "custom-products/promotional/company-swag-box"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Eco-Friendly",
                                                    "url": "custom-products/eco-friendly-products"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Notebooks",
                                                    "url": "custom-products/promotional/office-supplies/notebooks"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Technology_1724875401005.jpg",
                                                    "imageHyperLink": "custom-products/promotional/tech",
                                                    "altText": "An image of technology gadgets that you can print your logo on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Dress+Socks_1691787791428.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/socks",
                                                    "altText": "An image of custom socks that you can print your logo or designs on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Patches_1683050631692_1687556069173.jpeg",
                                                    "imageHyperLink": "custom-products/patches",
                                                    "altText": "An image of custom patches that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Shop%20by%20use_1683820891654.jpg",
                                                    "imageHyperLink": "custom-products",
                                                    "altText": "An image of custom products that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "Technology",
                                                    "url": "custom-products/promotional/tech"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Socks",
                                                    "url": "custom-products/custom-clothing/socks"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Patches",
                                                    "url": "custom-products/patches"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "And More...",
                                                    "url": "custom-products"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        }
                    ]
            }
        };
    }

    LocationSection.$inject = ['CommonUtilService']
    function LocationSection(CommonUtilService) {
        return {
            restrict: "EA",
            scope: {
                // from page template
                locationConfigOverrides: '=',
                locationProps: '=',
                preLink: '=',
                separator: '=',
                currentLocale: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/location-section.html',
            link: function($scope){

                $scope.productNameDisplay;
                $scope.chunkedData;

                if($scope.locationProps) {
                    $scope.productNameDisplay = $scope.locationProps.productName.dataProps.textValue;
                }

                var allLocations = _.sortBy(getLocations(), function(location) {
                    return location.province + location.city;
                });
                var filteredLocations = _.filter(allLocations, function(location) {
                    var locationKey = getLocationKey(location);
                    return !location.canonical && location.locale == $scope.currentLocale &&
                        (!$scope.locationConfigOverrides[locationKey] ||
                            !$scope.locationConfigOverrides[locationKey].disabled
                        )
                })
                $scope.chunkedData = chunk(filteredLocations, 1);

                // $scope.$watch("locationProps", function() {
                //     if($scope.locationProps) {
                //         $scope.productNameDisplay = $scope.locationProps.productName.dataProps.textValue;
                //     }
                // }, true)

                // $scope.$watchGroup(["currentLocale", "locationConfigOverrides"], function() {
                // var filteredLocations = _.filter(allLocations, function(location) {
                //     var locationKey = getLocationKey(location);
                //     return !location.canonical && location.locale == $scope.currentLocale &&
                //         (!$scope.locationConfigOverrides[locationKey] ||
                //             !$scope.locationConfigOverrides[locationKey].disabled
                //         )
                // })
                // $scope.chunkedData = chunk(filteredLocations, 1);
                // }, true)

                function chunk(arr, size) {
                    var newArr = [];
                    for (var i=0; i<arr.length; i+=size) {
                        newArr.push(arr.slice(i, i+size));
                    }
                    return newArr;
                }

                $scope.getLink = function(location){
                    var urlOverride = $scope.locationProps.linkUrlOverride.dataProps.textValue;
                    if (urlOverride) {
                        var cityToken = modelService.PAGE_TEMPLATE_LOCATION_TOKENS.LOCATION_CITY;
                        var stateToken = modelService.PAGE_TEMPLATE_LOCATION_TOKENS.LOCATION_STATE;
                        return urlOverride
                            .replace(cityToken, CommonUtilService.replaceSpaceWithHyphensAndLower(location.city))
                            .replace(stateToken, CommonUtilService.replaceSpaceWithHyphensAndLower(location.province))
                    } else {
                        return $scope.preLink + $scope.separator + CommonUtilService.buildUrl(location)
                    }
                }
            }
        }
    }

    function OurCompassSection() {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/our-compass-section.html',
            link: function(){}
        };
    }

    function ClientsSection($rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/clients-section.html',
            link: function($scope){
                activate();

                $scope.clients;

                function activate() {
                    if ($rootScope.fromUS()) {
                        $scope.clients = [
                            {
                                path: 'clientLogo/disney.png',
                                alt: 'We print tshirts for Disney Canada!',
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/upenn.png',
                                alt: "University of Pennsylvania has ordered custom clothing from Coastal Reign.",
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/microsoft.png',
                                alt: 'Microsoft Vancouver chooses Coastal Reign for their embroidered zip hoodies.',
                                imageWidth: 250,
                                imageHeight: 53
                            },
                            {
                                path: 'clientLogo/netflix.png',
                                alt: 'Netflix has ordered custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 76
                            },
                            {
                                path: 'clientLogo/princeton.png',
                                alt: 'Princeton student clubs love our design services and free shipping!',
                                imageWidth: 250,
                                imageHeight: 69
                            },
                            {
                                path: 'clientLogo/ebay.png',
                                alt: 'Coastal Reign has printed for Ebay!',
                                imageWidth: 250,
                                imageHeight: 100
                            },
                            {
                                path: 'clientLogo/amazon.png',
                                alt: 'Amazon chooses Coastal Reign to print their team specific hoodies and shirts!',
                                imageWidth: 250,
                                imageHeight: 75
                            },
                            {
                                path: 'clientLogo/tedx.png',
                                alt: 'Tedx orders custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 73
                            },
                        ]

                    } else {
                        $scope.clients = [
                            {
                                path: 'clientLogo/disney.png',
                                alt: 'We print tshirts for Disney Canada!',
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/cityofvancouver.png',
                                alt: "The City of Vancouver, specifically the Board of Parks and Recreation division, has ordered custom clothing from Coastal Reign.",
                                imageWidth: 250,
                                imageHeight: 131
                            },
                            {
                                path: 'clientLogo/microsoft.png',
                                alt: 'Microsoft Vancouver chooses Coastal Reign for their embroidered zip hoodies.',
                                imageWidth: 250,
                                imageHeight: 53
                            },
                            {
                                path: 'clientLogo/netflix.png',
                                alt: 'Netflix has ordered custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 76
                            },
                            {
                                path: 'clientLogo/ubc-logo-crest-only.png',
                                alt: 'UBC student clubs love our design services and our free shipping!',
                                imageWidth: 250,
                                imageHeight: 125
                            },
                            {
                                path: 'clientLogo/bchydro.png',
                                alt: 'We embroidered jackets for BC Hydro.',
                                imageWidth: 250,
                                imageHeight: 79
                            },
                            {
                                path: 'clientLogo/amazon.png',
                                alt: 'Amazon chooses Coastal Reign to print their team specific hoodies and shirts!',
                                imageWidth: 250,
                                imageHeight: 75
                            },
                            {
                                path: 'clientLogo/uot.png',
                                alt: 'The University of Toronto orders custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 90
                            },
                        ]
                    }
                }
            }
        };
    }

    function BrandsSection(BrandService) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/brands-section.html',
            link: function($scope) {
                $scope.brands = [
                    'Carhartt', 'Adidas', 'Nike', 'AS Colour', 'Helly Hansen', 'Northface', 'Columbia', 'Herschel Bags',
                    'Roots', 'Gildan', 'Champion', 'Tentree', 'Russell Athletics', 'Bella and Canvas'
                ]

                    //['Gildan', 'Fruit of the Loom', 'American Apparel', 'Champion', 'Callaway', 'Roots', 'Tentree', 'Under Armour',
                //'Carhartt', 'Nike', 'Northface', 'Russell Athletics']
                BrandService.getAllBrands()
                    .then(function(allBrands) {
                        $scope.brands = _.map($scope.brands, function(brandName) {
                            return _.find(allBrands, function(brand) {
                                return brand.name === brandName
                            });
                        })
                    })
            }
        };
    }

    function ReviewsSection($timeout, $rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/reviews-section.html',
            link: function($scope, element, attrs){

                $scope.isLoading = false;
                $scope.isFinishedLoading = false;
                var containerElement = angular.element(element).find('#reviews-widget-container')[0]
                var reviewTemplate = '<div style="overflow-x: hidden" class="elfsight-app-73d009d3-06ea-4f44-ac62-eaf05d4c02a6" data-elfsight-app-lazy></div>'
                var isLoaded = document.querySelectorAll('script[src="https://static.elfsight.com/platform/platform.js"]');

                function checkScrollListener() {
                    var offTop = element.offset().top
                        var scrollPos = $(this).scrollTop();
                        if (!$scope.reviewWidgetTemplate && (Math.abs(scrollPos > (offTop - 1500)))) {
                            $scope.loadScript();
                        }
                    }

                $scope.loadScript = function () {
                    if ($scope.isLoading) {
                        return;
                    } else {
                        $scope.isLoading = true;
                    }

                    var isLoaded = document.querySelectorAll('script[src="https://static.elfsight.com/platform/platform.js"]');
                    // maybe it was loaded from a previous page or from floating widget
                    if (isLoaded.length > 0) {
                        $timeout(function () {
                            $scope.isFinishedLoading = true;
                            $scope.reviewWidgetTemplate = reviewTemplate
                            $scope.$apply();
                        })
                    } else {
                        var myScript = document.createElement("script");
                        myScript.src = 'https://static.elfsight.com/platform/platform.js';
                        document.body.appendChild(myScript);
                        myScript.onload = function () {
                            $timeout(function () {
                                $scope.reviewWidgetTemplate = reviewTemplate
                                $scope.$apply();
                            })
                        }
                    }

                    var fullyLoadedWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.disconnect();
                        setTimeout(function () {
                            // console.log('ig widget');
                            $scope.isFinishedLoading = true;
                            $scope.$apply();

                        }, 0)
                    })

                    var containerWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.observe(mutation[0].addedNodes[0], {subtree: true, childList:true})
                        containerWidgetObserver.disconnect();
                    });
                    containerWidgetObserver.observe(containerElement, {childList: true});

                    // fallback
                    setTimeout(function() {
                        $scope.isFinishedLoading = true;
                        $scope.$apply();
                    }, 3500)
                }
                window.addEventListener('scroll', checkScrollListener);

                // do not wait for scroll for prerender and load immediately.
                if ($rootScope.isPrerender()) {
                    $scope.loadScript();
                }

                $scope.$on('$destroy', function() {
                    window.removeEventListener("scroll", checkScrollListener)
                })
            }
        };
    }

    function MerchSection($timeout, $rootScope, matchmedia) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/merch-section.html',
            link: function($scope, element, attrs){
                resizeIg();
                $scope.isLoading = false;
                $scope.isFinishedLoading = false;
                var containerElement = angular.element(element).find('#ig-widget-container')[0]

                var htmlTemplate = '<behold-widget  feed-id="zmH9xVzo5AzUASR5FPmR"></behold-widget>'

                //reserve space - CLS
                function resizeIg() {
                    var isPhone = matchmedia.is("(max-width: 900px)");
                    var numBoxes;
                    var buffer;
                    if (isPhone) {
                        numBoxes = 1
                        buffer = 15
                    } else {
                        numBoxes = 4;
                        buffer = 50;
                    }

                    document.getElementById("ig-container").style.height = ((Math.min(2500, window.innerWidth ) + buffer) / numBoxes) + 'px'
                }

                window.addEventListener('resize', resizeIg);
                $scope.loadScript = function () {
                    if ($scope.isLoading) {
                        return;
                    } else {
                        $scope.isLoading = true;
                    }

                    // maybe it was loaded from a previous page
                    if (isScriptLoaded && isScriptLoaded.length > 0) {
                        $timeout(function () {
                            $scope.igWidgetTemplate = htmlTemplate
                        })
                    } else {
                        var myScript = document.createElement("script");
                        myScript.src = 'https://w.behold.so/widget.js';
                        myScript.type = 'module'
                        myScript.className = 'ig-feed-script';
                        document.body.appendChild(myScript);
                        myScript.onload = function () {
                            $timeout(function () {
                                $scope.igWidgetTemplate = htmlTemplate })
                        }
                    }
                    var fullyLoadedWidgetObserver = new MutationObserver(function() {
                        fullyLoadedWidgetObserver.disconnect();
                        $timeout(function () {
                            // console.log('ig widget');
                            $scope.isFinishedLoading = true;
                        }, 0)
                    })

                    var containerWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.observe(mutation[0].addedNodes[0].shadow, {childList:true})
                        containerWidgetObserver.disconnect();
                    });
                    containerWidgetObserver.observe(containerElement, {subtree: true, childList: true});

                    // fallback
                    $timeout(function() {
                        $scope.isFinishedLoading = true;
                    }, 5000)
                }

                // do not wait for scroll for prerender and load immediately.
                if ($rootScope.isPrerender()) {
                    $scope.loadScript();
                }

                // <script type="module" src="https://w.behold.so/widget.js"></script>
                var isScriptLoaded = document.querySelectorAll('.ig-feed-script');
                if (isScriptLoaded.length > 0) {
                    $scope.loadScript();
                } else {
                    window.addEventListener('scroll', checkScrollListener);
                }


                function checkScrollListener() {
                    var offTop = element.offset().top
                    $(window).on("scroll",function() {
                        var scrollPos = $(this).scrollTop()

                        if (!$scope.igWidgetTemplate && (scrollPos > (offTop - 1000))) {
                            $scope.loadScript();
                        }
                    })
                }

                $scope.$on('$destroy', function() {
                    window.removeEventListener("scroll", checkScrollListener)
                    window.removeEventListener('resize', resizeIg)
                })
                checkScrollListener();
            }
        };
    }

    function FAQSection(SEOService, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                faqProps: '=',
                fromAdmin: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/faq-section.html',
            link: function($scope){
                $scope.faqList = []
                $scope.generateSchema = !$scope.faqProps.hideTitle.dataProps.booleanValue;
                activate();

                function activate() {
                    getFaqList();
                    // $scope.$watch("faqProps", function() {
                    //     getFaqList();
                    // }, true)
                }

                // console.log($scope.faqProps)

                function getFaqList() {
                    var questions = $scope.faqProps.questions.dataProps.dataTypeList;
                    var answers = $scope.faqProps.answers.dataProps.dataTypeList;

                    $scope.faqList = _.map(questions, function(question, index) {
                        return {
                            question: question,
                            answer: answers[index]
                        }
                    });

                    $scope.faqList[0].visible = true

                    if ($scope.fromAdmin) {
                        _.forEach($scope.faqList, function(faq) {
                            faq.visible = true
                        })
                    }
                    if ($scope.faqList.length > 0 && $scope.generateSchema) {
                        var faqPageSchema = SEOService.generateFaqTemplateSchema($scope.faqProps);
                        $scope.$emit('updatePageJsonSchema', faqPageSchema);
                    }
                }
            }
        };
    }

    function ImageRowSection() {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                imageProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/image-row-section.html',
            link: function($scope, elem,attr) {
                $scope.images = [];
                $scope.imageStyle = {};

                function activate() {
                    var images = $scope.imageProps.images.dataProps.dataTypeList;
                    var labels = $scope.imageProps.labels.dataProps.dataTypeList;

                    $scope.images = _.map(images, function(image, index) {
                        var label = labels[index];
                        if (label) {
                            if (!label.dataProps.url && image.dataProps.imageHyperLink) {
                                label.dataProps.url = image.dataProps.imageHyperLink
                            }
                        }
                        return {
                            image: image,
                            label: label
                        }
                    });

                    var hasPadding = $scope.imageProps.hasPadding.dataProps.booleanValue;
                    var style = {}
                    if (hasPadding) {
                        style.padding = "1%"
                    }

                    var fitWidth = $scope.imageProps.fitWidth.dataProps.booleanValue;
                    if (fitWidth) {
                        var numImages = $scope.imageProps.images.dataProps.dataTypeList.length;
                        var width;
                        if (numImages) {
                            width = (100 / numImages).toFixed(0);
                            style.width = width + "%"
                        }
                    }
                    $scope.imageStyle = style;

                    // $scope.$watch('imageProps', function() {
                    //
                    // }, true)
                }
                activate();
            }
        };
    }

    LeftColumnSection.$inject = ['$sce'];
    function LeftColumnSection($sce) {
        return {
            restrict: 'EA',
            scope: {
                leftColumnProps: '=',
                isHeading: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-column-section.html',
            link: function($scope){
                // Initialize variables
                $scope.titleHtml = '';
                $scope.hasTitleText = false;
                
                // Generate heading HTML once
                function generateHeadingHtml(tag, text, url) {
                    if (!text) return '';
                    
                    var html = '';
                    if (url) {
                        html = '<' + tag + ' style="font-size: 24px !important;"><a style="text-decoration: none;" href="' + url + '">' + text + '</a></' + tag + '>';
                    } else {
                        html = '<' + tag + ' style="font-size: 24px !important;">' + text + '</' + tag + '>';
                    }
                    
                    return $sce.trustAsHtml(html);
                }
                
                // Determine which title to use and update the model
                function activate() {
                    if (!$scope.leftColumnProps) return;
                    
                    // Check if h2 title is available
                    var h2TitleData = $scope.leftColumnProps.titleH2Text && 
                                      $scope.leftColumnProps.titleH2Text.dataProps;
                    
                    // Check if h3 title is available
                    var h3TitleData = $scope.leftColumnProps.titleText && 
                                      $scope.leftColumnProps.titleText.dataProps;
                    
                    var text = '';
                    var url = '';
                    var tag = 'h3';
                    
                    // Simplified logic: Prefer h2 unless only h3 has custom locale/location content
                    var useH2 = h2TitleData && h2TitleData.textValue;
                    var useH3 = h3TitleData && h3TitleData.textValue;
                    
                    // Special case: if h2 exists but has no custom content, and h3 has custom content, prefer h3
                    if (useH2 && useH3 && 
                        !h2TitleData.cstmCnt && h3TitleData.cstmCnt) {
                        useH2 = false; // Switch to h3 only in this specific case
                    } else if (useH2) {
                        useH3 = false; // Standard behavior: prefer h2 when available
                    }
                    
                    // Set the selected title data
                    if (useH2) {
                        text = h2TitleData.textValue;
                        url = h2TitleData.url || '';
                        tag = 'h2';
                    } else if (useH3) {
                        text = h3TitleData.textValue;
                        url = h3TitleData.url || '';
                        tag = 'h3';
                    }
                    
                    // If we have text and isHeading is true, use h1 tag
                    if (text && $scope.isHeading) {
                        tag = 'h1';
                    }
                    
                    // Generate the HTML once
                    if (text) {
                        $scope.titleHtml = generateHeadingHtml(tag, text, url);
                        $scope.hasTitleText = true;
                    }
                }

                activate();
            }
        };
    }

    RightColumnSection.$inject = ['$sce'];
    function RightColumnSection($sce) {
        return {
            restrict: 'EA',
            scope: {
                rightColumnProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/right-column-section.html',
            link: function($scope){
                // Initialize variables
                $scope.titleHtml = '';
                $scope.hasTitleText = false;
                
                // Generate heading HTML once
                function generateHeadingHtml(tag, text, url) {
                    if (!text) return '';
                    
                    var html = '';
                    if (url) {
                        html = '<' + tag + ' style="font-size: 24px !important;"><a style="text-decoration: none;" href="' + url + '">' + text + '</a></' + tag + '>';
                    } else {
                        html = '<' + tag + ' style="font-size: 24px !important;">' + text + '</' + tag + '>';
                    }
                    
                    return $sce.trustAsHtml(html);
                }
                
                // Determine which title to use and update the model
                function activate() {
                    if (!$scope.rightColumnProps) return;
                    
                    // Check if h2 title is available
                    var h2TitleData = $scope.rightColumnProps.titleH2Text && 
                                      $scope.rightColumnProps.titleH2Text.dataProps;
                    
                    // Check if h3 title is available
                    var h3TitleData = $scope.rightColumnProps.titleText && 
                                      $scope.rightColumnProps.titleText.dataProps;
                    
                    var text = '';
                    var url = '';
                    var tag = 'h3';
                    
                    // Simplified logic: Prefer h2 unless only h3 has custom locale/location content
                    var useH2 = h2TitleData && h2TitleData.textValue;
                    var useH3 = h3TitleData && h3TitleData.textValue;
                    
                    // Special case: if h2 exists but has no custom content, and h3 has custom content, prefer h3
                    if (useH2 && useH3 && 
                        !h2TitleData.cstmCnt && h3TitleData.cstmCnt) {
                        useH2 = false; // Switch to h3 only in this specific case
                    } else if (useH2) {
                        useH3 = false; // Standard behavior: prefer h2 when available
                    }
                    
                    // Set the selected title data
                    if (useH2) {
                        text = h2TitleData.textValue;
                        url = h2TitleData.url || '';
                        tag = 'h2';
                    } else if (useH3) {
                        text = h3TitleData.textValue;
                        url = h3TitleData.url || '';
                        tag = 'h3';
                    }
                    
                    // If we have text and isHeading is true, use h1 tag
                    if (text && $scope.isHeading) {
                        tag = 'h1';
                    }
                    
                    // Generate the HTML once
                    if (text) {
                        $scope.titleHtml = generateHeadingHtml(tag, text, url);
                        $scope.hasTitleText = true;
                    }
                }

                activate();
            }
        };
    }


    ProductListSection.$inject = ['ProductService', 'PageTemplateService', '$location', 'matchmedia', '$route', '$rootScope', '$timeout']
    function ProductListSection(ProductService, PageTemplateService, $location, matchmedia, $route, $rootScope, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                productListProps: '=',
                disableProductFilters: '=',
                recSkus: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/product-list-section.html',
            link: function($scope){
                $scope.fetchedProducts;
                $scope.previewProducts;
                $scope.props = {
                    showFilters: true,
                }

                $scope.previewLength = 3;
                $scope.watchers = []
                $scope.watchers.push(matchmedia.onTablet(function(mediaQuery) {
                    if(mediaQuery.matches) {
                        $scope.previewLength = 2;
                    }
                }));

                $scope.$on('pageTemplateQueryParam', function(current, old) {
                    activate();
                })

                function activate(initialLoad) {
                    if (initialLoad) {
                        if ($scope.disableProductFilters) {
                            $scope.props.showFilters = false;
                        }
                        // $scope.$on('productsLoaded', function () {
                        //     $scope.productsLoaded = true;
                        // })

                        $scope.$watch('$root.breadcrumb.isFetching', function() {
                            if ($rootScope.breadcrumb && !$rootScope.breadcrumb.isFetching && $rootScope.breadcrumb.list.length > 0) {
                                $scope.fetchCategoryUmbrella();
                            }
                        }, true)
                        $scope.fetchProducts();
                        $scope.$on('productsLoaded', function(){
                            $scope.productsLoaded = true;
                        })
                    }

                    try {
                        if ($scope.productListProps.productsTitle.dataProps.textValue) {
                            $scope.widgetTitle = $scope.productListProps.productsTitle.dataProps.textValue;
                            $scope.widgetId = $scope.productListProps.productsTitle.dataProps.textValue.replace(/\s/g, '_');
                        }
                    } catch(e) {

                    }

                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                function transformNestedTokenList(tagGroups) {
                    return _.map(tagGroups, function(tagGroup) {
                        return tagGroup.searchTokenList
                    });
                }

                function transformFacets(facetGroups) {
                    var facetQuery = {};
                     _.forEach(facetGroups, function(facetGroupArray) {
                        var existingItems = facetQuery[facetGroupArray.key];
                        if (!existingItems) {
                            facetQuery[facetGroupArray.key] = [];
                        }

                        facetQuery[facetGroupArray.key].push(facetGroupArray.searchTokenList);
                    })
                    return facetQuery;
                }


                $scope.fetchProducts = function() {
                    let productFilters = $scope.productListProps.productsQuery.dataProps;
                    var filterRequest = _.omit(productFilters, ['_id', 'dataType'])



                    if (filterRequest.tags) {
                        filterRequest.tags = transformNestedTokenList(filterRequest.tags);
                    }
                    // searchTextList is a nested array -> flatten
                    if (filterRequest.searchTextList) {
                        filterRequest.searchTextList = transformNestedTokenList(filterRequest.searchTextList);
                    }


                    if (filterRequest.productFeatureTags) {
                        filterRequest.productFeatureTags = transformNestedTokenList(filterRequest.productFeatureTags);
                    } else if (filterRequest.productTags) {
                        // legacy
                        filterRequest.productFeatureTags = transformNestedTokenList(filterRequest.productTags);
                    }

                    if (filterRequest.facets) {
                        filterRequest.facets = transformFacets(filterRequest.facets)
                    }
                    return ProductService.fetchProducts(filterRequest, true)
                        .then(function(fetchedProducts) {
                            $scope.fetchedProducts = fetchedProducts;
                            $scope.previewProducts = fetchedProducts.slice(0, Math.min($scope.previewLength, fetchedProducts.length));
                        })
                        .catch(function() {
                            $scope.fetchedProducts = [];
                            $scope.previewProducts = [];
                        })
                        .finally(function(){

                        })
                }

                $scope.categoryUmbrella = {
                    fetching: true
                }

                $scope.fetchCategoryUmbrella = function() {
                    // get parent breadcrumb
                    var parentPage = $rootScope.breadcrumb.list[1];
                    if (parentPage && parentPage._id) {
                        parentPage.displayName = PageTemplateService.cleanPageName(parentPage.targetKeyword, true);
                        PageTemplateService.getProductCategoryUmbrella(parentPage._id)
                            .then(function (children) {
                                // all Page
                                var allPageIndex;
                                var allPage;
                                _.forEach(children, function (page, index) {
                                    if ($rootScope.breadcrumb.list[0].targetKeyword === page.targetKeyword) {
                                        page.isActive = true;
                                    }
                                    page.displayName = PageTemplateService.cleanPageName(page.targetKeyword, true);
                                    if (_.isUndefined(allPageIndex) && (
                                            // page.targetKeyword.includes(' All ') ||
                                            page.pageUrl.endsWith('/all')) ||
                                            page.pageUrl.endsWith('/all-products')
                                    ) {
                                        page.displayName = 'All ' + parentPage.displayName;
                                        allPageIndex = index
                                    }
                                })
                                if (!_.isUndefined(allPageIndex)) {
                                  children.push(children.splice(allPageIndex, 1)[0]) ;

                                }
                                $scope.categoryUmbrella = {
                                    parent: parentPage,
                                    children: children
                                }
                            })
                            .catch(function (e) {
                                $scope.categoryUmbrella = {
                                    fetching: false
                                }
                        })
                    } else {
                        $scope.categoryUmbrella = {
                            fetching: false
                        }
                    }
                }

                activate(true);
            }
        };
    }

    BestSellersSection.$inject = []
    function BestSellersSection() {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                bestSellersProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/best-sellers-section.html',
            link: function($scope){
                $scope.bestSellerCategory = {};
                $scope.watchers = [];
                function activate() {

                    $scope.bestSellerCategory.name = $scope.bestSellersProps.bestSellersTitle.dataProps.textValue;
                    $scope.bestSellerCategory.displayName = $scope.bestSellerCategory.name;
                    $scope.bestSellerCategory.skus = _.map($scope.bestSellersProps.skus.dataProps.dataTypeList, function(skuDataType) {
                        return skuDataType.dataProps.sku;
                    })

                    console.log($scope.bestSellerCategory);
                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                activate();
            }
        };
    }

    ConfigurableBrandsSection.$inject = []
    function ConfigurableBrandsSection() {
        return {
            restrict: 'EA',
            scope: {
                configBrandsProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/configurable-brands-section.html',
            link: function($scope){
                $scope.watchers = [];
                $scope.brands;
                function activate() {
                    $scope.brands = $scope.configBrandsProps.brandsList.dataProps.dataTypeList;
                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                activate();
            }
        };
    }
})();
/**
 * Created by richa_000 on 2016-05-02.
 */

(function() {
    'use strict';
    angular.module('AuthService', [])
        .factory('AuthToken', function ($window) {
            var authTokenFactory = {};
            // get a token out of local storage
            authTokenFactory.getToken = function () {
                return $window.localStorage.getItem('userToken');
            };

            // set token to this (login token), otherwise set it to nothing (log out purposes)
            authTokenFactory.setToken = function (response) {
                if (response) {
                    $window.localStorage.setItem('userToken', response.token);
                } else
                    $window.localStorage.removeItem('userToken');
            };


            authTokenFactory.logOut = function () {
                authTokenFactory.setToken();
            };

            authTokenFactory.isLoggedIn = function () {
                if (authTokenFactory.getToken()) {
                    return true;
                } else {
                    return false;
                }

            };

            authTokenFactory.getCurrentUserDetails = function () {
                var token = authTokenFactory.getToken();
                if (token) {
                    try {
                        var payload = token.split('.')[1];
                        payload = $window.atob(payload);
                        payload = JSON.parse(payload);
                        return payload;
                    } catch (e) {
                        authTokenFactory.setToken();
                    }
                } else return {};
            };

            return authTokenFactory;
        })

        .factory('AuthInterceptor', function ($q, $location, AuthToken) {
            var interceptorFactory = {};
            interceptorFactory.request = function (config) {
                var token = AuthToken.getToken();
                // if there is a token
                // if the request is being made to cloudinary do not attach the token to the header.
                if (token && config.url.indexOf('api.cloudinary.com') === -1) {
                    config.headers['cr-access-token'] = token; //add to header
                }
                return config;
            };

            interceptorFactory.responseError = function (response) {
                if (response.status === 401) {
                    AuthToken.setToken();
                    // $location.path('/login');
                }

                return $q.reject(response);

            };
            return interceptorFactory;
        });
})();
(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('jsonld', ['$filter', '$sce', function ($filter, $sce) {
            return {
                restrict: 'E',
                template: function () {
                    return '<script type="application/ld+json" ng-bind-html="boundData"></script>';
                },
                scope: {
                    json: '=json'
                },
                link: function ($scope, element, attrs) {
                    $scope.boundData;

                    function activate() {
                        $scope.$watch('json', function(newValue, oldValue) {
                            if (newValue) {
                                $scope.boundData = $sce.trustAsHtml($filter('json')(newValue));
                            }
                        }, true);
                    }

                    activate();
                }
            };
        }])
})();
(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('bindHtmlCompile', BindHtmlCompileDirective);

    BindHtmlCompileDirective.$inject = ['$compile']

    // This directive recompiles the elements - allowing any links to reset if locale is defined
    function BindHtmlCompileDirective($compile) {

        var directive = {
            link: link,
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch(function () {
                return scope.$eval(attrs.bindHtmlCompile);
            }, function (value) {
                // In case value is a TrustedValueHolderType, sometimes it
                // needs to be explicitly called into a string in order to
                // get the HTML string.
                element.html(value && value.toString());
                // If scope is provided use it, otherwise use parent scope
                var compileScope = scope;
                if (attrs.bindHtmlScope) {
                    compileScope = scope.$eval(attrs.bindHtmlScope);
                }
                $compile(element.contents())(compileScope);
            });
        }
    }
})();
(function () {
    'use strict';

    function isLocalStorageNameSupported(storageOverride) {
        var testKey = 'test'
        var storage = window.localStorage;
        if (storageOverride) {
            storage = storageOverride;
        }
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }

    function insertPageNotFoundPrerenderTags() {
        var head = document.getElementsByTagName('head')[0];
        
        // Handle prerender-status-code meta tag
        var statusElement = document.querySelector(`meta[name='prerender-status-code']`) || null;
        if (statusElement) {
            head.removeChild(statusElement);
        }
        var statusMeta = document.createElement('meta');
        statusMeta.setAttribute('name', "prerender-status-code");
        statusMeta.setAttribute('content', '404');
        head.appendChild(statusMeta);

        // notify prerender crawler on next digest
        setTimeout(function(){
            window.prerenderReady = true;
        });
    }

// dependency injection, root level
    var app = angular.module("app",
        [
            // third party
            'oc.lazyLoad',
            'ui.bootstrap',
            'ngRoute',
            'ngSanitize',
            // 'ngAnimate',
            'matchmedia-ng',

            // our own deps
            'sharedModule',
            'landingPageModule',
            'AuthService'
    ]
);


    app.config(['$routeProvider', '$locationProvider', '$ocLazyLoadProvider', 'matchmediaProvider', 'loggerProvider', '$compileProvider',function ($routeProvider, $locationProvider, $ocLazyLoadProvider, matchmediaProvider, loggerProvider, $compileProvider) {
        $compileProvider.debugInfoEnabled(false);

        $ocLazyLoadProvider.config({
            // DEBUGGING DEV ONLY - console log events
            // "debug": true,
            "events": true
        });
        // loggerProvider.setDEVMODE(true);

        // loading bar config
        matchmediaProvider.rules.phone = "(max-width: 767px)";
        matchmediaProvider.rules.tablet = "(max-width: 1023px)";
        matchmediaProvider.rules.desktop = "(min-width: 1024px)";

    $routeProvider

        // todo: research if this is safe to remove
        .when('/:locale?/!', {
            templateUrl: 'views/home.html',
            controller: 'MainController',
            resolve: {
                loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'js/controllers/MainCtrl.js'
                    ]);
                }]
            }
        })

            .when('/:locale?/thank-you-for-your-order', {
                templateUrl: "views/non_bundled/ThankYouForYourOrder.html",
                controller: "ThankYouForYourOrderController",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/promotions/ThankYouForYourOrderCtrl.js'
                        ]);
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, nofollow'
                    },
                }
            })

            .when('/:locale?/thank-you-for-booking', {
                templateUrl: "views/non_bundled/ThankYouForBooking.html",
                controller: "ThankYouForBookingController",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/promotions/ThankYouForBookingCtrl.js'
                        ]);
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, nofollow'
                    },
                }
            })

            .when('/:locale?/sports-sponsorships', {
                templateUrl: "views/sports-sponsorships.html",
                controller: "SportSponsorController",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/promotions/SportSponsorCtrl.js'
                        ]);
                    }],
                }
            })

            .when('/:locale?/contract-pricing', { // contract printing removed as of December 29th 2021 by eddison.
                templateUrl: "views/non_bundled/Contract.html",
                controller: "ContractCtrl",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            //todo: cachedproducts
                            'shared/js/services/cachedProducts.js',
                            // 'shared/js/services/calculate.js',
                            'js/controllers/ContractCtrl.js'
                        ], {
                            serie: true
                        });
                    }]
                }
            })

            .when('/:locale?/action/:actionType/:orderNumber/:zip', {
                templateUrl: "views/UpdateActionOnOrder.html",
                controller: "ActionController",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/ActionCtrl.js'
                        ]);
                    }],
                    disableHrefLang: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/thank-you-for-contacting-us', {
                templateUrl: "views/non_bundled/ThankYouForContactingUs.html",
                controller: "ThankYouForContactingUsController",
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/ThankYouForContactingUsCtrl.js'
                        ]);
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, nofollow'
                    },
                    disableHrefLang: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/stock-colours', {
                templateUrl: 'views/non_bundled/SwatchColour.html',
                controller: 'SwatchController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'shared/js/services/printColoursService.js',
                            'js/controllers/one-off-pages/SwatchCtrl.js'
                        ]);
                    }]
                }
            })

        .when('/:locale?/review-request', {
            templateUrl: 'views/reviewRequest.html',
            controller: 'ReviewRequestController',
            resolve: {
                loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'js/controllers/one-off-pages/ReviewRequestCtrl.js'
                    ]);
                }]
            }
        })


        .when('/:locale?/promotional-offer', {
            templateUrl: 'views/promotional-offer.html',
            resolve: {
                loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                    ]);
                }]
            }
        })


            .when('/:locale?/contact', {
                templateUrl: 'views/contact.html',
                controller: 'ContactController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/ContactCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/sticker-printing', {
                templateUrl: 'views/vancouver-sticker-printing.html',
                controller: 'StickerPrintingController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'js/controllers/one-off-pages/our-services/StickerPrintingCtrl.js'
                        ]);
                    }],
                    calculateBreadcrumbs: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/sign-up', {
                templateUrl: 'views/non_bundled/signUp.html',
                controller: 'SignUpCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/account/SignUpCtrl.js'
                        ]);
                    }],
                    disableHrefLang: function() {
                        return true
                    }
                }
            })


            .when('/:locale?/design-help', {
                templateUrl: "views/design_help.html",
                controller: 'DesignHelpCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/design/DesignHelpCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/login', {
                templateUrl: "views/non_bundled/login.html",
                controller: 'LoginCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/account/LoginCtrl.js'
                        ]);
                    }],
                    disableHrefLang: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/sitemap', {
                templateUrl: 'views/non_bundled/SiteMap.html',
                controller: 'SitemapController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // todo: cachedproducts
                            'shared/js/services/cachedProducts.js',
                            // 'shared/js/services/calculate.js',
                            'shared/js/services/location.js',
                            'js/controllers/SiteMapCtrl.js'
                        ])
                    }]
                }
            })

            .when('/:locale?/stat-holidays', {
                templateUrl: 'views/non_bundled/StatHoliday.html',
                controller: 'StatHolidaysCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/StatHolidayCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/products/:productCategory/:productName', {
                templateUrl: 'views/product.html',
                controller: 'ProductCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'shared/libs/keen-slider/keen-slider.min.css',
                            'shared/libs/keen-slider/keen-slider.js',
                            'js/controllers/products-nav/ProductCtrl.js',
                        ]);
                    }],
                    calculateBreadcrumbs: function() {
                        return true
                    }
                },
                reloadOnSearch: false
            })

            .when('/:locale?/error', {
                templateUrl: 'views/404error.html'
            })

            .when('/:locale?/account', {
                templateUrl: 'views/non_bundled/account.html',
                controller: 'AccountCtrl',
                data: {
                    authRequired: true
                },
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/account/AccountCtrl.js'
                        ]);
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, nofollow'
                    },
                    disableHrefLang: function() {
                        return true
                    },
                }
            })

            .when('/:locale?/track-order', {
                templateUrl: 'views/non_bundled/track-order.html',
                controller: 'TrackOrderController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/TrackOrderCtrl.js'
                        ]);
                    }],
                    disableRecommendLocaleModal: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/designer/:productName', {
                templateUrl: 'views/non_bundled/Designer.html',
                controller: 'DesignerController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        loadingScreen('Loading Design Portal');
                        return $ocLazyLoad.load([
                            'js/controllers/design/DesignerCtrl.js'
                        ], {
                            serie: true
                        })
                            .finally(function () {
                                closeLoadingScreen();
                            })
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, follow'
                    },
                    calculateBreadcrumbs: function() {
                        return true
                    }
                },
                reloadOnSearch: false

            })

            .when('/:locale?/designer/:productName/:savedDesign', {
                templateUrl: 'views/non_bundled/Designer.html',
                controller: 'DesignerController',
                resolve: {
                    'fontLoaderService': function (fontLoaderService) {
                        return fontLoaderService.promise;
                    },
                    robotsContentOverrides: function() {
                        return 'noindex, follow'
                    },
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/design/DesignerCtrl.js'
                        ], {
                            serie: true
                        });
                    }],
                },

                reloadOnSearch: false
            })


            .when('/:locale?/cart', {
                templateUrl: 'views/cart.html',
                controller: 'CartController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/CartCtrl.js'
                        ]);
                    }],
                    disableHrefLang: function() {
                        return true
                    },
                    robotsContentOverrides: function() {
                        return 'noindex, follow'
                    },
                }
            })

            .when('/:locale?/cart/load/:oldCartId', {
                templateUrl: 'views/cart.html',
                controller: 'CartController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/CartCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/custom-products/patches/woven', {
                templateUrl: 'views/custom-woven-patches.html',
                controller: 'WovenPatchesCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'js/controllers/one-off-pages/our-services/WovenPatchesCtrl.js'
                        ]);
                    }],
                    calculateBreadcrumbs: function() {
                        return true
                    }
                }
            })


            .when('/:locale?/our-services/custom-embroidered-patches', {
                templateUrl: 'views/custom-embroidered-patches.html',
                controller: 'EmbroideredPatchesCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'js/controllers/one-off-pages/our-services/EmbroideredPatchesCtrl.js'
                        ]);
                    }],
                    calculateBreadcrumbs: function() {
                        return true
                    }
                }
            })


            .when('/:locale?/custom-products/patches/leather', {
                templateUrl: 'views/custom-leather-patches.html',
                controller: 'LeatherPatchesCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'js/controllers/one-off-pages/our-services/LeatherPatchesCtrl.js'
                        ]);
                    }],
                    calculateBreadcrumbs: function() {
                        return true
                    }
                }
            })

            .when('/:locale?/our-services/custom-sublimated-patches', {
                templateUrl: 'views/custom-sublimated-patches.html',
                controller: 'SublimatedPatchesCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            // 'shared/js/services/calculate.js',
                            'js/controllers/one-off-pages/our-services/SublimatedPatchesCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/reset', {
                templateUrl: 'views/non_bundled/reset.html',
                controller: 'ResetCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/account/ResetCtrl.js'
                        ], {
                            serie: true
                        });
                    }],
                    disableHrefLang: function() {
                        return true
                    }
                }

            })

            .when('/:locale?/privacy-policy', {
                templateUrl: 'views/non_bundled/privacy-policy.html'
            })

            .when('/:locale?/how-to-order', {
                templateUrl: 'views/how-to-order.html',
                controller: 'HowToOrderController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/HowToOrderCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/checkout', {
                templateUrl: 'views/non_bundled/checkout.html',
                controller: 'CheckoutController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/CheckoutCtrl.js'
                        ]);
                    }],
                    disableHrefLang: function() {
                        return true
                    },
                    robotsContentOverrides: function() {
                        return 'noindex, follow'
                    },
                    forceLocaleCheck: function() {
                        return true
                    }
                }
            })

            .when('/google5684cd0b08ed36b4.html', {
                templateUrl: "views/google5684cd0b08ed36b4"
            })

            .when('/:locale?/photo-submission', {
                templateUrl: "views/non_bundled/photo-submission.html",
                controller: 'PhotoController',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/PhotoCtrl.js'
                        ]);
                    }]
                }
            })

            .when('/:locale?/gallery', {
                templateUrl: "views/non_bundled/gallery.html",
                controller: 'GalleryCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/GalleryCtrl.js'
                        ]);
                    }]
                }
            })

        .when('/:locale?/custom-products/best-sellers', {
            templateUrl: "views/best-sellers.html",
            controller: 'BestSellersCtrl',
            resolve: {
                loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'js/controllers/one-off-pages/BestSellersCtrl.js',
                    ]);
                }]
            }
        })

            .when('/:locale?/search', {
                templateUrl: 'js/controllers/one-off-pages/global-search.html',
                controller: 'GlobalSearchCtrl',
                resolve: {
                    loadModule: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'js/controllers/one-off-pages/GlobalSearchCtrl.js'
                        ]);
                    }],
                    robotsContentOverrides: function() {
                        return 'noindex, follow'
                    },
                },
                reloadOnSearch: false
            })

            .when('/:locale?/page-not-found', {
                templateUrl: "views/404error.html",
                resolve: {
                    prerenderNotFoundTag: function() {
                        insertPageNotFoundPrerenderTags();
                    }
                }
            })

             // catch the rest
            .otherwise({
                templateUrl: "js/controllers/custom-page-manager.html",
                controller: 'CustomPageManagerController',
                reloadOnSearch: false,
                resolve: {
                    loadModule: ['$ocLazyLoad', '$rootScope', function ($ocLazyLoad, $rootScope) {
                        return $ocLazyLoad.load([
                            'js/controllers/customPageManager.controller.js'
                        ])
                    }],
                    routePath: function(CountryService) {
                        return CountryService.getCurrentBasePath();
                    }
            }
         })

        $locationProvider.html5Mode(true);
    }]);

    app.filter('unsafe', function ($sce) {
        return $sce.trustAsHtml;
    });

// attaches token with every HTTP request made to server (for forbidden routes)
    app.config(function ($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptor');
    });

    app.run(['$rootScope', '$location', '$http', '$window', "$anchorScroll", 'CommonUtilService', 'SEOService', 'PageTemplateService', '$uibModalStack', 'AnalyticsService','$sce', '$cacheFactory', 'CustomerService', 'CountryService', '$routeParams', '$timeout', 'AuthToken', '$route', 'matchmedia', '$uibModalStack', function ($rootScope, $location, $http, $window, $anchorScroll, CommonUtilService, SEOService, PageTemplateService, $modalStack, AnalyticsService, $sce, $cacheFactory, CustomerService, CountryService, $routeParams, $timeout, AuthToken, $route, matchmedia, $uibModalStack) {
        $rootScope.initialContentLoaded = false;

        $anchorScroll.yOffset = 146;

        $rootScope.phoneNumber = {
            local: "604-900-5924",
            localToronto: "647-494-6266",
            localNewYork: "917-259-0231",
            localCalgary: "587-200-4270",
            tollFree: "1(888)-210-3971"
        }

         // Initialize locale before any route changes
        var path = $location.path();
        var firstSubdirectory = path.split("/")[1];
        var initialLocale = "";

        if (CountryService.isValidLocale(firstSubdirectory)) {
            initialLocale = firstSubdirectory;
        }

        // Set initial locale
        CountryService.setLocale(initialLocale, false);
    
        //https://github.com/angular-ui/bootstrap/issues/5810
        $rootScope.$watch(function() {
            return $('.modal').length;
        }, function(val) { // everytime the number of modals changes
            if (val > 0 && $uibModalStack.getTop()) {
                $uibModalStack.getTop().value.backdrop = 'static'; // disable default close behaviour
                $('.modal').on('mousedown', function(e) {
                    if (e.which === 1) { // left click
                        $uibModalStack.getTop().key.dismiss(); // close top modal when clicking anywhere, you can close all modals using $modalStack.dismissAll() instead
                    }
                });
                $('.modal-content').on('mousedown', function(e) {
                    e.stopPropagation(); // avoid closing the modal when clicking its body
                });
            }
        });

        $rootScope.pageNotFoundPrerender = function() {
            insertPageNotFoundPrerenderTags();
            if (navigator.userAgent.indexOf('Prerender') === -1 && document.location.pathname != "/page-not-found") {
                $location.path('/page-not-found').replace();
            }
        }

        // remember images that have been loaded once
        $rootScope.lazyLoadedImagesCache = $cacheFactory('lazyLoadedImages');
        $rootScope.showSideNav = false;

        $rootScope.updateWithNewCartId = function(cartId,callback){
            $rootScope.verify(function(user){
                if (user){
                    $rootScope.updateCartWithUser(cartId, function(){
                        if (callback){
                            callback()
                        }
                    })
                } else {
                    localStorage.setItem("cartNew", cartId);
                    if (callback){
                        callback()
                    }
                }
            })
        }

        $rootScope.addItemLinesToCart = function (itemLines, products, design, callback) {
            AnalyticsService.trackAddItemsToCart(itemLines, products);
            $rootScope.getCartIdAndUser(function(user, cartId){
                if (cartId) {
                    // if cart is available, grab the cart and update the cart
                    $http.get('/Cart/' + cartId)
                        .success(function (response) {
                            for (var i = 0; i < itemLines.length; i++) {
                                response.listOfItems.push(itemLines[i])
                            }
                            $http.put('/Cart/' + cartId, {cart: response, design: design}).success(function (updatedCart) {
                                $rootScope.updateWithNewCartId(updatedCart._id, function(){
                                    callback()
                                })
                            })
                                .error(function (response) {
                                    callback("ErrorCode:A Something went wrong when we added an item to your cart, please contact a representative and we will be happy to place your order.")
                                })
                        })
                        //if there is an invalid cart, create a new cart
                        .error(function (response) {
                            $http.post('/Cart', {listOfItems: itemLines, design: design}).success(function (response) {
                                $rootScope.updateWithNewCartId(response._id, function(){
                                    callback()
                                })
                            })
                                .error(function (response) {
                                    callback("ErrorCode:B Something went wrong when we added an item to your cart, please contact a representative and we will be happy to place your order.")
                                });
                        });
                } else { //there has not been a cart stored here before, create a new cart
                    $http.post('/Cart', {listOfItems: itemLines, design: design}).success(function (response) {
                        $rootScope.updateWithNewCartId(response._id, function(){
                            callback()
                        })
                    })
                        .error(function (response) {
                            callback("Something went wrong when we added an item to your cart, please contact a representative and we will be happy to place your order.")
                        });
                }
            })
        }

        // safari requires us to disable scroll event directly
        function disableScroll(scrollPosition) {
            document.body.style.overflow = 'hidden';
        }

        function enableScroll(scrollPosition) {
            document.body.style.removeProperty('overflow');
        }

        $rootScope.$watch('showSideNav', function () {
            $rootScope.showSideNav ? disableScroll() : enableScroll();
        })

        // $rootScope.loadLiveChatScript = function () {
        //     LiveChatWidget.on('ready', function () {
        //         $rootScope.chatInitialized = true;
        //         $rootScope.$apply();
        //         LiveChatWidget.call("maximize");
        //     })
        //     LiveChatWidget.init();
        //
        //     // var isLoaded = document.querySelectorAll('.ze-script');
        //     // if (isLoaded.length > 0) {
        //     //     zE('messenger', 'open');
        //     //     return;
        //     // }
        //     //
        //     // var myScript = document.createElement("script");
        //     // myScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=6ff0d6aa-068a-476c-8226-2a704d44ec4d';
        //     // myScript.id = "ze-snippet";
        //     // myScript.className = 'ze-script';
        //     // document.body.appendChild(myScript);
        //     // window.zdonload = setInterval(function() {
        //     //     if(typeof zE !== 'undefined') {
        //     //         clearInterval(window.zdonload);
        //     //         $rootScope.isChatBotLoaded = true;
        //     //         zE('messenger', 'open');
        //     //     }
        //     // }, 50)
        //
        // }

        $rootScope.getSupplierByName = function (name) {
            return _.find($rootScope.suppliers, function (supplier) {
                return supplier.name == name;
            })
        }

        var suppliersPromise = null

        $rootScope.getAllSuppliers = function () {
            if (!suppliersPromise) {
                suppliersPromise = $http.get('/api/suppliers/')
                    .then(function (response) {
                        $rootScope.suppliers = response.data
                        return response.data;
                    })
                    .catch(function (err) {
                        showError(err.data.message);
                        return $q.reject(err);
                    })
            }
            return suppliersPromise;
        }
        $rootScope.getAllSuppliers()


        // local : "604-327-1710",
        // tollFree : "1(800)-599-6404"

                //getcategorytext.js
        $rootScope.calculateAveragePrice = function (product, quantity) {
            var category = _.find(categoryService.allCategories, function(cat){
                return product.category == cat.name
            })
            return calculationService.calculateAveragePrice(product, quantity,category)
        }

        $rootScope.setLocalStorage = function (key, value, storageOverride) {
            var storage = storageOverride;
            if (!storageOverride) {
                storage = window.localStorage;
            }
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            if (isLocalStorageNameSupported(storage)) {
                storage.setItem(key, value);
            } else {
                $rootScope[key] = value
            }
        }

        $rootScope.getLocalStorage = function (key, storageOverride) {
            var storage = storageOverride;
            if (!storageOverride) {
                storage = window.localStorage;
            }
            var item;
            if (isLocalStorageNameSupported(storage)) {
                item = storage.getItem(key);
            } else {
                item = $rootScope[key]
            }

            if (!item) {return;}

            if (item[0] === "{" || item[0] === '[') {
                try {
                    item = JSON.parse(item)
                } catch(e){

                }
            }
            return item
        }

        $rootScope.getPreviewUrl = function (url) {
            if (url.includes('res.cloudinary')) {
                return url.substr(0, url.lastIndexOf(".")) + ".png";
            } else {
                return url;
            }
        }

        // todo: async call for suppliers
        $rootScope.getLeadTimeForProduct = function (product) {
            return getLeadTimeForProduct(product, $rootScope.suppliers)
        }

        $rootScope.getSwatchProductColour = function (colour) {
            if (colour) {
                return {
                    'background-color': colour.hexVal,
                    'border-color': colour.secondaryHexVal ? colour.hexVal : 'auto',
                    'color': colour.secondaryHexVal ? colour.secondaryHexVal : 'none',
                    'border-width': colour.secondaryHexVal ? '2px' : 'none',
                    'border-style': colour.secondaryHexVal ? 'solid' : 'none',
                    'background-image': colour.secondaryHexVal ? 'linear-gradient(to left top, currentColor,currentColor 49%,transparent 50%)' : 'none'
                }
            }
        }

        $rootScope.isPrerender = function() {
            return navigator.userAgent.toLowerCase().includes('prerender')
        }

        $rootScope.printHasAStandardColour = function (print) {
            return printColoursService.printHasStandardColour(print)
        }

        $rootScope.changeToCA = function (filter) {
            // if ($rootScope.getLocalStorage("visitedLocationPage") || filter && !$rootScope.isPrerender()) {
            //     $rootScope.setLocalStorage("visitedLocationPage", "Canada");
            // }
            // $rootScope.setLocalStorage("country", "CA");
            // $rootScope.visitingCountry = "Canada"
            CountryService.setLocale("", true);
        }

        $rootScope.getImagePreview = function(url, cloudinaryImgQty) {
            if (url.includes('res.cloudinary')) {
                var cloudinaryQuality = 'w_800';
                if (cloudinaryImgQty) {
                    cloudinaryQuality = cloudinaryImgQty
                }
                var pngUrl = url.substr(0, url.lastIndexOf(".")) + ".png";
                var indexOfUpload = pngUrl.indexOf("upload") + 7
                pngUrl = pngUrl.slice(0, indexOfUpload) + cloudinaryQuality + "/" + pngUrl.slice(indexOfUpload);
                return pngUrl
            } else {
                return url;
            }
        }

        $rootScope.testingCouponCode = function(){
            return window.testingCouponCode
                && !$rootScope.getLocalStorage("existingOrder")
                && (!$rootScope.user || ($rootScope.user && $rootScope.user.orders && $rootScope.user.orders.length == 0 ))
        }

        $rootScope.getCouponCodePricing = function(price){
            return price * .95;
        }

        $rootScope.getProofPreview = function (itemLine, cloudinaryImgQty) {
            if (itemLine.proof) {
                return $rootScope.getImagePreview(itemLine.proof, cloudinaryImgQty);
            } else {
                return itemLine.mockup[0];
            }
        }

        $rootScope.onlyEmbroideryAllowed = function (category) {
            return calculationService.onlyEmbroideryAllowed(category)
        }

        // todo: refactor usage in templates
        $rootScope.fromUS = function () {
            return CountryService.getCurrentLocale() === 'en-us';
            // return $rootScope.getLocalStorage("country") == "US"
        }

        // todo: refactor usage in templates
        $rootScope.fromCA = function () {
            return !CountryService.getCurrentLocale();
            // return $rootScope.getLocalStorage("country") == "CA";
        }

        $rootScope.getCurrentLocale = function() {
            return CountryService.getCurrentLocale();
        }

        $rootScope.visitingCountry = function(codeOnly, localeToCheck) {
            var currentLocale;
            if (!_.isUndefined(localeToCheck)) {
                currentLocale = localeToCheck
            } else {
                currentLocale = CountryService.getCurrentLocale()
            }
            switch (currentLocale) {
                case 'en-us': if (codeOnly) { return "U.S" } else {return "the United States"}
                    break
                default: if (codeOnly) {return "CA" } else { return "Canada"}
            }
        }

        //todo: refactor
        $rootScope.changeToUS = function () {
            // $rootScope.setLocalStorage("visitedLocationPage", " ");
            // $rootScope.setLocalStorage("country", "US");
            // $rootScope.visitingCountry = "the United States"
            CountryService.setLocale('en-us', true);
        }


        $rootScope.changeToCountry = function (country) {
            // set timeout prevents flicker as page reloads
            $rootScope.showRecommendLocaleModal = false;
            setTimeout(function() {
                if (country == "CA" || country == '') {
                    $rootScope.changeToCA()
                }
                if (country == "US" || country == 'en-us') {
                    $rootScope.changeToUS()
                }
            }, 0)
        }

        $rootScope.orderCurrency = function(value, currencyObject) {
            if (currencyObject) {
                return calculationService.getCurrencyValue(value, currencyObject);
            } else {
                'N/A'
            }
        }

        //current currency for any value, not tied to order
        $rootScope.currency = function(value) {
            var currency;
            switch(CountryService.getCurrentLocale()) {
                case 'en-us':
                    currency = modelService.ORDER_CURRENCY.USD;
                    break;
                case '':
                    currency = modelService.ORDER_CURRENCY.CAD
                    break;
                default:
                    currency = modelService.ORDER_CURRENCY.CAD
                    break;
            }
            var amount = calculationService.ca2us(value, currency);
            return '$' + amount.toFixed(2) + ' ' + currency;
        }

        $rootScope.createTicket = function (ticketInfo, callback) {
            $http.post('/CreateTicket', ticketInfo)
                .success(function (messageId, error) {
                    callback(messageId, false)
                })
                .error(function () {
                    callback(false, true)
                })
        }

        /* Should be encoded (handles white spaces) */
        $rootScope.getTrackOrderLink = function (order) {
            if (!_.isEmpty(order)) {
                return getTrackOrderLink(order)
            } else return '';
        }

        $rootScope.getRecentTracking = function () {
            return localStorage.getItem("orderUrl")
        }

        $rootScope.getOrderStatus = function (order) {
            return getOrderStatus(order)
        }

        $rootScope.orderConfirmed = function (order) {
            var status = getOrderStatus(order)
            return status == "Printing" || status == "Shipped"
        }

        $rootScope.getLastStatusDate = function (order) {
            return getLastStatusDate(order)
        }


        $rootScope.encodeURI = function (str) {
            return encodeURI(str).toLowerCase()
        }

        $rootScope.decodeURI = function (str) {
            return decodeURI(str).toLowerCase()
        }

        $rootScope.breadcrumb = {
            list: [],
            isFetching: false
        };
        $rootScope.recommendLocale;

        // set min viewheight to prevent flickering as custom-page-manager loads
        //https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        $rootScope.setVh = function() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        $rootScope.$on('$routeChangeStart', function (event, next, current) {
            $modalStack.dismissAll();
            $('.modal-backdrop').remove();
            $('body').removeClass("modal-open");
            var routeLocale = next.params.locale;
            // todo: hack locale param not piped to custompagemanager, need to peek url
            if (!next.$$route) {
                var firstSubdirectory = $location.path().split("/")[1]
                if (CountryService.isValidLocale(firstSubdirectory)) {
                    routeLocale = firstSubdirectory;
                }
            }

            if (!routeLocale) {
                routeLocale = ""; // default to en-ca
            }

            // on initial app load only
            var disableRecommendLocaleModal = false;
            var forceLocaleCheck = false;
            try {
                if (next.resolve.disableRecommendLocaleModal) {
                    disableRecommendLocaleModal = next.resolve.disableRecommendLocaleModal()
                }
                if (next.resolve.forceLocaleCheck) {
                    forceLocaleCheck = next.resolve.forceLocaleCheck();
                }
            } catch (e) {

            }
            if (!current) {
                try {
                    $rootScope.setVh();
                    CountryService.validatePageLocale(forceLocaleCheck, disableRecommendLocaleModal);
                } catch (e) {
                    console.log(e);
                    $location.path('/page-not-found').replace();
                }
            } else {
                document.getElementById("footer-container").style.display = 'none'
                // internal navigation
                // url changes via $location.path() needs to respect locale
                var currentLocale = CountryService.getCurrentLocale();
                if (next !== current && currentLocale) {
                    if (routeLocale !== currentLocale) {
                        event.preventDefault();
                        // need to cancel url change and update  w.r.t locale
                        CountryService.reloadUrl();
                    }
                }

                if (forceLocaleCheck) {
                    CountryService.validatePageLocale(forceLocaleCheck, disableRecommendLocaleModal);
                }
            }

            if (next.data && next.data.authRequired) {
                if (!AuthToken.isLoggedIn()){
                    event.preventDefault();
                    $location.path('/login');
                }
            }
        });

        // clicked close on the modal
        $rootScope.userConfirmLocale = function() {
            $rootScope.showRecommendLocaleModal = false
            $rootScope.setLocalStorage('userConfirmedLocation', Date.now() + (60000 * 60 * 24 * 5));
        }

        // initial page load
        $rootScope.$on('$viewContentLoaded', function () {
            // page manager handles it in controller
            if ($route.current.loadedTemplateUrl !== "js/controllers/custom-page-manager.html") {
                // page loaded gtag event
                if (window.dataLayer && !$rootScope.initialViewContentLoaded) {
                    setTimeout(function(){
                        window.dataLayer.push({
                            'event': 'initial_view_content_loaded'
                        });
                    }, 5000)
                 $rootScope.initialViewContentLoaded = true;
                }
                // add after - cls
                setTimeout(function() {
                    document.getElementById("footer-container").style.display = 'block';
                })
                //Here your view content is fully loaded !!
            }
        });

        // matchmedia.onPhone(function(mediaQuery) {
        //     shouldShowStoryPage();
        // })
        // $window.onresize = shouldShowStoryPage;

        function shouldShowStoryPage() {
            $rootScope.showStoryPage = ($location.path() === "/" || $location.path() === '/en-us') && window.innerWidth < 767;
        }

        $rootScope.showStoryPage;
        $rootScope.$on('$routeChangeSuccess', function (event, next, current) {
            shouldShowStoryPage();
            // on route change scroll to top of page
            $anchorScroll();
            var navMain = $("#bs-example-navbar-collapse-1");
            navMain.collapse('hide');
            // home page
            var urlPath = CountryService.getCurrentBasePath().substring(1);
            if (!urlPath) {
                $rootScope.breadcrumb.list = []
                // delegate to CustomPageMananger has no route OR hardcoded route requires fetching
            } else if (!next.$$route || next.locals.calculateBreadcrumbs) {
                $rootScope.breadcrumb.isFetching = true;
            } else {
                $rootScope.breadcrumb.list = [];
            }

            // update canonical element
            var host = $location.protocol() + '://' + location.host;
            // no query params
            var fullUrl = encodeURI(host + $location.path());
            SEOService.updateCanonicalTag(fullUrl);

            var basePath;
            if (!next.locals.disableHrefLang) {
                basePath = CountryService.getCurrentBasePath();
            }
            SEOService.updateHrefLangTags(host, basePath, $location.search());

            // Set robots meta tag, override if supplied
            var robotsContent = null;
            if (next.locals.robotsContentOverrides) {
                robotsContent = next.locals.robotsContentOverrides;
            }
            SEOService.updateRobotsTag(robotsContent);
        });

        $rootScope.smoothScrollTo = function (target, animationTimeOverride) {
            var animationMs = 750;
            if (animationTimeOverride >= 0) {
                animationMs = animationTimeOverride;
            }
            var $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, animationMs, 'swing', function () {

            });
        }

        $rootScope.signUp = function (user, callback) {
            $http.post('/User/', user)
                .success(function (userToken) {
                    AnalyticsService.customTrackSignUp(user.username)
                    callback(userToken)
                })
                .error(function () {
                    callback()
                })
        }

        $rootScope.getProductCategoryUrl = function(product) {
            return calculationService.getProductCategoryUrl(product, categoryService.allCategories);
        }

        // determine best guess breadcrumb from product metadata
        $rootScope.getBreadcrumbFromProduct = function(product) {
            var breadcrumbUrl = $rootScope.getProductCategoryUrl(product);
            breadcrumbUrl = breadcrumbUrl.substring(1);
            var productUrlWithLocale = CommonUtilService.buildProductUrl(product);
            var currentLocale = CountryService.getCurrentLocale();
            if (currentLocale) {
                productUrlWithLocale = '/' + currentLocale + productUrlWithLocale;
            }
                return PageTemplateService.getBreadcrumb(breadcrumbUrl, $rootScope.breadcrumb)
                .then(function(breadcrumbRes) {
                    if (breadcrumbRes.url === breadcrumbUrl) {
                        breadcrumbRes.breadcrumb.unshift({
                            targetKeyword: CommonUtilService.toTitleCase(product.name),
                            // need current url path to handle locale
                            pageUrl: productUrlWithLocale.substring(1)
                        })
                        $rootScope.breadcrumb.list = breadcrumbRes.breadcrumb
                        return breadcrumbRes.breadcrumb;
                    }
                })
                    .catch(function(e) {
                        $rootScope.breadcrumb = null;
                    })
                    .finally(function() {
                        $rootScope.breadcrumb.isFetching = false;
                    })
        }

        //getcategorytext.js
        $rootScope.findCategoryFromString = function(categoryString){
            function replaceHyphenWithStrings(inputText, replacementString) {
                var replacedText = inputText.replace(/-/g, replacementString);
                return replacedText;
            }

            var category = _.find(categoryService.allCategories, function(category){
                var matching = replaceHyphenWithStrings(categoryString," ").toLowerCase()
                return matching == replaceHyphenWithStrings(category.name, " ").toLowerCase()
            })

            if (!category){
                category = categoryService.defaultCategory;
            }
            return category
        }

        //todo: split up this endpoint
        $rootScope.verify = function (callback) {
            if (window.localStorage.userToken){
                $http.post('/Verify', {token: window.localStorage.userToken})
                    .success(function (user) {
                        callback(user)
                    })

                    .error(function () {
                        callback(false)
                    })

            } else {
                callback(false)
            }
        }


        $rootScope.addLocaleToJotForm = function(jotformurl){
            if($rootScope.fromUS()){
                jotformurl = jotformurl + "?local=en-us/"
            }
            return jotformurl
        }


        $rootScope.getDesignHelpForm = function(){
            return $rootScope.addLocaleToJotForm("https://form.jotform.com/231234543785256")
        }

        $rootScope.compressImage = function (url) {
            return CommonUtilService.compressImage(url);
        }

        $rootScope.getJotFormUrlFromProduct = function(product, productColour){
            var url = "https://form.jotform.com/230964611728258?w=" + encodeURI(product.name)

             if (productColour){
                 url = url + "&whatColour=" + encodeURI(productColour)
             }
            return $sce.trustAsResourceUrl(url)
        }

        $rootScope.getProductImage = function(product,colourIndex,view){
            if (product && product.colours[colourIndex]&& product.colours[colourIndex][view]) {
                return product.colours[colourIndex][view];
            } else {
                return false
            }
        }

        $rootScope.getProductFront = function (product, index) {
            if (product && product.colours[index].front) {
                return product.colours[index].front;
            }
        }

        $rootScope.getProductBack = function (product, index) {
            if (product && product.colours[index].back) {
                return product.colours[index].back;
            }
        }

        $rootScope.getPromoDecorationGroupsForProduct = function (product) {
            var printTypes = [];
            _.forOwn(calculationService.promoProductDecorationGrouping, function (grouping, key) {
                if (_.some(grouping.list, function (printName) {
                    return product.promoPrintMethods.includes(printName)
                })) {
                    printTypes.push(grouping.name)
                }
            });
            return printTypes;
        }


        $rootScope.codeLogin = function (username, oneTimeCode, callback) {
            var request = {
                username: username,
                oneTimeCode: oneTimeCode
            }

            $http.post('/AuthenticateUserWithCode', request)
                .success(function (response) {
                    window.localStorage.userToken = response.token;
                    callback("true")
                })
                .error(function (response) {
                    callback(false)
                });
        }

        $rootScope.deleteUpload = function(upload, accountUploads){
            $http.post('/DeleteUpload', {token: window.localStorage.userToken, uploadId : upload._id})
                .success(function () {
                    var uploadIndex = _.findIndex(accountUploads, function(existingUpload){
                        return existingUpload._id == upload._id
                    })
                    accountUploads.splice(uploadIndex,1)
                })
                .error(function () {
                    showError("Could not delete design, please try again later.")
                })
        }

        $rootScope.truncateText = function(str, length){
            if (str.length > length) {
                return str.substring(0, length - 3) + '...';
            } else {
                return str;
            }
        }

        $rootScope.getUserToken = function(){
            return window.localStorage.userToken
        }

        $rootScope.setToken = function(token){
            window.localStorage.userToken = token;
        }


        $rootScope.login = function (username, password, callback) {
            var request = {
                username: username,
                password: password
            }

            $http.post('/AuthenticateUser', request)
                .success(function (response) {
                    $rootScope.setToken(response.token)
                    callback("true")
                })

                .error(function (response) {
                    callback(false)
                });
        }

        $rootScope.getProductUrl = function (product) {
            return CommonUtilService.buildProductUrl(product)
        }


        $rootScope.goToProduct = function (product) {
            $location.path(CommonUtilService.buildProductUrl(product)).search({});
        }

        $rootScope.getCartTotal = function (cart) {
            var cartTotal = 0;
            if (cart) {
                for (var i = 0; i < cart.length; i++) {
                    cartTotal = (cartTotal + cart[i].price * cart[i].totalQty);
                }
            }
            return cartTotal

        }

        $rootScope.updateCartWithUser = function(cartId,callback){
            CustomerService.updateCart(cartId)
                .then(function() {
                    if(callback){
                        callback()
                    }
                });
        }



        $rootScope.getCartIdAndUser = function(callback){
            $rootScope.verify(function(user) {
                var localCart = $rootScope.getLocalCartId();
                if (user){
                    if (user.currentCart){
                        callback(user,user.currentCart)
                    } else if (localCart){
                        $rootScope.updateCartWithUser(localCart, function(){
                            localStorage.setItem("cartNew", "")
                            callback(user,localCart)
                        })
                    } else {
                        callback(user,localCart)
                    }
                } else {
                    callback(false,localCart)
                }
            })
        }

        $rootScope.getLocalCartId = function () {
            var cartId = localStorage.getItem("cartNew");
            return cartId
        }

        $rootScope.refreshUserAndCartId = function(){
            $rootScope.getCartIdAndUser(function(user,cartId){
                if (user) {
                    $rootScope.user = user;
                }
                $rootScope.cartId = cartId
            })
        }

        $rootScope.refreshUserAndCartId()



        $rootScope.updateCartInDb = function (cart, callback) {
            $http.put('/Cart/' + cart._id, {cart: cart})
                .success(function (response) {
                    callback(true)
                })
                .error(function () {
                    callback(false)
                })
        }


        $rootScope.getCart = function (cartId, callback) {
            if (cartId) {
                $http.get('/Cart/' + cartId).success(function (response) {
                    if (!response) {
                        callback({listOfItems: []})
                    } else {
                        callback(response)
                    }

                })
                    .error(function () {
                        callback({listOfItems: []})
                    });
            } else {
                callback({listOfItems: []})
            }
        }

    }]);

    /*
     * Max length on all textareas
     */
    app.directive('textarea', function() {
        return {
            restrict: 'E',
            link: function($scope, $element, attrs) {
                if (!attrs.maxlength) {
                    attrs.$set('maxlength', 35000); // default
                }
            }
        };
    });

    /*
  * Default Maximums on all inputs
  */
    app.directive('input', function() {
        return {
            restrict: 'E',
            link: function($scope, $element, attrs) {
                if (attrs.type) {
                    if (attrs.type === 'text' || attrs.type === 'email') {
                        if (!attrs.maxlength) {
                            attrs.$set('maxlength', 250); // default
                        }
                    } else if (attrs.type === 'number') {
                        if (!attrs.max) {
                            attrs.$set('max', 100000)
                        }
                    }
                }
            }
        };
    });

    // refresh all anchor elements with locale and relative domain
    app.directive('a', ['CountryService', function(CountryService) {
        return {
            restrict: 'E',
            scope: {
                anchorCanUpdate: '=?'
            },
            link: function($scope, element, attrs) {
                if (CountryService.getCurrentLocale === "") {
                    // do nothing default
                } else {
                    var localeDeregister = $scope.$on('localeReady', function () {
                        updateHref();
                    })

                    var hrefSetDeregister = attrs.$observe('href', function () {
                        updateHref();
                    });
                }

                function updateHref() {
                    if ((attrs.href !== '#' && attrs.href && !_.isUndefined(CountryService.getCurrentLocale()))) {
                        // pass in absolute url from anchor context
                       var hrefToUpdate = CountryService.getRelativeLocaleUrl(element.context.href);
                       // set the first time then deregister
                        if (attrs.href !== hrefToUpdate) {
                            if (!$scope.anchorCanUpdate) {
                                hrefSetDeregister();
                                localeDeregister();
                            }
                            setTimeout(function(){
                                attrs.$set('href', hrefToUpdate);
                                // console.log(element.context.href)
                            })
                        }
                    }
                }
            }
        }
    }]);

    app.directive('loginForm', function () {
        return {
            restrict: 'E',
            scope: {
                onLoginSuccess: '&',
                email: '=',
                signUp : '='
            },
            templateUrl: '../../views/non_bundled/login-screen-directive.html',
            controller: ['$scope', '$http', '$location', '$rootScope', function ($scope, $http, $location, $rootScope) {

                $scope.$watch('email', function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        $scope.user.username = newVal || '';
                    }
                });

                $scope.user = {
                    username : $scope.email
                }
                $scope.login = function () {
                    $rootScope.login($scope.user.username, $scope.user.password, function (success) {
                        if (success) {
                            $rootScope.refreshUserAndCartId();
                            $scope.onLoginSuccess();
                        } else {
                            showError("Username and password combination is incorrect");
                        }
                    });
                };

                $scope.codeLoginForm = function () {
                    loadingScreen("Verifying Code");
                    $rootScope.codeLogin($scope.user.username, $scope.oneTimeCode, function (success) {
                        if (success) {
                            closeLoadingScreen();
                            $rootScope.refreshUserAndCartId();
                            $scope.onLoginSuccess();
                        } else {
                            closeLoadingScreen();
                            showError("Code Incorrect");
                        }
                    });
                };

                $scope.forgotPassword = function () {
                    $scope.forgotPasswordScreen = true;
                    $scope.loginPassword = false;
                };

                $scope.loginWithPassword = function () {
                    $scope.oneTimeCode = "";
                    $scope.loginPassword = true;
                    $scope.loginCode = false;
                    $scope.forgotPasswordScreen = false;
                };

                $scope.sendOneTimeCode = function () {
                    var request = {
                        username: $scope.user.username
                    };

                    loadingScreen("Sending Code");
                    $http.post('/SendOneTimeCode', request)
                        .success(function () {
                            closeLoadingScreen();
                            $scope.oneTimeCodeSent = true;
                        })
                        .error(function (token) {
                            closeLoadingScreen();
                            showError("Sorry, the email you entered is not valid.");
                        });
                };

                $scope.loginWithOneTimeCode = function () {
                    $scope.loginPassword = false;
                    $scope.loginCode = true;
                    $scope.oneTimeCode = "";
                    $scope.user.username = "";
                    $scope.oneTimeCodeSent = false;
                };

                $scope.loginWithPassword();

                $scope.resetPassword = function () {
                    if (!$scope.user.username) {
                        showError("Please enter your email and then proceed to clicking \"Forgot Password\"");
                        return;
                    }
                    loadingScreen("Resetting...");
                    var request = {
                        username: $scope.user.username
                    };

                    $http.post('/ForgotPassword', request)
                        .success(function (token) {
                            closeLoadingScreen();
                            success("If your email is in our database, a link will be sent to reset your password.");
                            $scope.forgotPasswordScreen = false;
                            $scope.loginPassword = true;
                        })
                        .error(function (token) {
                            closeLoadingScreen();
                            success("If your email is in our database, a link will be sent to reset your password.");
                            $scope.forgotPasswordScreen = false;
                            $scope.loginPassword = true;
                        });
                };
            }]
        };
    });

    app.directive('onErrorSrc', function() {
        return {
            link: function(scope, element, attrs) {
                element.bind('error', function() {
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', attrs.onErrorSrc);
                    }
                });
            }
        }})

    app.directive('cantEmpty', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                function isEmpty(value) {
                    return !value || !value.trim();
                }

                function setInvalid() {
                    if (element.is('input[type="radio"]')) {
                        element.parent().parent().css({
                            'border': '2px solid #a94442',
                            'border-radius': '5px'
                        });
                    } else {
                        element.css({
                            'border': '2px solid #a94442',
                            'border-radius': '5px',
                        });
                    }

                    // Scroll to the element
                    element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                function setValid() {
                    if (element.is('input[type="radio"]')) {
                        element.parent().parent().css({
                            'border': '',

                        });
                    } else {
                        element.css({
                            'border': '',
                        });
                    }
                }


                function validate() {
                    ngModelCtrl.$setValidity('cantEmpty', !isEmpty(ngModelCtrl.$viewValue));
                    if (!ngModelCtrl.$valid) {
                        setInvalid();
                    } else {
                        setValid();
                    }
                }

                // Validate on form submission
                scope.$on('formSubmitted', function() {
                    validate();
                });

                // Validate on input change
                element.on('input', function() {
                    scope.$apply(function() {
                        validate();
                    });
                });

                element.on('change', function() {
                    scope.$apply(function() {
                        validate();
                    });
                });
            }
        };
    });

    app.directive('valuesCheckBox', ['CommonUtilService',  function (CommonUtilService) {
        return {
            templateUrl: '../../views/values-checkbox-directive.html',
            scope: {
                prefix: '@prefix',
                titleheader: '@titleheader',
                aprefix: '@aprefix',
                postorder: '@postorder'
            },
            link: function ($scope) {

            }
        };
    }]);

    app.directive('clients', function () {
        return {
            templateUrl: 'views/clients.html',
            link: function () {
            }
        }
    });

    app.directive("ngMobileClick", [function () {
        return function (scope, elem, attrs) {
            elem.bind("touchstart click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                scope.$apply(attrs["ngMobileClick"]);
            });
        }
    }])
})();
(function () {
    'use strict';

    angular.module('app')
        .directive('localeFindAndReplace', LocaleFindAndReplaceDirective);

    LocaleFindAndReplaceDirective.$inject = ['$compile', 'CountryService']

    function LocaleFindAndReplaceDirective($compile, CountryService) {

        var directive = {
            link: link,
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            var ensureCompileRunsOnce = scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.localeFindAndReplace);
                },
                function(value) {

                    var updatedText = CountryService.textFindAndReplace(value);

                    // when the 'compile' expression changes
                    // assign it into the current DOM
                    element.html(updatedText);
                    // Remove the attribute after processing
                    element.removeAttr('locale-find-and-replace');
                    // Use un-watch feature to ensure compilation happens only once.
                    ensureCompileRunsOnce();
                }
            );
        }
    }
})();
(function () {
    'use strict';

    angular.module('app')
        .directive('navbar', NavbarDirective);

    NavbarDirective.$inject = ['CustomerService', 'PageTemplateService', 'CommonUtilService', '$rootScope', '$location','$window']

    function NavbarDirective(CustomerService, PageTemplateService, CommonUtilService, $rootScope, $location, $window) {
        var directive = {
            link: link,
            templateUrl: 'js/widget/navbar.html',
            restrict: 'E',
            scope: {}
        };
        return directive;

        function link($scope, element, attrs, $window) {

            $scope.commonUtilService = CommonUtilService;
            $scope.globalSearchInput = "";
            $scope.validSearchInput = "";
            $scope.globalSearchResults = {};
            $scope.showMobileSearchBar = false;
            $scope.showSearchResults = false;
            $scope.showSubLinks = ''

            $scope.onDesignerPage = function(){
                return $location.path().includes('designer')
            }

            $scope.hasSubLinks = function(category) {
               return category.subLinks.length > 0 || category.secondaryLinks.length > 0
            }

            $scope.bestSellers = {
                categoryTitle: 'Best Sellers',
                isStarred: true,
                categoryUrl: '/custom-products/best-sellers',
                categoryLinks: [
                    {
                        title: 'Short Sleeve Shirts',
                        icon: null,
                        url: 'custom-products/custom-clothing/t-shirts/short-sleeve',
                        imageUrl : "storyBanner/short-sleeve-shirts.jpeg",
                        altText : "One of our best sellers for custom products is tshirts"
                    },
                    {
                        title: 'Long Sleeve Shirts',
                        icon: null,
                        url: 'custom-products/custom-clothing/t-shirts/long-sleeve',
                        imageUrl : "storyBanner/long-sleeve-shirts.jpeg",
                        altText : "One of our best sellers for custom products is long sleeve shirts"
                    },
                    {
                        title: 'Hoodies and Sweatshirts',
                        url: '/custom-products/custom-clothing/hoodies-sweaters',
                        imageUrl : "storyBanner/hoodies.jpeg",
                        altText : "Hoodies are one of our best sellers"
                    },
                    {
                        title: 'Polo Shirts',
                        url: '/custom-products/custom-clothing/polos',
                        imageUrl : "storyBanner/polos.jpeg",
                        altText : "Custom polos are a favourite for our customers"
                    },
                    {
                        title: 'Tote Bags',
                        url: '/custom-products/custom-bags/tote-bags',
                        imageUrl : "storyBanner/tote-bags.jpeg",
                        altText : "We often print tote bags for our clients"
                    },
                    {
                        title: 'Hats',
                        url: '/custom-products/custom-clothing/hats',
                        imageUrl : "storyBanner/hats.jpeg",
                        altText : "Custom hats is one of our best sellers"
                    },
                    {
                        title: 'Jackets',
                        url: '/custom-products/custom-clothing/jackets',
                        imageUrl : "storyBanner/jackets.jpeg",
                        altText : "Custom jackets are a popular option in the winter."
                    },
                    {
                        title: 'Drinkware',
                        url: 'custom-products/promotional/drinkware',
                        imageUrl : "storyBanner/drinkware.jpeg",
                        altText : "Print custom bottles, mugs and more"
                    },
                    {
                        title: 'Notebooks',
                        url: '/custom-products/promotional/office-supplies/notebooks',
                        imageUrl : "storyBanner/notebooks.jpeg",
                        altText : "Custom print notebooks for your business"
                    },
                    {
                        title: 'Patches',
                        url: '/custom-products/patches',
                        imageUrl : "storyBanner/patches.jpeg",
                        altText : "Custom Patches are an amazing way to stand out. "
                    }
                ]
            }

            $scope.moreWaysToShop = {
                categoryTitle: 'More Ways to Shop',
                categoryUrl: '',
                isStarred: false,
                categoryLinks: [
                    {
                        title: 'Eco Friendly',
                        icon: '/images/icons/navbar/Eco_Friendly.svg',
                        isStarred: false,
                        url: 'custom-products/eco-friendly-products'
                    },
                    {
                        title: 'Brands',
                        icon: '/images/icons/navbar/Brands.svg',
                        isStarred: false,
                        url: 'custom-products/brands'
                    },
                    {
                        title: 'Bulk Products',
                        icon: '/images/icons/navbar/bulk-products.svg',
                        isStarred: false,
                        url: '/custom-products/bulk-products'
                    }
                    ]
            },

                $scope.hatsCat =   {
                    categoryTitle: 'Hats',
                    categoryUrl: 'custom-products/custom-clothing/hats',
                    isStarred: false,
                    categoryLinks: [
                        {
                            title: 'Dad Hats',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/dad-hats'
                        },
                        {
                            title: 'Flat Brimmed Hats',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/flat-brimmed'
                        },
                        {
                            title: 'Bucket Hats',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/bucket-hats'
                        },
                        {
                            title: 'Trucker Hats',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/trucker-hats'
                        },
                        {
                            title: 'Toques',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/toques'
                        },
                        {
                            title: 'Visors',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/hats/visors'
                        },
                        {
                            title: 'Youth Hats',
                            isStarred: false,
                            icon: null,
                            url: 'custom-products/custom-clothing/youth/hats'
                        },
                    ]
                };
            $scope.websiteLinks = [
                {
                    title: 'Products',
                    url: 'custom-products',
                    subLinks: [
                        {
                            categoryTitle: 'All Categories',
                            isStarred: false,
                            categoryUrl: 'custom-products',
                            categoryLinks: []
                        },
                        $scope.bestSellers,
                        {
                            categoryTitle: 'T-Shirts',
                            isStarred: false,
                            categoryUrl: '/custom-products/custom-clothing/t-shirts',
                            categoryLinks: [
                                {
                                    title: 'Short Sleeve',
                                    icon: null,
                                    url: 'custom-products/custom-clothing/t-shirts/short-sleeve'
                                },
                                {
                                    title: 'Long Sleeve',
                                    icon: null,
                                    url: 'custom-products/custom-clothing/t-shirts/long-sleeve'
                                },
                                {
                                    title: 'Athletic Shirts',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/t-shirts/athletic'
                                },
                                {
                                    title: 'Tank Tops and Sleeveless',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/t-shirts/tank-tops'
                                },
                                {
                                    title: 'Ladies Shirts',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/ladies/t-shirts'
                                },
                                {
                                    title: 'Kids Shirts',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/youth/t-shirts'
                                }
                            ]
                        },
                        {
                            categoryTitle: 'Apparel',
                            categoryUrl: 'custom-products/custom-clothing',
                            isStarred: false,
                            categoryLinks: [
                                {
                                    title: 'Hoodies and Sweatshirts',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/hoodies-sweaters'
                                },
                                {
                                    title: 'Sweatpants',    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/pants-bottoms/sweatpants'
                                },
                                {
                                    title: 'Polo Shirts',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/polos'
                                },
                                {
                                    title: 'Button Down Shirts',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/button-downs'
                                },
                                {
                                    title: 'Jerseys',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/jerseys'
                                },
                                {
                                    title: 'Sportswear',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/jerseys/sports'
                                },
                                {
                                    title: 'Sublimation',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/jerseys/sublimated-apparel'
                                },
                                {
                                    title: 'Jackets',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/jackets'
                                },
                                {
                                    title: 'Vests',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/jackets/vests'
                                },
                                {
                                    title: 'Shorts and Bottoms',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/pants-bottoms'
                                },
                                {
                                    title: 'Socks',
                                    isStarred: false,
                                    icon: null,
                                    url: '/custom-products/custom-clothing/socks'
                                },
                                {
                                    title: 'Ladies',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/ladies'
                                },
                                {
                                    title: 'Youth and Kids',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-clothing/youth'
                                }
                            ]
                        },
                        {
                            categoryTitle: 'Bags',
                            categoryUrl: 'custom-products/custom-bags',
                            isStarred: false,
                            categoryLinks: [
                                {
                                    title: 'Tote Bags',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/tote-bags'
                                },
                                {
                                    title: 'Shopping Bags',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/shopping'
                                },
                                {
                                    title: 'Duffel Bags',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/duffel-bags'
                                },
                                {
                                    title: 'Backpacks',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/custom-backpacks'
                                },
                                {
                                    title: 'Cinch Bags',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/custom-cinch-bags'
                                },
                                {
                                    title: 'Laptop Bags',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/custom-laptop-bags'
                                },
                                {
                                    title: 'Laptop and Tablet Sleeves',
                                    isStarred: false,
                                    icon: null,
                                    url: 'custom-products/custom-bags/custom-laptop-tablet-sleeves'
                                },
                            ]
                        },
                        $scope.hatsCat,
                        {
                            categoryTitle: 'Promotional Products',
                            categoryUrl: 'custom-products/promotional',
                            isStarred: false,
                            categoryLinks: [
                                {
                                    title: 'Drinkware',
                                    url: 'custom-products/promotional/drinkware',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Notebooks',
                                    url: 'custom-products/promotional/office-supplies/notebooks',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Pens',
                                    url: 'custom-products/promotional/office-supplies/custom-pens',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Technology',
                                    url: 'custom-products/promotional/tech',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Lanyards',
                                    url: 'custom-products/promotional/office-supplies/lanyards',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Stickers',
                                    url: 'sticker-printing',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Patches',
                                    url: 'custom-products/patches',
                                    isStarred: false,
                                    icon: null,
                                },
                                {
                                    title: 'Swag Boxes',
                                    url: 'custom-products/promotional/company-swag-box',
                                    isStarred: false,
                                    icon: null,
                                },
                            ]
                        },
                        $scope.moreWaysToShop
                    ],
                    secondaryLinks: [
                        {
                            categoryTitle: 'Shop by Use',
                            categoryUrl: 'custom-products/shop-by-use',
                            categoryLinks: [
                                {
                                    title: 'Corporate',
                                    icon: '/images/icons/navbar/Corporate.svg',
                                    url: 'custom-products/custom-clothing/corporate-apparel'
                                },
                                {
                                    title: 'Safety Wear',
                                    icon: '/images/icons/navbar/Work.svg',
                                    url: 'custom-products/custom-clothing/work-wear/safety'
                                },
                                {
                                    title: 'School',
                                    icon: '/images/icons/navbar/School.svg',
                                    url: 'custom-products/custom-clothing/school'
                                },
                                {
                                    title: 'Streetwear',
                                    icon: '/images/icons/navbar/Streetwear.svg',
                                    url: 'custom-products/custom-clothing/street-wear'
                                },
                                {
                                    title: 'Sport',
                                    icon: '/images/icons/navbar/Sport.svg',
                                    url: 'custom-products/jerseys/sports'
                                },
                                {
                                    title: 'Workwear and Uniforms',
                                    icon: '/images/icons/navbar/Uniform.svg',
                                    url: 'custom-products/custom-clothing/work-wear'
                                }
                            ]
                        },
                    ]
                },
                {
                    title: 'How to Order',
                    url: 'how-to-order',
                    subLinks: [],
                    secondaryLinks: []
                    // subLinks: []
                    // ,
                    // secondaryLinks: [
                    //     {
                    //         // categoryTitle: 'How to Order',
                    //         // categoryUrl: 'how-to-order',
                    //         categoryLinks: [
                    //             {
                    //                 title: 'Placing an Online Order',
                    //                 icon: '../../images/icons/navbar/Online_Order.svg',
                    //                 url: '/how-to-order?tab=ONLINE'
                    //             },
                    //             {
                    //                 title: 'Request a Quote',
                    //                 icon: '../../images/icons/navbar/Request_A_Quote.svg',
                    //                 url: '/how-to-order?tab=REQUEST'
                    //             },
                    //             {
                    //                 title: 'Contact Us',
                    //                 icon: '../../images/icons/navbar/Design_Help_Contact_Us.svg',
                    //                 url: '/contact'
                    //             },
                    //             {
                    //                 title: "Don't Have a Design?",
                    //                 icon: '../../images/icons/navbar/Dont_Have_A_Design.svg',
                    //                 url: $rootScope.getDesignHelpForm()
                    //             },
                    //         ]
                    //     },
                    // ]
                },
                // {
                //     title: 'Design',
                //     url: 'designer/atc-everyday-cotton-tee',
                //     secondaryLinks: [
                //         {
                //             categoryLinks: [
                //                 {
                //                     title: 'Design a Shirt',
                //                     icon: '../../images/icons/navbar/Design_A_Shirt.svg',
                //                     url: 'designer/gildan-ultra-cotton-t-shirt'
                //                 },
                //                 {
                //                     title: 'Design Help',
                //                     icon: '../../images/icons/navbar/Design_Help.svg',
                //                     url: 'design-help'
                //                 }
                //             ]
                //         }
                //     ],
                //     subLinks: []
                // },
                {
                    title: 'About',
                    url: 'about-us',
                    secondaryLinks: [
                        {
                            categoryLinks: [
                                // {
                                //     title: 'Contact Us',
                                //     icon: '../../images/icons/navbar/Contact_Us.svg',
                                //     url: 'contact'
                                // },
                                {
                                    title: 'About Us',
                                    icon: '../../images/icons/navbar/About_Us.svg',
                                    url: 'about-us'
                                },
                                {
                                    title: 'Our Facilities',
                                    icon: '../../images/icons/navbar/Our_Facilities.svg',
                                    url: 'our-facilities'
                                },
                                {
                                    title: 'Print Methods',
                                    icon: '../../images/icons/navbar/Print_Methods.svg',
                                    url: 'print-methods'
                                },
                                {
                                    title: 'Gallery',
                                    icon: '../../images/icons/navbar/Gallery.svg',
                                    url: 'gallery'
                                },
                                {
                                    title: 'Blog',
                                    icon: '../../images/icons/navbar/Blog.svg',
                                    url: 'blog'
                                },
                                // {
                                //     title: 'FAQ',
                                //     icon: '../../images/icons/navbar/FAQ.svg',
                                //     url: 'https://help.coastalreign.com'
                                // }
                            ]
                        }
                    ],
                    subLinks: []
                },
                {
                    title: 'FAQ',
                    url: 'https://help.coastalreign.com',
                    subLinks: [],
                    secondaryLinks: []
                }
            ]
            $scope.productCategoryLinks = []

            // only generate link when its ready
            $scope.$on('localeReady', function() {
                if ($rootScope.fromUS()) {
                    var toquesIndex = _.findIndex($scope.hatsCat.categoryLinks, function (subCat) {
                        return subCat.title === 'Toques'
                    })
                    if (toquesIndex > -1) {
                        $scope.hatsCat.categoryLinks.splice(
                            toquesIndex,
                            1,
                            {
                                title: 'Beanies',
                                isStarred: false,
                                icon: null,
                                url: 'custom-products/custom-clothing/hats/toques'
                            }
                    )}
                }
                $scope.moreWaysToShop.categoryLinks.unshift(
                {
                    title: $rootScope.fromUS() ? 'Made in USA' : 'Made in Canada',
                    icon: $rootScope.fromUS() ? '/images/icons/navbar/made-in-usa.svg' : '/images/icons/navbar/Made_In_Canada.svg',
                    isStarred: false,
                    url:  $rootScope.fromUS() ? 'custom-products/custom-clothing/made-in-usa' : 'custom-products/custom-clothing/made-in-canada'
                }
                )
            })
            $scope.$watch('globalSearchInput', function() {
                if ($scope.globalSearchInput.length >= 3) {
                    // do the search
                    $scope.showSearchResults = true;
                    $scope.validSearchInput = $scope.globalSearchInput;
                    CustomerService.searchKeyword($scope.validSearchInput, true)
                        .then(function(results) {
                            // transform faq text content
                            if (results.faqArticlesResult.length > 0) {
                                _.map(results.faqArticlesResult, function(faqArticle) {
                                    var tempDiv = document.createElement('div');
                                    tempDiv.innerHTML = faqArticle.body;
                                    var textContent = tempDiv.textContent;
                                    // remove \n
                                    textContent = textContent.replace(/(\r\n|\n|\r)/gm," ");

                                    var allSentences = textContent.match( /[^\.!\?]+[\.!\?]+/g);

                                    var indexOfMatch = _.findIndex(allSentences, function(sentence) {
                                        return sentence.toLowerCase().includes($scope.validSearchInput.toLowerCase());
                                    })

                                    if (indexOfMatch > -1) {
                                        var firstIndex = indexOfMatch;
                                        var hasMoreTextBefore = '';
                                        if (firstIndex > 0) {
                                            hasMoreTextBefore = '. . . ';
                                        }
                                        firstIndex = firstIndex >= 0 ? firstIndex : 0;
                                        var before = allSentences.slice(firstIndex, indexOfMatch);

                                        var hasMoreTextAfter = '';
                                        var lastIndex = indexOfMatch;
                                        if (lastIndex < allSentences.length) {
                                            hasMoreTextAfter = ' . . .';
                                            var lastWord = allSentences[lastIndex];
                                            lastWord = lastWord.slice(0, lastWord.length - 1);
                                            allSentences[lastIndex] = lastWord;
                                        }
                                        var after = allSentences.slice(indexOfMatch, lastIndex + 1);
                                        textContent = hasMoreTextBefore + before.join(" ") + after.join(" ") + hasMoreTextAfter;
                                    } else {
                                        textContent = allSentences.slice(0, 1).join(" ").slice(0, -1) + ' . . .';
                                    }

                                    faqArticle.textBody = textContent;
                                })
                            }
                            _.forEach(results.pageResults, function(page) {
                                if (!page.previewImageUrl) {
                                    page.previewImageUrl = 'https://image.coastalreign.com/search_placeholder.jpg';
                                }
                            })
                            $scope.globalSearchResults = results;
                            // console.log($scope.globalSearchResults);
                        })
                } else {
                    // remove the search results
                    $scope.globalSearchResults = {};
                    $scope.validSearchInput = "";
                    $scope.showSearchResults = false;
                }
            })

            $scope.goToNavLink = function(url, event) {
                $scope.toggleSideNav(false);
            }

            $rootScope.$on('$routeChangeStart', function() {
                document.getElementById('searchInputElement').blur();
                $scope.showMobileSearchBar = false;
                $scope.showSubLinks = '';
                $scope.showSearchResults = false;
                $scope.globalSearchResults = {};
                $scope.globalSearchInput = '';
                $scope.validSearchInput = '';
            })

            $scope.mobileGlobalSearchDisplayClass = function() {
                return {
                    'hide-on-mobile': !$scope.showMobileSearchBar,
                    'show-on-mobile': $scope.showMobileSearchBar
                }
            }

            $scope.navSlideInClass = function() {
                return {
                    'slide-in': $rootScope.showSideNav,
                    'slide-out': $rootScope.showSideNav
                };
            }
            $scope.toggleSideNav = function(shouldShow) {
                $rootScope.showSideNav = shouldShow;
            }

            $scope.navigateToSearchMore = function() {
                if ($scope.validSearchInput) {
                    $location.url($rootScope.encodeURI("/search?query=" + $scope.validSearchInput));
                } else {
                    // $location.url('/search?query=');
                }
            }

            $scope.toggleSubLinks = function(websiteLink) {
                if (websiteLink && $scope.hasSubLinks(websiteLink) && !$scope.showSearchResults) {
                    $scope.showSubLinks = websiteLink.title;
                    $scope.subLinks = websiteLink;
                } else {
                    $scope.showSubLinks = '';
                    $scope.subLinks = {}
                }
            }

            $scope.toggleSearchResult = function(shouldShow) {
                if (_.isEmpty($scope.globalSearchResults)) {
                    $scope.showSearchResults = false;
                } else {
                    $scope.showSearchResults = shouldShow;
                }
            }

            $scope.toggleMobileSearchBar = function(shouldShow) {
                $scope.showMobileSearchBar = shouldShow;
                if (shouldShow) {
                    setTimeout(function(){
                        document.getElementById('searchInputElement').click();
                        document.getElementById('searchInputElement').focus();
                    })
                }
            }

            $scope.cleanPageName = function(name) {
                return PageTemplateService.cleanPageName(name);
            }

            $scope.getProductLink = function(product) {
                return CommonUtilService.buildProductUrl(product);
            }

            $scope.getProductDisplay = function(product){
                return CommonUtilService.getProductDisplay(product).url
            };

            $scope.compressImage = function(url) {
                return CommonUtilService.compressImage(url);
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app')
        .directive('footer', FooterDirective);

    FooterDirective.$inject = ['$rootScope', '$location']

    function FooterDirective($rootScope, $location) {
        var directive = {
            link: link,
            templateUrl: 'js/widget/footer.html',
            restrict: 'EA',
            scope: {}
        };
        return directive;

        function link($scope, element, attrs) {

        }
    }
})();
(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('lazyLoadedImage', LazyLoadedImageDirective);

    LazyLoadedImageDirective.$inject = ['$rootScope']

    function LazyLoadedImageDirective($rootScope) {

        var linker = function ($scope, element, attrs) {
            element.addClass('lazyload');
        };

        return {
            restrict: "A",
            link: linker
        };
    }
})();
(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('responsiveImage', ResponsiveImageDirective);

    ResponsiveImageDirective.$inject = ['$rootScope', 'CommonUtilService']

    function ResponsiveImageDirective($rootScope, CommonUtilService) {
        var directive = {
            restrict: "A",
            scope: {
                originalUrl: '@',
                isBanner: '@',
                isProductImage: '@',
                imageCanUpdate: '=',
                imagePath: '@?',
                imageSizes: '@?',
                noSrcset: '@'

            },
            link: linker
        }
        return directive;

        function linker ($scope, element, attrs) {

            // mobile, tablet, desktop breakpoints
            var DEFAULT_IMAGE_SIZES = "(max-width: 767px) 100vw, (max-width: 1023px) 100vw, 100vw"
            var NAMED_TRANSFORMATIONS = {
                'image-xs': "100w",
                'image-s': "250w",
                'image-sm': '350w',
                'image-m': "600w",
                'image-l': "1250w"
            }

            var NAMED_PRODUCT_TRANSFORMATIONS = {
                'product-img-xs': "100w",
                'product-img-s': "200w",
                'product-img-sm': '400w',
                'product-img-m': "600w",
                'product-img-l': "1250w"
            }

            function intialize(reload) {

                var imagekit = new ImageKit({
                    urlEndpoint: "https://image.coastalreign.com"
                });

                var src;
                var srcset = '';
                if ($scope.imagePath && !$scope.originalUrl) {
                    src = 'https://image.coastalreign.com/' + $scope.imagePath
                } else {
                    src = $scope.originalUrl;
                }

                if (!$scope.imageSizes) {
                    $scope.imageSizes = DEFAULT_IMAGE_SIZES;
                }

                var transformations = NAMED_TRANSFORMATIONS
                if ($scope.isProductImage) {
                    transformations = NAMED_PRODUCT_TRANSFORMATIONS
                }

                if (src) {
                    src = CommonUtilService.compressImage(src);
                    if (src.includes('image.coastalreign.com')) {
                        // create srcset images
                        if (!$scope.noSrcset) {
                            var transformedUrls = _.map(_.keys(transformations), function (transformationLabel) {
                                var transformedUrl = imagekit.url({
                                    src: src,
                                    transformation: [{
                                        "n": transformationLabel
                                    }]
                                })

                                return transformedUrl + " " + transformations[transformationLabel]
                            })

                            srcset = transformedUrls.join(", ");
                        }

                        if ($scope.isBanner) {
                            src = imagekit.url({
                                src: src,
                                transformation: [{
                                    "n": 'banner-quality'
                                }]
                            })
                        }

                    }
                }

                if ($rootScope.lazyLoadedImagesCache && $rootScope.lazyLoadedImagesCache.get(src)) {
                    element.addClass('imageLoadNoFade');
                    element.removeClass('lazyloaded');
                    element.removeClass('lazyload');
                    attrs.$set('src', src);
                    attrs.$set('srcset', srcset);
                    attrs.$set('sizes', $scope.imageSizes);
                } else {
                    if (attrs.$attr.lazyLoadedImage) {
                        if (reload) {
                            element.addClass('imageLoadNoFade');
                            element.removeClass('lazyloaded');
                            element.removeClass('lazyload');
                            attrs.$set('src', src);
                            attrs.$set('srcset', srcset)
                            attrs.$set('sizes', $scope.imageSizes)
                        } else {
                            attrs.$set('data-srcset', srcset)
                            attrs.$set('data-src', src);
                            attrs.$set('data-sizes', $scope.imageSizes)
                        }
                        if ($rootScope.lazyLoadedImagesCache) {
                            $rootScope.lazyLoadedImagesCache.put(src, true);
                        }
                    } else {
                        attrs.$set('src', src);
                        attrs.$set('srcset', srcset);
                        attrs.$set('sizes', $scope.imageSizes);
                    }
                }
            }

            intialize();
            if ($scope.imageCanUpdate) {
                $scope.$watch('originalUrl', function originalUrlUpdate(newValue, oldValue) {
                    if (oldValue && (newValue !== oldValue)) {
                        intialize(true);
                        // console.log(newValue);
                    }
                })
                $scope.$watch('imagePath', function imagePathUpdate(newValue, oldValue) {
                    if (oldValue && (newValue !== oldValue)) {
                        intialize(true);
                        // console.log('imagepath')
                    }
                })
            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('sharedModule')
        .factory('CommonUtilService', CommonUtilService)

    CommonUtilService.$inject = [];

    // shared by both admin and public, if this starts getting bloated create more specific services
    function CommonUtilService() {

        function getDateString(timestamp, format) {
            var formatToUse = format ? format: "LL"
            return moment(timestamp).local().format(formatToUse);
        }

        function getAddressTooltip(address) {
            return getAddressTooltipHelper(address);
        }

        function getAvailablePrints(product) {
            if (product.type === 'Promotional Product') {
                return _.uniq(_.map(product.promoPrintMethods, function(specificPrintMethod) {
                    var found = _.find(_.values(calculationService.promoProductDecorationGrouping), function(promoPrintGroup) {
                        return promoPrintGroup.list.includes(specificPrintMethod);
                    })
                    if (found) {
                        return found.name
                    }
                }));
            } else if (product.type === 'Sticker') {
                return ['Sticker']
            } else if (product.type === 'Patch') {
                return ['Patch']
            } else if (product.category === 'Sublimation') {
                return ['Sublimation']
            } else {
                // garment
                if (calculationService.onlyEmbroideryAllowed(product.foundCategory)) {
                    return ["Embroidery"]
                } else {
                    return ["Print", "Embroidery"]
                }
            }
        }
        function isProductDesignable(product) {
            return product.productStatus === 'LIVE'
                && product.type != 'Sticker'
                && product.category != 'Sublimation'
                && product.type != 'Patch'
        }

        var imagekit = new ImageKit({
            urlEndpoint: "https://image.coastalreign.com"
        });

        var FILE_UPLOAD_URLS = [
            'file-uploads-cr.s3.amazonaws.com',
            's3.amazonaws.com/file-uploads-cr',
            's3-us-west-2.amazonaws.com/product-image',
        ]

        var IMAGE_FILE_FORMATS = [
            'jpeg', 'jpg', 'png', 'webp', 'svg', 'avif'
        ]


        function compressImage(url, namedTransformation){
            var compressedUrl = url;
            if (url) {
                if (url.indexOf("cloudinary") >= 0){
                    // var indexOfUpload = url.indexOf("upload") + 7
                    // if (indexOfUpload >= 7){
                    //     var left = url.substring(0, indexOfUpload)
                    //     var right = url.substring(indexOfUpload, url.length)
                    //     var finalUrl = left + "f_auto,q_auto,w_1400/" + right
                    //     // console.log(finalUrl)
                    //     return finalUrl
                    // } else {
                    //     return url
                    // }
                } else {
                    var foundUrlHeader = _.find(FILE_UPLOAD_URLS, function(matchingUrl) {
                        return url.indexOf(matchingUrl) >= 0
                    });
                    if (foundUrlHeader) {
                        var dotPos = url.lastIndexOf(".");
                        var fileFormat = url.substring(dotPos + 1);
                        if (IMAGE_FILE_FORMATS.includes(fileFormat.toLowerCase())){
                            // get compressed img
                            var transformation = [];
                            if (namedTransformation) {
                                transformation = [{
                                    "n": namedTransformation
                                }]
                            }
                            compressedUrl = imagekit.url({
                                src: url.replace(foundUrlHeader, "image.coastalreign.com"),
                                transformation: transformation
                            })
                        }
                    }
                }
            }
            return compressedUrl;
        }

        var copyToClipboard = function(str){
            function listener(e) {
                e.clipboardData.setData("text/html", str);
                e.clipboardData.setData("text/plain", str);
                e.preventDefault();
            }

            var el = document.createElement('textarea');
            el.value = str;
            document.body.appendChild(el);
            el.select();
            document.addEventListener("copy", listener);
            document.execCommand('copy');
            document.removeEventListener("copy", listener);
            document.body.removeChild(el);
        }

        // URL methods
        function buildUrl(location){
            return replaceSpaceWithHyphensAndLower(location.city) + "-" + replaceSpaceWithHyphensAndLower(location.province)
        }

        function buildLocationUrl(location){
            return modelService.CUSTOM_URL_LINK_FRAGMENTS.T_SHIRT_PRINTING + buildUrl(location)
        }

        function buildLocationSPUrl(location){
            return modelService.CUSTOM_URL_LINK_FRAGMENTS.SCREEN_PRINTING + buildUrl(location)
        }

        function buildLocationEMBUrl(location){
            return modelService.CUSTOM_URL_LINK_FRAGMENTS.EMBROIDERY + buildUrl(location)
        }

        function buildCategoryUrl(category){
            return category.path;
        }


        function getGroupUrl(groupName){
            return "/products/" + replaceSpaceWithHyphensAndLower(groupName)
        }

        function buildProductUrl(product){
            return calculationService.buildProductUrl(product);
        }

        function buildProductDesignUrl(product){
            return "/designer/" + replaceSpaceWithHyphensAndLower(product.name)
        }

        function getProductDisplay(product) {
            var url;
            var colour;
            if (!product.useDisplayPhoto) {
                if (product.displayColour) {
                    colour = product.displayColour.name;
                    url = product.displayColour.front
                } else if (product.supplementaryImages && product.supplementaryImages[0] && product.supplementaryImages[0].isAnchored) {
                    url = product.supplementaryImages[0].imageUrl
                } else {
                    colour = product.colours[0].name;
                    url = product.colours[0].front;
                }
            } else {
                url = "../images/displayImages/Custom_Printed_" + replaceSpaceWithUnderscore(product.name) + ".png"
            }

            var altText = product.name;
            if (colour) {
                altText = product.name + ' in ' + colour
            }

            return {
                colour: colour,
                url: url,
                altText : altText
            }
        }

        function replaceSpaceWithUnderscore(word){
            return word.replace(/\s/g, "_")

        }

        function replaceSpaceWithHyphensAndLower(word){
            word = word.replace(/\s/g, "-")
            return word.toLowerCase()
        }

        // Current blob size limit is around 500MB for browsers
        // used to bypass CORS browser download
        function downloadResource(url, filename) {
            function forceDownload(blob, filename) {
                var a = document.createElement('a');
                a.download = filename;
                a.href = blob;
                // For Firefox https://stackoverflow.com/a/32226068
                document.body.appendChild(a);
                a.click();
                a.remove();
            }

            if (!filename) filename =
                decodeURIComponent(url.split('\\').pop().split('/').pop());
            fetch(url, {
                headers: new Headers({
                    'Origin': location.origin
                }),
                mode: 'cors'
            })
                .then(response => response.blob())
                .then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    forceDownload(blobUrl, filename);
                })
                .catch(e => console.error(e));
        }

        function toTitleCase(str) {
            if(!str){
                return
            }
            var str = str.toLowerCase();
            var strnew = "";
            var i = 0;
            for (i = 0; i < str.length; i++) {
                if (i == 0) {
                    strnew = strnew + str[i].toUpperCase();
                } else if (i != 0 && str[i - 1] == " ") {
                    strnew = strnew + str[i].toUpperCase();
                } else {
                    strnew = strnew + str[i];
                }
            }
            return strnew
        }


        return {
            getDateString: getDateString,
            getAddressTooltip: getAddressTooltip,
            compressImage: compressImage,
            isProductDesignable: isProductDesignable,
            replaceSpaceWithUnderscore: replaceSpaceWithUnderscore,
            replaceSpaceWithHyphensAndLower: replaceSpaceWithHyphensAndLower,
            buildUrl: buildUrl,
            buildLocationUrl: buildLocationUrl,
            buildLocationSPUrl: buildLocationSPUrl,
            buildLocationEMBUrl: buildLocationEMBUrl,
            buildCategoryUrl: buildCategoryUrl,
            getGroupUrl: getGroupUrl,
            getAvailablePrints: getAvailablePrints,
            buildProductUrl: buildProductUrl,
            buildProductDesignUrl: buildProductDesignUrl,
            getProductDisplay: getProductDisplay,
            downloadResource: downloadResource,
            copyToClipboard: copyToClipboard,
            toTitleCase: toTitleCase,
        }

    }
})();
(function() {
    'use strict';

    angular.module('app')
        .factory('AnalyticsService', AnalyticsService)

    AnalyticsService.$inject = [];

    // private helper functions //

    function transformItemLinesToGoogleAnalyticItems(itemLines, products) {
        var googleItems = _.map(itemLines, function(itemLine) {
            var foundProduct = _.find(products, function(product){
                return product.sku === itemLine.sku
            })
            return transformItemLineToGoogleAnalyticsItem({
                itemLine: itemLine,
                product: foundProduct
            });
        });
        return googleItems;
    }

    // function to transform cart lineitem/product combination to google analytics item object
    //todo: find a way to pipe in prints and other information to google analytics (via custom metrics/dimensions)
    function transformItemLineToGoogleAnalyticsItem(itemLineAndProduct) {
        return {
            item_id: itemLineAndProduct.itemLine.sku,
            item_name: itemLineAndProduct.itemLine.productName,
            price: itemLineAndProduct.itemLine.price,
            quantity: itemLineAndProduct.itemLine.totalQty,
            item_variant: itemLineAndProduct.itemLine.details.colourName,
            item_brand: itemLineAndProduct.product ? itemLineAndProduct.product.brand: null,
            item_category: itemLineAndProduct.product ? itemLineAndProduct.product.type: null,
            item_category2: itemLineAndProduct.product ? itemLineAndProduct.product.category: null
        }
    }


    // Google GA4 Analytics
    function AnalyticsService() {

        function trackSearchEvent(keyword) {
            gtag("event", "search", {
                search_term: keyword
            });

            if (fbq){
                fbq('track', 'Search', {
                    search_string: keyword // Replace with the user's search query
                });
            }
        }

        function trackViewItemEvent(product) {
            var dummyItem = {
                totalQty: 1,
                price: product.colours[0].price,
                sku: product.sku,
                productName: product.name,
                details: {
                    colourName: null
                },
            }
            var googleAnalyticsItem = transformItemLineToGoogleAnalyticsItem({
                itemLine: dummyItem,
                product: product
            });

            gtag("event", "view_item", {
                value: dummyItem.price,
                items: [googleAnalyticsItem]
            })
        }

        function trackAddItemsToCart(itemLines, products) {
            var items = transformItemLinesToGoogleAnalyticItems(itemLines, products);
            var value = _.reduce(itemLines, function(acc, itemLine) {
                return acc + (itemLine.price * itemLine.totalQty);
            }, 0)
                gtag("event", "add_to_cart", {
                    value: value,
                    items: items
                })

            if (fbq){
                fbq('track', 'AddToCart', {
                    value: value, // Replace with the price of the product added to the cart
                    currency: "CAD"
                });
            }

            if (window.VWO){
                // Do not change anything in the following two lines
                window.VWO = window.VWO || [];
                VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
                // Replace the property values with your actual values
                VWO.event("addToCart", {
                    "value": 100
                });
            }
        }

        function trackBeginCheckout(itemLines, products, cartTotal) {
            var items = transformItemLinesToGoogleAnalyticItems(itemLines, products);
                gtag("event", "begin_checkout", {
                    value: cartTotal,
                    items: items
                });
        }

        function trackBeginCheckoutTimeline(itemLines, products, cartTotal) {
            var items = transformItemLinesToGoogleAnalyticItems(itemLines, products);

                gtag("event", "begin_checkout_timeline", {
                    value: cartTotal,
                    items: items
                });
        }

        function trackBeginCheckoutFinalReview(itemLines, products, cartTotal) {
            var items = transformItemLinesToGoogleAnalyticItems(itemLines, products);
            gtag("event", "begin_checkout_final_review", {
                value: cartTotal,
                items: items
            });
        }

        function trackPurchase(order, products) {
            var items = transformItemLinesToGoogleAnalyticItems(order.listOfItems, products);

                gtag("event", "purchase", {
                    transaction_id: order.number,
                    value: order.subTotalPrice,
                    shipping: order.shippingCost,
                    tax: order.gst + order.pst,
                    items: items
                })

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.transaction
                (
                    order.number,
                    order.subTotalPrice, //Replace 25.65 with your order total - Required
                    0, //Replace 2.56 with your order tax - Required (Use 0 for no value)
                    0, //Replace 1.53 with your order shipping - Required (Use 0 for no value)
                    {
                        'Full Name': order.emailAddress,
                        'Email Address': order.emailAddress,
                        'Phone Number' : order.phoneNumber
                    }
                )
            }

            if (fbq){
                fbq('track', 'Purchase', {
                    value: order.subTotalPrice, // Replace with the total order value
                    currency: 'CAD',
                    order_id : order.number
                });
            }

        }

        function customTrackUploadDesign(url){

                gtag("event", "designer_image_upload", {
                    design_id: String(url)
                })

            if (window.VWO){
                VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
                // Replace the property values with your actual values
                VWO.event("uploadImage", {
                    "uploadImage": url
                });
            }

            if (fbq){
                fbq('trackCustom', 'ImageUpload', {});
            }
        }


        function customTrackSaveDesign(design) {
            gtag("event", "save_design", {
                design_number: String(design.number),
                design_link: design.link
            })

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Design', //Replace User with the event category - Required
                    'Save', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': design.email,
                        'Email Address': design.email
                    }
                )
            }
        }

        function customTrackApproveQuote(order, products) {
            var items = transformItemLinesToGoogleAnalyticItems(order.listOfItems, products)
            gtag("event", "approve_quote", {
                transaction_id: order.number,
                value: parseInt(order.subTotalPrice),
                order_number_quote_approved: String(order.number),
                order_subtotal_quote_approved: parseInt(order.subTotalPrice),
                items: items
            })
        }

        function customTrackPlaceOrder(order, products) {
            var items = transformItemLinesToGoogleAnalyticItems(order.listOfItems, products)
            gtag("event", "place_order", {
                transaction_id: order.number,
                value: parseInt(order.subTotalPrice),
                order_number: String(order.number),
                order_subtotal: parseInt(order.subTotalPrice),
                items: items
            })

            if (window.VWO){
                window.VWO = window.VWO || [];
                VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
                VWO.event("orderPlacedValue", {
                    "price": 100,
                    // "price": parseInt(order.subTotalPrice),
                    "number": order.number
                });
            }

            if(fbq){
                fbq('trackCustom', 'PlaceOrder', {
                    order_id: order.number, // Replace with the actual order ID
                    value: order.subTotalPrice, // Replace with the total order value
                    currency: 'CAD'
                });
            }

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Order', //Replace User with the event category - Required
                    'Created', //Replace Signup with the event action - Required
                    order.number, //Replace New with the event label - Optional
                    0, //Replace 5 with the event value - Optional
                    {
                        'Full Name': order.emailAddress,
                        'Email Address': order.emailAddress,
                        'Phone Number' : order.phoneNumber,
                        'Subtotal' : parseInt(order.subTotalPrice)
                    }
                )
            }
        }

        function customTrackMeetingBooked(bookee) {
            gtag("event", "meeting_booked", {
                meeting_bookee: bookee
            });
        }

        function customTrackPromotionalOffer(ticket_id,email,phone) {
            gtag("event", "promotional_offer", {
                offer_id: ticket_id
            });

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Form Submission', //Replace User with the event category - Required
                    'Promotional Offer', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email,
                        'Phone Number' : phone
                    }
                )
            }

            if(fbq){
                fbq('trackCustom', 'PromotionalOfferSubmission', {
                    form_id: ticket_id, // Optional: Unique identifier for the form
                    user_email: email // Optional: User's email (if captured)
                });
            }
        }


        function customTrackContactUs(ticket_id,email,phone) {
            gtag("event", "contact_us", {
                zendesk_ticket_id: ticket_id
            });

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Form Submission', //Replace User with the event category - Required
                    'Contact Us', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email,
                        'Phone Number' : phone
                    }
                )
            }

            if(fbq){
                fbq('trackCustom', 'ContactUsFormSubmission', {
                    form_id: ticket_id, // Optional: Unique identifier for the form
                    user_email: email // Optional: User's email (if captured)
                });
            }
        }

        function customTrackRequestQuote(quoteId,email,phone) {
            gtag("event", "request_quote", {
                quote_id: quoteId
            });

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Form Submission', //Replace User with the event category - Required
                    'Desktop Quote Request', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email,
                        'Phone Number' : phone
                    }
                )
            }

            if(fbq){
                fbq('trackCustom', 'RequestQuoteSubmission', {
                    form_id: quoteId, // Optional: Unique identifier for the form
                    user_email: email // Optional: User's email (if captured)
                });
            }
        }

        function customTrackMobileRequestQuote(quoteId,email,phone) {
            gtag("event", "mobile_request_quote", {
                mobile_quote_id: quoteId
            });

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Form Submission', //Replace User with the event category - Required
                    'Mobile Quote Request', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email,
                        'Phone Number' : phone
                    }
                )
            }

            if(fbq){
                fbq('trackCustom', 'MobileRequestQuoteSubmission', {
                    form_id: quoteId, // Optional: Unique identifier for the form
                    user_email: email // Optional: User's email (if captured)
                });
            }
        }

        function customTrackSignUp(email){
            gtag("event", "user_signup");
            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'User', //Replace User with the event category - Required
                    'Sign Up', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email
                    }
                )
            }

        }

        function customTrackDesignHelp(designHelpId,email,phone) {
            gtag("event", "design_help_request", {
                design_help_id: designHelpId
            });

            if ($wc_leads && $wc_leads.track){
                $wc_leads.track.event
                (
                    'Form Submission', //Replace User with the event category - Required
                    'Design Help', //Replace Signup with the event action - Required
                    false, //Replace New with the event label - Optional
                    false, //Replace 5 with the event value - Optional
                    {
                        'Full Name': email,
                        'Email Address': email,
                        'Phone Number' : phone
                    }
                )
            }

            if(fbq){
                fbq('trackCustom', 'DesignHelpSubmission', {
                    form_id: designHelpId, // Optional: Unique identifier for the form
                    user_email: email // Optional: User's email (if captured)
                });
            }
        }

        return {
            // google recommended events
            trackSearchEvent: trackSearchEvent,
            trackViewItemEvent: trackViewItemEvent,
            trackAddItemsToCart: trackAddItemsToCart,
            trackBeginCheckout: trackBeginCheckout,
            trackPurchase: trackPurchase,

            // custom events
            trackBeginCheckoutTimeline: trackBeginCheckoutTimeline,
            trackBeginCheckoutFinalReview: trackBeginCheckoutFinalReview,
            customTrackSaveDesign: customTrackSaveDesign,
            customTrackPlaceOrder: customTrackPlaceOrder,
            customTrackApproveQuote : customTrackApproveQuote,
            customTrackMeetingBooked: customTrackMeetingBooked,
            customTrackContactUs: customTrackContactUs,
            customTrackPromotionalOffer: customTrackPromotionalOffer,
            customTrackRequestQuote: customTrackRequestQuote,
            customTrackMobileRequestQuote: customTrackMobileRequestQuote,
            customTrackDesignHelp: customTrackDesignHelp,
            customTrackUploadDesign : customTrackUploadDesign,
            customTrackSignUp : customTrackSignUp
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .factory('CustomerService', CustomerService)

    CustomerService.$inject = ['$http', '$q', '$rootScope', 'AnalyticsService', 'CountryService', '$cacheFactory'];

    function CustomerService($http, $q, $rootScope, AnalyticsService, CountryService, $cacheFactory) {

        var searchResultsCache = $cacheFactory.get('globalSearchCache');
        if (!searchResultsCache) {
            searchResultsCache = $cacheFactory('globalSearchCache', {capacity: 3});
        }

        function getOrders() {
            return $http.get('/api/customers/orders')
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }
        function getDesigns() {
            return $http.get('/api/customers/designs')
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function getUploads() {
            return $http.get('/api/customers/uploads')
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }


        function updateEmail(updatedEmail) {
            return $http.patch('/api/customers/email', {username: updatedEmail})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updateCart(updatedCart) {
            return $http.patch('/api/customers/currentCart', {currentCart: updatedCart})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updatePassword(updatedPassword) {
            return $http.patch('/api/customers/password', {password: updatedPassword})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updateProfile(profileObject) {
            return $http.patch('/api/customers/profile', profileObject)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updateShipping(shippingAddress) {
            return $http.patch('/api/customers/shippingAddress', {shippingAddress: shippingAddress})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updateBilling(billingAddress) {
            return $http.patch('/api/customers/billingAddress', {billingAddress: billingAddress})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function updateBlindPackaging(isBlindPackaging) {
            return $http.patch('/api/customers/blindPackaging', {blindPackaging: isBlindPackaging})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        /**
         * Copy line items from specified order number
         * @param orderNumber
         * @param cartId - if provided, means that we copy to the specified cart. if null, create new cart.
         * @return copied line items (no qtys)
         */
        function copyOrder(orderNumber, cartId) {
            return $http.post('/api/customers/copyOrderItems/' + orderNumber, {cartId: cartId})
                .then(function (response) {
                    return response.data;
                })
                .catch(function (err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function getQuoteItems(orderNumber, quoteId) {
            return $http.get('/api/customers/getQuote', {
                params: {
                    orderNumber: orderNumber, quoteId: quoteId
                }
            })
                .then(function (response) {
                    return response.data;
                })
                .catch(function (err) {
                    return $q.reject(err.data);
                })
        }

        function getCart(cartId) {
            return $http.get('/api/customers/getCart/' + cartId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (err) {
                    showError(err.data.message);
                    return $q.resolve({
                        cart: {
                            _id: cartId,
                            listOfItems: []
                        },
                        invalidItems: [],
                        products: []
                    });
                })
        }

        function searchKeyword(searchKeyword, isPreview) {
            // GA4 SEARCH https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#search
            AnalyticsService.trackSearchEvent(searchKeyword);
            return $http.get('/api/customers/globalSearchKeyword',
                {
                    params: {
                        searchText: searchKeyword,
                        isPreview: isPreview,
                        locale: CountryService.getCurrentLocale()
                    },
                    cache: searchResultsCache
                })
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    if (err.data.message) {
                        showError(err.data.message);
                    } else {
                        showError();
                    }
                    return $q.reject(err);
                })
        }

        return {
            updateEmail: updateEmail,
            updatePassword: updatePassword,
            updateCart : updateCart,
            updateProfile: updateProfile,
            updateShipping: updateShipping,
            updateBilling: updateBilling,
            updateBlindPackaging: updateBlindPackaging,
            copyOrder: copyOrder,
            getCart: getCart,
            getQuoteItems: getQuoteItems,
            searchKeyword: searchKeyword,
            getOrders: getOrders,
            getDesigns: getDesigns,
            getUploads: getUploads
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .factory('PageTemplateService', PageTemplateService)

    PageTemplateService.$inject = ['$http', '$q', 'CountryService', '$cacheFactory'];

    function PageTemplateService($http, $q, CountryService, $cacheFactory) {

        var pageTemplateCache = $cacheFactory.get('pageTemplate');
        var breadcrumbCache = $cacheFactory.get('breadcrumbCache');
        var productCategoryUmbrellaCache = $cacheFactory.get('productCategoryUmbrellaCache');
        if (!pageTemplateCache) {
            pageTemplateCache = $cacheFactory('pageTemplate', {capacity: 3});
            breadcrumbCache = $cacheFactory('breadcrumb', {capacity: 3});
            productCategoryUmbrellaCache = $cacheFactory('productCategoryUmbrellaCache', {capacity: 3});
        }

        function findPageTemplateByUrl(url, locale, viewToken) {
            return $http.get('/api/pageTemplates/find',
                {params: {url: url, locale: locale, viewToken: viewToken}, cache: false})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function getAllLivePageTemplates(locale) {
            return $http.get('/api/pageTemplates/', {params: {locale: locale}})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }


        function getBreadcrumb(url) {
            return $http.get('/api/pageTemplates/breadcrumb',
                {params: {url: url, locale: CountryService.getCurrentLocale()}, cache: false})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }


        // todo duplicate in admin
        function cleanPageName(targetKeyword, replaceLocation) {
            //1. remove instances of word custom
            targetKeyword = targetKeyword.replace(' Custom ', ' ');
            targetKeyword = targetKeyword.replace('Custom ', '');

            //2. replace location
            if (replaceLocation) {
                targetKeyword = targetKeyword.replace(/in Canada$/i, "");
                targetKeyword = targetKeyword.replace(/Canada$/i, "");
                targetKeyword = targetKeyword.replace(/in Vancouver$/i, "");
                targetKeyword = targetKeyword.replace(/Vancouver$/i, "");
            }

            return targetKeyword;
        }

        function getProductCategoryUmbrella(pageId) {
            return $http.get('/api/pageTemplates/productCategoryUmbrella',
                {params: {parentPage: pageId, locale: CountryService.getCurrentLocale()}})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return [];
                })
        }


        return {
            findPageTemplateByUrl: findPageTemplateByUrl,
            getBreadcrumb: getBreadcrumb,
            getAllLivePageTemplates: getAllLivePageTemplates,
            cleanPageName: cleanPageName,
            getProductCategoryUmbrella: getProductCategoryUmbrella
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .factory('CountryService', CountryService)

    CountryService.$inject = ['$http', '$rootScope', '$q', '$location', '$timeout'];

    function CountryService($http, $rootScope, $q, $location, $timeout) {

        var availableLocalesURLs = ["", 'en-us'];
        var currentLocale;

        function validatePageLocale(forceLocaleCheck, disableRecommendModal, overridesTo) {
            return recommendLocalePopupPromise(forceLocaleCheck, overridesTo)
                .then(function (proposedLocale) {
                    if (proposedLocale !== getCurrentLocale()) {
                        $rootScope.recommendLocale = proposedLocale
                        if (disableRecommendModal) {
                            // ignore
                        } else {
                            $rootScope.showRecommendLocaleModal = true;
                        }
                    }
                })
                .catch(function (e) {
                    //ignore
                })
        }

        function getUserVisitingInfoPromise(forceFetch) {
            var promise;
            var userGeoObject = $rootScope.getLocalStorage("iplocale");
            var refetch = false
            if (forceFetch) {
                refetch = true
            } else if (!userGeoObject) {
                refetch = true
            } else if (userGeoObject.expiry) {
                if (Date.now() >= userGeoObject.expiry) {
                    refetch = true
                }
            }
            if (!userGeoObject || refetch) {
                promise = $http.post('/country')
                    .then(function (response) {
                        var geoResponse = response.data;
                        var proposedLocale = "" // default ca
                        if (geoResponse.country === 'CA') {
                            proposedLocale = ''
                        } else {
                            proposedLocale = "en-us"
                        }
                        var toSaveGeoObject = {
                            locale: proposedLocale,
                            expiry: Date.now() + (60000 * 60 * 24 * 7),
                            country: geoResponse.country,
                            region: geoResponse.region,
                            city: geoResponse.city,
                        }

                        $rootScope.setLocalStorage("iplocale", JSON.stringify(toSaveGeoObject));
                        return toSaveGeoObject
                    })
                    .catch(function (e) {
                        return $q.reject()
                    })
            } else {
                // console.log(userGeoObject);
                promise = $q.resolve(userGeoObject)
            }
            return promise
        }

        // remove locale
        function getCurrentBasePath() {
            var urlPath = $location.path().split('/');
            urlPath.shift();
            if (isValidLocale(urlPath[0])) {
                urlPath.shift();
            }
            urlPath = urlPath.join('/');
            return '/' + urlPath;
        }

        // 1. determine country from url
        // 2. if popup not closed before, geolocate (async) ip and determine best viewing website
        function recommendLocalePopupPromise(forceLocaleCheck, overridesLocale) {
            var promise;
            
            // Skip for bot/crawler user agents
            if (isBotUserAgent()) {
                return $q.resolve(currentLocale);
            }
            
            if (!_.isUndefined(overridesLocale)) {
                promise = $q.resolve(overridesLocale);
            } else {
                var confirmExpiry = $rootScope.getLocalStorage('userConfirmedLocation');
                if (!forceLocaleCheck && confirmExpiry && Date.now() <= Number(confirmExpiry)) {
                    promise = $q.resolve(currentLocale);
                } else {
                    promise = getUserVisitingInfoPromise(forceLocaleCheck)
                        .then(function (userGeoObject) {
                            return userGeoObject.locale
                        })
                }
            }

            return promise;
        }
        
        // Helper function to detect bots by user agent
        function isBotUserAgent() {
            var userAgent = navigator.userAgent || '';
            userAgent = userAgent.toLowerCase();
            
            // Common bot patterns
            var botPatterns = [
                'bot', 'spider', 'crawler', 'scraper', 'preview', 
                'prerender', 'headless', 'phantom', 'selenium', 'puppeteer', 
                'lighthouse', 'slurp', 'facebookexternalhit', 'whatsapp',
                'googlebot', 'bingbot', 'yahoo', 'baiduspider', 'yandex',
                'duckduckbot', 'facebot', 'twitterbot', 'pinterest',
                'applebot', 'snapchat', 'discordbot'
            ];
            
            // Check for common bot patterns
            for (var i = 0; i < botPatterns.length; i++) {
                if (userAgent.indexOf(botPatterns[i]) !== -1) {
                    return true;
                }
            }
            
            // Check for typical headless browser tells
            if (navigator.webdriver || 
                navigator.hasOwnProperty('webdriver') || 
                window.callPhantom || 
                window._phantom || 
                window.__nightmare || 
                window.navigator.languages === undefined || 
                window.navigator.languages.length === 0) {
                return true;
            }
            
            return false;
        }

        function isValidLocale(givenLocale) {
            return availableLocalesURLs.includes(givenLocale);
        }

        // meant to run ONCE on initial page load only, if need to set again the page refreshes via shouldReloadApp
        function setLocale(givenLocale, shouldReloadApp) {
            if (!isValidLocale(givenLocale)) {
                throw Error('Invalid Locale ' + givenLocale);
            } else {
                if (currentLocale !== givenLocale) {
                    currentLocale = givenLocale;
                    if (shouldReloadApp) {
                        reloadUrl(true);
                    } else {
                        $timeout(function(){
                            $rootScope.$broadcast('localeReady');
                        }, 100)
                    }
                }
            }
        }

        function reloadUrl(shouldHardReload) {
            var newUrl;
            if (currentLocale) {
                var currentPath = $location.url();
                if (currentPath === '/') {
                    currentPath = ''
                }
                newUrl = '/' + currentLocale + currentPath;
            } else {
                // replace first subfolder directory which would be the locale
                newUrl = $location.url().replace(/\/[^\/]+/, '');
            }
            if (shouldHardReload) {
                window.location.href = newUrl; // app reload
            } else {
                // update location (for internal navigation cart -> checkout)
                $location.url(newUrl);
            }
        }

        function getCurrentLocale() {
            return currentLocale;
        }

        // given absolute url returns a path with correct locale context
        function getRelativeLocaleUrl(url) {
            var baseUrl = $location.protocol() + '://' + location.host;
            // absolute url
            var fallbackUrl = 'https://coastalreign.com'

            var returnUrl = url;
            if (!_.isUndefined(currentLocale)) {
                var matchingPath;
                if (url.indexOf(baseUrl) === 0) {
                    matchingPath = url.substring(baseUrl.length);
                } else if (url.indexOf(fallbackUrl) === 0) {
                    matchingPath = url.substring(fallbackUrl.length);
                }
                if (matchingPath) {
                    returnUrl = matchingPath;
                    var pathLocale = ""; // default ca
                    var firstSubdirectory = matchingPath.split("/")[1]
                    if (isValidLocale(firstSubdirectory)) {
                        pathLocale = firstSubdirectory;
                    }
                    if (pathLocale !== currentLocale) {
                        if (matchingPath === '/') {
                            matchingPath = ''
                        }
                        returnUrl = '/' + currentLocale + matchingPath
                    }
                }
            }


            return returnUrl;
        }

        function textFindAndReplace(stringToCheck) {
            var returnString = stringToCheck;
            if (currentLocale === 'en-us') {
                returnString = returnString
                    .replace(new RegExp(/colour/, "g"), 'color')
                    .replace(new RegExp(/Colour/, "g"), 'Color')
                    .replace(new RegExp(/colours/, "g"), 'colors')
                    .replace(new RegExp(/Colours/, "g"), 'Colors')
                    .replace(new RegExp(/\bgrey\b/, "g"), 'gray')
                    .replace(new RegExp(/\bGrey\b/, "g"), 'Gray')
                    .replace(new RegExp(/\blabour\b/, "g"), 'labor')
                    .replace(new RegExp(/\bLabour\b/, "g"), 'Labor')
                    .replace(new RegExp(/\bOdour\b/, "g"), 'Odor')
                    .replace(new RegExp(/\bodour\b/, "g"), 'Odor')
            }
            return returnString;
        }

        return {
            getUserVisitingInfoPromise: getUserVisitingInfoPromise,
            validatePageLocale: validatePageLocale,
            setLocale: setLocale,
            getRelativeLocaleUrl: getRelativeLocaleUrl,
            isValidLocale: isValidLocale,
            getCurrentLocale: getCurrentLocale,
            reloadUrl: reloadUrl,
            textFindAndReplace: textFindAndReplace,
            getCurrentBasePath: getCurrentBasePath
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .factory('BrandService', BrandService)

    BrandService.$inject = ['$http', '$q'];

    function BrandService($http, $q) {

        var brandsPromise = null

        function getAllBrands() {
            if (!brandsPromise) {
                brandsPromise = $http.get('/api/brands')
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (err) {
                        showError(err.data.message);
                        return $q.reject(err);
                    })
            }
            return brandsPromise;
        }

        return {
            getAllBrands: getAllBrands
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .factory('ProductService', ProductService)

    ProductService.$inject = ['$http', '$q', '$cacheFactory'];

    function ProductService($http, $q, $cacheFactory) {
        // sizes
        var productQueryCache = $cacheFactory.get('productsQuery');
        var fuzzySearchCache = $cacheFactory.get('fuzzyProductsQuery');
        if (!productQueryCache) {
            productQueryCache = $cacheFactory('productsQuery', {capacity: 1});
            fuzzySearchCache = $cacheFactory('fuzzyProductsQuery', {capacity: 1});
        }

        function getProductByUrl(url, category) {
            var route = '/api/products/name/' + url;
            if (category) {
                route += '/' + category
            }
            return $http.get(route)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function getProductBySku(sku) {
            var route = '/api/products/' + sku;
            return $http.get(route)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }


        function fetchProducts(query, shouldCache) {
            if (query) {
                var queryString = Qs.stringify(query, {encode: true});
                return $http.get('/api/products/filter?' + queryString)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (err) {
                        return $q.reject(err);
                    })
            }
        }

        function fuzzySearchProducts(queryString) {
            return $http.get('/api/products/search/fuzzy/' + queryString, {cache: false})
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function getComplimentaryStyles(sku){
            return $http.get('/api/products/complimentaryStyles/' + sku)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function getRelatedProducts(sku) {
            return $http.get('/api/products/relatedProducts/' + sku)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        return {
            getProductByUrl: getProductByUrl,
            getProductBySku: getProductBySku,
            fetchProducts: fetchProducts,
            fuzzySearchProducts: fuzzySearchProducts,
            getRelatedProducts: getRelatedProducts,
            getComplimentaryStyles: getComplimentaryStyles
        };
    }

})();

(function () {
    'use strict';

    angular.module('sharedModule')
        .factory('SEOService', SEOService)

    SEOService.$inject = ['$rootScope', '$http', '$location', '$q', 'CommonUtilService', 'PageTemplateService', 'CountryService', '$window'];

    function SEOService($rootScope, $http, $location, $q, CommonUtilService, PageTemplateService, CountryService, $window) {

        // todo: remove from index and use these methods instead
        function setMetaTitle(title) {
            $window.document.title = title;
        }

        function setMetaDescription (description) {
            var meta = $window.document.getElementsByTagName("meta");
            for (var i = 0; i < meta.length; i++) {
                if (meta[i].name.toLowerCase() == "description") {
                    meta[i].content = description;
                }
            }
        };

        function setMetaImage(image) {
            var meta = $window.document.getElementsByTagName("meta");
            for (var i = 0; i < meta.length; i++) {
                if (meta[i].name.toLowerCase() == "og:image") {
                    meta[i].content = image;
                }
            }
        }

        function updateMetaTags(metaInfo) {
            var defaults = {
                title: 'Coastal Reign | Custom Printed Clothing and Swag',
                description: 'A Vancouver based provider of custom products and swag. We are proud to offer free shipping, responsive live chat, and expert design help.',
                image: 'https://coastalreign.com/images/sharedImage.png'
            };

            metaInfo = angular.extend({}, defaults, metaInfo);

            angular.element('meta[name=description]').attr('content', metaInfo.description);
            angular.element('meta[property="og:description"]').attr('content', metaInfo.description);
            angular.element('meta[property="og:image"]').attr('content', metaInfo.image);
            angular.element('meta[property="og:title"]').attr('content', metaInfo.title);
            $window.document.title = metaInfo.title;
        }

        // SEO
        function localeBusinessSchema(city) {
            var schema = {
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Coastal Reign Printing",
                "image": [
                    "https://image.coastalreign.com/In+House+Screen+printing_1731112196082.jpg",
                    "https://image.coastalreign.com/About+Us+Banner+Photo_1691789095253.jpg",
                    "https://image.coastalreign.com/In+House+Production_1721839307987.jpg",
                    "https://image.coastalreign.com/staff%20image%20%202_1654016360648.jpg"
                ],
                "url": "https://coastalreign.com/",
                "description": "Coastal Reign is a custom clothing company based in Canada. Our team exists to provide high-quality screen printing, embroidery, direct-to-film printing, and sublimation on a large variety of custom clothing that allows brands, schools, and sports teams to stand out."
            };
            if (city === 'Vancouver') {
                schema.address = {
                    "@type": "PostalAddress",
                    "streetAddress": "8793 Cambie St",
                    "addressLocality": "Vancouver",
                    "addressRegion": "BC",
                    "postalCode": "V6P 3J9",
                    "addressCountry": "CA"
                };
                schema.openingHoursSpecification = [
                    {
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday"
                      ],
                      "opens": "09:00",
                      "closes": "17:00"
                    }
                  ];
                schema.geo = {
                    "@type": "GeoCoordinates",
                    "latitude": 49.20629067207281,
                    "longitude": -123.11759198650792
                };
                schema.hasMap = "https://www.google.com/maps/place/Coastal+Reign+Printing/@49.206168,-123.1201347,17z/data=!3m2!4b1!5s0x548674f0ea4fe15d:0x8cf3a5ded9a88fe4!4m6!3m5!1s0x5486769f38599947:0xfab5117abf828aea!8m2!3d49.2061645!4d-123.1175598!16s%2Fg%2F11b7cbswwg?entry=ttu";
                schema.telephone = "+1-604-900-5924";
            } else if (city === 'Toronto') {
                schema.address = {
                    "@type": "PostalAddress",
                    "streetAddress": "310 Judson St Unit 3",
                    "addressLocality": "Toronto",
                    "addressRegion": "ON",
                    "postalCode": "M8Z 5T6",
                    "addressCountry": "CA"
                };
                schema.openingHoursSpecification = [
                    {
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday"
                      ],
                      "opens": "09:00",
                      "closes": "17:00"
                    }
                  ]
                schema.geo = {
                    "@type": "GeoCoordinates",
                    "latitude": 43.6130283,
                    "longitude": -79.5144381
                };
                schema.hasMap = "https://www.google.com/maps/place/Coastal+Reign+Printing/@43.6130283,-79.5144381,15z/data=!4m6!3m5!1s0x882b49d23cccd757:0xebbcec353dd53df7!8m2!3d43.6130283!4d-79.5144381!16s%2Fg%2F11rq17cn5k?entry=ttu";
                schema.telephone = "+1-647-494-6266";
            } else if (city === 'Calgary') {
                schema.address = {
                    "@type": "PostalAddress",
                    "addressLocality": "Calgary",
                    "addressRegion": "AB",
                    "postalCode": "T2P 0P7",
                    "streetAddress": "903 8 Ave SW 9th Floor, Suite 900",
                    "addressCountry": "CA"

                };
                schema.geo = {
                    "@type": "GeoCoordinates",
                    "latitude": 51.0459601,
                    "longitude": -114.0817835
                };
                schema.hasMap = "https://www.google.com/maps/place/Coastal+Reign+Printing/@51.0459601,-114.0817835,15z/data=!4m2!3m1!1s0x0:0xf73991494c057f87?sa=X&ved=1t:2428&ictx=111";
                schema.telephone = "+1-888-210-3971";
            } else if (city === 'New York') {
                schema.address = {
                    "@type": "PostalAddress",
                    "addressLocality": "New York",
                    "addressRegion": "NY",
                    "postalCode": "10016",
                    "streetAddress": "136 Madison Avenue, #555-03",
                    "addressCountry": "US"

                };
                schema.geo = {
                    "@type": "GeoCoordinates",
                    "latitude": 40.7467174,
                    "longitude": -73.9928654
                };
                schema.hasMap = "https://www.google.com/maps/place/Coastal+Reign+Printing/@40.7467174,-73.9928654,15z/data=!3m1!5s0x89c25487d78692b3:0x60405634ab56b3a5!4m6!3m5!1s0x89c2593957bcef7f:0xd89dedda4cab9127!8m2!3d40.7462357!4d-73.9844308!16s%2Fg%2F11x2q7dcx7?entry=ttu&g_ep=EgoyMDI1MDIxOS4xIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"
                schema.telephone = "+1-917-259-0231";
            }

            return schema;
        }

        function generateMainPageSchema() {
            return {
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Organization",
                        "additionalType": "Corporation",
                        "@id": "https://coastalreign.com/",
                        "description": "Looking for custom clothing and t-shirt printing in Canada? Coastal Reign offers a variety of custom clothing services with free shipping and expert design help.",
                        "name": "Coastal Reign",
                        "email": "sales@coastalreign.com",
                        "department": [
                            localeBusinessSchema('Vancouver'),
                            localeBusinessSchema('Calgary'),
                            localeBusinessSchema('Toronto'),
                            localeBusinessSchema('New York'),
                        ],
                        "sameAs": [
                            "https://www.facebook.com/coastalreignprint",
                            "https://twitter.com/coastalreign",
                            "https://www.linkedin.com/company/coastal-reign-printing-ltd",
                            "https://www.instagram.com/coastalreign/"
                        ],
                        "url": "https://coastalreign.com/",
                        "image": "https://image.coastalreign.com/coastal-reign-logo.png",
                        "telephone": "1-888-210-3971",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": [
                                "+1-888-210-3971"
                            ],
                            "availableLanguage": [
                                "English"
                            ],
                            "contactType": "customer service",
                            "areaServed": {
                                "@type": "AdministrativeArea",
                                "address": {
                                    "@type": "PostalAddress",
                                    "addressCountry": [
                                        "CA", "US"
                                    ]
                                }
                            }
                        }
                    }
                ]
            }
        }

        function generateFaqTemplateSchema(faqSectionProps) {
            var faqSchema = {};
            if (faqSectionProps) {
                const questions = faqSectionProps.questions.dataProps.dataTypeList;
                const answers = faqSectionProps.answers.dataProps.dataTypeList;

                faqSchema = {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": questions.map((question, index) => ({
                        "@type": "Question",
                        "name": question.dataProps.textValue,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": answers[index].dataProps.richTextValue
                        }
                    }))
                };
            }
            return faqSchema;
        }

        function generateProductCollectionSchema(productListTitle, products) {
            var collectionPageSchema = {
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                "name": productListTitle,
                "mainEntity": {
                    "@type": "ItemList",
                    "name": productListTitle,
                    "itemListElement": []
                }
            }

            var allProductSchemas = _.map(products, function(product) {
                return generateProductPLPSchema(product);
            })

            collectionPageSchema.mainEntity.itemListElement = allProductSchemas;

            return collectionPageSchema
        }


        function generateCodedPageSchema(pageMetadata) {
            // 1. Create and add base webpage schema
            const webPageSchema = {
                "@context": "https://schema.org",
                "@type": "WebPage",
                "url": "https://coastalreign.com" + pageMetadata.pageUrl,
                "name": pageMetadata.metaTitle,
                "description": pageMetadata.metaDescription,
                "publisher": {
                    "@type": "Organization",
                    "name": "Coastal Reign",
                    "url": "https://coastalreign.com",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://coastalreign.com/logo.png"
                    }
                },
                "about": [
                    {
                        "@type": "Thing",
                        "name": "Custom Printed Clothing",
                        "sameAs": "https://www.wikidata.org/wiki/Q11460"
                    },
                    {
                        "@type": "Thing",
                        "name": "Promotional Products",
                        "sameAs": "https://en.wikipedia.org/wiki/Promotional_product"
                    },
                    {
                        "@type": "Thing",
                        "name": "Expert Design Help",
                        "sameAs": "https://en.wikipedia.org/wiki/Graphic_design"
                    },
                    {
                        "@type": "Thing",
                        "name": "Custom Apparel",
                        "sameAs": "https://en.wikipedia.org/wiki/Clothing"
                    },
                    {
                        "@type": "Thing",
                        "name": "T-Shirt Printing",
                        "sameAs": "https://en.wikipedia.org/wiki/T-shirt"
                    },
                    {
                        "@type": "Thing",
                        "name": "Screen Printing",
                        "sameAs": "https://en.wikipedia.org/wiki/Screen_printing"
                    },
                    {
                        "@type": "Thing",
                        "name": "Embroidery",
                        "sameAs": "https://en.wikipedia.org/wiki/Embroidery"
                    },
                    {
                        "@type": "Thing",
                        "name": "E-commerce",
                        "sameAs": "https://en.wikipedia.org/wiki/E-commerce"
                    },
                    {
                        "@type": "Thing",
                        "name": "Branding",
                        "sameAs": "https://en.wikipedia.org/wiki/Branding"
                    },
                    {
                        "@type": "Thing",
                        "name": "Customization",
                        "sameAs": "https://en.wikipedia.org/wiki/Customization"
                    }],
                "mainEntity": [],
                offers: {
                    '@type': 'Offer',
                    'shippingDetails': [
                        {
                            '@type': 'OfferShippingDetails',
                            'shippingRate': {
                                '@type': 'MonetaryAmount',
                                'value': '0.00',
                                'currency': 'USD'
                            },
                            'shippingDestination': {
                                '@type': 'DefinedRegion',
                                'addressCountry': 'US'
                            }
                        },
                        {
                            '@type': 'OfferShippingDetails',
                            'shippingRate': {
                                '@type': 'MonetaryAmount',
                                'value': '0.00',
                                'currency': 'CAD'
                            },
                            'shippingDestination': {
                                '@type': 'DefinedRegion',
                                'addressCountry': 'CA'
                            }
                        }
                    ]
                }
            };
            if (pageMetadata.primaryImage) {
                webPageSchema.primaryImageOfPage = {
                    "@type": "ImageObject",
                    "name": pageMetadata.metaTitle,
                    "url": pageMetadata.primaryImage,
                    "embedUrl": pageMetadata.primaryImage
                };
            }
            return webPageSchema;
        }

        function generatePageTemplateSchema(pageTemplate) {
            // 1. Create and add base webpage schema
            const webPageSchema = {
                "@context": "https://schema.org",
                "@type": "WebPage",
                "url": "https://coastalreign.com/" + pageTemplate.pageUrl,
                "name": pageTemplate.metaInformation.metaTitle,
                "description": pageTemplate.metaInformation.metaDescription,
                "publisher": {
                    "@type": "Organization",
                    "name": "Coastal Reign",
                    "url": "https://coastalreign.com",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://coastalreign.com/logo.png"
                    }
                },
                "about": [
                    {
                        "@type": "Thing",
                        "name": "Custom Printed Clothing",
                        "sameAs": "https://www.wikidata.org/wiki/Q11460"
                    },
                    {
                        "@type": "Thing",
                        "name": "Promotional Products",
                        "sameAs": "https://en.wikipedia.org/wiki/Promotional_product"
                    },
                    {
                        "@type": "Thing",
                        "name": "Expert Design Help",
                        "sameAs": "https://en.wikipedia.org/wiki/Graphic_design"
                    },
                    {
                        "@type": "Thing",
                        "name": "Custom Apparel",
                        "sameAs": "https://en.wikipedia.org/wiki/Clothing"
                    },
                    {
                        "@type": "Thing",
                        "name": "T-Shirt Printing",
                        "sameAs": "https://en.wikipedia.org/wiki/T-shirt"
                    },
                    {
                        "@type": "Thing",
                        "name": "Screen Printing",
                        "sameAs": "https://en.wikipedia.org/wiki/Screen_printing"
                    },
                    {
                        "@type": "Thing",
                        "name": "Embroidery",
                        "sameAs": "https://en.wikipedia.org/wiki/Embroidery"
                    },
                    {
                        "@type": "Thing",
                        "name": "E-commerce",
                        "sameAs": "https://en.wikipedia.org/wiki/E-commerce"
                    },
                    {
                        "@type": "Thing",
                        "name": "Branding",
                        "sameAs": "https://en.wikipedia.org/wiki/Branding"
                    },
                    {
                        "@type": "Thing",
                        "name": "Customization",
                        "sameAs": "https://en.wikipedia.org/wiki/Customization"
                    }],
                "mainEntity": []
            };

            // Add preview image if exists
            const previewImage = $rootScope.compressImage(pageTemplate.previewImageUrl);
            if (previewImage) {
                webPageSchema.primaryImageOfPage = {
                    "@type": "ImageObject",
                    "name": pageTemplate.previewImageAltText,
                    "url": previewImage,
                    "embedUrl": previewImage
                };
            }

            // Add free shipping default offer
            webPageSchema.offers = {
                '@type': 'Offer',
                'shippingDetails': [
                    {
                        '@type': 'OfferShippingDetails',
                        'shippingRate': {
                            '@type': 'MonetaryAmount',
                            'value': '0.00',
                            'currency': 'USD'
                        },
                        'shippingDestination': {
                            '@type': 'DefinedRegion',
                            'addressCountry': 'US'
                        }
                    },
                    {
                        '@type': 'OfferShippingDetails',
                        'shippingRate': {
                            '@type': 'MonetaryAmount',
                            'value': '0.00',
                            'currency': 'CAD'
                        },
                        'shippingDestination': {
                            '@type': 'DefinedRegion',
                            'addressCountry': 'CA'
                        }
                    }
                ]
            };

            return webPageSchema;
        }

        function generateBreadcrumb(breadcrumbArray) {
            var breadcrumbStructuredListElement = _.map(breadcrumbArray, function (breadcrumbObject, index) {
                var pageUrl = (breadcrumbObject.pageUrl === '/')? '' : '/' + breadcrumbObject.pageUrl;
                return {
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": PageTemplateService.cleanPageName(breadcrumbObject.targetKeyword),
                    "item": {
                        "name": PageTemplateService.cleanPageName(breadcrumbObject.targetKeyword),
                        "id": 'https://coastalreign.com' + pageUrl
                    }
                }
            });

            var breadcrumbData = {
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                "itemListElement": breadcrumbStructuredListElement
            }

            return breadcrumbData;
        }

        function generateProductPLPSchema(productFromPLP) {
            var priceCurrency = 'CAD';
            var priceRegion = 'CA'
            var productPrice = productFromPLP.averagePrice;

            if ($rootScope.fromUS()) {
                priceCurrency = 'USD';
                priceRegion = 'US'
                productPrice = calculationService.ca2us(productPrice, priceCurrency);
            }
            // todo: update description to be product specific
            var productSchema =  {
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": productFromPLP.name,
                "sku": productFromPLP.sku,
                "image": CommonUtilService.compressImage(productFromPLP.colours[0].front, 'image-sm'),
                "description": "Have your custom design printed on a " + productFromPLP.name + ". We offer free shipping and expert design help.",
                "brand": {
                    "@type": "Brand",
                    "name": productFromPLP.brand
                },
                "offers": {
                    "@type": "Offer",
                    "url": $location.protocol() + '://coastalreign.com' + productFromPLP.productUrl,
                    "priceCurrency": priceCurrency,
                    "price": productPrice.toFixed(2),
                },
            };

            var shippingDetails = [{
                "@type": "OfferShippingDetails",
                "name": "Standard Lead Time",
                "description": 'Free Standard Shipping',
                'shippingRate': {
                    '@type': 'MonetaryAmount',
                    'value': '0.00',
                    'currency': priceCurrency
                },
                'shippingDestination': {
                    '@type': 'DefinedRegion',
                    'addressCountry': priceRegion
                },
                "deliveryTime": {
                    "@type": "ShippingDeliveryTime",
                    "handlingTime": {
                        "@type": "QuantitativeValue",
                        "minValue": productFromPLP.standardLeadTime,
                        "maxValue": productFromPLP.standardLeadTime + calculationService.NON_GUARANTEED_EXTRA_DAYS,
                        "unitCode": "d"
                    },
                    "transitTime": {
                        "@type": "QuantitativeValue",
                        "minValue": 1,
                        "maxValue": 5,
                        "unitCode": "d"
                    }
                },
            }]

            if (productFromPLP.rushAvailable) {
                shippingDetails.push({
                    "@type": "OfferShippingDetails",
                    "name": "Rush Lead Time",
                    "description": 'Shipping rates vary by service selected',
                    "shippingRate": {
                        "@type": "MonetaryAmount",
                        "value": null,
                        "currency": priceCurrency
                    },
                    'shippingDestination': {
                        '@type': 'DefinedRegion',
                        'addressCountry': priceRegion
                    },
                    "deliveryTime": {
                        "@type": "ShippingDeliveryTime",
                        "handlingTime": {
                            "@type": "QuantitativeValue",
                            "minValue": productFromPLP.fastestLeadTime,
                            "maxValue": productFromPLP.slowestRushLeadTime,
                            "unitCode": "d"
                        },
                        "transitTime": {
                            "@type": "QuantitativeValue",
                            "minValue": 1,
                            "maxValue": 5,
                            "unitCode": "d"
                        }
                    }
                })
            }

            productSchema['offers'].shippingDetails = shippingDetails;

            return productSchema;
        }

        function generateProductGroupSchema(product, breadcrumbArray) {
            var category = _.find(categoryService.allCategories, function (cat) {
                return product.category == cat.name
            })
            var breadcrumbSchemaObject = generateBreadcrumb(breadcrumbArray);
            var priceCurrency = 'CAD'
            var offerCount = 1000;
            var lowCount = 25;
            try {
                 lowCount = calculationService.getStartingQuantityForProduct(product);
            } catch(e) {

            }
            var lowCountPrice = calculationService.calculateAveragePrice(product, lowCount, category).price
            var highCountPrice = calculationService.calculateAveragePrice(product, offerCount, category).price

            var localeUrl = ''
            if ($rootScope.fromUS()) {
                priceCurrency = 'USD';
                lowCountPrice = calculationService.ca2us(lowCountPrice, priceCurrency);
                highCountPrice = calculationService.ca2us(highCountPrice, priceCurrency);
                 localeUrl = '/en-us'
            }

            var brandName;
            if (product.brand === 'No Brand' || !product.brand) {
                brandName = 'Coastal Reign'
            } else {
                brandName = product.brand
            }
            var productGroup = {
                '@context': "https://schema.org/",
                "@type": "ProductGroup",
                'productGroupID': product.sku,
                "name": product.name,
                "sku": product.sku,
                "brand": {
                    "@type": "Brand",
                    "name": brandName
                },
                "offers": {
                    "@type": "AggregateOffer",
                    'url': $location.protocol() + '://coastalreign.com' + localeUrl + CommonUtilService.buildProductUrl(product),
                    "priceCurrency": priceCurrency,
                    "highPrice": lowCountPrice.toFixed(2),
                    "lowPrice": highCountPrice.toFixed(2),
                    "offerCount": offerCount,
                    "price": lowCountPrice.toFixed(2),
                    'availability': "https://schema.org/InStock"
                },
                "description": "Have your custom design printed on a " + product.name + ". We offer free shipping and expert design help.",
                'url': $location.protocol() + '://coastalreign.com' + localeUrl + CommonUtilService.buildProductUrl(product),
                'variesBy': [
                    "https://schema.org/size",
                    "https://schema.org/color"
                ]
            }


            function createProductVariant(product, colourSchema, size) {
                var variantName = colourSchema.name + ' ' + product.name + ' in ' + size;
                var variantImages = _.map(_.reject(
                    [colourSchema.front, colourSchema.back], function (imageUrl) {
                        return _.isEmpty(imageUrl)
                    }), function (image) {
                    return CommonUtilService.compressImage(image, 'image-sm')
                });
                var variantUrl = productGroup.url + '?selectedColour=' + encodeURI(colourSchema.name) + '&size=' + encodeURI(size);
                return {
                    '@type': "Product",
                    "sku": product.sku + '_' + CommonUtilService.replaceSpaceWithUnderscore(colourSchema.name) + '_' + CommonUtilService.replaceSpaceWithUnderscore(size),
                    // "inProductGroupWithID": product.sku,
                    "image": variantImages,
                    "name": variantName,
                    "description": "Have your custom design printed on a " + variantName,
                    "color": colourSchema.name,
                    "size": size,
                    "offers": {
                        "@type": "AggregateOffer",
                        "url": variantUrl,
                        "priceCurrency": priceCurrency,
                        "highPrice": lowCountPrice.toFixed(2),
                        "lowPrice": highCountPrice.toFixed(2),
                        "offerCount": offerCount,
                        "price": lowCountPrice.toFixed(2),
                        'availability': "https://schema.org/InStock"
                    }
                }
            }

            var variantsSchema = [];
            _.forEach(product.colours, function(colourSchema) {
                if (product.sizes.length === 1) {
                    variantsSchema.push(createProductVariant(product, colourSchema, 'One Size'))
                } else {
                    _.forEach(product.sizes, function (size) {
                        variantsSchema.push(createProductVariant(product, colourSchema, size))
                    })
                }
            })
            productGroup.hasVariant = variantsSchema;


            var productSchema = {
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": product.name,
                "sku": product.sku,
                "image": CommonUtilService.compressImage(product.colours[0].front, 'image-sm'),
                "description": "Have your custom design printed on a " + product.name + ". We offer free shipping and expert design help.",
                "brand": {
                    "@type": "Brand",
                    "name": product.brand
                },
                "offers": {
                    "@type": "AggregateOffer",
                    'url': $location.protocol() + '://coastalreign.com' + localeUrl + CommonUtilService.buildProductUrl(product),
                    "priceCurrency": priceCurrency,
                    "highPrice": lowCountPrice.toFixed(2),
                    "lowPrice": highCountPrice.toFixed(2),
                    "offerCount": offerCount,
                    "price": lowCountPrice.toFixed(2),
                    'availability': "https://schema.org/InStock"
                },
            };

            return [
                breadcrumbSchemaObject,
                productSchema,
                productGroup
            ]
        }

        function updateCanonicalTag(routeURL) {
            var head = document.getElementsByTagName('head')[0];
            var element = document.querySelector(`link[rel='canonical']`) || null
            if (element) {
                head.removeChild(element);
            }

            element = document.createElement('link');
            head.appendChild(element);
            element.setAttribute('rel', 'canonical')
            element.setAttribute('href', routeURL)
        }

        // baseUrl = canadian url
        function updateHrefLangTags(host, basePath) {
            var head = document.getElementsByTagName('head')[0];
            // 1) clear all hreflang elements first
            var elements = document.querySelectorAll(`link[hreflang]`)
            if (elements.length > 0) {
                for(var i = 0; i < elements.length; i ++) {
                    var hreflangElement = elements[i]
                    head.removeChild(hreflangElement);
                }
            }

            //2. create new tags given base url
            if (!_.isUndefined(basePath)) {
                var caUrl = host + basePath;
                if (basePath == '/') {
                    basePath = ''
                }
                var usUrl = host + '/en-us' + basePath;

                //1. x-default
                var defaultElement = document.createElement('link');
                head.appendChild(defaultElement);
                defaultElement.setAttribute('rel', 'alternate')
                defaultElement.setAttribute('hreflang', 'x-default')
                defaultElement.setAttribute('href', encodeURI(caUrl))

                //2. en-ca
                var enCAElement = document.createElement('link');
                head.appendChild(enCAElement);
                enCAElement.setAttribute('rel', 'alternate')
                enCAElement.setAttribute('hreflang', 'en-CA')
                enCAElement.setAttribute('href', encodeURI(caUrl))

                //3. en-us
                var enUSElement = document.createElement('link');
                head.appendChild(enUSElement);
                enUSElement.setAttribute('rel', 'alternate')
                enUSElement.setAttribute('hreflang', 'en-US')
                enUSElement.setAttribute('href', encodeURI(usUrl))
            }
        }

        function createMetaTag(key, identifier, content){
            var metas = document.getElementsByTagName("meta");
            var meta = _.find(metas, function(meta){
                return meta.getAttribute(key) == identifier
            });
            if (meta){
                meta.content = content
            } else {
                $('head').append('<meta '+ key + " = \"" + identifier + "\"" + ' content=\"' + content + '\" />');
            }
        }

        function updateRobotsTag(content) {
            // Default to "index, follow" if no content is provided
            content = content || "index, follow";
            
            var head = document.getElementsByTagName('head')[0];
            var robotsTag = document.querySelector('meta[name="robots"]');
            
            // If robots meta tag exists, update it
            if (robotsTag) {
                robotsTag.setAttribute('content', content);
            } 
            // Otherwise create a new one
            else {
                robotsTag = document.createElement('meta');
                robotsTag.setAttribute('name', 'robots');
                robotsTag.setAttribute('content', content);
                head.appendChild(robotsTag);
            }
        }

        return {
            generateMainPageSchema: generateMainPageSchema,
            localeBusinessSchema: localeBusinessSchema,
            generateCodedPageSchema: generateCodedPageSchema,
            generatePageTemplateSchema: generatePageTemplateSchema,
            generateProductCollectionSchema: generateProductCollectionSchema,
            generateBreadcrumb: generateBreadcrumb,
            generateProductPLPSchema: generateProductPLPSchema,
            generateFaqTemplateSchema: generateFaqTemplateSchema,
            generateProductGroupSchema: generateProductGroupSchema,
            updateCanonicalTag: updateCanonicalTag,
            updateHrefLangTags: updateHrefLangTags,
            updateRobotsTag: updateRobotsTag,
            createMetaTag: createMetaTag
        };
    }

})();

(function() {
    'use strict';

    angular.module('app')
        .factory('OrderService', OrderService)

    OrderService.$inject = ['$http', '$q'];

    function OrderService($http, $q) {

        function approveQuote(order, userDetails) {
            return $http.post('/approveQuote', {
                order: order,
                userDetails: userDetails
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function saveQuoteDetails(orderNumber, order) {
            return $http.patch('/api/orders/saveQuoteDetails/' + orderNumber, {
                order: order
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    // fail silently
                    return $q.reject(err);
                })
        }

        function updateQuoteItemLine(order) {
            return $http.patch('/api/orders/updateQuoteItemLine/' + order.number, {
                order: order
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function trackOrder(orderNumber, zip) {
            return $http.post('/api/orders/trackOrder/' + orderNumber + '/' + zip)
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function rejectMockup(orderNumber, viewToken, rejectionNotes) {
            return $http.post('/api/orders/declineMockup/' + orderNumber, {
                viewToken: viewToken,
                rejectionNotes: rejectionNotes
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function approveTerms(orderNumber, viewToken, socialMediaConsent, signature) {
            return $http.post('/api/orders/approveTerms/' + orderNumber, {
                viewToken: viewToken,
                socialMediaConsent: socialMediaConsent,
                signature :signature
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function payBalance(orderNumber, viewToken, cardDetails) {
            return $http.post('/api/orders/payBalance/' + orderNumber, {
                viewToken: viewToken,
                cardDetails: cardDetails
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function acceptMockupAndPay(orderNumber, viewToken, cardDetails) {
            return $http.post('/api/orders/approveMockup/' + orderNumber, {
                viewToken: viewToken,
                cardDetails: cardDetails
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        function requestNewInvoice(orderNumber, viewToken) {
            return $http.post('/api/orders/requestStockCheck/' + orderNumber, {
                viewToken: viewToken
            })
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function getOrderRates(toAddress, shipments, warehouse) {
            var req = {
                address: toAddress,
                shipments: shipments,
                warehouse: warehouse
            }
            return $http.post('/api/orders/getOrderShippingRates', req)
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    showError(err.data.message);
                    return $q.reject(err);
                })
        }

        function recommendedWarehouse(shippingAddress, itemLines, pickUpLocation, failSilent) {
            var req = {
                shippingAddress: shippingAddress,
                itemLines: itemLines,
                pickUpLocation: pickUpLocation
            }
            return $http.post('/api/orders/recommendedWarehouse', req)
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    if (!failSilent) {
                        showError(err.data.message);
                    }
                    return $q.reject(err);
                })
        }

        function estimateShippingRates(zip, warehouse, isDummy, location) {
            var req = {
                zip: zip,
                warehouse: warehouse,
                isDummy: isDummy,
                location: location
            }
            return $http.post('/api/orders/estimateShippingRates', req)
                .then(function(response) {
                    return response.data
                })
                .catch(function(err) {
                    return $q.reject(err);
                })
        }

        return {
            trackOrder: trackOrder,
            rejectMockup: rejectMockup,
            acceptMockupAndPay: acceptMockupAndPay,
            payBalance: payBalance,
            approveTerms : approveTerms,
            requestNewInvoice: requestNewInvoice,
            estimateShippingRates: estimateShippingRates,
            getOrderRates: getOrderRates,
            recommendedWarehouse: recommendedWarehouse,
            approveQuote: approveQuote,
            saveQuoteDetails: saveQuoteDetails,
            updateQuoteItemLine: updateQuoteItemLine
        };
    }

})();

(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('breadcrumb', BreadcrumbDirective);

    BreadcrumbDirective.$inject = ['PageTemplateService', '$rootScope', '$anchorScroll', '$timeout']

    function BreadcrumbDirective(PageTemplateService, $rootScope, $anchorScroll, $timeout) {
        var directive = {
            link: link,
            templateUrl: 'shared/js/widget/breadcrumb.html',
            restrict: 'EA',
            scope: {
                breadcrumblist: '='
            }
        };
        return directive;

        function link($scope, element, attrs) {

            $scope.$watch('breadcrumblist', function() {
                // console.log($scope.breadcrumblist);
                $timeout(function() {
                    var scrollable = document.getElementById("breadcrumblist");
                    if (scrollable) {
                        scrollable.scrollLeft = scrollable.scrollWidth;
                    }
                })
            })

            $scope.cleanPageName = function(name) {
                return PageTemplateService.cleanPageName(name);
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('sharedModule')
        .directive('skeletonProductList', SkeletonProductList);

    SkeletonProductList.$inject = ['matchmedia']

    function SkeletonProductList(matchmedia) {
        var directive = {
            restrict: 'EA',
            scope: {
                isPreview: '=?',
                showFilters: '='
            },
            templateUrl: 'shared/js/widget/skeleton-product-list.html',
            link: function ($scope, $elem, $attr) {
                $scope.onPhone = false;
                $scope.numElements = Array.from(Array(24));
                if ($scope.isPreview) {
                    $scope.numElements = [1, 2, 3];
                }

                $scope.watchers = [];

                $scope.watchers.push(matchmedia.onPhone(function(mediaQuery) {
                    if (mediaQuery.matches) {
                        $scope.onPhone = true;
                        if ($scope.isPreview) {
                            $scope.numElements = [1, 2];
                        }
                    }
                }));

                $scope.$on('$destroy', function() {
                    _.forEach($scope.watchers, function(watcher){
                        watcher();
                    })
                })

            }
        }
        return directive
    }
})();
/**
 * Created by eddisonng on 2016-10-13.
 */

function showError(message) {
    var message = message;
    if (message == null) {
        message = "Unfortunately there was an error with your request."
    }
    $("#errorMessage").html(message)
    $("#errorMessageModal").modal()
}

function note(message, callback) {
    var message = message;
    $("#noteMessage").html(message);
    $("#noteMessageModal").modal()
    $('#noteMessageModal').unbind('hidden.bs.modal')
    $('#noteMessageModal').on('hidden.bs.modal', callback)
}

function success(message, callback) {
    $('#successMessageModal').unbind('hidden.bs.modal')
    var message = message;
    if (message == null) {
        message = "Success!"
    }
    $("#successMessage").html(message)
    $("#successMessageModal").modal()
    if (callback) {
        $('#successMessageModal').on('hidden.bs.modal', callback)
    }
}


function loadingScreen(message) {
    // close any pre-existing screens
    closeLoadingScreen();
    var loadingScreenObj = window.pleaseWait({
        logo: "../images/loading-image.png",
        backgroundColor: 'white',
        loadingHtml: "<p class='loading-message'>" + message + "</p>" + '<div id="progressBarLoading" class="progress" style="width: 5%; height: 100%; background-color: #39bdae; border-radius: 0;"></div>'
    });
    window.loading_screen = loadingScreenObj;
    return loadingScreenObj;
}

function closeLoadingScreen() {
    if (window.loading_screen) {
        window.loading_screen.finish();
    }
}
